<app-headnav [user]="reportInfo" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>
<div id="overlay" style="background: black url('/assets/images/loader.gif') center center no-repeat;"></div>
<div id="overlay2" style="display:none; background: transparent url('/assets/images/loader.gif') center center no-repeat;"></div>
<div *ngIf="expanded" id="reportList" class="task-box2" cdkDrag>
	<div class="row" style="margin: 4px; padding:0; background-color: #4C4C4C;">
		<label style="font-size: 18px; margin-left:32%; margin-top:5px; color: #C2D63F;width:65%"><strong>Company Reports</strong><span *ngIf="reports&&reports.length>0" class="srcLabel"> ( Category: {{reports[0].REPORT_CATEGORY}} / Template: {{reportInfo?.TEMPLATE[0].TEMPLATE_TITLE}} )</span></label>
		<a style="cursor: pointer; color: #C2D63F; margin-top:8px" (click)="expanded=false" title="Close">
			<i class="fas fa-times" size="lg"></i>
		</a>
		
	</div>
	<p class="noteText"  style="width:80vw;padding:0 10px"><span class="noteTitle">How to select your Source Report: </span>
		Search any field(s) to find the Source Report you would like to 'Import' from.
		Click the ‘Import Report’ icon to the right of the ‘Report Name’ field (this will be your Source Report).</p>
	
	<div class="row" style="margin: 1px; margin-top: 0px;">
		
	
		<div style="width:80vw;">
			<p-table #ttt styleClass="p-datatable-sm" [value]="reports" [columns]="cols7" [scrollable]="true"
            scrollHeight="calc(100vh - 250px)">
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>
              
                </span>
                <span>

                <input type="search" pInputText placeholder="Search"
                  (input)="ttt.filterGlobal($event.target.value, 'contains')">
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns; trackBy:trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>

              </tr>
              <tr> 
                <th *ngFor="let col of columns; let i=index; trackBy:trackByFuntion" style="padding:2px">
                  <input class="inputHeader" pInputText type="text"
                    (input)="ttt.filter($event.target.value, col.field, 'contains')"
                    style="margin:0 2px; font-size:12px; width:98%;">                   
      
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy:trackByFuntion" [ngStyle]="{'width': col.width}">
                  <span *ngIf="col.field!='REPORT_TITLE'">{{rowData[col.field]}} </span>
                  <a *ngIf="col.field=='REPORT_TITLE'" [href]="'complete-rpt/'+rowData.PROJECT_ID+'/'+rowData.REPORT_ID" target=_blank>{{rowData[col.field]}} </a>
                  <a *ngIf="col.field=='REPORT_TITLE'" class="iconBtn float-md-right" title="Import Report" (click)="importRpt(rowData)"><i  class="fas fa-file-import"></i></a>
                </td>
              </tr>
            </ng-template>
          </p-table>
		</div>
	</div>
</div>
<div *ngIf="compareShow" id="compareList" class="task-box3" cdkDrag>
	<div style="margin: 4px; padding:0; background-color: #4C4C4C;">
		<label style="font-size: 18px; text-align:center; margin-top:5px; color: #C2D63F;"><strong>Importing Data from Past Reports</strong></label>
		<a class="float-md-right mr-3 mt-2" style="cursor: pointer; color: #C2D63F;" (click)="importCancel(); compareShow=false;" title="Close">
		<i class="fas fa-times" size="lg"></i>
		</a>
	</div>
	<div  style="width:60vw;height:80vh">
	<p class="noteText m-0"  style="padding:0 10px"><span class="noteTitle">Your Current Report is displayed on the left, the source report being copied from is on the right. </span>
		On the left-hand side use the drop-down menu(s) to choose the sections to be imported over from the source report.  If you would like to import an entire section, ensure that you use the down caret ( <span class="noteBtn1">v</span> ) to open the entire section and choose each child section separately.</p>
	<p class="noteText m-0"  style="padding:0 10px"><span class="noteTitle">Copy All Sections: </span>
		You can use the “Check on all Common Sections” button in the bottom right of this screen to auto check off all sections between your current report and the source report.</p>
	<p class="noteText m-0"  style="padding:0 10px"><span class="noteTitle">NOTE: </span>
		If there is an active user in a section of your Current Report, the selected Source Report content for that section will not import to prevent overwriting current work.</p>
	<p class="noteText m-0"  style="padding:0 10px">
		When you have completed your import section choices, press the <span class="noteBtn">Import</span>  button in the bottom right of this screen.</p>
	
	<div class="row" style="margin: 10px 1px 0 1px;width:100%;padding:0">
		<label class="srcLabel ml-2" style="width:44%; text-align:center">Current Report ( {{reportInfo.PROJECT_NUMBER}} )</label>
		<i class="fas fa-long-arrow-alt-left fa-3X" style="margin-left:40px; margin-right:40px; color:#327FC2; font-size:24px"></i>
		<label class="srcLabel">Source Report  ( {{importPorj}} )<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span></label>
	</div>
	<div class="row" style="margin: 0 1px 0 2px; padding-top:0; width:100%; height:80%">
		<div style="width:67%; background-color:#ccc; height:100%; overflow:auto; margin-top:0">
			<ng-container *ngFor="let doc of contents; let i=index; trackBy:trackByFuntion">
				<div class="baseItem" [ngClass]="{'active':curSrcItem&&curSrcItem['id']&&doc.id==curSrcItem?.id}"  (click)="selSrcItem(doc,1)">
				<label  style="margin-left:10px; vertical-align:top"  class='seq'>. {{doc.SECTION_SEQUENCE}} </label>
				<label  style="font-weight:bold; max-width:50%" [ngStyle]="{'background-color':allimportIds.indexOf(doc.id)==-1?'#f86565':'#ccc'}">{{doc.SECTION_TITLE}}</label>
				<i *ngIf="doc.SUB_SECTIONS.length>0" class="btn-blue1 fas fa-angle-down" (click)="toggleChild1($event)"></i>
				<!--<input *ngIf="doc.TYPE!='COST'" type="checkbox" class="importType" [(ngModel)]="doc['replaced']" (change)="getSrcItem($event, doc, 1)" [disabled]="noImportTypes.indexOf(doc.TYPE)>-1">-->
				<select *ngIf="noImportTypes.indexOf(doc.TYPE)==-1" class="importType" style="width:25%; font-size: 12px;" (change)="setReplaceId($event, doc)">
					<option></option>
					<ng-container *ngFor="let idoc of importContents">
						<option [selected]="doc['replaceBy']==idoc.id" [disabled]="noImportTypes.indexOf(idoc.TYPE)>-1" [value]="idoc.id">{{idoc.SECTION_SEQUENCE}}.{{idoc.SECTION_TITLE}}</option>
					</ng-container>
				</select>
			</div>
				
				<div class="curItem" style="display:none">
				<ng-container *ngFor="let doc1 of doc.SUB_SECTIONS; let j=index; trackBy:trackByFuntion">
					<div class="baseItem" [ngClass]="{'active':curSrcItem&&curSrcItem['id']&&doc1.id==curSrcItem.id}" (click)="selSrcItem(doc1,2)">
						<label  style="margin-left:20px; vertical-align:top"  class='seq'>. {{doc1.SECTION_SEQUENCE}} </label>
						<label  style="font-weight:bold; max-width:50%" [ngStyle]="{'background-color':allimportIds.indexOf(doc1.id)==-1&&doc1.TYPE!='UNITTABLE'?'#f86565':'#ccc'}">{{doc1.SECTION_TITLE}}</label>
						<i *ngIf="doc1.SUB_SECTIONS.length>0" class="btn-blue1 fas fa-angle-down" (click)="toggleChild1($event)"></i>
						<!--<input *ngIf="doc.TYPE!='COST'" type="checkbox" class="importType" [(ngModel)]="doc1['replaced']"  (change)="getSrcItem($event, doc1, 2)" [disabled]="doc['replaced']||noImportTypes.indexOf(doc.TYPE)>-1||noImportTypes.indexOf(doc1.TYPE)>-1">-->
						<select *ngIf="!doc1.tableClass&&noImportTypes.indexOf(doc1.TYPE)==-1&&(!(doc1.TYPE=='TABLE'&&doc1.data&&doc1.data['erisName']))" class="importType" style="width:25%; font-size: 12px;" (change)="setReplaceId($event, doc1)">
							<option></option>
							<ng-container *ngFor="let idoc of importContents;">
								<option disabled><label *ngIf="idoc.DISPLAY_SEQUENCE=='Y'">{{idoc.SECTION_SEQUENCE}}.</label>{{idoc.SECTION_TITLE}}</option>
								<ng-container *ngFor="let idoc1 of idoc.SUB_SECTIONS">
									<option [selected]="doc1['replaceBy']==idoc1.id" [disabled]="idoc1.tableClass||noImportTypes.indexOf(idoc1.TYPE)>-1||(idoc1.TYPE=='TABLE'&&idoc1.data&&idoc1.data['erisName'])"  [value]="idoc1.id"><label *ngIf="idoc1.DISPLAY_SEQUENCE=='Y'">{{idoc1.SECTION_SEQUENCE}}.</label>{{idoc1.SECTION_TITLE}}</option>
								</ng-container>
							</ng-container>
						</select>
				</div>
					
					<div class="curItem" style="display:none">
					<ng-container *ngFor="let doc2 of doc1.SUB_SECTIONS; let k=index; trackBy:trackByFuntion">
						<div class="baseItem" [ngClass]="{'active':curSrcItem&&curSrcItem['id']&&doc2.id==curSrcItem.id}" (click)="selSrcItem(doc2,3)">
						<label  style="margin-left:30px; vertical-align:top"  class='seq'>. {{doc2.SECTION_SEQUENCE}} </label>
						<label  style="font-weight:bold; max-width:50%" [ngStyle]="{'background-color':allimportIds.indexOf(doc2.id)==-1?'#f86565':'#ccc'}">{{doc2.SECTION_TITLE}}</label>
						<!--<input *ngIf="doc.TYPE!='COST'" type="checkbox" [(ngModel)]="doc2['replaced']"  (change)="getSrcItem($event, doc2, 3)" [disabled]="doc['replaced']||doc1['replaced']||noImportTypes.indexOf(doc.TYPE)>-1||noImportTypes.indexOf(doc1.TYPE)>-1||noImportTypes.indexOf(doc2.TYPE)>-1" class="importType">-->
						<select *ngIf="!doc2.tableClass&&noImportTypes.indexOf(doc2.TYPE)==-1&&(!(doc2.TYPE=='TABLE'&&doc2.data&&doc2.data['erisName']))" class="importType" style="width:25%; font-size: 12px;" (change)="setReplaceId($event, doc2)">
							<option></option>
							<ng-container *ngFor="let idoc of importContents">
								<option disabled><label *ngIf="idoc.DISPLAY_SEQUENCE=='Y'">{{idoc.SECTION_SEQUENCE}}.</label>{{idoc.SECTION_TITLE}}</option>
								<ng-container *ngFor="let idoc1 of idoc.SUB_SECTIONS">
									<option disabled><label *ngIf="idoc1.DISPLAY_SEQUENCE=='Y'">{{idoc1.SECTION_SEQUENCE}}.</label>{{idoc1.SECTION_TITLE}}</option>
									<ng-container *ngFor="let idoc2 of idoc1.SUB_SECTIONS">
										<option [selected]="doc2['replaceBy']==idoc2.id" [disabled]="idoc2.tableClass||noImportTypes.indexOf(idoc2.TYPE)>-1||(idoc2.TYPE=='TABLE'&&idoc2.data&&idoc2.data['erisName'])"  [value]="idoc2.id"><label *ngIf="idoc2.DISPLAY_SEQUENCE=='Y'">{{idoc2.SECTION_SEQUENCE}}.</label>{{idoc2.SECTION_TITLE}}</option>
									</ng-container>
								</ng-container>
							</ng-container>
						</select>
					</div>
					</ng-container>
					</div>
				</ng-container>
				</div>
			</ng-container>
		</div>
		<div style="width:2%">
			
		</div>
		<div style="width:30%; background-color:#eee; height:100%; overflow:auto;font-size: 12px;">
			<ng-container *ngFor="let doc of importContents">
				<div class="baseItem" [ngClass]="{'active':curSrcItem&&curSrcItem['id']&&(doc['replaceTo']==curSrcItem?.id)}">
					<label  style="margin-left:10px; vertical-align:top"  class='seq'>. {{doc.SECTION_SEQUENCE}} </label>
					<label   style="font-weight:bold; max-width:75%" [ngStyle]="{'background-color':allsrcIds.indexOf(doc.id)==-1?'#f86565':'#eee'}">{{doc.SECTION_TITLE}}</label>
					<i *ngIf="doc.SUB_SECTIONS.length>0" class="btn-blue1 fas fa-angle-down" (click)="toggleChild1($event)"></i>
					<!--<input *ngIf="doc.TYPE!='COST'" type="checkbox" class="importType" [(ngModel)]="doc['replaced']"  (change)="setTargetItem($event, doc)" [disabled]="curLevel!=1||noImportTypes.indexOf(doc.TYPE)>-1">-->
				</div>
				<div class="srcItem" style="display:none">
				<ng-container *ngFor="let doc1 of doc.SUB_SECTIONS">
					<div class="baseItem" [ngClass]="{'active':curSrcItem&&curSrcItem['id']&&(doc1['replaceTo']==curSrcItem.id)}">
						<label  style="margin-left:20px; vertical-align:top"  class='seq'>. {{doc1.SECTION_SEQUENCE}} </label>
						<label   style="max-width:75%" [ngStyle]="{'background-color':allsrcIds.indexOf(doc1.id)==-1&&doc1.TYPE!='UNITTABLE'?'#f86565':'#eee'}">{{doc1.SECTION_TITLE}}</label>
						<i *ngIf="doc1.SUB_SECTIONS.length>0" class="btn-blue1 fas fa-angle-down" (click)="toggleChild1($event)"></i>
						<!--<input *ngIf="doc.TYPE!='COST'" type="checkbox" class="importType" [(ngModel)]="doc1['replaced']"  (change)="setTargetItem($event, doc1)" [disabled]="doc['replaceTo']||curLevel!=2||noImportTypes.indexOf(doc.TYPE)>-1||noImportTypes.indexOf(doc1.TYPE)>-1">-->
					</div>
					<div class="srcItem" style="display:none">
						<ng-container *ngFor="let doc2 of doc1.SUB_SECTIONS">
							<div class="baseItem" [ngClass]="{'active':curSrcItem&&curSrcItem['id']&&(doc2['replaceTo']==curSrcItem.id)}">
							<label  style="margin-left:30px; vertical-align:top"  class='seq'>. {{doc2.SECTION_SEQUENCE}} </label>
							<label  style="max-width:75%" [ngStyle]="{'background-color':allsrcIds.indexOf(doc2.id)==-1?'#f86565':'#eee'}">{{doc2.SECTION_TITLE}}</label>
							<!--<input *ngIf="doc.TYPE!='COST'" type="checkbox" [(ngModel)]="doc2['replaced']"  (change)="setTargetItem($event, doc2)" [disabled]="doc['replaceTo']||doc1['replaceTo']||curLevel!=3||noImportTypes.indexOf(doc.TYPE)>-1||noImportTypes.indexOf(doc1.TYPE)>-1||noImportTypes.indexOf(doc2.TYPE)>-1" class="importType">-->
						</div>
							
						</ng-container>
					</div>
				</ng-container>
				</div>
			</ng-container>
		</div>
	</div>
	<div style="padding: 0 20px;margin-top: 0;">
		<a class="pcaBtn" (click)="expandToggle1($event, 'curItem')">Expand All</a>
		<a class="pcaBtn" (click)="expandToggle1($event, 'srcItem')"style="float:right">Expand All</a>
		<a class="presetBtn" (click)="presetReplaceId()" style="float:right; margin-right: 100px;">Check On all Common Section</a>
		<a class="presetBtn" (click)="clearReplaceId()" style="float:right; margin-right: 100px;">Clear All Selected Section(s)</a>
	</div>
	<div class="m-3" style="width:96%; position:relative">
		<!--<input type="checkbox" class="m-1" [(ngModel)]="inclApp"><label class='savedLabel'>Include Appendices</label>
		<input type="checkbox" class="mt-1 ml-4 mr-1"[(ngModel)]="importAll"><label class='savedLabel'>Import All Report Sections</label>-->		
		<button type="button" class="btn btn-outline-light btn-sm" style="float:right;" (click)=importTo()>Import</button>
		<button type="button" class="btn btn-outline-light btn-sm" style="float:right;" (click)=importCancel()>Cancel</button>
	</div>
	</div>
</div>
<div *ngIf="userId" class="studio">
	<div class="sidenav flex-container" [style.width]="sideNavWidth">
			<a href="dashboard" title="Dashboard" target=_blank>
			<!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
			<span data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
			</span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

			</a>
			<!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
			<a href="cover" title="Cover Page" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
			</a>
			<a href="template" title="Template" target=_blank><i class="icon-Template" style="font-size:32px"></i>
				<span aria-hidden="true" style="position: absolute; left: 86px">Templates</span>

			</a>
			<!--<a href="complete" title="Completed Reports" target=_blank>
				<i style="margin-left: 5px" class="far fa-list-alt"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Complete Reports</span>
			</a>
			<a href="company" style="border-top: 1px solid #000000;" title="Company" target=_blank><i class="icon-property" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Company Info</span>

			</a>
					
			<a title="Library and Repeat Fields" href="resources" style="border-top: 1px solid #000000" target=_blank>
			<span aria-hidden="true" data-icon="&#xe90f;" class="icon-Libraries" style="font-size:32px; margin-left:5px"></span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Libraries</span>

			</a>
			<a *ngIf="userInfo.ERIS_STAFF=='Y'" title="ERIS" href="erisonly" style="border-top: 1px solid #000000" target=_blank>
				<i  class="icon-eris" style="font-size: 32px;"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">ERIS Only</span>

				</a>-->

			<a  (click)="toggleSideBar()"> 

				<i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
				<i  *ngIf="toggleSideBarVar"class="pi pi-chevron-left" style="font-size: 24px;"></i>

			</a>			
		</div>

<div class="main  example-boundary">
<div class="row container-fluid p-0 m-0" style="height:100%; overflow:auto">
<div class="col-md-3 contentContainer">
	<ul class="nav nav-tabs">
    <li class="nav-item">
		<a class="nav-link active" data-toggle="tab" href="#content" (click)="logTab('sec');">Sections</a>		
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#app" (click)="getUpdated(); logTab('appendix');">Appendices</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#slot" title="Repeat Field" (click)="logTab('rf');">Re-Fields</a>
    </li>
	<li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#lib" title="Libraries" (click)="logTab('lib'); checkLib()">LIB</a>
    </li>
	<li class="nav-item" *ngIf="reportInfo?.PCA_INDICATOR=='Y'||reportInfo?.PCA_INDICATOR=='4099e'||reportInfo?.PCA_INDICATOR=='frm1105'" (click)="getPCAData();logTab('PCA')">
      <a class="nav-link" data-toggle="tab" href="#pca" title="PCA">PCA</a>
    </li>
  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    <div id="content" class="container tab-pane active" style="padding:0; position:relative" [style.pointer-events]="tableShow ? 'none' : 'auto'">
	<ng-container>
			<div style="position:fixed; top:116px; background-color:rgb(9, 17, 33); width:24.11%">
			<select class="expandSel">
				<option class="expandOp" value='1'>1</option>
				<option class="expandOp" value='2'>2</option>				
			</select>
			<button class="btn btn-black btn-list" (click)='op201.toggle($event);loading=false;'> + </button>
			<button  type="button" class="btn btn-black btn-list " [disabled]="allowAdd!='Y'" [disabled]="(reportInfo?.PCA_INDICATOR=='frm1104'||reportInfo?.PHASE1_TYPE=='1103')&&selectedEditor!='F'" (click)='addFSections("root")'>Add Section</button>
			<p-overlayPanel #op201 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '200px'}">
                <ng-template pTemplate>
					<div style="max-height:100px; overflow-y:auto">
						<button  type="button" class="btn btn-black btn-list1" [disabled]="allowAdd!='Y'" (click)='addFPage()'>Add Section Before TOC</button>
					</div>					
				</ng-template>
            </p-overlayPanel>
			<button  type="button"  class="btn btn-black btn-list" (click)='expandToggle($event)'>Expand</button>
			<!--<button  type="button" class="btn btn-outline-dark btn-list" (click)='addFSections("app")'>Add Appendix</button>-->
			</div>
		</ng-container>
	<div class='fixContent' >	
	<div cdkDropList [cdkDropListData]="frontpages" (cdkDropListDropped)="dropFront($event)">
	<div class="example-list" cdkDrag [cdkDragData]="page" *ngFor="let page of frontpages;let s=index; trackBy:trackByFuntion" style="background:#000; color:white;" [cdkDragDisabled]="allowDrag!='Y'">
		<a  [id]="page.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" style="font-weight:bold" [ngClass]="{'active':listid==page.id}" (click)="getFListPosition(page, $event,s);selectedRow=-1;selectedCell=null; curDoc=page">
			<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;">
			{{page.SECTION_TITLE}}	</label>					
			<i class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('front',page,s)" style="color:#F78181"></i>
			<a *ngIf="page.pageSrc=='pdf'&&page.pdf?.length>0" class="float-md-right" [href]="page.pdf" target=_blank ><i class="btn-outline-dark btn-small far fa-file-pdf p-2" style="color:#C2D63F"></i></a>
			<i *ngIf="page.SUB_SECTIONS&&page.SUB_SECTIONS.length>0" class="btn-outline-dark btn-small fas fa-angle-down p-2 float-md-right" style="color:#ccc" (click)="toggleChild($event)"></i>
			<app-edit-input *ngIf="page.id==listid&&page.id==onlock" class="float-md-right" [text]="page.SECTION_TITLE" (edited)="addLib=false; changeTitle('front',$event,s)"></app-edit-input>
		</a>
		<div cdkDropList class="example-list exDiv1" [attr.data-id]="page.id+'panel'" [cdkDropListData]="page.SUB_SECTIONS" 
			(cdkDropListDropped)="dropFItem($event)"	[cdkDropListConnectedTo]="getFConnectedList()" style="display:none; background:#000000; clear: right">
			<div class="example-box" 
				*ngFor="let page1 of page.SUB_SECTIONS;let t=index; trackBy:trackByFuntion" 
				cdkDrag [cdkDragData]="page1"  style="background:#000;" [cdkDragDisabled]="allowDrag!='Y'">
					<a  [id]="page1.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':page1.id==listid}" (click)="getFListPosition(page1, $event,s,t);selectedRow=-1;selectedCell=null; curDoc=page1">
						<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;"> . {{page1.SECTION_TITLE}}</label>
						<i *ngIf="page1['TYPE']!='PITABLE'"class=" btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('front',page1,s, t)"  style="color:#F78181"></i>
						<i *ngIf="page1['TYPE']=='PITABLE'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section can not be delete." style="color:#666; pointer-events:none"></i>
						<app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" class="float-md-right" [text]="page1.SECTION_TITLE" (edited)="addLib=false; changeTitle('front',$event,s,t)"></app-edit-input>
					</a>
			</div>
		</div>
	</div>
	</div>
	<div class="example-list" style="background:#000; color:white;">
		<a class="dropdown-item listItem" href="javascript:void(0)" style="font-weight:bold">
			<label style="max-width: 70%; white-space: normal;color:#999;pointer-events: none;">
			Table of Contents</label>					
			
		</a>
	</div>
	<div cdkDropList [cdkDropListData]="contents" (cdkDropListDropped)="dropGroups($event)">
	<div cdkDropListGroup class="example-list" *ngFor="let group of contents;let i=index; trackBy:trackByFuntion" cdkDrag [cdkDragData]="group"  style="background:#000; color:white;" [cdkDragDisabled]="allowDrag!='Y'">
		<a  [id]="group.id+'list'" class="dropdown-item listItem" [ngClass]="{'active':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1)}" href="javascript:void(0)" style="font-weight:bold" (click)="getListPosition(group, $event,i);selectedRow=-1;selectedCell=null; curDoc=group">
							
							<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;">
								{{group.SECTION_SEQUENCE}} {{group.SECTION_TITLE}}	</label>					
								<!--<i *ngIf="group.TYPE!='COST'&&group.TYPE!='4099e'&&group.TYPE!='SUMMARY'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('content',group,i)" style="color:#F78181"></i>
								<i *ngIf="group.TYPE=='COST'||group.TYPE=='4099e'||group.TYPE=='SUMMARY'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section is Mandatory for Report" style="color:#666; pointer-events:none"></i>
							-->
								<i *ngIf="group.TYPE!='COST'&&group.TYPE!='4099e'&&group.TYPE!='PISUMMARY'&&group.TYPE!='PCASUMMARY'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('content',group,i)" style="color:#F78181"></i>
								<i *ngIf="group.TYPE=='COST'||group.TYPE=='4099e'||group.TYPE=='PISUMMARY'||group.TYPE=='PCASUMMARY'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section is Mandatory for Report" style="color:#666; pointer-events:none"></i>
								<i *ngIf='group.TYPE=="PISUMMARY"||group.TYPE=="PCASUMMARY"' class="btn-outline-dark btn-small fas fa-plus p-2 float-md-right" style="color:#666"></i>
								<i *ngIf='group.TYPE!="PISUMMARY"&&group.TYPE!="PCASUMMARY"' class="btn-outline-dark btn-small fas fa-plus p-2 float-md-right" (click)="addChild($event,'content',group,i)" style="color:#ccc"></i>
								<i *ngIf="group.SUB_SECTIONS.length>0" class="btn-outline-dark btn-small fas fa-angle-down p-2 float-md-right" style="color:#ccc" (click)="toggleChild($event)"></i>
								<app-edit-input *ngIf="group.id==listid&&group.id==onlock" class="float-md-right" [text]="group.SECTION_TITLE" (edited)="addLib=false; changeTitle('content',$event,i)"></app-edit-input>
								</a>
		<div cdkDropList class="exDiv1" [attr.data-id]="group.id+'panel'" [cdkDropListData]="group.SUB_SECTIONS" (cdkDropListDropped)="dropGroup($event,i)"  style="display:none; background:#000; margin:0; padding:0;clear: right">
	<div cdkDropListGroup class="example-list"   *ngFor="let items of group.SUB_SECTIONS;let j=index; trackBy:trackByFuntion" cdkDrag [cdkDragData]="items" style="background:#000; color:white" [cdkDragDisabled]="allowDrag!='Y'">
		<a [id]="items.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':(curIndex[0]==i)&&curIndex[1]==j&&!(curIndex[2]>-1)}" (click)="getListPosition(items, $event,i,j);selectedRow=-1;selectedCell=null; curDoc=items">
									<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;"> . {{items.SECTION_SEQUENCE}} {{items.SECTION_TITLE}}</label>
									<i *ngIf="items.TYPE!='PCATABLE'&&items.TYPE!='4099e'&&items.TYPE!='PITABLE'&&(!items['tableClass'])" class=" btn-outline-dark btn-small fas fa-trash p-2  float-md-right" (click)="removeSec('content',items,i, j)" style="color:#F78181"></i>
									<i *ngIf="items.TYPE=='PCATABLE'||items.TYPE=='4099e'||items.TYPE=='PITABLE'||items['tableClass']" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section is Mandatory for Report" style="color:#666; pointer-events:none"></i>
									<i *ngIf='items.TYPE=="PITABLE"||items["tableClass"]' class="btn-outline-dark btn-small fas fa-plus p-2  float-md-right" style="color:#666"></i>
									<i *ngIf='items.TYPE!="PITABLE"&&(!items["tableClass"])'class=" btn-outline-dark btn-small fas fa-plus p-2 float-md-right" (click)="addChild($event,'content',items,i, j)" style="color:#ccc"></i>
									<i *ngIf="items.SUB_SECTIONS?.length>0" class=" btn-outline-dark btn-small fas fa-angle-down p-2 float-md-right" (click)="toggleChild($event)" style="color:#ccc"></i>
									<app-edit-input *ngIf="items.id==listid&&items.id==onlock" [text]="items.SECTION_TITLE" class="float-md-right" (edited)="addLib=false; changeTitle('content',$event,i,j)"></app-edit-input>
										
									
									</a>
		<div cdkDropList class="example-list exDiv2" [attr.data-id]="items.id+'panel'" [cdkDropListData]="items.SUB_SECTIONS" 
    (cdkDropListDropped)="dropItem($event)"
		[cdkDropListConnectedTo]="getConnectedList()" style="display:none; background:#000000; clear: right">
			<div class="example-box" 
				*ngFor="let item of items.SUB_SECTIONS;let k=index; trackBy:trackByFuntion" 
				cdkDrag [cdkDragData]="item"  style="background:#000;" [cdkDragDisabled]="allowDrag!='Y'">
					<a  [id]="item.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k}" (click)="getListPosition(item, $event,i,j,k);selectedRow=-1;selectedCell=null; curDoc=item">
						<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;"> . . {{item.SECTION_SEQUENCE}} {{item.SECTION_TITLE}}</label>
						<i *ngIf="item.TYPE!='4099e'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('content',item,i, j, k)"  style="color:#F78181"></i>
						<i *ngIf="item.TYPE=='4099e'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section can not be delete." style="color:#666; pointer-events:none"></i>
						<app-edit-input *ngIf="item.id==listid&&item.id==onlock" class="float-md-right" [text]="item.SECTION_TITLE" (edited)="addLib=false; changeTitle('content',$event,i,j,k)"></app-edit-input>
					</a>
			</div>
		</div>
	</div>
</div>
</div>
</div>
</div>
</div>
<div id="app" class="container tab-pane fade" style="padding:0" [style.pointer-events]="tableShow ? 'none' : 'auto'">
	<div class="fixContent1">
	<span class="noteLabel"> *Only unsecured PDF files will be generated in report.</span><br>
	<span class="noteLabel">(NOTE: ERIS files shown in white have not been produced yet or were not ordered.)</span>
	<div *ngIf="appendices" class="example-list dropdown-item listItem" style="font-weight:bold; background:#444;">
		<!--<app-editable [text]="appendices?.SECTION_TITLE" (edited)="changeTitle('app',$event)"></app-editable>-->
		<label style="max-width:70%;  white-space: normal;color:white;pointer-events: none;">{{appendices?.SECTION_TITLE}}</label>
		
		<i [ngClass]="{'disabled':appEditable=='N'||allowAdd!='Y'}" class="btn-cog btn-outline-dark btn-small fas fa-plus p-2 float-md-right" (click)="addChild($event,'app','')"></i>
		<app-edit-input *ngIf="appEditable=='Y'&&allowAdd=='Y'" class="float-md-right" [text]="appendices?.SECTION_TITLE" (edited)="changeTitle('app',$event)"></app-edit-input><br>
		<label class="applabel"><input type="checkbox" name="printnodata" [checked]="printnodataforAppendix=='N'" (change)="noDataConfig($event)">Disable "No Data Available" Message</label>
	</div>
	<div *ngIf="appendices"  cdkDropList class="example-list" [cdkDropListData]="appendices.SUB_SECTIONS" (cdkDropListDropped)="dropApp($event)" style="background:#000;">
			<div class="example-list" 
				*ngFor="let item of appendices.SUB_SECTIONS;let i=index; trackBy:trackByFuntion" 
				cdkDrag [cdkDragData]="item" style="background:#000;" [cdkDragDisabled]="allowAdd!='Y'||allowDrag!='Y'">
					<a class="dropdown-item listItem" href="javascript:void(0)" (click)="selectedRow=-1;selectedCell=null">. {{item.SECTION_SEQUENCE}}
						<!--<app-editable [text]="item.SECTION_TITLE" (edited)="changeTitle('app',$event,i)"></app-editable>-->
						<label [ngStyle]="{'color':item.omit?'#999':'white'}"style="max-width:65%; white-space: normal; color:white;pointer-events: none;"><span [innerHTML]="item.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span><span *ngIf="item['nodata']"> - No Data Available</span></label>
						<i [ngClass]="{'disabled':appEditable=='N'||allowAdd!='Y'}" class=" btn-outline-dark btn-small fas fa-trash p-2 mr float-md-right btn-trash" (click)="removeSec('app',item,i)"></i>
						<i [ngClass]="{'disabled':appEditable=='N'||allowAdd!='Y'}" class=" btn-outline-dark btn-small fas fa-cog p-2 mr-1 float-md-right btn-cog" (click)="getUpdated();getProjectFiles(); getAddedPdf(item); op30.toggle($event);loading=false;appSetting($event)"></i>
						<!--<i class=" btn-outline-dark btn-small fas fa-plus p-2 mr-1 float-md-right" (click)="addPdfs($event, i)"  style="color:#ccc"></i>-->
						<app-edit-input *ngIf="appEditable=='Y'&&allowAdd=='Y'" class="float-md-right" [text]="item.SECTION_TITLE" (edited)="changeTitle('app',$event,i)"></app-edit-input>
						<p-overlayPanel #op30 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '500px'}" (onShow)="showItem(item); appOp='O'">
                                                <ng-template pTemplate>
                                                    <div style="width: 480px; margin: 10px; padding-right:0; color:#C2D63F;max-height:60vh; overflow:auto"> 
														<label style="font-size:14; font-weight:bold">Add File</label>
														<span style="font-size:.8em; margin-left:40px"><input type="checkbox" [(ngModel)]='item.omit' (change)="autoSave('appendix update','Omit','appendix update');"/>Omit Appendix from Report<i class="fas fa-info-circle iconBtn" title="This appendix will not print in the report PDF."></i></span>	
														<span style="font-size:.8em; margin-left:10px"><input type="checkbox" [(ngModel)]='item["resume"]' (click)="resumeSec($event, item)"/>Set as Resume Section<i class="fas fa-info-circle iconBtn" title="This section will only for resume files."></i></span>
														<hr class="line2">
														<a class="btn iconBtn2 mr-1" [ngClass]="{'disabled':uploading}" (click)='upload("FILE")'>Upload Documents</a><!--(click)='uploadType="FILE"; fileShow=true' -->
														<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span>															
														<a *ngIf="reportInfo?.PHOTOLOG_LIST.length==0||(reportInfo['PHOTOLOG_LIST']&&reportInfo['PHOTOLOG_LIST'].length>0&&reportInfo['PHOTOLOG_LIST'][0]['PHOTOLOG_URL'].length==0)" class="btn iconBtn2 mr-1" [href]="'photolog/'+reportInfo.PROJECT_ID+'/'+reportInfo.REPORT_ID" target=_blank>Create New Photo log</a>
														<!--<span *ngIf="pdfs&&pdfs.length==0" style="color:yellow; font-size:10px">No ERIS Orders.</span>
														<hr class="line2">
															<a class="btn iconBtn2 ml-1" (click)="addPdfs($event, i)">No Data Available Item</a>-->
														<hr class="line2">
															<input *ngIf="reportInfo['PHOTOLOG_LIST']&&reportInfo['PHOTOLOG_LIST'].length>0&&reportInfo['PHOTOLOG_LIST'][0]['PHOTOLOG_URL'].length>0" [ngClass]="{'disabled':(!reportInfo['PHOTOLOG_LIST'])||reportInfo['PHOTOLOG_LIST'].length==0}" type="checkbox" [checked]="addedPdfs.indexOf(reportInfo['PHOTOLOG_LIST'][0]['PHOTOLOG_URL'])>-1" (change)="addPdfs($event,i,reportInfo['PHOTOLOG_LIST'][0])"><a [ngClass]="{'disabled':(!reportInfo['PHOTOLOG_LIST'])||reportInfo['PHOTOLOG_LIST'].length==0||(!reportInfo['PHOTOLOG_LIST'][0]['PHOTOLOG_URL'])}" style="font-size:.8em; margin:2px">Photo log</a>	
														<div *ngIf="maps&&maps.length>0" class="labelContainer">
														<hr class="line2">
														<a class="float-btns btn btn-sm iconBtn3">Maps/Figures</a>
															<ng-container *ngFor="let map of maps; trackBy:trackByFuntion">
																<input type="checkbox" [checked]="addedPdfs.indexOf(map.MAP_REPORT_URL)>-1" [disabled]="map?.MAP_REPORT_URL?.length==0" (change)="addPdfs($event, i, map)"><a [href]="map?.MAP_REPORT_URL" [ngClass]="{'disabled':map?.MAP_REPORT_URL?.length==0}" target=_blank style="font-size:.8em; margin:2px">{{map.MAP_REPORT_TITLE}}</a><br>
															</ng-container>
														</div>
														
														<div *ngIf="pdfs&&pdfs.length>0" class="labelContainer">
														<hr class="line2">
															<a class="float-btns btn btn-sm iconBtn3">ERIS</a>
														
															<ng-container *ngFor="let pdf of pdfs;; trackBy:trackByFuntion">
																<input type="checkbox" [checked]="addedPdfs.indexOf(pdf.REPORT_URL)>-1" (change)="addPdfs($event, i, pdf)"><a [href]="pdf.REPORT_URL" target=_blank style="color:rgb(195,212,47); font-size:.8em; margin:2px">{{pdf.REPORT_NAME}}</a><br>
															</ng-container>
														</div>
															
															<div *ngIf="projectFiles&&projectFiles.length>0" class="labelContainer">
															<hr class="line2">
																<a class="float-btns btn btn-sm iconBtn3">Project Docs</a>
														
																<ng-container *ngFor="let file of projectFiles;; trackBy:trackByFuntion">
																	<input type="checkbox" [checked]="addedPdfs.indexOf(file.FILE_URL)>-1"  (change)="addPdfs($event, i, file)"><a [href]="file.FILE_URL" target=_blank style="color:rgb(195,212,47); font-size:.8em; margin:2px">{{file.FILE_NAME}}</a><br>
																</ng-container>	
															</div>														
															<!--<a class="btn iconBtn2 mr-1" [ngClass]="{'disabled':pdfs.length==0}" (click)="op301.toggle($event); getAddedPdf(item)">Choose ERIS Files</a>
																<p-overlayPanel #op301 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '260px'}">
																	<ng-template pTemplate>
																		<ng-container *ngFor="let pdf of pdfs;; trackBy:trackByFuntion">
																			<input type="checkbox" [checked]="addedPdfs.indexOf(pdf.REPORT_URL)>-1" (change)="addPdfs($event, i, pdf)"><a [href]="pdf.REPORT_URL" target=_blank style="color:rgb(195,212,47); font-size:.8em; margin:2px">{{pdf.REPORT_NAME}}</a><br>
																		</ng-container>					
																	</ng-template>
																</p-overlayPanel>
																<span *ngIf="pdfs.length==0" style="color:yellow; font-size:10px">No ERIS Orders.</span>
																<br>
															<a class="btn iconBtn2 mr-1" [ngClass]="{'disabled':projectFiles.length==0}" (click)="op302.toggle($event)">Project Documents</a>
																<p-overlayPanel #op302 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '300px'}">
																	<ng-template pTemplate>
																		<ng-container *ngFor="let file of projectFiles;; trackBy:trackByFuntion">

																			<input type="checkbox" [checked]="addedPdfs.indexOf(file.FILE_URL)>-1"  (change)="addPdfs($event, i, file)"><a [href]="file.FILE_URL" target=_blank style="color:rgb(195,212,47); font-size:.8em; margin:2px">{{file.FILE_NAME}}</a><br>
																		</ng-container>					
																	</ng-template>
																</p-overlayPanel>																
																<a class="btn iconBtn2 mr-1" (click)='uploadType="FILE"; fileShow=true'>Upload</a>
														<br>
														<a [ngClass]="{'disabled':(!reportInfo?.PHOTOLOG_LIST)||reportInfo?.PHOTOLOG_LIST.length==0}" class="btn iconBtn2 mr-1" (click)='addPdfs($event,i,reportInfo.PHOTOLOG_LIST[0])'> Add Photo log</a>
														-->
													</div>
                                                </ng-template>
                                            </p-overlayPanel>		
						<i *ngIf='item["resume"]' title="Resume Section" class="brn btn-outline-dark btn-small pt-0 pl-2 pr-2 mr-2 float-md-right" style="color:#C2D63F; font-weight: bolder; font-size: 14px;">R</i>				
					</a>
					<div class="example-list"  cdkDropList [cdkDropListData]="item.app" (cdkDropListDropped)="dropItem($event)"  style="background:#000;clear: right">
						<div  cdkDrag [cdkDragData]="rf" class="example-box" *ngFor="let rf of item.app;let k=index; trackBy:trackByFuntion" style="background:#444;" [cdkDragDisabled]="allowAdd!='Y'||allowDrag!='Y'">
							<a class="dropdown-item listItem" href="javascript:void(0)">
								<div style="max-width: 100%; white-space: normal; padding-left:20px"> 
								<input [disabled]="(rf.type&&rf.type?.toUpperCase()!='PDF')||appEditable=='N'||allowAdd!='Y'" type="checkbox" class="mt-1 mr-1" [checked]="rf.selectedfile" (change)="appSelect($event, i, k)">
								<label *ngIf="(!rf?.url||rf?.url?.length==0)&&!(rf.name=='Photo log'||rf.name=='Photo Log'||rf.name=='Phase I - Freddie Mac 1103')" style="max-width:70%; color:white;pointer-events: none;">{{rf.name}}{{rf.text}}</label>
								<a *ngIf="(!rf?.url||rf?.url?.length==0)&&(rf.name=='Photo log'||rf.name=='Photo Log')" style="max-width:70%; color:white;" href="javascript:void(0)" title="Create New Photo log" (click)="getPhotolog('app', rf)">{{rf.name}}{{rf.text}}</a>
								<a *ngIf="(!rf?.url||rf?.url?.length==0)&&(rf.name=='Phase I - Freddie Mac 1103')" style="max-width:70%; color:white;" href="javascript:void(0)" (click)="get1103('app')">{{rf.name}}</a>
								<ng-container *ngIf="rf.TYPE&&rf.TYPE=='resume'">
									<a  *ngIf='rf.RESUME_TITLE.length>0' [href]="rf?.RESUME_URL" target=_blank style="color: rgb(195,212,47)">{{rf.RESUME_TITLE}} ({{rf.FIRST_NAME}} {{rf.LAST_NAME}})</a>
								</ng-container>
								<ng-container *ngIf="rf.name!='Photo log'&&rf!='Photo Log'&&rf.name!='Phase I - Freddie Mac 1103'">
									<a  *ngIf='rf?.url?.length>0' [href]="rf?.url" target=_blank style="color: rgb(195,212,47)">{{rf.name}}{{rf.text}}{{rf['COPIED']?' (Copied)':''}}</a>
								</ng-container>
								<ng-container *ngIf="rf.name=='Photo log'||rf.name=='Photo Log'">
									<a *ngIf='rf?.url?.length>0' href='javascript:void(0)' style="color: rgb(195,212,47)" (click)="getPhotolog('app', rf)">{{rf.name}}{{rf.text}}{{rf['COPIED']?' (Copied)':''}}</a>
								</ng-container>
								<ng-container *ngIf="rf.name=='Phase I - Freddie Mac 1103'">
									<a *ngIf='rf?.url?.length>0' href='javascript:void(0)' style="color: rgb(195,212,47)" (click)="get1103('app')">{{rf.name}}</a>
								</ng-container>
								<i [ngClass]="{'disabled':appEditable=='N'||allowAdd!='Y'}" class=" btn-outline-dark btn-small fas fa-trash p-2  float-md-right btn-trash" (click)="removePdf(i, k)"></i>
								<!--<i class=" btn-outline-dark btn-small fas fa-cog p-2 float-md-right" (click)="op31.toggle($event);loading=false;appSetting($event)"  style="color:#ccc"></i>-->
								<ng-container *ngIf="rf.name!='Photo log'&&rf.name!='Photo Log'&&rf.name!='Phase I - Freddie Mac 1103'">
									<app-edit-input  *ngIf="appEditable=='Y'&&allowAdd=='Y'&&rf.name" class="float-md-right" [text]="rf.name" (edited)="addLib=false; changeTitle('app',$event,i,k)"></app-edit-input>
								</ng-container>
								<app-edit-input  *ngIf="appEditable=='Y'&&allowAdd=='Y'&&rf.text" class="float-md-right" [text]="rf.text" (edited)="addLib=false; changeTitle('app',$event,i,k)"></app-edit-input>
								</div>
								<!--<p-overlayPanel #op31 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '500px'}" (onShow)="appOp='O'">
                                                <ng-template pTemplate>
                                                    <div style="width: 440px; margin: 10px; padding-right:0; color:#C2D63F;"> 
													<h6>Set PDF</h6>
													<hr>
														 <input type="radio" name="apps"  checked (change)="appOp='O'">
														<a class="btn iconBtn2 mr-1" [ngClass]="{'disabled':pdfs.length==0||appOp!='O'}" (click)="op303.toggle($event);">Choose ERIS Files</a>
																<p-overlayPanel #op303 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '260px'}">
																	<ng-template pTemplate>
																		<ng-container *ngFor="let pdf of pdfs;; trackBy:trackByFuntion">
																			<input type="checkbox" [checked]="addedPdfs.indexOf(pdf.REPORT_URL)>-1" (change)="addPdf(i,k, pdf)"><a [href]="pdf.REPORT_URL" target=_blank style="color:rgb(195,212,47); font-size:.8em; margin:2px">{{pdf.REPORT_NAME}}</a><br>
																		</ng-container>					
																	</ng-template>
																</p-overlayPanel>
																<span *ngIf="pdfs.length==0" style="color:yellow; font-size:10px">No ERIS Orders.</span>
														<br>
														 <input type="radio" (change)="appOp='U'" name="apps">
														<a class="btn iconBtn2 mr-1" [ngClass]="{'disabled':projectFiles.length==0||appOp!='U'}" (click)="op304.toggle($event)">Project Documents</a>
																<p-overlayPanel #op304 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '300px'}">
																	<ng-template pTemplate>
																		<ng-container *ngFor="let file of projectFiles;; trackBy:trackByFuntion">
																			<input type="checkbox" (change)="addPdf(i,k, file)"><a [href]="file.FILE_URL" target=_blank style="color:rgb(195,212,47); font-size:.8em; margin:2px">{{file.FILE_NAME}}</a><br>
																		</ng-container>					
																	</ng-template>
																</p-overlayPanel>															
																<a class="btn iconBtn2 mr-1" (click)='opPrjFile()'>Upload</a>
														<br>
														<input type="radio" name="apps"  (change)="appOp='P';getPhotolog()">
														<a [ngClass]="{'disabled':(!reportInfo?.PHOTOLOG_LIST)||reportInfo?.PHOTOLOG_LIST.length==0||appOp!='P'}" class="btn iconBtn2 mr-1" (click)='addPdf(i,k, reportInfo.PHOTOLOG_LIST[0])'> Add Photo log</a>
														<a *ngIf="reportInfo?.PHOTOLOG_LIST.length==0" class="btn iconBtn2 mr-1" [href]="'photolog/'+reportInfo.PROJECT_ID+'/'+reportInfo.REPORT_ID" target=_blank>Create New Photo log</a>
														<br>
														<input type="radio" name="apps" (change)="appOp='D'"><label style="width:100px">No Data Available</label><br> 
														<textarea class="col-md-12" [disabled]="appOp!='D'" row="4"></textarea>				
														<button type="button" class="btn btn-outline-light btn-sm float-md-right mb-2" (click)="appsave($event, op31, i, k)">Save</button>
			                                           <i *ngIf="loading" class="fas fa-circle-notch fa-spin" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>-->
							</a>
	
						</div>
					</div>
			</div>
		</div>
	</div>
</div>
<div id="slot" class="container tab-pane fade" style="padding:0; position:relative">
			<div style="color:#C2D63F; font-size:.9em; padding-left:20px">
			<label class="radio-inline">
			 <input type="radio" name="slots" [checked]="slotGroup=='D'" (change)="selSlotGroup('D')"> 
				 Section Assigned 
			</label> 
			<label class="radio-inline ml-3">
			<input type="radio" name="slots" [checked]="slotGroup=='T'" (change)="selSlotGroup('T')">
 				Report
			</label> 
			<label class="radio-inline ml-3"> 
				<input type="radio" name="slots" [checked]="slotGroup=='A'" (change)="selSlotGroup('A')">
				All
			</label>
			</div>
	<!--<div *ngIf="definedSlotGroup.length>0">
	<label class="group-title">Defined</label>
	<a href="javascript:void(0)" class="m-3" (click)="selSlotGroup('D')"><i *ngIf="slotGroup!='D'" class="fas fa-chevron-down"></i><i *ngIf="slotGroup=='D'" class="fas fa-chevron-right"></i></a><br>-->
	<div [ngStyle]="{'display':slotGroup=='D'?'block':'none'}"  class="fixTable">		
		<p-table #dt1 [value]="definedSlotGroup" [paginator]="false" [globalFilterFields]="['KEY','CONTENT']"  (onFilter)="onFilter($event, dt1)">
				<!--<ng-template pTemplate="header" let-columns>
					<tr>
						<th>
							<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="20" placeholder="Filter" (input)="dt1.filterGlobal($event.target.value, 'contains')" style="width:auto">
			
						</th>
					</tr>		
				</ng-template>-->
				<ng-template pTemplate="body" let-rowData>
					<tr>
						<td style="background-color:rgb(28, 36, 51)">
							<div class="card"> 						
								<div class="row"  style="width:100%">
									<p style="width:80%; margin-left:16px;color:rgb(195,212,47);">{{rowData.KEY}}<span style="color:#04B486; margin:0 2px">({{rowData.TYPE}})</span>
									<!--<a *ngIf="rowData.CONTENT.length>0" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op11.toggle($event);"><i class="fas fa-eye"></i></a>					
									<a *ngIf="rowData.TYPE!='PDF'" href="javascript:void(0)" [ngStyle]="{'color':rowData.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op11.toggle($event);"><i class="fas fa-eye"></i>-->
										<a  *ngIf="addLib&&rowData.TYPE!='Table'&&rowData.TYPE!='PDF'&&rowData.TYPE!='File'&&rowData.STATUS=='Active'" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('slot', rowData)"><i class="fas fa-arrow-right"></i></a>	
										<a *ngIf="addLibShow&&rowData.TYPE!='Table'&&rowData.TYPE!='PDF'&&rowData.TYPE!='File'&&rowData.STATUS=='Active'" href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('newLib', rowData)"><i class="fas fa-arrow-right"></i></a>
										
									<a *ngIf="rowData.TYPE!='PDF'&&rowData.TYPE!='Selection'" href="javascript:void(0)" [ngStyle]="{'color':rowData.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op11.toggle($event);"><i class="fas fa-eye"></i></a>
									<a *ngIf="rowData.TYPE!='PDF'&&rowData.TYPE=='Selection'" href="javascript:void(0)" [ngStyle]="{'color':rowData.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op11.toggle($event);"><i class="far fa-list-alt"></i></a>
							
									<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(rowData.TYPE, rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{rowData.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{rowData.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{rowData.TYPE}}</span><br>
														<strong *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')">															
														Content :</strong>
														<div *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')&&(rowData.TYPE!='File')">
															<textarea  style="width:100%" rows="3"  [value]="rowData.CONTENT">
															</textarea>
															<button *ngIf="rowData.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-md-right btn-op" (click)="updateSlotContent($event,rowData);op11.hide();">Update</button>
			                                           </div>
													   <div *ngIf="rowData.TYPE=='File'">
															<a [href]="rowData.CONTENT"  style="width:100%; word-break:break-all" target=_blank>{{rowData.FILE_NAME}}}</a>														
														</div>
													   <div *ngIf="rowData.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="rowData.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Selection )</span><span *ngIf="rowData.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Selection ) </span><br>
															<ng-container *ngFor="let item of tableContent; let s=index">
															<div>
															<input type="checkbox" [checked]="tableContent1.indexOf(item)>-1" (click)="selOP($event, item, rowData.MULTIPLE_CHOICE)">
																<span style="color:white">{{item}}</span> 
															</div>
														</ng-container>
														<button type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op" (click)="updateSlotContent($event,rowData);slotShow=false;">Update</button>
													
														</div>	
														<div *ngIf="rowData.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="color:white; width:90%; border: 1px solid black;  border-collapse: collapse;">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
									<span *ngIf="rowData.STATUS!='Active'" class="inaciveMsg">{{rowData.STATUS}}</span>
									
									<br>
									<span style="margin-left:16px; color:white">{{rowData.SHORT_CONTENT}}	</span>
									
								</div>								
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>
	</div>
	<div [ngStyle]="{'display':slotGroup=='T'?'block':'none'}" class="fixTable">		
		<p-table #dt4 [value]="tempSlots" [paginator]="false" [globalFilterFields]="['KEY','CONTENT']"  (onFilter)="onFilter($event, dt4)">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th  style="background-color:rgb(28, 36, 51)">
							<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="20" placeholder="Filter" (input)="dt4.filterGlobal($event.target.value, 'contains')" style="width:auto">
			
						</th>
					</tr>		
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr *ngIf="rowData.KEY">
						<td  style="background-color:rgb(28, 36, 51)">
							<div class="card"> 						
								<div class="row" style="width:100%">
									<p style="width:80%; margin-left:16px;color:rgb(195,212,47);">{{rowData.KEY}}<span style="color:#04B486; margin:0 2px">({{rowData.TYPE}})</span></p><!--<span style="color:rgb(195,212,47); margin-bottom:0">{{rowData.KEY}}</span>
									<a *ngIf="rowData.TYPE!='PDF'" href="javascript:void(0)" [ngStyle]="{'color':rowData.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op12.toggle($event);"><i class="fas fa-eye"></i>-->
									<a *ngIf="rowData.TYPE!='PDF'&&rowData.TYPE!='Selection'" href="javascript:void(0)" [ngStyle]="{'color':rowData.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op12.toggle($event);"><i class="fas fa-eye"></i></a>
									<a *ngIf="rowData.TYPE!='PDF'&&rowData.TYPE=='Selection'" href="javascript:void(0)" [ngStyle]="{'color':rowData.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op12.toggle($event);"><i class="far fa-list-alt"></i></a>
							
									<p-overlayPanel #op12 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(rowData.TYPE, rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:.9em"> 
													<strong>{{rowData.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{rowData.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{rowData.TYPE}}</span><br>
													<strong *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')">Content :</strong>
														<!--<span *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')">{{rowData.CONTENT}}</span>-->
														<div *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')&&(rowData.TYPE!='File')">
															<textarea style="width:100%" rows="3" [value]="rowData.CONTENT">
															</textarea>
															<button *ngIf="rowData.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-md-right  btn-op" (click)="updateSlotContent($event,rowData);op12.hide();">Update</button>
			                                           </div>
													   <div *ngIf="rowData.TYPE=='File'">
															<a [href]="rowData.CONTENT"  style="width:100%; word-break:break-all" target=_blank>{{rowData.FILE_NAME}}</a>
														</div>
														<div *ngIf="rowData.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="rowData.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Selection )</span><span *ngIf="rowData.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Selection ) </span><br>
														<ng-container *ngFor="let item of tableContent; let s=index">
															<div>
															<input type="checkbox" [checked]="tableContent1.indexOf(item)>-1" (click)="selOP($event, item, rowData.MULTIPLE_CHOICE)">
																<span style="color:white">{{item}}</span> 
															</div>
														</ng-container>
														<button *ngIf="rowData.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op" (click)="updateSlotContent($event,rowData);slotShow=false;">Update</button>
													
														</div>	
														<div *ngIf="rowData.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="color:white; width:90%; border: 1px solid black;  border-collapse: collapse;">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
													
									<span *ngIf="rowData.STATUS!='Active'" class="inaciveMsg">{{rowData.STATUS}}</span>
									<a *ngIf="addLib&&rowData.TYPE!='Table'&&rowData.TYPE!='PDF'&&rowData.TYPE!='File'&&rowData.STATUS=='Active'" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('slot', rowData)"><i class="fas fa-arrow-right"></i></a>	
									<a *ngIf="addLibShow&&rowData.TYPE!='Table'&&rowData.TYPE!='PDF'&&rowData.TYPE!='File'&&rowData.STATUS=='Active'" href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('newLib', rowData)"><i class="fas fa-arrow-right"></i></a>
									<br>
									<span style="margin-left:16px">{{rowData.SHORT_CONTENT}}	</span>
									
								</div>
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>
	</div>
	<!--<label class="group-title">All</label>
	<a href="javascript:void(0)" class="m-3" (click)="selSlotGroup('A')"><i *ngIf="slotGroup!='A'" class="fas fa-chevron-down"></i><i *ngIf="slotGroup=='A'" class="fas fa-chevron-right"></i></a><br>-->
	<div  [ngStyle]="{'display':slotGroup=='A'?'block':'none'}"  class="fixTable">
	<p-table #tb [columns]="cols2" [value]="groupSlots" dataKey="CATEGORY" sortMode="single" [expandedRowKeys]="expandedRows"><!-- (onPage)="onPage($event)" (onRowExpand)="onRowExpand()" (onRowCollapse)="onRowCollapse()"-->
    <ng-template pTemplate="caption"> 
	<div style="display:inline-block; ">
		<a style="cursor: pointer;font-size: 16px; color:rgb(195,212,47);" (click)="expandAll()">
			<i *ngIf="!isExpanded" class="fas fa-angle-double-right"></i>
			<i *ngIf="isExpanded" class="fas fa-angle-double-down"></i>
		</a>
		<i class="pi pi-refresh" style="margin:4px 4px 0 20px" pTooltip="Reload Repeat Fields" (click)='refreshSlots()'></i>
	</div>
        <div style="float: right; display:inline-block; ">        
            <input type="text" pInputText size="10" placeholder="Filter" (change)="filterSlots($event)" style="width:auto">
			<i class="pi pi-search" style="margin:4px 4px 0 0" (click)='filterSlots($event)'></i>			
			<!--<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" title="Add New Report" data-toggle="modal" data-target="#slotModal"><i class="fas fa-plus"></i></a>
			-->
			<a style="cursor: pointer; font-size: 16px;" (click)="op2.toggle($event);" title="Add Repeat Field">
                                                <i class="pi pi-plus" style="margin: 5px;"></i>
                                            </a>
                        
                                            <p-overlayPanel #op2 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '500px'}" (onShow)="resetNewSlot()">
                                                <ng-template pTemplate>
                                                    <div  style="width: 440px; margin: 10px; padding-right:0; color:#C2D63F;"> 
													<h6>Add Repeat Field</h6>
													<hr>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0 ">Title:<span style="font-weight:bold" [ngStyle]="{'color':newSlotLabel.trim()=== '' ? 'red' : 'white' }">*</span> </label>
														<input class="col-md-8 ml-0" type="text" [(ngModel)]='newSlotLabel'/>
														
													</div>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0">Category:<span style="font-weight:bold" [ngStyle]="{'color':newSlotCat.trim()=== '' ? 'red' : 'white' }">*</span> </label>
														<input type='text' ngClass="col-md-7"[(ngModel)]='newSlotCat' style="padding-left:0">
														<select class="col-md-1  ml-0" [(ngModel)]='newSlotCat' (mousedown)="getSlotPara()">
															<ng-container *ngFor="let cat of slotCategories">
																<option [value]="cat.CATEGORY">{{cat.CATEGORY}}</option>				
															</ng-container>
														</select>
														
													</div>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0">Type:<span style="font-weight:bold" [ngStyle]="{'color':newSlotType=== '' ? 'red' : 'white' }">*</span> </label>
														<!--<input type='text' [ngClass]="newSlotType=='Selection'? 'col-md-3':'col-md-7'"[(ngModel)]='newSlotType' style="padding-left:0">-->
														<select [ngClass]="newSlotType=='Selection'? 'col-md-4':'col-md-8'" [(ngModel)]='newSlotType' style="padding-left:0">
															<ng-container *ngFor="let type of slotTypes">
																<option [value]="type.SLOT_TYPE"><label class="mr-2">{{type.SLOT_TYPE}}</label></option>				
															</ng-container>
														</select>
														<select *ngIf="newSlotType=='Selection'" class="col-md-4" [(ngModel)]='newSlotMultiple' style="padding-left:0">
															<option value="N">Single Choice</option>
															<option value="Y">Multiple Choice</option>																
														</select>
														
													</div>
													<div class="row p-1" style="font-size:.9em;max-height:300px">
														<label class="col-md-3  ml-0">Content: 	</label>
														<textarea *ngIf="newSlotType!='Table'&&newSlotType!='Selection'&&newSlotType!='File'" class="col-md-8  ml-0" rows="10" [(ngModel)]='newSlotContent'></textarea>
														<input *ngIf="newSlotType=='Selection'" class="col-md-7  mt-1" [(ngModel)]='newSlotOp'/>
														<a href="javascript:void(0)" *ngIf="newSlotType=='Selection'" class="col-md-1 ml-0 mt-1 mr-0 slotBtn" (click)="addOpItem($event)"><i class="fas fa-plus"></i></a>
														<ng-container *ngIf="newSlotType=='File'">
															<button  class="btn btn-outline-light btn-op ml-0 mr-2" (click)="upload('slot')">Upload File</button>
															<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span>
															<br>
															<a [href]="newSlotFile.url"  style="margin-left:25%; width:70%; word-break: break-all;" target=_black>{{newSlotFile.name}}</a>															
														</ng-container>
														<label class="col-md-3  ml-0"></label>
														<button  *ngIf="newSlotType!='Selection'&&newSlotType!='File'" class="btn btn-outline-light rf-btn ml-1 slotBtn" data-target='#libraryModal' data-toggle="modal" (click)=" getLibraries(); libToSlot=true;filteredData=null;rangeIndex=1; rangeLib=libraries;">Libraries</button>		
														</div>
														
														<ng-container *ngIf="newSlotType=='Selection'&&newSlotOps.length>0">
															<div  class="selInput col-md-12" style="max-height:300px; overflow:auto; font-size:.9em; border:1px solid gray; padding:0">
																<ng-container *ngFor="let item of newSlotOps; let i=index">
																	<div class="row" style="width:100%; margin:0; padding:0">
																	<label class="col-md-10 pl-1"> . {{item}}</label>
																	<span class="small"><i class="fas fa-arrow-up float-right"  title="Move Up" (click)="selUp(i)"></i></span>
																	<span class="small"><i class="fas fa-arrow-down float-right" title="Move Down" (click)="selDown(i)"></i></span>
																	<span class="small"><i class="far fa-trash-alt float-right"  title="Remove" (click)="selRemove(i)"></i></span>
																	</div>
																</ng-container>
															</div>
															<!--<a href="javascript:void(0)" (click)="clearOpItem()">Clear</a>-->
														</ng-container>
														<label *ngIf="missingSlot==true" style="color: red; width:100%; font-size:.8em">&nbsp;{{missingSlotMessage}}</label>
														 <!--<a style="cursor: pointer; font-size: 16px;" title="Add Tag" (click)='op2.hide();'>
                                                            <i class="pi pi-plus-circle" style="margin: 5px;"></i>
                                                        </a>-->
														<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createSlot($event, op2);">Save</button>
														<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4"  (click)="createSlot($event);">Save and Create New</button>	
			                                           
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
		</div>
    </ng-template>
	
    <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr style="font-size:12px"><!-- [pSelectableRow]="rowData" -->
            <td  style="background-color:rgb(28, 36, 51)">
                <a href="#" [pRowToggler]="rowData">
                    <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                </a>
            </td>
            <td *ngFor="let col of columns"  style="padding:6px; background-color:rgb(28, 36, 51)"  [ngStyle]="{'width': col.width}">
				<ng-container *ngIf="col.field=='CATEGORY'">
					{{rowData[col.field]}}
					<span *ngIf="rowData.TOTAL_SLOTS">( {{ rowData.TOTAL_TEMPLATE_SLOTS}} /{{rowData.TOTAL_SLOTS}}  )</span>
					<label *ngIf="rowData.CATEGORY=='ERIS Data'" class="ml-1 mr-1" style="color:rgb(195,212,47)">Order No: </label>
					<input *ngIf="reportInfo&&rowData.CATEGORY=='ERIS Data'" type="text" [disabled]="reportInfo.ORDER_NUM?.length>0" style="font-size:.9em; width:100px" [value]='reportInfo.ORDER_NUM'>
					<i *ngIf="reportInfo&&reportInfo.ORDER_NUM?.length==0&&rowData.CATEGORY=='ERIS Data'" class="fas fa-check iconBtn" (click)="addOrder($event)"></i>
					
				</ng-container>               
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="cols3">
        <tr>
            <td [attr.colspan]="cols2.length + 1" style="padding:0 20px; background-color:rgb(28, 36, 51)">
				<!--<ng-container *ngFor="let r of rowData.RW_TEMPLATE_SLOTS; trackBy:trackByFuntion">
					<div class="card" style="margin:10px 0"> 
						<div class="row"  style="width:100%; padding:0 0 0 16px;">
						
							<label style="width:85%; margin-top:8px;color:rgb(195,212,47);">{{r.KEY}}<span style="color:#04B486; margin:0 2px">({{r.TYPE}})</span>
							<i *ngIf="r.SYSTEM_IND=='Y'" class="fas fa-globe"></i>
							<i *ngIf="r.SYSTEM_IND=='N'" class="fas fa-cog"></i>
							<span *ngIf="r.STATUS!='Active'" class="inaciveMsg">{{r.STATUS}}</span></label>
							<a *ngIf="r.TYPE!='PDF'&&r.TYPE!='Selection'" href="javascript:void(0)" [ngStyle]="{'color':r.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op13.toggle($event);"><i class="fas fa-eye"></i></a>
							<a *ngIf="r.TYPE!='PDF'&&r.TYPE=='Selection'" href="javascript:void(0)" [ngStyle]="{'color':r.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op13.toggle($event);"><i class="far fa-list-alt"></i></a>
							<a  *ngIf="addLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'&&r.STATUS=='Active'" href="javascript:void(0)" style="width:5%; margin-top:2px" title="Add to Doc" (click)="addRepeat('slot', r)"><i  class="fas fa-arrow-right"></i></a>
							<a *ngIf="addLibShow&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'&&r.STATUS=='Active'"  href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('newLib', r)"><i class="fas fa-arrow-right"></i></a>		
							
							<p-overlayPanel #op13 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(r.TYPE, r)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{r.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{r.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{r.TYPE}}</span><br>
														<strong *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">Content : </strong> 
														
														<div *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')&&(r.TYPE!='File')">
															<textarea  style="width:100%" rows="3"  [value]="r.CONTENT">
															</textarea>
															<button *ngIf="r.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-md-right btn-op" (click)="updateSlotContent($event,rowData);op13.hide();">Update</button>
			                                           </div>
													   <div *ngIf="r.TYPE=='File'">
															<a [href]="r.CONTENT" style="width:100%; word-break:break-all" target=_blank>{{r.FILE_NAME}}</a>
														</div>
														<div *ngIf="r.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="r.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Selection )</span><span *ngIf="r.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Selection ) </span><br>
														
															<ng-container *ngFor="let item of tableContent; let s=index">
																<div>
																	<input type="checkbox" [checked]="tableContent1.indexOf(item)>-1" (click)="selOP($event, item,r.MULTIPLE_CHOICE)">
																	<span style="color:white">{{item}}</span> 
																</div>
															</ng-container>
															<button *ngIf="r.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-md-right btn-op" (click)="updateSlotContent($event,r);op13.hide();">Update</button>
														
														</div>
														<div *ngIf="r.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="width:90%; border: 1px solid black;  border-collapse: collapse;color:white">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
											
						
					</div><span>{{r.SHORT_CONTENT}}</span>
					</div>
				</ng-container>-->
				<ng-container *ngFor="let r of rowData.RW_SLOTS; trackBy:trackByFuntion">
					<div *ngIf="r.STATUS=='Active'"class="card" style="margin:10px 0; "> 
						<div  class="row"  style="width:100%; padding:0 0 0 16px;">
							<label style="width:85%; margin-top:8px;color:rgb(195,212,47);">{{r.KEY}}<span style="color:#04B486; margin:0 2px">({{r.TYPE}})</span>
							<i *ngIf="r.SYSTEM_IND=='Y'" class="fas fa-globe"></i>
							<i *ngIf="r.SYSTEM_IND=='N'" class="fas fa-cog"></i>
							<span *ngIf="r.STATUS!='Active'" class="inaciveMsg">{{r.STATUS}}</span></label>
							<a *ngIf="r.TYPE!='PDF'&&r.TYPE!='Selection'" href="javascript:void(0)" [ngStyle]="{'color':r.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op14.toggle($event);"><i class="fas fa-eye"></i></a>
							<a *ngIf="r.TYPE!='PDF'&&r.TYPE=='Selection'" href="javascript:void(0)" [ngStyle]="{'color':r.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op14.toggle($event);"><i class="far fa-list-alt"></i></a>
							<a  *ngIf="addLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'&&r.STATUS=='Active'" href="javascript:void(0)" style="width:5%; margin-top:2px"  title="Add to Doc" (click)="addRepeat('slot', r)"><i class="fas fa-arrow-right" ></i></a>
							<a *ngIf="addLibShow&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'&&r.STATUS=='Active'"  href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('newLib', r)"><i class="fas fa-arrow-right"></i></a>		
							<p-overlayPanel #op14 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(r.TYPE, r)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{r.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{r.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{r.TYPE}}</span><br>
														<strong *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">Content :</strong> 
														<!--<span *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">{{r.CONTENT}}</span>-->
														<div *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')&&(r.TYPE!='File')">
															<textarea  style="width:100%" rows="3"  [value]="r.CONTENT">
															</textarea>
															<button *ngIf="r.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-md-right btn-op" (click)="updateSlotContent($event,r);op14.hide();">Update</button>
			                                           </div>
													   <div *ngIf="r.TYPE=='File'">
															<a [href]="r.CONTENT"  style="width:100%; word-break:break-all" target=_blank>{{r.FILE_NAME}}</a>	
														</div>
														<div *ngIf="r.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="r.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Selection )</span><span *ngIf="r.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Selection ) </span><br>
													
															<ng-container *ngFor="let item of tableContent; let s=index">
																<div>
																	<input type="checkbox" [checked]="tableContent1.indexOf(item)>-1" (click)="selOP($event, item,r.MULTIPLE_CHOICE)">
																	<!--<input *ngIf="r.MULTIPLE_CHOICE=='Y'" type="checkbox" [checked]="tableContent1.indexOf(item)>-1" (click)="selOP($event, item,r.MULTIPLE_CHOICE)">
																	<input *ngIf="r.MULTIPLE_CHOICE=='N'" type="radio" name="selection" [checked]="tableContent1.indexOf(item)>-1" (click)="selOP($event, item,r.MULTIPLE_CHOICE)">-->
																	<span style="color:white">{{item}}</span> 
																</div>
															</ng-container>
															<button  *ngIf="rowData.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-md-right btn-op" (click)="updateSlotContent($event,r);op14.hide();">Update</button>
															
														</div>
														<div *ngIf="r.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="color:white; width:90%; border: 1px solid black;  border-collapse: collapse;">
															<thead>
																<tr>
																<th>No.</th>
																<th>H</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
							
						
					</div><span>{{r.SHORT_CONTENT}}</span>
					</div>
				</ng-container>
				
            </td>
           
        </tr>
    </ng-template>
</p-table>
</div>
</div>
<div id="lib" class="container tab-pane fade" style="padding:0; color:white">
	<label class="radio-inline ml-3">
		<input type="radio" name="libs" [checked]="libGroup=='D'" (change)="selLibGroup('D')"> 
		 Section Assigned 
	</label>		
	<label class="radio-inline ml-3"> 
		<input type="radio" name="libs" [checked]="libGroup=='A'" (change)="selLibGroup('A')">
		All
	</label>
<!--<div *ngIf="definedLibGroup.length>0">
	<label class="group-title">Defined</label>
	<a href="javascript:void(0)" class="m-3" (click)="selLibGroup('D')"><i *ngIf="libGroup!='D'" class="fas fa-chevron-down"></i><i *ngIf="libGroup=='D'" class="fas fa-chevron-right"></i></a><br>-->
	<div [ngStyle]="{'display':libGroup=='D'?'block':'none'}"  class="fixTable">		
		<p-table #dt6 [value]="definedLibGroup" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','CONTENT']"  (onFilter)="onFilter($event, dt6)">
			<ng-template pTemplate="body" let-rowData>
					<tr>
						<td style="background-color:rgb(28, 36, 51)">
							<div class="card"> 						
								<div class="row">
								<p style="width:80%; margin-left:16px;color:rgb(195,212,47);">{{rowData.ITEM_TITLE}} <span *ngIf="rowData.STATUS!='Active'" class="inaciveMsg">({{rowData.STATUS}})</span></p>
								<!--<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Instruction" (click)="op.toggle($event);"><i class="fas fa-info-circle"></i></a>-->
								<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op.toggle($event)"><i class="fas fa-eye"></i></a>					
								<a *ngIf="rowData.STATUS=='Active'" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('lib', rowData)"><i *ngIf="addLib" class="fas fa-arrow-right"></i></a>		
								</div>
								<span>{{rowData.SHORT_CONTENT}}</span>
								<p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '600px'}" (onShow)="getSftContent(rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<h6>{{rowData.ITEM_TITLE}}</h6>
													<ng-container *ngFor="let label of rowData.LABELS.split(';')">
														<label class="tag">{{label}}</label>
													</ng-container>
													<div>
														<strong>Instruction : </strong>
														<span style="color:white">{{rowData.INSTRUCTIONS}}</span>
													</div>
													<div>
														<strong>Content : </strong>
														<span *ngIf="!rowData.CONTENT_HTML||rowData.CONTENT_HTML?.length==0" style="color:white">{{rowData.CONTENT}}</span>
														<div *ngIf="rowData.CONTENT_HTML?.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="rowData.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
													</div>
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>
	</div>
	<!--</div>
	<label class="group-title">All</label>
	<a href="javascript:void(0)" class="m-3" (click)="selLibGroup('A')"><i *ngIf="libGroup!='A'" class="fas fa-chevron-down"></i><i *ngIf="libGroup=='A'" class="fas fa-chevron-right"></i></a><br>-->
	<div  [ngStyle]="{'display':libGroup=='A'?'block':'none'}"  class="fixTable">
		<p-table #dt2 [value]="libraries" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','LABELS']"  (onFilter)="onFilter($event, dt2)">
			
				<ng-template pTemplate="caption">
					
						<div style="display:inline-block; padding:0">   
							<!--<p-dropdown [options]="libLabels"  placeholder="Identifier" [style]="{'width':'120px','minWidth':'80px', 'minHeight':'26px', 'height':'30px'}" (onChange)="dt2.filter($event.value, 'LABELS', 'contains')"  [showClear]="true"></p-dropdown>-->
							<select style="margin-bottom:2px;margin-top:4px; width:90px;min-width:50px; font-size:14px; background-color:rgb(28, 36, 51); color:#ccc" (change)="filterLibs($event)">
						<option value="">Identifier
						</option>
						<ng-container *ngFor="let label of libLabels">
						<option [value]="label.value">{{label.value}}
						</option>
						</ng-container>
						</select>
						</div>
						<div style="float: right; display:inline-block">
							<i class="pi pi-refresh" style="margin-right: 20px " pTooltip="Reload Libraries" (click)='refreshLibs()'></i>
							<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47);display:inline"></span>								
							<!--<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="8" placeholder="Filter" (input)="dt2.filterGlobal($event.target.value, 'contains')" style="width:auto">-->
							<input type="text" pInputText size="10" placeholder="Filter" (change)="filterLibs($event)" style="width:auto">
							<i class="pi pi-search" style="margin:4px 4px 0 0" (click)='filterLibs($event)'></i>	
							<a href="javascript:void(0)" style="cursor: pointer; font-size: 16px;" title="Add Libraries" (click)="toNewLib();"><!--data-toggle="modal" data-target="#createLibModal" -->
								<i class="pi pi-plus" style="margin: 5px;"></i>
							</a>							
						</div>
				
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr *ngIf="rowData.STATUS=='Active'">
						<td style="background-color:rgb(28, 36, 51)">
							<div class="card"> 						
								<div class="row">
								<p style="width:80%; margin-left:16px;color:rgb(195,212,47);">{{rowData.ITEM_TITLE}} <span *ngIf="rowData.STATUS!='Active'" class="inaciveMsg">({{rowData.STATUS}})</span></p>
								<!--<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Instruction" (click)="op.toggle($event);"><i class="fas fa-info-circle"></i></a>-->
								<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op1.toggle($event);"><i class="fas fa-eye"></i></a>					
								<a *ngIf="rowData.STATUS=='Active'" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('lib', rowData)"><i *ngIf="addLib"class="fas fa-arrow-right"></i></a>		
								</div>
								<span>{{rowData.SHORT_CONTENT}}</span>
								<!--<p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '800px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto"> 
											<h6>{{rowData.ITEM_TITLE}}</h6>
											<hr>
											<div>
												<strong>Instruction : </strong>{{rowData.INSTRUCTIONS}}
											</div>										
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>-->
								<p-overlayPanel #op1 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '600px'}" (onShow)="getSftContent(rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<h6>{{rowData.ITEM_TITLE}}</h6>
													<ng-container *ngFor="let label of rowData.LABELS.split(';')">
														<label class="tag">{{label}}</label>
													</ng-container>
													<div>
														<strong>Instruction : </strong>
														<span style="color:white">{{rowData.INSTRUCTIONS}}</span>
													</div>
													<div>
														<strong>Content : </strong>
														<span *ngIf="!rowData.CONTENT_HTML||rowData.CONTENT_HTML.length==0" style="color:white">{{rowData.CONTENT}}</span>
														<div *ngIf="rowData.CONTENT_HTML&&rowData.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="rowData.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
													</div>
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
							</div>
										
						</td>
					</tr>            
				</ng-template>
	
			</p-table>
	</div>
</div>
<div  *ngIf="reportInfo?.PCA_INDICATOR=='Y'||reportInfo?.PCA_INDICATOR=='4099e'||reportInfo?.PCA_INDICATOR=='frm1105'" id="pca" class="container tab-pane fade" style="padding:0; color:white">
	<div class="pca">
		<label>Short Term</label>
		<select [disabled]="PCAEditable=='N'" [disabled]="reportInfo.PCA_INDICATOR=='4099e'" [(ngModel)]="pcaOp.term" (change)="setCostTableTitle()">
			<option>Include</option>
			<option>Exclude</option>
		</select>
		<label>Cost Table Multiplier</label>
		<select [disabled]="PCAEditable=='N'" [(ngModel)]="pcaOp.multiplier" (change)="changeUnit()">
			<option></option>
			<option *ngFor="let item of multipliers" [value]="item.LABEL">{{item.LABEL}}</option>
		</select><span *ngIf="pcaOp.multiplier.length==0" style="color:red">*</span>
		<label>Quantity for Cost Table Multiplier</label>
		<input [disabled]="PCAEditable=='N'" [(ngModel)]="pcaOp.quantity" min="0"   max="1000000000" type="number" (blur)="changeFactor(pcaOp.quantity,'quantity')"/>
		<span *ngIf="pcaOp.quantity==0" style="color:red">*</span>
		<label>Reserve Term</label>
		<input *ngIf="reportInfo?.PCA_INDICATOR!='4099e'&&reportInfo?.PCA_INDICATOR!='Y'" id="reserveInput" [disabled]="PCAEditable=='N'||reportInfo?.PCA_INDICATOR=='frm1105'||rptUser.length>1" [value]="pcaOp.reserve" min="1"   max="30" title="usually 10 or 12" type="number"/>
		<input *ngIf="reportInfo?.PCA_INDICATOR=='Y'" id="reserveInput" style="width:30%" [disabled]="PCAEditable=='N'||rptUser.length>1" [value]="pcaOp.reserve" min="1"   max="30" title="usually 10 or 12" type="number"/>
		<input *ngIf="reportInfo?.PCA_INDICATOR=='4099e'" id="reserveInput" style="width:30%" [disabled]="PCAEditable=='N'||rptUser.length>1" [value]="pcaOp.reserve" min="1"   max="15" title="usually 10 or 12" type="number"/>
		<button *ngIf="reportInfo?.PCA_INDICATOR=='4099e'||reportInfo?.PCA_INDICATOR=='Y'" type="button" [disabled]="rptUser.length>1" class="btn btn-outline-light btn-sm sm-btn" style="width:9%; margin-left: 4px; margin-bottom: 3px;" (click)="changeReserve('reserve', $event)">Save</button>
		<i *ngIf="rptUser.length>1&&(reportInfo?.PCA_INDICATOR=='4099e'||reportInfo?.PCA_INDICATOR=='Y')" class="fas fa-info-circle iconBtn" title="Editing the Reserve Term should only be done when in Single User Mode."></i>
		<label>Effective Age of Property</label>
		<input [disabled]="PCAEditable=='N'||reportInfo.PCA_INDICATOR=='4099e'"  [(ngModel)]="pcaOp.age" min="0"   max="1000" type="number" (blur)="changeFactor(pcaOp.age, 'age')"/>
		<hr class="line mt-4 mb-4">
		<label>Display Decimal Places</label>
		<select  [(ngModel)]="pcaOp.decimal" disabled>
		<option *ngIf="reportInfo.PCA_INDICATOR!='4099e'">0</option>
		<option>2</option>
		</select>
		<label>Round Options</label>
		<select  [(ngModel)]="pcaOp.round" disabled>
		<option>Round</option>
		<option>Round Up</option>
		<option>Round Down</option>
		</select>
		<hr class="line mt-4 mb-4">
		<label>Currency to be used for Calculations</label>
		<select [disabled]="PCAEditable=='N'" [(ngModel)]="pcaOp.currency" (change)="autoSave('PCA Factor Update','PCA','PCA Factor Update');">
			<option *ngFor="let item of currencies" [value]="item.CURRENCY">{{item.CURRENCY}}</option>
		</select>
		<label>Inflation Rate</label>
		<select [disabled]="PCAEditable=='N'||reportInfo?.PCA_INDICATOR=='frm1105'" (change)="setInflation($event)">
		<option *ngIf="reportInfo?.PCA_INDICATOR!='4099e'" value='2.5' [selected]="pcaOp.inflation==2.5">2.5%</option>
		<option value='3'  [selected]="pcaOp.inflation==3">3%</option>
		</select>
		<hr class="line mt-4 mb-4">
		<table *ngIf="reportInfo?.PCA_INDICATOR=='Y'" style="width:95%; border: 1px solid black;  border-collapse: collapse;font-size:12px; color:white; margin-top:10px">
				<thead>
					<tr>
						<th style="width:70%;color:rgb(195,212,47);">Item</th>
						<th style="width:30%;color:rgb(195,212,47);">Result</th>																
					</tr>
				</thead>
					<tbody>
						<tr>
							<td>Short Term Costs</td>
							<td>{{currSign}}{{totalCost[0]}}</td>								
						</tr>
						<!--<tr>
							<td>Short Term Inflated Costs</td>
							<td>{{currSign}}{{totalCost[1]}}</td>								
						</tr>-->
						<tr>
							<td>Immediate Costs</td>
							<td>{{currSign}}{{totalCost[2]}}</td>								
						</tr>
						<!--<tr>
							<td>Immediate Inflated Costs</td>
							<td>{{currSign}}{{totalCost[3]}}</td>								
						</tr>-->
						<tr>
							<td>Reserve Uninflated Costs</td>
							<td>{{currSign}}{{totalCost[4]}}</td>								
						</tr>
						<tr>
							<td>Reserve Uninflated Costs / {{pcaOp.multiplier}}/ Year</td>
							<td>{{currSign}}{{totalCost[5]}}</td>								
						</tr>
						<tr>
							<td>Reserve Inflated Costs</td>
							<td>{{currSign}}{{totalCost[6]}}</td>								
						</tr>
						<tr>
							<td>Reserve Inflated Costs / {{pcaOp.multiplier}}/ Year</td>
							<td>{{currSign}}{{totalCost[7]}}</td>								
						</tr>
						
						
					</tbody>
				</table>
				
	</div>
	<hr class="line mt-3 mb-1">
	<input type='checkbox' [(ngModel)]='onlyCost' (change)="getParent($event)">	
	<label class="savedLabel ml-1">Show me the Cost Recommendations</label>
	<div>	
	
	</div>
</div>
</div>
	
	
</div>
<div id="editPanel" class="col-md-7 editContainer">
<a class="btn hidebtn btn-sm p-1" style="z-index:1000; position:absolute; right:0; top:0" (click)="toolPanelToggle($event)"><i class="fas fa-angle-double-right" style="pointer-events: none;"></i></a>
<div class="tool sticky-top row p-0">
<button class="btn btn-black btn-sm mr-1" title="Portrait" [ngStyle]="{'border':selectpage.type==='portrait'? '1px solid yellow':'none'}" (click)="selectPage('portrait')"><i class="fas fa-arrows-alt-v"></i>
</button>
<button class="btn btn-black btn-sm mr-1" title="Landscape" [ngStyle]="{'border':selectpage.type==='landscape'? '1px solid yellow':'none'}" (click)="selectPage('landscape')"><i class="fas fa-arrows-alt-h"></i>
</button>
<button class="btn btn-black btn-sm mr-1" title="Margin" data-target='#marginModal' data-toggle="modal"><i class="fas fa-arrows-alt"></i>
</button>
<button class="btn btn-black btn-sm mr-1" title="Preview" data-target='#preModal' data-toggle="modal"  (click)="preShow=true"><i class="far fa-eye"></i>
</button>
<button class="btn btn-black btn-sm mr-1" title="Hide Hidden Section" [ngClass]="{'active':hideSection}" (click)="hideSection=!hideSection"><i class="fas fa-eye-slash"></i>
</button>	
<div style="font-size:.8em; padding-top:2px">
		<label class="m-1"  style="color:rgb(195,212,47); font-weight:bold">ERIS Order No: </label>
		<a *ngIf="reportInfo?.ORDER_NUM?.length>0&&erisPdfs&&erisPdfs.length>0" [ngStyle]="{'color':erisUpdated?'#F78181':'rgb(195,212,47)'}" href="javascript:void(0)" (click)="updateOrder($event)">{{reportInfo?.ORDER_NUM}}
			<p-overlayPanel #op120 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="false" [style]="{width: '200px'}">
                <ng-template pTemplate>
					<ng-container *ngFor="let pdf of erisPdfs;">
						<a [href]="pdf.REPORT_URL" target=_blank style="color:rgb(195,212,47); font-size:.8em; margin:2px">{{pdf.REPORT_NAME}}</a><br>
					</ng-container>					
				</ng-template>
            </p-overlayPanel>	
		</a>
		<label *ngIf="reportInfo?.ORDER_NUM?.length>0&&erisPdfs&&erisPdfs.length==0" style="color:white; font-size:.8em; margin:2px">{{reportInfo?.ORDER_NUM}}
		</label>
		<input *ngIf="reportInfo?.ORDER_NUM?.length==0||editOrder" type="text" style="width:100px; padding:0 4px" [value]='reportInfo?.ORDER_NUM'>
		<i *ngIf="reportInfo&&reportInfo.ORDER_NUM?.length==0||editOrder" class="fas fa-check iconBtn" (click)="addOrder($event)"></i>
		<i *ngIf="reportInfo&&reportInfo.ORDER_NUM?.length>0&&!editOrder" class="far fa-edit iconBtn" (click)="editOrder=!blockMultiUser()"></i>
		<i *ngIf="erisUpdated" class="fas fa-exclamation-triangle iconBtn" style="color:#F78181" (click)="updateEris()"></i>
		<i *ngIf="toUpdatedEris.length>0" class="fas fa-exclamation-triangle iconBtn" title="New ERIS Product table is ready to use &#013;Click to refresh your report" style="color:#FE9900" (click)="updateErisTables()"></i>
		
</div>
<a title='Find & Replace' class="ml-3 spellIcon" [ngClass]="{'spellOn':replaceShow,'spellOff':!replaceShow}" (click)="replaceToggle();"><i class="fas fa-search"></i></a>
	

<!--<div  (click)="curId=null;">
	<a title='Case Sensitive' class="ml-3 spellIcon" [ngClass]="{'spellOn':caseOn,'spellOff':!caseOn}" (click)="caseOn=!caseOn"><img  style='height:24px; width:18px' src="/assets/images/case-sensitive.svg"></a>
	<i (click)='op105.show($event);selectedCell=null; curId=null;' class="fas fas fa-angle-down iconBtn" title="To Replace"></i>
	<input [(ngModel)]="searchText" type="search" placeholder="Search String" style="width:160px; font-size: 12px;padding:2px; margin-left: 4px;">
	<p-overlayPanel #op105 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [style]="{'width': '300px'}">
		<ng-template pTemplate>                                                    
			<div style="width:290px">
				<input width="260px" maxlength="20" style="width:150px" [(ngModel)]="replaceText"><button class="btn btn-black btn-small ml-3 toolBtn p-1" (click)="replaceSingle()">Replace</button>
				<button class="btn btn-black btn-small ml-3 toolBtn p-1" (click)="replaceAll()">Replace All</button>
			</div>
		</ng-template>
		</p-overlayPanel>
		<a class="btn btn-black btn-sm p-0" (click)="findPrev()"><i class="fas fa-arrow-down fa-sm"></i></a>
		<a class="btn btn-black btn-sm p-0" (click)="findNext()"><i class="fas fa-arrow-up fa-sm"></i></a>
</div>
<a title='Turn On/Off Spelling Check' class="mr-2 ml-2 spellIcon" [ngClass]="{'spellOn':checkOn,'spellOff':!checkOn}" (click)="spellCheck()"><img style='height:24px; width:18px' src="/assets/images/spell-check.svg"></a>
--><a title='Spell Check Whole Report Excludes !@#$%^&*()+=\[\]{}:\\|<>\/?~.' class="mr-2 ml-2 spellIcon spellOn" [ngClass]="{'spellOn':checkOnAll,'spellOff':!checkOnAll}" (click)="spellCheckAll()"><img style='height:24px; width:24px' src="/assets/images/spell-check.png"></a>
	
	
</div>
<a *ngIf="selectedCover.COVERPAGE_ID" class="sticky-right btn btn-outline-success btn-sm" style="top:260px" [ngClass]="{'disabled':erisShow||allowAdd!='Y'}" title="Sign The Cover Page" (click)='editCoverSign()'><i class="fas fa-file-signature"></i></a>
<a class="sticky-right btn btn-outline-success btn-sm" [ngClass]="{'disabled':erisShow}" title="Save Report" (click)='autoSave("manual save")'><i class="far fa-save"></i></a>
<div class="pageContainer">
<div class="example-list"  #viewer [style.width.px]="selectpage.size.width" [style.min-height.px]="selectpage.size.height"><!-- [style.height.px]="selectpage.size.height"-->
	<div *ngIf="matchShow" class="lib-box2" cdkDrag>
		<ng-container *ngIf="!spellCheckErr">
			<span *ngIf="!checking&&allMatch>0" class="spellmsg">Spelling Errors Underlined Below in Red</span>
			<span *ngIf="!checking&&allMatch==0" class="spellmsg1">Spelling Check Complete - No Errors Found</span>
			<span *ngIf="checking" class="spellmsg1">Spell Check is Currently Running</span> 
			<span *ngIf="checking" class="fa fa-spinner fa-spin ml-2" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span>
		</ng-container>
		<span *ngIf="spellCheckErr" class="spellmsg">{{spellCheckErr}}</span>		
	</div>
	<div *ngIf="replaceShow" class="lib-box1" cdkDrag [cdkDragDisabled]="dragDisabled">
		<i class="iconBtn far fa-window-close mr-3 mt-2 float-right" style="float:right" (click)="replaceShow=false;"></i>
		<div  style="display: flex; flex-flow: row wrap; justify-content: start;">
			<!--<i (click)='replaceShow1=!replaceShow1;selectedCell=null; curId=null;' class="fas fas fa-angle-down iconBtn" title="To Replace"></i>-->
			<input type='search' width="260px" maxlength="100" placeholder="Find" style="width:150px; margin-left: 10px" [(ngModel)]="searchText" (keydown)="replaceCheck()">
			<a title='Match Case' class="ml-3 spellIcon" [ngClass]="{'spellOn':caseOn,'spellOff':!caseOn}" (click)="caseOn=!caseOn"><img  style='height:24px; width:18px' src="/assets/images/case-sensitive.svg"></a>
			<a title='Find Next' class="btn btn-black btn-sm p-0 m-1" (click)="findNext()"><i class="fas fa-arrow-down fa-sm"></i></a>
			<a title='Find Previous' class="btn btn-black btn-sm p-0 m-1" (click)="findPrev()"><i class="fas fa-arrow-up fa-sm"></i></a>			
		</div>
		<div style="display: flex; flex-flow: row wrap; justify-content: start;">
			<input type='search' width="260px" maxlength="100" placeholder="Replace" style="width:150px; margin-left: 10px;" [(ngModel)]="replaceText" (keydown)="replaceCheck()">
			<button class="btn btn-black btn-small ml-3 toolBtn p-1" (click)="replaceSingle()">Replace</button>
			<button class="btn btn-black btn-small ml-3 toolBtn p-1" (click)="replaceAllText()">Replace All</button>
			<span *ngIf="replacing"  class="fa fa-spinner fa-spin ml-2" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span>
		</div>
	</div>
	<div *ngIf="addLibShow" id="lib-box" class="lib-box" cdkDrag [cdkDragDisabled]="dragDisabled">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.9em"> 
			<div style="width: 500px; margin: 10px; padding-right:0; color:white;"> 
														<h6>Add Library</h6>
														<hr>
														<label class="col-md-3">Title: </label>
														<input class="col-md-7 ml-2" type="text" id="libTitle" /><span style="color:red">*</span>
														<br>
														<label class="col-md-3">Identifier: <i class="fas fa-info-circle iconBtn" (click)="op302.toggle($event)"></i>
														</label>
														<input type="text" class="col-md-7  ml-2" id="libLabel" placeholder="separate your identifier by ;"/>
														<button (click)="getLibLabels(); op301.toggle($event);"><i class="fas fa-chevron-down" style="pointer-events:none; color:#C2D63F"></i></button>
														<i class="fas fa-plus iconBtn" (click)="addLabel($event)"></i>
														<p-overlayPanel #op301 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
															<ng-template pTemplate>
																<div style="margin:0; max-height:400px; padding:4px; width:220px; overflow:auto">
																	<ng-container *ngFor="let label of libLabels; trackBy: trackByFuntion">
																		<div class="listItem2" style="margin:0; width:180px; border:1px ridge black" >
																			<a href="javascript:void(0)" style="color:rgb(195,212,47); font-size:.8em; margin:2px" (click)="addToIden(label.label, 'libLabel')">{{label.label}}</a><br>
																		</div>
																	</ng-container>
																</div>																
															</ng-template>
														</p-overlayPanel>
														<p-overlayPanel #op302 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '420px'}">
															<ng-template pTemplate>
																<div style="max-height:400px; padding:0; width:380px; overflow:auto;">
																	<ul>
																		<li class="instr">You may select multiple Identifiers from the dropdown list.</li>
																		<li class="instr">If the Identifier required is not in the dropdown list, you may create a new one by typing it into the “Identifier” field (under the “Title” field).</li>
																	</ul>
																</div>																
															</ng-template>
														</p-overlayPanel>
														<div  class="col-md-2"></div>
														<div class="col-md-9 ml-2">
															<ng-container *ngFor="let label of inputLabels.split(';') let i=index; trackBy:trackByFuntion">
																<label *ngIf="label.trim().length>0" class="tag">{{label}}<i class="fas fa-times iconBtn" (click)='removeLabel(i)'></i></label>
															</ng-container>
														</div>
														<label class="col-md-5">Instruction: </label>
														<div class="ml-3 mr-4 ckContainer"   style="min-height:150px; max-height:200px; overflow-y:auto; cursor:auto">
															<app-paragraph [srcViewer]="'N'" [editorType]="'lite'" [content]="newLibPara[4]" (outText)="libPara2($event, 0)"  (onExit)="libPara1($event, 1)"  (mouseleave)='dragDisabled=false' (mouseenter)="dragDisabled=true"></app-paragraph>
														</div>
														<label class="col-md-2">Content: </label>
														<div class="ml-3 mr-4 ckContainer"  style="min-height:150px; max-height:250px; overflow:auto; cursor:auto">
															<app-paragraph [srcViewer]="'Y'" [editorType]="'lite'" [content]="newLibPara[5]" [addedSlot]="addedItem" (outText)="libPara2($event, 2)" [getText]="itemIndex" (onExit)="libPara1($event, 3)"  (mouseleave)='dragDisabled=false' (mouseenter)="dragDisabled=true;"></app-paragraph>
														</div>
														<button  class="btn btn-outline-light rf-btn ml-1" (click)="showSlots(); addSlotPrep('new') ">Repeat Fields</button>		
																												
														
														<span *ngIf="addLibWarn" style="color:red">* Title not valid</span>	
														<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createLibrary($event, 'new');">Save</button>
														<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createLibrary($event);">Save and Create New</button>				                                           
														<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="addLibShow=false">Cancel</button>															
								
												   </div>
		</div>					
	</div>
	<div *ngIf="headerShow" id="task-box" class="task-box"  style="width:710px" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em;"> 
		<label>Header Content</label>
		<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="headerShow=false; closeCol()"></i>
		<div *ngIf="curSec" class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:450px; overflow:auto; cursor:auto">
			<app-paragraph [addedSlot]="curSec.addedItem"  class="docItem" [users]="curCol.tcusers" [suggests]="curCol.suggestions" [comments]="curCol.comments" [content]="curCol.NAME" [getText]="curSec['reqIndex']"  (selected)="selectedRow=-1;getPosition(curSec, $event);addLib=true; selectedEditor='C'" (onExit)='colData($event, curSec.id)' (outText)="colText($event)" (rfSelected)="selectedRF($event)" (onTrackChange)="colSuggest($event, curSec.id)" (selected)="logUsers(curSec.id, curSec.SECTION_TITLE)"></app-paragraph>
		</div>
		<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCol(curSec.id);headerShow=false">Save</button>
	</div>					
	</div>
	<div *ngIf="cellShow" id="task-box" class="task-box"  style="width:710px;" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em;"> 
		<label>Cell Content</label>
		<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="cellShow=false; closeCell()"></i>
		<div class="cplabel">
		<label>Background:</label>
		<input class="cpicker"				
       [style.background]="curCell.bkcolor"
       [(colorPicker)]="curCell.bkcolor"/>
	   <input type="checkbox" [(ngModel)]="allCol">Apply to Entire Column
	   <input type="checkbox" [(ngModel)]="allRow">Apply to Entire row
	  <!-- <label>Font Color:</label>
		<input class="cpicker" 
       [style.background]="curCell.fcolor"
       [(colorPicker)]="curCell.fcolor"/>
	   <input type="checkbox">Apply to Entire Column
	   <input type="checkbox">Apply to Entire row-->
	   <ng-container *ngIf="(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)">
		<a class="btnRound1" [ngStyle]="{'color':(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)?'#c2d63e':'#999','border-color':(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" style='float:none; margin-left: 60px;' (click)="op0.toggle($event)">Field Options</a>
							<p-overlayPanel #op0 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
								<ng-template pTemplate>
									<div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
										<h6>Choose Field Value(s)</h6>
											<!--<input type="text" class="col-md-6" placeholder="Input your Field Options here"/>
											<i class="fas fa-plus iconBtn" title="Add Item to Action" (click)="addFOItem($event, item)"></i>-->
											<div *ngIf='curCol.FO&&curCol.FO.length>0' class="col-md-10">
												<ng-container *ngFor="let label of curCol.FO; let i=index; trackBy:trackByFuntion">
													<label class='mr-2'*ngIf="label.trim().length>0">{{label}}<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItem(label)'></i></label><br>
												</ng-container>
											</div>
											<ng-container *ngIf="curCol.DefaultFO&&curCol.DefaultFO.html">
												<p class="savedLabel">Default Value:</p>
												<div style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="curCol.DefaultFO.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div><br>
												<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItem(curCol.DefaultFO)'></i>						
											</ng-container>
									</div>
								</ng-template>
							</p-overlayPanel>
   </ng-container>
	   </div>
		<div *ngIf="curSec" class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:160px; max-height:460px; overflow:auto; cursor:auto;">
			<app-paragraph [addedSlot]="curSec.addedItem"  class="docItem" [users]="curCell.tcusers" [suggests]="curCell.suggestions" [comments]="curCell.comments" [content]="curCell.htmltext" [getText]="curCell['reqIndex']"  (selected)="selectedRow=-1;addLib=true; selectedEditor='C'" (onExit)='cellData($event, curSec.id)'  (rfSelected)="selectedRF($event)" (onTrackChange)="cellSuggest($event, curSec.id)" (outText)="curCell.data=$event" ></app-paragraph>
			<button  [ngClass]="{'hasLibs':curCell.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;filteredData=null;selectedRow=-1; selectedEditor='C';showSavedLib(curCell.libs);op42.toggle($event);">Libraries</button>
			<button  [ngClass]="{'hasLibs':curCell.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; filteredData=null;selectedRow=-1; selectedEditor='C';showsavedSlot(curCell.slots)">Repeat Fields</button>					
			<!--<button  class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; getPosition(curSec.id, $event); filteredData=null;selectedRow=-1;addCheck()">Check Mark</button>-->					
			<p-overlayPanel #op42 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; max-height: 300px; overflow:auto; margin:0; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<ng-container *ngFor="let item of curCell.libs; trackBy:trackByFuntion"> 
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op421.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
					
					<p-overlayPanel #op421 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> {{item.COST}}
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</ng-container>										
				</div>
				</ng-template>
			</p-overlayPanel>
		</div>
		<span *ngIf="cellsaveErr" style="color:orange; margin-top: 4px;">Saving not Successful, Please try again!</span><button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCell(curSec.id)">Save</button>
		<!--<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="cellShow=false">Close Window</button>-->								
	</div>					
	</div>
	<div *ngIf="tableShow" id="task-box" class="task-box"  style="width:45vw;right:5vw; top:5vh" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em;max-height: 90vh;position: relative;">
			<label>Table Content</label>
			<i #hotkeyIcon class="iconBtn fas fa-info-circle mt-2" style="float:right; margin-right: -16px;" (click)="op99.toggle($event)"></i>
			<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="tableShow=false; curHeader=false; tableToolShow=false; customizedTablesave()"></i>
			<i class="iconBtn fas fa-toolbox mr-3 mt-2" style="color:white;float:right" title="Table Tools" (click)="tableToolShow=true"></i>
			<p-overlayPanel #op99 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
				<ng-template pTemplate>
					<div style="margin: 10px; color:#C2D63F;overflow:auto; font-size:11px"> 
						<h6>Hot Key:</h6>
						<div class="m-0 p-0 tableInfo" style="color: white;">
							<div style="padding-left: 4px; margin: 0;">
								<label>Navigation Before a Table Cell is Opened: </label>
								<ul>
									<li>
										Ctrl + ➡️⬆️⬅️⬇️ will <span>move</span> to adjacent cell.
									</li>
									<li>
										Ctrl + Enter key will <span>open Editor</span> with currrent cell content.
									</li>
									<li>							
										Ctrl + C key will <span>copy</span> currrent cell content.
									</li>
									<li>
										Ctrl + V key will <span>paste</span> to currrent cell.
									</li>
									<li>
										Ctrl + Space key will <span>clear</span> currrent cell content.
									</li>
								</ul>
							</div>
							<div style="padding-left: 4px;">
								<label>Table Navigation While Editing Cell Data: </label>
								<ul>
									<li>
										Alt + ➡️⬆️⬅️⬇️ will <span>move</span> to adjacent cell with Editor opening <span>after saving</span> current content.
									</li>
									<li>
										Alt + S key will <span>close Editor after saving</span> current content.
									</li>
									<!--<li>
										Alt + C key will <span>close Editor without save</span>.
									</li>-->
								</ul>
							</div>
							
						</div>
					</div>
				</ng-template>
			</p-overlayPanel>
			<div style="min-height: 264px;border:solid 1px #C2D63F;padding:2px;position: relative;">
				<div *ngIf="!curHeader&&(!curCell)" class="row m-0 p-0 tableInfo" style="font-size: 12px; color: white;">
					<div style="width: 50%;margin: 0;padding: 20px;line-height:150%;">
						<label>Navigation Before a Table Cell is Opened: </label>
						<ul>
							<li>
								Ctrl + ➡️⬆️⬅️⬇️ will <span>move</span> to adjacent cell.
							</li>
							<li>
								Ctrl + Enter key will <span>open Editor</span> with currrent cell content.
							</li>
							<li>							
								Ctrl + C key will <span>copy</span> currrent cell content.
							</li>
							<li>
								Ctrl + V key will <span>paste</span> to currrent cell.
							</li>
							<li>
								Ctrl + Space key will <span>clear</span> currrent cell content.
							</li>
						</ul>
					</div>
					<div style="width: 50%;padding: 20px;line-height:150%;">
						<label>Table Navigation While Editing Cell Data: </label>
						<ul>
							<li>
								Alt + ➡️⬆️⬅️⬇️ will <span>move</span> to adjacent cell with Editor opening <span>after saving</span> current content.
							</li>
							<li>
								Alt + S key will <span>close Editor after saving</span> current content.
							</li>
							<!--<li>
								Alt + C key will <span>close Editor without save</span>.
							</li>-->
						</ul>
					</div>
					<div style="padding:24px 42px; width:100%; border-top: #C2D63F solid 1px;vertical-align: middle;"><span style="font-weight:bold; color:orange">*</span> <span  class="tableInfo ml-2">Vertical Header</span> can be set in table setting</div>
				</div>
				<!--<div class="cplabel" *ngIf="!selectedHeaderType&&curCap" style="cursor:auto;margin:auto">
					<label><input type="checkbox" [(ngModel)]="curCap['border']">With Border</label>
					<label class="ml-3">Text Alignment:</label><select [(ngModel)]="curCap['align']">
						<option value="Center">Center</option>
						<option value="Left">Left</option>
						<option value="Right">Right</option>
					</select>
				</div>
				<div pFocusTrap *ngIf="!selectedHeaderType&&curCap" >
					<div class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto;">
						<app-paragraph [addedSlot]="curCap['addedItem']"  class="docItem" [users]="curCap['tcusers']" [suggests]="curCap['suggestions']" [comments]="curCap['comments']" [content]="curCap.NAME" [getText]="curCap['reqIndex']"  (selected)="selectedRow=-1;addLib=true" (onExit)='capData($event, curSec.id)' (outText)="capText($event,curSec.id)" (rfSelected)="selectedRF($event)" (onTrackChange)="capSuggest($event, curSec.id)"></app-paragraph>
					</div>
					<div style="float: right;position: relative;">
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="closeCap();">Close</button>
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCap(curSec.id);">Save</button>
					</div>
				</div>-->
				<div pFocusTrap *ngIf="!selectedHeaderType&&curHeader">
					<div class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto;">
						<app-paragraph [addedSlot]="curCol.addedItem"  class="docItem" [users]="curCol.tcusers" [suggests]="curCol.suggestions" [comments]="curCol.comments" [content]="curCol.NAME" [getText]="curSec['reqIndex']"  (selected)="selectedRow=-1;getPosition(curSec, $event);addLib=true; selectedEditor='C'" (onExit)='colData($event, curSec.id)' (outText)="colText($event)" (rfSelected)="selectedRF($event)" (onTrackChange)="colSuggest($event, curSec.id,curCol['VH'])" (selected)="logUsers(curSec.id, curSec.SECTION_TITLE)"></app-paragraph>
					</div>
					<div style="float: right;position: relative;">
						<!--<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="closeCol(); curHeader=false">Close</button>-->
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCol(curSec.id); curHeader=false">Save</button>
					</div>
				</div>
				<div pFocusTrap *ngIf="selectedHeaderType&&curHeader">
					<div class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto;">
						<app-paragraph [addedSlot]="curCol.addedItem"  class="docItem" [users]="curCol.tcusers" [suggests]="curCol.suggestions" [comments]="curCol.comments" [content]="curCol.NAME" [getText]="curSec['reqIndex']"  (selected)="selectedRow=-1;getPosition(curSec, $event);addLib=true; selectedEditor='C'" (onExit)='colData($event, curSec.id,selectedHeaderType)' (outText)="colText($event,selectedHeaderType)" (rfSelected)="selectedRF($event)" (onTrackChange)="colSuggest($event, curSec.id,curCol['VH'],selectedHeaderType)" (selected)="logUsers(curSec.id, curSec.SECTION_TITLE)"></app-paragraph>
					</div>
					<div style="float: right;position: relative;">
						<!--<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="closeCol(selectedHeaderType); curHeader=false">Close</button>-->
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCol(curSec.id,selectedHeaderType); curHeader=false">Save</button>
					</div>
				</div>
			<div *ngIf="curCell">
				<div class="cplabel" style="max-height:360px; overflow:auto; cursor:auto;margin:auto">
					<label>Background:</label>
					<input class="cpicker" [disabled]="(curCol['lock'])||(curSec.data['locked']&&curSec.data.rows[selectedCell.row]['lock'])"				
				   [style.background]="curCell.bkcolor"
				   [(colorPicker)]="curCell.bkcolor"/>
				   <input type="checkbox" [(ngModel)]="allCol" [disabled]="(curCol['lock'])||(curSec.data['locked']&&curSec.data.rows[selectedCell.row]['lock'])">Apply to Entire Column
				   <input type="checkbox" [(ngModel)]="allRow" [disabled]="(curCol['lock'])||(curSec.data['locked']&&curSec.data.rows[selectedCell.row]['lock'])">Apply to Entire row
				   <ng-container *ngIf="(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)">
					<a class="btnRound1" [ngStyle]="{'color':(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)?'#c2d63e':'#999','border-color':(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" style='float:none; margin-left: 60px;' (click)="op0.toggle($event)">Field Options</a>
										<p-overlayPanel #op0 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
											<ng-template pTemplate>
												<div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
													<h6>Choose Field Value(s)</h6>
														<div *ngIf='curCol.FO&&curCol.FO.length>0' class="col-md-10">
															<ng-container *ngFor="let label of curCol.FO; let i=index; trackBy:trackByFuntion">
																<label class='mr-2'*ngIf="label.trim().length>0">{{label}}<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItem(label)'></i></label><br>
															</ng-container>
														</div>
														<ng-container *ngIf="curCol.DefaultFO&&curCol.DefaultFO.html">
															<p class="savedLabel">Default Value:</p>
															<div style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="curCol.DefaultFO.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div><br>
															<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItem(curCol.DefaultFO)'></i>						
														</ng-container>
												</div>
											</ng-template>
										</p-overlayPanel>
			   </ng-container>
			   <label *ngIf="allowLock=='Y'" class="ml-3"><input type="checkbox" [disabled]="allowLock!='Y'" [(ngModel)]="curCell['lock']" (change)="setLock($event, curCell)">Lock Content from Editing</label>
			    </div>
				<div *ngIf="!curHeader" pFocusTrap >
				<!--<div [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto">--> 
				<div *ngIf="!curCell['lock']&&(!(selectedCell&&curSec.data.rows[selectedCell.row]['lock']))&&(!curCol['lock']||curCell['colspan'])" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto">  
					<app-paragraph [addedSlot]="curSec.addedItem"  class="docItem" [users]="curCell.tcusers" [suggests]="curCell.suggestions" [comments]="curCell.comments" [content]="curCell.htmltext" [getText]="curCell['reqIndex']"  (selected)="selectedRow=-1;addLib=true; selectedEditor='C'" (onExit)='cellData($event, curSec.id)'  (rfSelected)="selectedRF($event)" (onTrackChange)="cellSuggest($event, curSec.id)" (outText)="curCell.data=$event" ></app-paragraph>
				</div> 
				<div *ngIf="curCell['lock']||(selectedCell&&curSec.data.rows[selectedCell.row]['lock'])||(!curCell['colspan']&&curCol['lock'])" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:100px; max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto; background-color: white;color:black">  
					<span *ngIf="curCell.DATA" class="innerCell" [innerHTML]="curCell.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				</div> 
				<button  [disabled]="curCell['lock']||(selectedCell&&curSec.data.rows[selectedCell.row]['lock'])" tabindex="-1" [ngClass]="{'hasLibs':curCell.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;filteredData=null;selectedRow=-1; selectedEditor='C';showSavedLib(curCell.libs);op42.toggle($event);">Libraries</button>
				<button  [disabled]="curCell['lock']||(selectedCell&&curSec.data.rows[selectedCell.row]['lock'])" tabindex="-1" [ngClass]="{'hasLibs':curCell.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; filteredData=null;selectedRow=-1; selectedEditor='C';showsavedSlot(curCell.slots)">Repeat Fields</button>					
				<div style="float: right;position: relative;">
					<span *ngIf="cellsaveErr" style="color:orange; margin-top: 4px;">Saving not Successful, Please try again!</span> <button type="button" class="btn btn-outline-light btn-sm mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCell(curSec.id)">Save</button>
					<!--<button type="button" class="btn btn-outline-light btn-sm mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="closeCell()">Close</button>-->
				</div>			
			</div>
				<p-overlayPanel #op42 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
					<ng-template pTemplate>
					<div style="width: 240px; max-height: 300px; overflow:auto; margin:0; padding-right:1; color:#C2D63F;font-size:.8em"> 
						<ng-container *ngFor="let item of curCell.libs; trackBy:trackByFuntion"> 
						<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
						<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op421.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
						<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
						
						<p-overlayPanel #op421 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																	<ng-template pTemplate>
																		<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																			<h6>{{item.ITEM_TITLE}}</h6>
																			<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																				<label class="tag">{{label}}</label>
																			</ng-container>	
																			<div *ngIf="item.LIBRARY_ID>-1">
																				<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																			</div>
																			<div *ngIf="!item.COST_LIBRARY_ID">
																				<strong>Content :</strong>
																				<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																				<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
																			</div>
																			<div *ngIf="item.COST_LIBRARY_ID>-1">
																				<strong>Cost :</strong> {{item.COST}}
																			</div>
																		</div>																	
																	</ng-template>
							</p-overlayPanel>
						</ng-container>										
					</div>
					</ng-template>
				</p-overlayPanel>
			</div>
		</div>
		<div class="m-0 p-0" style="position: relative;width: 100%;">
			
		</div>
		
				<div *ngIf="curSec" #edittableContainer style="max-height: 500px;overflow: auto;margin-top: 10px;" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false'>
					<!--<table *ngIf="curSec.data['caption']" style="width: 100%;margin: 0;color:#333"  (click)="selectCap(curSec)">
						<tr>
						  <th [ngStyle]="{'border':curSec.data['caption']['border']?'solid 1px black':'none', 'text-align':curSec.data['caption']['align']?curSec.data['caption']['align']:'center'}" style="font-size: 11px;margin: 0;background-color: white;">{{curSec.data['caption']['text']}}	</th>						  
						</tr>
					</table>-->
					<p-table [value]="curSec.data.rows" [columns]="curSec.data.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, curSec.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, curSec)">
						<ng-template pTemplate="header" let-columns>
							<ng-container *ngFor="let brow of curSec.data.beforeHeaders; let bindex=index">
							<tr>
								<th  style="color:#555; background:#dedede; padding:4px; font-size:11px; cursor: pointer;" title='Additional Header' (click)="selectToggle($event, curSec, bindex, 'beforeHeaders');selectedCell=null;" title="Right click to lock/unlock header." (contextmenu)="setrowLock($event, 'beforeHeaders', bindex)" [ngClass]="{'selected':brow['selected']}" >
									<span *ngIf="!(curSec.data['locked']&&curSec.data['locked']['beforeHeaders'].indexOf(bindex)>-1)" class="pi pi-bars"></span>
									<span *ngIf="curSec.data['locked']&&curSec.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="pi pi-lock"></span>
								</th>
								<ng-container *ngFor="let col of brow; let u=index">
									<th *ngIf="!col.colspan" style="background:#dedede !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" [ngClass]="{'highlightCell':selectedHeaderType=='beforeHeaders'&&curHeader&&colIndex==u&&bindex==headerIndex}">
										<i *ngIf="col.suggestions&&col.suggestions.length>0" class="celltcicon">TC</i>
										<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" style="color:#444"></span>
										<a (click)="selectCol(curSec, u, col, 'beforeHeaders', bindex)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
									</th>
									<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="background:#dedede !important;vertical-align:middle;" [ngStyle]="{'text-align':col.colAlign}" [ngClass]="{'highlightCell':selectedHeaderType=='beforeHeaders'&&curHeader&&colIndex==u&&bindex==headerIndex}">
										<i *ngIf="col.suggestions&&col.suggestions.length>0" class="celltcicon">TC</i>
										<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" style="color:#444"></span>
										<a (click)="selectCol(curSec, u, col, 'beforeHeaders', bindex)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
									</th>
								</ng-container>
							</tr>
							</ng-container>
							<tr>
								<th class="cellItem" style="width:24px; background:white !important;vertical-align:middle" title="Right click to lock/unlock header." (contextmenu)="setrowLock($event, 'header')">
									<span *ngIf="curSec.data['locked']&&curSec.data['locked']['header']" class="pi pi-lock"></span>
								</th>
								<th *ngFor="let col of columns; let u=index" style="background:white !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" [ngClass]="{'highlightCell':!selectedHeaderType&&curHeader&&colIndex==u}" pReorderableColumn pResizableColumn class="cellItem">
									<i *ngIf="col.suggestions&&col.suggestions.length>0" class="celltcicon">TC</i>
									<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" [ngStyle]="{'color':curSec.OHEADER?'#C4C4C4':'#444'}"></span>
									<a (click)="selectCol(curSec, u, col)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
								</th>
							</tr>
							<ng-container *ngFor="let brow of curSec.data.afterHeaders; let bindex=index">
								<tr>
									<th style="color:#555; background:#dedede; padding:4px; font-size:11px; cursor: pointer;" title='Additional Header' (click)="selectToggle($event, curSec, bindex, 'afterHeaders');selectedCell=null;" title="Right click to lock/unlock header."  (contextmenu)="setrowLock($event, 'afterHeaders', bindex)" [ngClass]="{'selected':brow['selected']}" >
										<span *ngIf="!(curSec.data['locked']&&curSec.data['locked']['afterHeaders'].indexOf(bindex)>-1)" class="pi pi-bars"></span>
										<span *ngIf="curSec.data['locked']&&curSec.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="pi pi-lock"></span>
									</th>
									<ng-container *ngFor="let col of brow; let u=index">
										<th *ngIf="!col.colspan" style="background:#dedede !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" [ngClass]="{'highlightCell':selectedHeaderType=='afterHeaders'&&curHeader&&colIndex==u&&bindex==headerIndex}">
											<i *ngIf="col.suggestions&&col.suggestions.length>0" class="celltcicon">TC</i>
											<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" style="color:#444"></span>
											<a (click)="selectCol(curSec, u, col, 'afterHeaders', bindex)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
										</th>
										<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="background:#dedede !important;vertical-align:middle;" [ngStyle]="{'text-align':col.colAlign}" [ngClass]="{'highlightCell':selectedHeaderType=='afterHeaders'&&curHeader&&colIndex==u&&bindex==headerIndex}">
											<i *ngIf="col.suggestions&&col.suggestions.length>0" class="celltcicon">TC</i>
											<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" style="color:#444"></span>
											<a (click)="selectCol(curSec, u, col, 'afterHeaders', bindex)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
										</th>
									</ng-container>
								</tr>
							</ng-container>
						</ng-template>
						<ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
							<tr [pReorderableRow]="index" class="editrow">
								<td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, curSec, index);selectedCell=null;" (contextmenu)="setrowLock($event, 'row',index)" [ngClass]="{'selected':rowData.selected}">
									<!--<span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>-->
									<span *ngIf="!(rowData['lock'])" class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>
									<span *ngIf="rowData['lock']" class="pi pi-lock" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>						
								</td>			
								 <ng-container *ngIf="rowData.items[0].colspan">
									<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (click)="toEditCell(curSec, index, columns[0], rowData.items[0])" [ngClass]="{'rowHide':rowData.hide, 'highlightCell':!curHeader&&preCell.row==index&&preCell.col==0, 'normalCell':preCell.row!=index||preCell.col!=0}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
										<i *ngIf="rowData.items[0].suggestions&&rowData.items[0].suggestions.length>0" class="celltcicon">TC</i>
										<span class="innerCell" *ngIf="rowData.items[0].DATA" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='index' data-y="0" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
										<i *ngIf="rowData.items[0]['lock']||rowData['lock']" class="fas fa-lock lockicon"  title="Cell/row Locked"></i>
										<a *ngIf="!(rowData['lock']||rowData.items[0]['lock'])" (click)="op504.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
										<p-overlayPanel #op504 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
									<ng-template pTemplate>
										<div style="max-height:160px; overflow-y:auto">
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[0]); op504.hide()">Copy</a><br>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[0]); op504.hide()">Paste</a><br>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[0]); op504.hide()">Checkmark</a>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[0]); op504.hide()">Clear</a>
										</div>					
									</ng-template>
								</p-overlayPanel>
									</td>
								</ng-container>	
								<ng-container *ngIf="!rowData.items[0].colspan">
									<td *ngFor="let col of columns; let u=index" [ngStyle]="{'text-align':col.celAllign, 'background':rowData.items[u].bkcolor? rowData.items[u].bkcolor:'white'}"  class="cellItem" (click)="toEditCell(curSec, index, col, rowData.items[u])" [ngClass]="{'rowHide':rowData.hide, 'highlightCell':!curHeader&&preCell.row==index&&preCell.col==u, 'normalCell':preCell.row!=index||preCell.col!=u}">
										<i *ngIf="rowData.items[u].suggestions&&rowData.items[u].suggestions.length>0" class="celltcicon">TC</i>
										<span class="innerCell" *ngIf="rowData.items[u].DATA" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='index'[attr.data-y] ="u" [innerHTML]="rowData.items[u].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
										<i  class="fas fa-lock lockicon" *ngIf="col['lock']||rowData['lock']" title="Column/row Locked" ></i>
										<ng-container *ngIf="!(col['lock']||rowData['lock'])">
											<i *ngIf="rowData.items[u]['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>
											<a *ngIf="!rowData.items[u]['lock']" (click)="op501.toggle($event)" class="toolicon" title="Edit"><i class="fas fa-cog"></i></a>
										</ng-container>
										<!--<a (click)="op501.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[u].libs&&rowData.items[u].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>-->
										<p-overlayPanel #op501 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
									<ng-template pTemplate>
										<div style="max-height:160px; overflow-y:auto">
											<!--<a (click)="getFPosition(page1,$event,s,t); selectCell(page1, index, col, rowData.items[u]);" class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;" [ngStyle]="{'color':rowData.items[u].libs&&rowData.items[u].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit">Edit</a><br>-->
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[u]); op501.hide()">Copy</a><br>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[u]); op501.hide()">Paste</a><br>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[u]); op501.hide()">Checkmark</a>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[u]); op501.hide()">Clear</a>
										</div>					
									</ng-template>
								</p-overlayPanel>
									</td>
								</ng-container>			
							</tr>
						</ng-template>
					</p-table> 
				
			</div>
			
		</div>					
		</div>
	<div *ngIf="erisCellShow" class="task-box"  style="width:710px;z-index: 1201;" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em;"> 
			<label>Cell Content</label>
			<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="erisCellShow=false; closeErisCell()"></i>
			<ng-container *ngIf="(curErisCol.FO&&curErisCol.FO.length>0)||(curErisCol.DefaultFO&&curErisCol.DefaultFO.html)">
				<a class="btnRound1 p-1" [ngStyle]="{'color':(curErisCol.FO&&curErisCol.FO.length>0)||(curErisCol.DefaultFO&&curErisCol.DefaultFO.html)?'#c2d63e':'#999','border-color':(curErisCol.FO&&curErisCol.FO.length>0)||(curErisCol.DefaultFO&&curErisCol.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" style='float:none; margin-left: 60px;' (click)="op0.toggle($event)">Field Options</a>
									<p-overlayPanel #op0 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
										<ng-template pTemplate>
											<div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
												<h6>Choose Field Value(s)</h6>
													<!--<input type="text" class="col-md-6" placeholder="Input your Field Options here"/>
													<i class="fas fa-plus iconBtn" title="Add Item to Action" (click)="addFOItem($event, item)"></i>-->
													<div *ngIf='curErisCol.FO&&curErisCol.FO.length>0' class="col-md-10">
														<ng-container *ngFor="let label of curErisCol.FO; let i=index; trackBy:trackByFuntion">
															<label class='mr-2'*ngIf="label.trim().length>0">{{label}}<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItemEris(label)'></i></label><br>
														</ng-container>
													</div>
													<ng-container *ngIf="curErisCol.DefaultFO&&curErisCol.DefaultFO.html">
														<p class="savedLabel">Default Value:</p>
														<div style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="curErisCol.DefaultFO.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div><br>
														<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItemEris(curErisCol.DefaultFO)'></i>						
													</ng-container>
											</div>
										</ng-template>
									</p-overlayPanel>
		   </ng-container>
			<!--<div class="cplabel">
			<label>Background:</label>
			<input class="cpicker"				
		   [style.background]="curErisCell.bkcolor"
		   [(colorPicker)]="curErisCell.bkcolor"/>
		   <input type="checkbox" [(ngModel)]="allCol">Apply to Entire Column
		   <input type="checkbox" [(ngModel)]="allRow">Apply to Entire row
		  <ng-container *ngIf="(curErisCol.FO&&curErisCol.FO.length>0)||(curErisCol.DefaultFO&&curErisCol.DefaultFO.length>0)">
			<a class="btnRound1" [ngStyle]="{'color':(curErisCol.FO&&curErisCol.FO.length>0)||(curErisCol.DefaultFO&&curErisCol.DefaultFO.length>0)?'#c2d63e':'#999','border-color':(curErisCol.FO&&curErisCol.FO.length>0)||(curErisCol.DefaultFO&&curErisCol.DefaultFO.length>0)?'#c2d63e':'#999'}" title="Field Options" style='float:none; margin-left: 60px' (click)="op0.toggle($event)">Field Options</a>
								<p-overlayPanel #op0 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
									<ng-template pTemplate>
										<div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
											<h6>Choose Field Value(s)</h6>
												
												<div *ngIf='curErisCol.FO&&curErisCol.FO.length>0' class="col-md-10">
													<ng-container *ngFor="let label of curErisCol.FO; let i=index; trackBy:trackByFuntion">
														<label class='mr-2'*ngIf="label.trim().length>0">{{label}}<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItemEris(label)'></i></label><br>
													</ng-container>
												</div>							
												<p class="savedLabel">Default Value:</p>
												<label>{{curErisCol.DefaultFO}}</label>	<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItemEris(curErisCol.DefaultFO)'></i>
										</div>
									</ng-template>
								</p-overlayPanel>
	   </ng-container>
		   </div>-->
			<div *ngIf="curEris" class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:460px; overflow:auto; cursor:auto;">
				<app-paragraph class="docItem" [addedSlot]="curEris.addedItem" [users]="tempUsers"  [suggests]="tempSuggestions" [comments]="tempComms" [content]="tempHtml"  (selected)="selectedRow=-1;addLib=true; selectedEditor='C'" (onExit)='erisCellHtml($event)' (onTrackChange)="erisCellSuggest($event)" (outText)="erisCellText($event)" ></app-paragraph>
			</div>
			<span *ngIf="cellsaveErr" style="color:orange; margin-top: 4px;">Saving not Successful, Please try again!</span><button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toErisCell()">Save</button>
										
		</div>					
		</div>
	<div *ngIf="pageOPShow" class="task-box" style="width:10px; top:30vh;  right:250px; max-height:60vh" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 4px; padding:10px; color:#C2D63F;"> 
			<div style="color:#C2D63F;max-height:480px; overflow:auto; font-size:12px">
				<label style="font-weight:bold; font-size:14px">Set Section Rules</label><a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="pageOPShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
				<br>
				<ng-container *ngIf="curDoc.TYPE!='TABLE'&&curDoc.TYPE!='PHOTOS'"><input type="checkbox" [(ngModel)]="curDoc.OSNAME">Omit Section Name<i title="The section name will not print in the report PDF." class="fas fa-info-circle  ml-1"></i><br></ng-container> 
				<hr class="line3">
				<label style="font-weight:bold; font-size:14px">Page Content Setting</label>
				
				<br>
					<input type="checkbox" [checked]="curDoc.pageSrc=='pdf'" (change)="changeSrc($event, curDoc, 'pdf')">Upload PDF<br>
					<hr class="line3">
					<div *ngIf="curDoc.pageSrc!='pdf'">
					<label style="font-weight:bold">Page Header and Footer Setting</label><br>
					<input type="radio" name="hfSetting" [checked]="curDoc.pageSrc=='report'" (change)="changeSrc($event, curDoc, 'report')">Use Same Header & Footer as Report<br>
					<input type="radio" name="hfSetting" [checked]="curDoc.pageSrc=='letter_style'" (change)="changeSrc($event, curDoc, 'letter_style')">Set Letter Style Header and Footer<br>
					<div *ngIf="curDoc.pageSrc=='letter_style'" class="pl-3">
						<label>Header: </label>
						<a class="ml-1" (click)="getAllHeader(); op901.toggle($event);" title="Choose Header"><i class="pi pi-angle-down"></i></a>
						<a class="ml-2" *ngIf="curDoc.header"  href="javascript:void(0)" (click)="openHFPage(curDoc.header.HEADERFOOTER_ID)">{{curDoc.header.HF_TITLE}}</a>
						<br>
						<p-overlayPanel #op901 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
							<ng-template pTemplate>
								<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
									<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc.header=null;curDoc['fHeader']=null; op901.hide();">
										None
									</a><br>
									<ng-container *ngFor="let header of headers; trackBy:trackByFuntion">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc.header=header; op901.hide();">
											{{header.HF_TITLE}}
										</a>
										<br>
									</ng-container>
								</div>
							</ng-template>
						</p-overlayPanel>
						<ng-container *ngIf="selectedEditor=='F'&&curDoc['header']">
							<label>First Page Header: </label>
							<a class="ml-1" (click)="getAllHeader(); op902.toggle($event);" title="Choose Header" style="cursor: pointer;"><i class="pi pi-angle-down"></i></a>
							<a class="ml-2" *ngIf="curDoc['fHeader']" href="javascript:void(0)" (click)="openHFPage(curDoc['fHeader']['HEADERFOOTER_ID'])">{{curDoc['fHeader']['HF_TITLE']}}</a>
							<br>
							<p-overlayPanel #op902 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
								<ng-template pTemplate>
									<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc['fHeader']=null;op902.hide();">
											None
										</a><br>
										<ng-container *ngFor="let header of headers; trackBy:trackByFuntion">
											<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc['fHeader']=header; op902.hide();">
												{{header.HF_TITLE}}
											</a>
											<br>
										</ng-container>
									</div>
								</ng-template>
							</p-overlayPanel>
						</ng-container>
						<label>Footer: </label>
						<a class="ml-1" (click)="getAllFooter(); op910.toggle($event);" title="Choose Footer"><i class="pi pi-angle-down"></i></a>
						<a class="ml-2" *ngIf="curDoc.footer" href="javascript:void(0)" (click)="openHFPage(curDoc.footer.HEADERFOOTER_ID)">{{curDoc.footer.HF_TITLE}}</a>
						<br>
						<p-overlayPanel #op910 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
							<ng-template pTemplate>
								<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
									<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc.footer=null;curDoc['fFooter']=null;op910.hide();">
										None
									</a><br>
									<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc.footer=footer; op910.hide();">
											{{footer.HF_TITLE}}
										</a>
										<br>
									</ng-container>
								</div>
							</ng-template>
						</p-overlayPanel>
						<ng-container *ngIf="selectedEditor=='F'&&curDoc['footer']">
							<label>First Page Footer: </label>
							<a class="ml-1" (click)="getAllFooter(); op912.toggle($event);" title="Choose Footer" style="cursor: pointer;"><i class="pi pi-angle-down"></i></a>
							<a class="ml-2" *ngIf="curDoc['fFooter']" href="javascript:void(0)" (click)="openHFPage(curDoc['fFooter']['HEADERFOOTER_ID'])">{{curDoc['fFooter']['HF_TITLE']}}</a>
							<br>
							<p-overlayPanel #op912 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
								<ng-template pTemplate>
									<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc['fFooter']=null;op912.hide();">
											None
										</a><br>
										<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
											<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc['fFooter']=footer; op912.hide();">
												{{footer.HF_TITLE}}
											</a>
											<br>
										</ng-container>
									</div>
								</ng-template>
							</p-overlayPanel>
						</ng-container>
					</div>
					<!--<div *ngIf="curDoc.pageSrc=='letter_style'" class="pl-3">
						<label>Header: </label>
						<a class="ml-1" (click)="getAllHeader(); op901.toggle($event);" title="Choose Header" style="cursor: pointer;"><i class="pi pi-angle-down"></i></a>
						<a class="ml-2" *ngIf="curDoc.header" target=_blank [href]="'cover/Header-'+curDoc.header.HEADER_ID">{{curDoc.header.HF_TITLE}}</a>
						<br>
						<p-overlayPanel #op901 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
							<ng-template pTemplate>
								<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
									<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc.header=null;op901.hide();">
										None
									</a><br>
									<ng-container *ngFor="let header of headers; trackBy:trackByFuntion">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc.header=header; op901.hide();">
											{{header.HF_TITLE}}
										</a>
										<br>
									</ng-container>
								</div>
							</ng-template>
						</p-overlayPanel>
						<label>Footer: </label>
						<a class="ml-1" (click)="getAllFooter(); op910.toggle($event);" title="Choose Footer" style="cursor: pointer;"><i class="pi pi-angle-down"></i></a>
						<a class="ml-2" *ngIf="curDoc.footer" target=_blank [href]="'cover/Footer-'+curDoc.footer.FOOTER_ID">{{curDoc.footer.HF_TITLE}}</a>
						<br>
						<p-overlayPanel #op910 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
							<ng-template pTemplate>
								<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
									<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc.footer=null;op910.hide();">
										None
									</a><br>
									<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc.footer=footer; op910.hide();">
											{{footer.HF_TITLE}}
										</a>
										<br>
									</ng-container>
								</div>
							</ng-template>
						</p-overlayPanel>
						<input type="checkbox" [checked]="curDoc['firstHF']" (change)="setFirstHF($event, curDoc)">First Page Header and Footer<br>
						<ng-container *ngIf="curDoc['firstHF']">
							<label>Header: </label>
							<a class="ml-1" (click)="getAllHeader(); op902.toggle($event);" title="Choose Header" style="cursor: pointer;"><i class="pi pi-angle-down"></i></a>
							<a class="ml-2" *ngIf="curDoc['fHeader']" target=_blank [href]="'cover/Header-'+curDoc['fHeader']['HEADER_ID']">{{curDoc['fHeader']['HF_TITLE']}}</a>
							<br>
							<p-overlayPanel #op902 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
								<ng-template pTemplate>
									<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc['fHeader']=null;op902.hide();">
											None
										</a><br>
										<ng-container *ngFor="let header of headers; trackBy:trackByFuntion">
											<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc['fHeader']=header; op902.hide();">
												{{header.HF_TITLE}}
											</a>
											<br>
										</ng-container>
									</div>
								</ng-template>
							</p-overlayPanel>
							<label>Footer: </label>
							<a class="ml-1" (click)="getAllFooter(); op912.toggle($event);" title="Choose Footer" style="cursor: pointer;"><i class="pi pi-angle-down"></i></a>
							<a class="ml-2" *ngIf="curDoc['fFooter']" target=_blank [href]="'cover/Footer-'+curDoc['fFooter']['FOOTER_ID']">{{curDoc['fFooter']['HF_TITLE']}}</a>
							<br>
							<p-overlayPanel #op912 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
								<ng-template pTemplate>
									<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc['fFooter']=null;op912.hide();">
											None
										</a><br>
										<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
											<a href="javascript:void(0)" style="color: #C2D63F;" (click)="curDoc['fFooter']=footer; op912.hide();">
												{{footer.HF_TITLE}}
											</a>
											<br>
										</ng-container>
									</div>
								</ng-template>
							</p-overlayPanel>
						</ng-container>
					</div>-->
					</div>
					<ng-container *ngIf="curDoc.pageSrc=='pdf'">
						<i class="fas fa-cloud-upload-alt iconBtn" (click)="upload('pdf')"></i>
						<a *ngIf="curDoc.pdf&&curDoc.pdf.length>0" [href]="curDoc.pdf" target=_blank ><label style="width:200px; font-size:11px">{{curDoc.pdfName}}</label></a>
						<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline"></span><br>
						<!--<button type="button" class="btn btn-outline-light btn-sm mr-4  mb-1 pt-0 pb-0 pl-1 pr-1" (click)="curDoc.pdf=''; curDoc.pdfName=''; autoSave('modify',curDoc.id, curDoc.SECTION_TITLE,selectedEditor); optionShow=false;"><span style="font-size:.8em;">Delete PDF</span></button>-->
					</ng-container>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="autoSave('modify',curDoc.id, curDoc.SECTION_TITLE,'F');pageOPShow=false;"><span style="font-size:.8em;">Save</span></button>
					<ng-container *ngIf="curDoc.pageSrc!='pdf'&&(curDoc.text?.length>=0&&(!curDoc.intro)&&(otherTypes.indexOf(curDoc.TYPE)==-1))||(curDoc.TYPE=='TABLE'&&curDoc.data&&(!curDoc.data.erisName))">	
						<hr class="line3">
						<p class="opBtn1" (click)="getHistory(0,curDoc)">Get History</p>
						<!--<p class="opBtn1" (click)="getChHistory(0)">Track Changes</p>-->
						</ng-container>					
					</div>
		</div>					
	</div>
	<div *ngIf="new1103show" class="task-box" style="width:400px; top:30vh;  right:250px; max-height:60vh" cdkDrag [cdkDragDisabled]="intext">
		<div style="width:380px; margin:0 4px; padding:10px; color:#C2D63F;font-size:12px"> 
			<label style="font-weight:bold; font-size:14px">Create New Phase I - Freddie Mac 1103 Report</label>
			<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="new1103show=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
			<br>
			<label class="col-md-5">Template Identifier</label><input class="col-md-7 ml-0" type="text" disabled value='Phase I - Freddie Mac 1103'/><br>
			<label class="col-md-5">Template<span style="font-weight:bold; color:red">*</span></label>
			<select  class="col-md-7 ml-0" [(ngModel)]="selectedTemp">
				<option></option>
				<option *ngFor="let temp of frm1103Temps" [value]="temp.TEMPLATE_ID">{{temp.TEMPLATE_TITLE}}</option>
			</select>
			<hr>
			<button *ngIf="!frm1103url" (click)="addnewFrm1103()">Add</button><span *ngIf="frm1103Warn" style="margin-left: 20px;color:red">Failed</span>
			<a *ngIf="frm1103url" style="margin-left: 40px;color:C2D63F" target=_blank [href]="frm1103url">Phase I - Freddie Mac 1103</a>
		</div>
	</div>
	<div *ngIf="optionShow" class="task-box" style="width:10px; top:30vh;  right:250px; max-height:60vh" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 4px; padding:10px; color:#C2D63F;font-size:12px"> 
			<label style="font-weight:bold; font-size:14px">Set Section Rules</label>
			<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="optionShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
			<br>
			<ng-container *ngIf="curDoc.TYPE=='PDFSEC'">
				<!--<input type="checkbox" [checked]="curDoc.pageSrc=='pdf'" (change)="changeSrc($event, curDoc, 'pdf')">Upload PDF<br>
				<hr class="line3">-->
				<span class="cplabel">Upload PDF</span><i class="fas fa-cloud-upload-alt iconBtn" (click)="upload('pdf')"></i>
				<a *ngIf="curDoc.pdf?.length>0" [href]="curDoc.pdf" target=_blank ><label style="width:200px; font-size:11px">{{curDoc.pdfName}}</label></a>
				<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span><br>
				<button type="button" class="btn btn-outline-light btn-sm mr-4  mb-1 pt-0 pb-0 pl-1 pr-1" (click)="curDoc.pdf=''; curDoc.pdfName=''; autoSave('modify',curDoc.id, curDoc.SECTION_TITLE,selectedEditor);"><span style="font-size:.8em;">Remove PDF</span></button>
				<button type="button" class="btn btn-outline-light btn-sm mr-4  mb-1 pt-0 pb-0 pl-1 pr-1" (click)="autoSave('modify',curDoc.id, curDoc.SECTION_TITLE,selectedEditor); optionShow=false;"><span style="font-size:.8em;">Save</span></button>
			</ng-container>
			<div *ngIf="curDoc.TYPE!='PDFSEC'">
					<ng-container *ngIf="!curDoc['tableClass']&&curDoc.TYPE!='TABLE'&&curDoc.TYPE!='PHOTOS'"><input type="checkbox" [checked]="curDoc?.DISPLAY_SEQUENCE=='N'"  [disabled]='noSeq||selectedEditor=="F"' (click)="ifSeq($event, curDoc)">Omit Section Number<i title="The section number will not print in the report PDF." class="fas fa-info-circle  ml-1"></i><br>
						<p *ngIf='noSeq' style="color:#F78181; margin: 0 4px;font-size: .9em;">Could not find the upper level section number.</p>
					</ng-container>
					<ng-container *ngIf="!curDoc['tableClass']&&curDoc.TYPE!='TABLE'&&curDoc.TYPE!='PHOTOS'"><input type="checkbox" [(ngModel)]="curDoc.OSNAME"  (click)="ifSecTitle($event, curDoc)">Omit Section Name<i title="The section name will not print in the report PDF." class="fas fa-info-circle  ml-1"></i><br></ng-container>
					<ng-container *ngIf="!curDoc['tableClass']&&curDoc.TYPE=='TABLE'"><input type="checkbox" [(ngModel)]='curDoc.OTNAME'>Omit Table Name <i title="The table name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="curDoc.TYPE=='PHOTOS'"><input type="checkbox" [(ngModel)]='curDoc.OPNAME'>Omit Photo Name <i title="The photo name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="curDoc.TYPE=='TABLE'"><input type="checkbox" [(ngModel)]='curDoc.OTABLE'>Hide Table<i title="The table will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="!curDoc['tableClass']&&curDoc.TYPE=='TABLE'&&(!(curDoc.data&&curDoc.data.erisName))"><input type="checkbox" [disabled]="curDoc['data']['locked']&&curDoc['data']['locked']['header']" [(ngModel)]='curDoc.OHEADER'>Omit Table Header<i title="Table header will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="!curDoc['tableClass']"><input type="checkbox" [(ngModel)]='curDoc.TOC' [disabled]='selectedEditor=="F"'>Hide from TOC<i title="The section/table name will not print in TOC but will print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>	
					<ng-container *ngIf="curDoc.TYPE!='TABLE'"><input type="checkbox" [disabled]='curDoc.required' [(ngModel)]='curDoc.HIDE'>Hide Section<i title="The entire section will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>			
					<ng-container *ngIf="!curDoc['ZOOM']&&(!curDoc['tableClass'])"><input type="checkbox" [(ngModel)]='curDoc.NEW'>Add Page Break<i title="Section will print on a new page." class="fas fa-info-circle ml-1"></i><br></ng-container>	
					<ng-container *ngIf="curDoc.TYPE=='TABLE'||curDoc.TYPE=='COSTTABLE'">		
						<label style="width:50%" >Table border class</label><input type="text" maxlength="20" [(ngModel)]='curDoc.borderClass'style="width:50%" (change)="addTableClass($event)">
					</ng-container>
					<button type="button" class="btn btn-outline-light btn-sm mr-4  mb-1 pt-0 pb-0 pl-1 pr-1" (click)="autoSave('modify',curDoc.id, curDoc.SECTION_TITLE,selectedEditor); optionShow=false;"><span style="font-size:.8em;">Save</span></button>
					<div *ngIf="curDoc.TYPE=='PCASUMMARY'">
						<hr class="line3">
						<label>Show Summary Categories</label>
						<i class="iconBtn fas fa-info-circle ml-2" (click)="op511.toggle($event)"></i>
						<p-overlayPanel #op511  [appendTo]="'body'" [dismissable]="true" [style]="{width: '280px'}">
							<ng-template pTemplate>
							<div class="listItem2" style="margin:0; border:1px ridge black" *ngFor="let item of summaryCategory">
								<label >{{item}}</label>
							</div>
							</ng-template>
						</p-overlayPanel>
					</div>
					<div *ngIf="otherTypes.indexOf(curDoc.TYPE)==-1&&reportInfo?.PCA_INDICATOR=='4099e'&&(!curDoc.data)&&selectedEditor=='O'">
						<hr class="line3">
						<label >Fannie Mae Category: </label>
						<select class="costInput" [ngStyle]="{'border':curDoc.ul?.cat.length>0? 'none':'2px solid #F78181'}" style="width:90%; font-size: 11px;" (change)="selFmeUl(curDoc, $event, 'cat')">
							<option value="">Please Select Fannie Mae Category</option>
							<option *ngFor="let item of capitalCategory; let i=index" [value]="item.label" [selected]="item.label==curDoc.ul?.cat">{{item.label}}</option>
						</select>
						<div *ngIf="curDoc.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
							<label class="fmeLabel">Average EUL (yr): </label>
							<label class="fmeLabel">Effective Age (yr): </label>
							<input  class="fmeInput" type="number" [(ngModel)]='curDoc.ul.EUL' min="0" (change)="selFmeUl(curDoc, $event, 'EUL')">
							<input  class="fmeInput" type="number" [(ngModel)]='curDoc.ul.EFF' min="0" (change)="selFmeUl(curDoc, $event, 'EFF')">
						</div>
						<div  *ngIf="curDoc.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
							<label  class="fmeLabel">Rating: </label>
							<label class="fmeLabel"></label>
							<select class="fmeInput mr-1" [ngStyle]="{'border':curDoc.ul?.RATING.length>0? 'none':'2px solid #F78181'}" (change)="selFmeUl(curDoc, $event, 'RATING')">
								<option value="">Select Rating</option>
								<option *ngFor="let item of ratingOps; let i=index" [value]="item" [selected]="item==curDoc['ul'].RATING">{{item}}</option>
							</select>
							<!--<select class="fmeInput" [ngStyle]="{'border':curDoc.ul?.ACTION.length>0? 'none':'2px solid #F78181'}" (change)="selFmeUl(curDoc, $event, 'ACTION')">
								<option value="">Select Action Item</option>
								<option *ngFor="let item of actionItemOps; let i=index" [value]="item" [selected]="item==curDoc['ul'].ACTION">{{item}}</option>
							</select>-->
							<!--<p-multiSelect [style]="{'width':'100%', 'padding':'1px', 'font-size':'10px'}" [options]="actionItemOps" [filter]="false" [ngStyle]="{'border':curDoc.ul?.ACTION.length>0? 'none':'2px solid #F78181'}" [(ngModel)]="curDoc.ul.ACTION" optionLabel="name" (onChange)="selFmeUl(curDoc, $event, 'ACTION')"></p-multiSelect>
								-->
							</div>
					</div>
					<!--<div *ngIf="curDoc.TYPE=='COSTTABLE'&&reportInfo?.PCA_INDICATOR=='frm1105'">
						<hr class="line3">
						<label>Freddie Mac Category: </label>
						<select class="costInput" style="width:90%; font-size: 11px;" (change)="selFrmUl(curDoc, $event, 'cat')">
							<option value="">Please Select Freddie Mac Category</option>
							<option *ngFor="let item of capitalCategory; let i=index" [value]="item.tag" [selected]="item.tag==curDoc.ul?.cat">{{item.label}}</option>
						</select>
						<div *ngIf="curDoc.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
							<label class="fmeLabel">Estimated Useful Life: </label>
							<label class="fmeLabel">Remaining Useful Life: </label>
							<input  class="fmeInput" type="text" min="0" [(ngModel)]='curDoc.ul.EUL'  (change)="selFrmUl(curDoc, $event, 'EUL')">
							<input  class="fmeInput" type="text" min="0" [(ngModel)]='curDoc.ul.RUL'  (change)="selFrmUl(curDoc, $event, 'RUL')">
						</div>
						<div  *ngIf="curDoc.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
							<label  class="fmeLabel">Condition: </label>
							<label class="fmeLabel">Action Item: </label>
							<select class="fmeInput" (change)="selFrmUl(curDoc, $event, 'CONDITION')">
								<option value="">Select Condition</option>
								<option *ngFor="let item of conditionOps; let i=index" [value]="item" [selected]="item==curDoc['ul'].CONDITION">{{item}}</option>
							</select>
							<p-multiSelect [style]="{'width':'100%', 'padding':'1px', 'font-size':'10px'}" [options]="actionItemOps" [filter]="false" [ngStyle]="{'border':curDoc.ul?.ACTION.length>0? 'none':'2px solid #F78181'}" [(ngModel)]="curDoc.ul.ACTION" optionLabel="name" (onChange)="selFrmUl(curDoc, $event, 'ACTION')"></p-multiSelect>
						</div>
					</div>-->
					<!--<ng-container *ngIf="curDoc.TYPE=='TABLE'&&curDoc.data?.SLOT_ID">
					<hr class="line3">
					<p *ngIf="curDoc.data?.filters&&curDoc.data?.filters.length>0" class="opBtn1" (click)="slotToLib=false; filteredData=null; selectedRow=-1;selectedCell=null; resetFilters(curDoc.data?.filters, curDoc.data?.SLOT_ID)">Filter ERIS Table</p>
					<p  class="opBtn1" (click)="getHistory(0,curDoc)">Reset ERIS Table</p>
					</ng-container>-->
					<ng-container *ngIf="curDoc.TYPE=='PCATABLE'">
						<hr class="line3">
						<input type="radio" [checked]='lpagesize=="legal-landscape"' name="pagesize" (change)="savePDFconfig('legal-landscape')"/>Print in Landscape Legal Size<br>
						<!--<input type="radio" [checked]='lpagesize=="landscape-content"' name="pagesize" (change)="savePDFconfig('landscape-content')">Print in Landscape Letter Size<br>-->
						<input type="radio" [checked]='lpagesize=="ledger-landscape"' name="pagesize" (change)="savePDFconfig('ledger-landscape')"/>Print in Landscape Ledger Size<br>
						<hr class="line3">
						<ng-container *ngIf="curDoc['ZOOM']">
							<input type="radio" [checked]='pcaTableSize=="all"' name="tablesize" (change)="savePcaTableConfig($event,'tableSize')" value="all"/>Print All Years <br>
							<input type="radio" [checked]='pcaTableSize=="split"' name="tablesize" (change)="savePcaTableConfig($event,'tableSize')" value="split"/>Split Years for PDF<br>
							<div class="yearSplitContent" *ngIf="pcaTableSize=='split'">
								<input type="checkbox" class="yearchk" [checked]="pcaTableSetting[0]['selected']" (change)="setPcaTablePage($event, 0)"><label class="yearLabel">First Table from: </label>
								<input class="yearInput" id="start0" [(ngModel)]="pcaTableSetting[0]['start']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[0]['start'] !=1|| pcaTableSetting[0]['start'] >= pcaTableSetting[0]['end'] ? 'red' : 'black'}">
								To: <input class="yearInput" id="end0" [(ngModel)]="pcaTableSetting[0]['end']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[0]['start'] > pcaTableSetting[0]['end'] || pcaTableSetting[0]['end'] > pcaOp.reserve ||(pcaTableSetting[1]['selected']&& ((pcaTableSetting[0]['end'] + 1 )!= pcaTableSetting[1]['start']))||(!pcaTableSetting[1]['selected']&&pcaTableSetting[0]['end'] != pcaOp.reserve)? 'red' : 'black'}"><br>
								<input type="checkbox" class="yearchk" [checked]="pcaTableSetting[1]['selected']" (change)="setPcaTablePage($event, 1)"><label class="yearLabel">Second Table from: </label>
								<input class="yearInput" id="start1" [(ngModel)]="pcaTableSetting[1]['start']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[1]['start'] > pcaTableSetting[1]['end'] || ( pcaTableSetting[0]['end'] + 1 )!= pcaTableSetting[1]['start'] ? 'red' : 'black'}">
								To: <input class="yearInput" id="end1" [(ngModel)]="pcaTableSetting[1]['end']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[1]['start'] > pcaTableSetting[1]['end'] || pcaTableSetting[1]['end'] > pcaOp.reserve ||(pcaTableSetting[2]['selected']&&( pcaTableSetting[1]['end'] + 1 )!= pcaTableSetting[2]['start'])||(!pcaTableSetting[2]['selected']&&pcaTableSetting[1]['end'] != pcaOp.reserve) ? 'red' : 'black'}"><br>
								<input type="checkbox" class="yearchk" [checked]="pcaTableSetting[2]['selected']" (change)="setPcaTablePage($event, 2)"><label class="yearLabel">Third Table from: </label>
								<input class="yearInput" id="start2" [(ngModel)]="pcaTableSetting[2]['start']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[2]['start'] > pcaTableSetting[2]['end'] || ( pcaTableSetting[1]['end'] + 1 )!= pcaTableSetting[2]['start'] ? 'red' : 'black'}">
								To: <input class="yearInput" id="end2" [(ngModel)]="pcaTableSetting[2]['end']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[2]['start'] > pcaTableSetting[2]['end'] || pcaTableSetting[2]['end'] != pcaOp.reserve ? 'red' : 'black'}"><br>
								<label *ngIf="!pcaTableValidate" style="color:orange">Please Check your year input</label>
							</div>
							<button type="button" class="btn btn-outline-light btn-sm mr-4  mb-1 pt-0 pb-0 pl-1 pr-1" (click)="savePcaTablePage()"><span style="font-size:.8em;">Save setting</span></button>
						</ng-container>	
					</ng-container>
					<!--<ng-container *ngIf="curDoc.TYPE=='TABLE'&&curDoc.data&&curDoc.data.erisName&&curDoc.data?.erisName.length>0">-->
						<ng-container *ngIf="curDoc.TYPE!='PCATABLE'&&(!curDoc.tableClass)&&(curDoc.TYPE!='4099e'&&selectedEditor=='O')">
						<hr class="line3">
							<input type="checkbox" [checked]='curDoc.landscape' name="pagesize" (change)="setPageSize(curDoc, $event)"/>Print in Landscape<br>
						</ng-container>
					<ng-container *ngIf="curDoc.TYPE=='TABLE'||curDoc.TYPE=='COSTTABLE'||curDoc.TYPE=='PCATABLE'">
			<hr class="line3">
						<p class="opBtn1" (click)="selectedRow=-1;selectedCell=null;exportExcel(curDoc)">Export to Excel</p>
					<ng-container *ngIf="curDoc.TYPE=='TABLE'">	
						<!--<p *ngIf="curDoc.data&&curDoc.data.parent_table&&curDoc.data.parent_table.length>0" class="opBtn1" (click)="newSlotCat=''; selectedRow=-1;selectedCell=null;op210.toggle($event);newSlotCat='ERIS Data';">Create Re-Field</p>-->
						<p *ngIf="!curDoc.data?.disableCopiedEris" class="opBtn1" (click)="copyTableData(curDoc); optionShow=false;">Copy Table</p>
						<p *ngIf="!curDoc.data?.disableCopiedEris" class="opBtn1" (click)="pasteTableData()">Paste Table</p>
						<p *ngIf="!curDoc.data||(curDoc.data&&(!curDoc.data.erisName))" class="opBtn1" (click)="toimportTable()">Import from Excel</p>
					</ng-container>{{curDoc.text}}
		<p-overlayPanel #op210  [appendTo]="'body'" [showCloseIcon]="true"  [dismissable]="false" [style]="{width: '290px'}">
            <ng-template pTemplate>
                <div style="width: 280px; margin:0; padding-right:0; color:#C2D63F;font-size:.8em"> 
					<label style="font-weight:bold">Set Repeat Field Property</label><br>
					<div class="row" style="font-size:.9em">
						<label class="col-md-3 ml-0 ">Identifier: </label>
						<input class="col-md-7 ml-0" type="text"/>
						<span style="font-weight:bold; color:red">*</span>
					</div>
					<div class="row" style="font-size:.9em">
						<label class="col-md-3  ml-0">Category: </label>
						<select class="ml-0 col-md-3" [(ngModel)]='newSlotCat' (mousedown)="getSlotPara()">
				
										<option *ngFor="let cat of slotCategories" [value]="cat.CATEGORY">{{cat.CATEGORY}}</option>				
										
						</select>
						<span style="font-weight:bold; color:red">*</span>
					</div>					
					<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="tableToSlot($event, curDoc, op210)">Save</button>
			    </div>
            </ng-template>
        </p-overlayPanel>
			</ng-container>
			<ng-container *ngIf="!curDoc.tableClass&&((curDoc.text?.length>=0&&(!curDoc.intro)&&(otherTypes.indexOf(curDoc.TYPE)==-1))||(curDoc.TYPE=='TABLE'&&curDoc.data&&(!curDoc.data.erisName)))">	
				<hr class="line3">
				<p class="opBtn1" (click)="getHistory(0,curDoc)">Get History</p>
				<!--<p class="opBtn1" (click)="getHistory(0,'', 'changes')">Track Changes</p>-->
			</ng-container>
			<hr class="line3">
			<p class="opBtn1" *ngIf="!curDoc['tableClass']" (click)="getLink(curDoc)">Get Section Link</p>
			
		</div>
		
		</div>	
		
					
	</div>
	<div *ngIf="tableToolShow" class="task-box" style="width:700px; top:30vh;  right:250px; max-height:60vh" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;"> 
		<label style="font-weight:bold;">Table Tools</label>
				<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="tableToolShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
		<!--<div class="cplabel" style="padding:10px 0; color:#C2D63F;width: 100%;font-size: 12px;text-align: center;">
			<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="resetProp(curDoc,'beforeHeaders'); resetProp(curDoc,'afterHeaders'); resetProp(curSec)">Clear Selection</button>
		</div>-->					
		<div class="row" style="width:100%;font-size:.9em; ">
			<!--<div class="cplabel" style="padding:10px 0; color:#C2D63F;width: 100%;font-size: 12px;">
				<label class="col-md-7"><input type="checkbox" name='caption' [checked]="curSec.data['caption']" (change)="addCap($event, curSec)">Display Caption</label>
				<label class="col-md-5"><input type="radio" name='caption' [checked]="curSec.data['caption']&&(!curSec.data['caption']['border'])" (change)="addCap(curSec)">Display Caption without Border</label>
				<label class="col-md-4"><input type="radio" name='caption' [checked]="curSec.data['caption']&&curSec.data['caption']['border']" (change)="addCap(curSec, true)">Display Caption with Border</label>
				<label class="col-md-3"><input type="radio" name='caption' [checked]="!curSec.data['caption']" (change)="deleteCap(curSec)">No Caption</label>
				<button type="button" [disabled]="curDoc.data['caption']" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="addCap(curDoc)">Add Caption without Border</button>
				<button type="button" [disabled]="curDoc.data['caption']" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="addCap(curDoc, true)">Add Caption with Border</button>
				<button type="button" [disabled]="!curDoc.data['caption']" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="deleteCap(curDoc)">Delete Caption</button><br></div>
				<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="resetProp(curDoc,'beforeHeaders'); resetProp(curDoc,'afterHeaders'); resetProp(curSec)">Clear Selection</button>
				<br>
			</div>-->
			<div style="padding:10px 20px; color:#C2D63F;width: 50%"> 
				<ng-container *ngIf="!curDoc.append">
					<label style="font-weight:bold;text-align: center;display: block;">Additional Header Rows</label>
						<!--<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="resetProp(curDoc,'beforeHeaders'); resetProp(curDoc,'afterHeaders')">Clear Addtional Header Selection</button>-->
						<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 mb-2" style="font-size: .9em;" (click)="deleteHeaders(curDoc)">Delete Addtional Header(s)</button><br>						
						<div style="font-size:.9em; color:#C2D63F; ">
							<input type="checkbox" [checked]="addHBefore" style="margin-right: 4px;" (change)="addHBefore=!addHBefore">Insert Header Above<br>
								<!--<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>-->
								<a href="javascript:void(0)" class="btn btn-sm btn-outline-light mt-2 mb-3 pb-0 pt-0 tbtn" (click)="addHeaders($event)"><span style="font-size:.9em; pointer-events:none">Add Additional Header For Each Column</span></a><br>
								<select style="width:70px; height:20px;">
									<option>Left</option>
									<option selected>Center</option>
									<option>Right</option>
								</select>
								<a href="javascript:void(0)"  [ngClass]="{'disabled':curDoc.id=='pca_summary_0'}" class="btn btn-sm btn-outline-light tbtn pb-0 pt-0 ml-1" (click)="addHSub($event)"><span style="font-size:.9em; pointer-events:none">Add Header Across All Rows</span></a>
								<!--<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 mt-3" style="font-size: .95em; margin-left: 20%;" (click)="deleteHeaders(curDoc)">Delete Addtional Header(s)</button><br>-->

						</div>
					</ng-container>							
			</div>
			<div style="padding:10px 20px; color:#C2D63F;width: 50%;border-left: 2px solid #C2D63F;"> 
				<label style="font-weight:bold;text-align: center;display: block;">Add/Delete/Edit Table Rows</label>
					<ng-container *ngIf="!curDoc.append">
						<button type="button"  [ngClass]="{'disabled':curDoc.id=='pca_summary_0'}" class="btn btn-outline-light btn-sm mr-4 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="hideRows(curDoc)">Hide Row(s)</button><br>
						<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="deleteRows(curDoc)">Delete Row(s)</button><br>
						<!--<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="resetProp(curDoc)">Clear Row Selection</button>-->
						<div style="font-size:.9em; color:#C2D63F; ">
							<input type="checkbox" [checked]="addBefore" style="margin-right: 4px;" (change)="addBefore=!addBefore">Insert Row Above<br>
								<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
								<a href="javascript:void(0)" class="btn btn-sm btn-outline-light tbtn pb-0 pt-0 ml-1 mb-1" (click)="addCRows($event)"><span style="font-size:.9em; pointer-events:none">Add Row</span></a><br>
								<select style="width:70px; height:20px;">
									<option>Left</option>
									<option selected>Center</option>
									<option>Right</option>
								</select>
								<a href="javascript:void(0)"  [ngClass]="{'disabled':curDoc.id=='pca_summary_0'}" class="btn btn-sm btn-outline-light tbtn pb-0 pt-0 ml-1 mb-1" (click)="addCSub($event)"><span style="font-size:.9em; pointer-events:none;">Add Sub-Header</span></a>
						</div>
					</ng-container> 	
						
					<ng-container *ngIf="curDoc.append">
						<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="appendFMErow(curDoc)">Add Row</button>
					</ng-container> 		
			</div>
		</div>
	</div>					
	</div>
	<div *ngIf="commShow" class="task-box" style="width:330px; top:30vh;  right:250px; max-height:60vh" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 4px; padding:10px; color:#C2D63F;"> 
			<div *ngIf="curDoc.id==secCommId" style="width: 300px; margin:0; color:#C2D63F;font-size:.9em;">
							<b>Comments</b><span class="savedLabel1">({{curDoc.SECTION_SEQUENCE}} {{curDoc.SECTION_TITLE.slice(0,20)}}<ng-container *ngIf="curDoc.SECTION_TITLE.length>20">...</ng-container>)</span>
							<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="commShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
							<a class="float-sm-right m-1 iconBtn" pTooltip="Add New Comment" tooltipZIndex='auto'(click)="op71.toggle($event);"><i class="far fa-comment-dots" style="pointer-events:none"></i></a>
							<p-overlayPanel #op71  [appendTo]="'body'" [dismissable]="true" [style]="{width: '320px'}">
								<ng-template pTemplate>
									<div style="width: 300px; padding:10px; color:#C2D63F;font-size:.8em"> 
										<textarea [(ngModel)]='secComment' class="form-control" style="background-color:#222; color:white;"></textarea>
										<button type="button" class="btn btn-dark btn-sm float-sm-right" (click)="op71.hide();"><span style="font-size:.8em;">Close</span></button>
										<button [disabled]="secComment.length==0" type="button" class="btn btn-dark btn-sm float-sm-right" (click)='reComment(curDoc.id, curDoc.SECTION_TITLE);op71.hide();'>Save</button>							
							
									</div>
								</ng-template>
							</p-overlayPanel>
							<hr class='line'>
							<div style="height:300px; overflow:auto;">
							<ng-container *ngFor='let comm of secComments'>								
							<div class="card" style="margin-bottom:4px; border:1px solid #C3D42F; padding:2px">
								
								<div [style.color]="'dedede'">
									<i class="fas fa-user-circle m-1" style="font-size:1.4em; color:rgb(195,212,47)"></i>
									<span style="font-weight:bold">{{comm.CREATED_BY}}</span><span style="font-size:.8em; margin-left:10px">{{comm.CREATED_TIMESTAMP}}</span>
									<p style="margin:0 0 0 24px">{{comm.COMMENT_CONTENT}}</p>									
									<i *ngIf="comm.COMMENT_STATUS=='Resolved'"  pTooltip="Resolved" tooltipZIndex='auto'class="fas fa-check-circle  float-sm-right m-0" style="font-size:1.4em; color:rgb(195,212,47)"></i>
									<a *ngIf="comm.COMMENT_STATUS=='New'"  pTooltip="Not Resolved" tooltipZIndex='auto'class="btn btn-dark btn-sm float-sm-right m-0" style="padding:0 2px" (click)="updateStatus(comm.COMMENT_ID)"><i class="far fa-check-circle" style="font-size:1.2em;"></i>
									</a>
								</div>
							</div>
							</ng-container>
							</div>						
						</div>		
		</div>					
	</div>
	<div *ngIf="slotShow" class="task-box" style="width:500px; top:60vh;  right:250px; max-height:60vh;" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 4px; padding:10px; color:#C2D63F;"> 
			<label style="font-weight:bold">{{curRF.KEY}}</label><span style="color:#04B486; margin:0 2px; font-size:.8em">( {{curRF.TYPE}} )</span><span style="color:#C2D63F; margin:0 2px; font-size:.8em"> -  {{curRF.CATEGORY}}</span>
			<hr class="line1">
			<div style="color:#C2D63F;max-height:480px; overflow:auto; font-size:.9em"> 
				<!--<strong>{{curRF.KEY}}</strong><br>
				<strong>Category : </strong> 
				<span style="color:white">{{curRF.CATEGORY}}</span><br>
				<strong>Type : </strong> 
				<span style="color:white">{{curRF.TYPE}}</span><br>
				<strong *ngIf="(curRF.TYPE!='Table')&&(curRF.TYPE!='Selection')">Content :</strong> -->
				<div *ngIf="(curRF.TYPE!='Table')&&(curRF.TYPE!='Selection')">
					<textarea  style="width:100%" rows="5"  [value]="curRF.CONTENT" (mouseenter)='intext=true' (mouseleave)='intext=false'>
					</textarea>
					<button  *ngIf="curRF.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op" (click)="updateSlotContent($event,curRF);slotShow=false;">Update</button>
				</div>
				<div *ngIf="curRF.TYPE=='Selection'">
					<span>Options</span>
					<span *ngIf="curRF.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Selection )</span><span *ngIf="curRF.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Selection ) </span><br>
					<ng-container *ngFor="let item of tableContent; let s=index">
						<div>
						<input type="checkbox" [checked]="tableContent1.indexOf(item)>-1" (click)="selOP($event, item, curRF.MULTIPLE_CHOICE)">
							<span style="color:white">{{item}}</span> 
						</div>
					</ng-container>
					<button *ngIf="curRF.STATUS=='Active'" type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op" (click)="updateSlotContent($event,curRF);slotShow=false;">Update</button>
					
				</div>
				<div *ngIf="curRF.TYPE=='Table'">
					<strong>Headers of Table</strong>
					<table style="color:white; width:90%; border: 1px solid black;  border-collapse: collapse;">
						<thead>
							<tr>
								<th>No.</th>
								<th>H</th>
								<th>Type</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let item of tableContent; let i=index">
								<tr>
									<td>{{i}}</td>
									<td>{{item.NAME}}</td>
									<td>{{item.TYPE}}</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
					<span *ngIf="curRF.STATUS!='Active'" class="inaciveMsg" style="font-size:11px">The Repeat Field you are editing is Inactive for your company. Please go to the Libraries Module/Repeat Fields area and change the status to Active. </span>
					<button type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op" (click)="slotShow=false">Close</button>
							
			</div>
		</div>					
	</div>
	<div *ngIf="updateShow" class="task-box " style="width:900px; top:20vh;  right:200px; max-height:60vh" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 4px; padding:10px; color:#C2D63F; font-size:12px"> 
			<h6 style="font-weight:bold">Comparison Table  <label class="savedLabel"><b>( Project Number: {{reportInfo.PROJECT_NUMBER}} )</b></label>
			<span *ngIf="loading3" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
				
					  <i class="iconBtn far fa-times-circle ml-3" style="float:right" (click)="updateShow=false"></i>
			<button class="btn pcaBtn float-md-right" (click)="op110.toggle($event)">Choose Reports from Project </button></h6>
				
			<hr class="line1 mb-1">
			<p-overlayPanel #op110 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '400px'}">
				<ng-template pTemplate>
                <div style="width: 260px; margin:0; color:#C2D63F;font-size:.8em; max-height:300px; overflow:auto"> 
					<input type="checkbox" checked disabled>
					<a class="savedLabel1" >{{projectRpts[0]?.REPORT_TITLE}}</a>
					<br>
					<ng-container *ngFor="let rpt of projectRpts|slice:1; trackBy:trackByFuntion"> 
						<input type="checkbox" [checked]="compareRpts.indexOf(rpt.REPORT_ID)>-1" (change)="addCompareRpt($event, rpt)">
						<a class="ml-2" target=_blank [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID">{{rpt.REPORT_TITLE}}</a><br>
					</ng-container>										
				</div>
				<button class="btn uploadBtn" (click)="getCompareRpts()">Get Comparison Table</button>
				<span *ngIf="loading2" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
				</ng-template>
			</p-overlayPanel>
			<p class="noteLabel">For each Repeat Field to be updated:</p>
			<p class="savedLabel1 ml-2">Click the drop-down arrow and select the correct value.</p>
			<p class="savedLabel1 ml-2">Values in <span class="noteLabel">RED</span> font show the new value in the report.</p>
			<p class="savedLabel1 ml-2"><span class="noteLabel">PLEASE NOTE:</span> We strongly suggest Users do not edit any of the reports while the repeat fields are being updated. The comparison table only takes a few seconds to work its magic.</p>
			<div style="color:#C2D63F; max-height:50vh; width:880px; font-size:.9em"> 
				<div style="width:100%; max-height:40vh;overflow:auto">
				<table *ngIf="compareSlots.length>0" [ngStyle]="{'width': (compareRpts.length*160+160)+'px'}" style="color:white; border: 1px solid black;  border-collapse: collapse; background-color:rgb(28, 36, 51); margin-right:8px; margin-left:2px;">
					<thead style=" text-align:center">
						<tr style="position: sticky; top: 0;background:rgb(28, 36, 51);">
							<th></th>
							<ng-container *ngFor="let rpt of compareTitles; let i=index">
								<th style="width:160px">{{rpt}}</th>
							</ng-container>
						</tr>
						<tr style="color:#C2D63F; height:20px">
							<th>Re-Fields Identifier</th>
							<ng-container *ngFor="let rpt of compareTitles; let i=index">
								<th>Re-Fields Value</th>
							</ng-container>							
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let item of compareSlots; let i=index">
							<tr  [ngStyle]="{'color':item['TYPE']!='ex'?'rgb(201 218 251)':'white'}">
								<td style="padding-left:2px">{{item.SLOT_KEY}}</td>
								<ng-container *ngFor="let rpt of item.REPORT_VALUE_LIST; let j=index"  style="padding-left:2px">
									<td><span>{{rpt.RF_CONTENT}}</span>
										<select *ngIf="rpt.RF_CONTENT!='Not Used'" style="width:20px; float:right" (change)="updaterpts($event, item, j)">
											<option></option>
											<ng-container *ngFor="let slot of item.REPORT_VALUE_LIST; let k=index">
											<option *ngIf="slot.RF_CONTENT!='Not Used'" [value]="k">
												{{slot.RF_CONTENT}}
											</option>
											</ng-container>
										</select>
										<span class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:none"></span>
				
										
									</td>													
								</ng-container>
							</tr>
						</ng-container>						
					</tbody>
				</table>				
				</div>				
			</div>
			<hr class="m-0 p-0">
			<button *ngIf="!loading&&(updatedSlots.length>0||exSlots.length>0)" class="btn pcaBtn mb-2 float-md-right" (click)="updateSlots()">Update Selected Re-Fields</button>
			<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block; float:right"></span>
			
		</div>					
	</div>
	<div *ngIf="filterShow" id="task-box" class="task-box" style="width:500px" cdkDrag>
	<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
		<label>Table Filters</label><br>
	<ng-container *ngFor="let filter of filterData; let i=index">
								<span style="color:white; font-size:.7em; font-weight:bold">{{filter.DISPLAY_NAME}}: </span>
									<p-multiSelect [options]="filter.FILTER_ITEM" [(ngModel)]="selectedFilters[i]" (onChange)="$event?.originalEvent?.originalEvent?.stopPropagation();" [defaultLabel]="filter.DISPLAY_NAME" optionLabel="FILTERVALUE" selectedItemsLabel="{0} items selected" [style]="{'width':'100%', 'font-size':'11px'}" [panelStyle]="{'width':'90%', 'font-size':'11px'}"></p-multiSelect><br>
								</ng-container>	
								<span *ngIf="filtering" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47);display:inline"></span>
								<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="tableFilter(filterData)">Apply</button>
								<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="filterShow=false">Close</button>
								<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="resetTable(filterData)">Reset</button>
	</div>					
</div>

<div *ngIf="erisShow" id="task-box" cdkDragBoundary=".example-boundary" class="task-box" style="width:65vw; height:85vh; right:30px; top:10px; " cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 10px; padding:10px; font-size:.8em;height:99%; position: relative;">
		<label style="color:#C2D63F;">ERIS Table - {{curErisData.erisName}}</label>
		<i class="iconBtn far fa-times-circle ml-3" style="float:right" (click)="erisShow=false;"></i>
				<button type="button" [disabled]='erisCellShow' class="btn btn-outline-light btn-sm float-sm-right mr-1 pt-0 pb-0 pl-1 pr-1" (click)="saveErisEdit();">Save</button>
				<button type="button" [disabled]='erisCellShow' class="btn btn-outline-light btn-sm float-sm-right mr-1 pt-0 pb-0 pl-1 pr-1" (click)="resetErisFilter()">Reset Filter</button>
				<button type="button" [disabled]='erisCellShow' class="btn btn-outline-light btn-sm float-sm-right mr-1 pt-0 pb-0 pl-1 pr-1" (click)="tableFilter(filterData)">Apply Filter</button>
				<button [disabled]='erisCellShow' class="btn btn-outline-light btn-sm float-sm-right mr-1 pt-0 pb-0 pl-1 pr-1" (click)="resetErisTable()">Reset ERIS Table</button>
			<span *ngIf="filtering" class="fa fa-spinner fa-spin float-sm-right" style="font-size:16px;color:rgb(195,212,47);display:inline"></span>
		
		<div *ngIf='erisCheck' id="overlay1" style="background: black url('/assets/images/loader.gif') center center no-repeat;"></div> 
		<div style="height:93%; width:100%; overflow: auto;margin: 2px 0; padding:0;" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false'>
			<ng-container *ngIf="curDoc.data?.filters&&curDoc.data?.filters.length>0">
				<!--<label style="color:white;font-weight: bold;">Filters:</label>-->
				<ng-container *ngFor="let filter of filterData; let i=index">
					<div style="width:21%; color:white;font-size:.8em; display: inline-block;">
						<span style="font-weight:bold">{{filter.DISPLAY_NAME}}: </span>
						<p-multiSelect [options]="filter.FILTER_ITEM" [(ngModel)]="selectedFilters[i]" (onChange)="$event?.originalEvent?.originalEvent?.stopPropagation();" [defaultLabel]="filter.DISPLAY_NAME" optionLabel="FILTERVALUE" selectedItemsLabel="{0} items selected" [style]="{'width':'100%', 'font-size':'10px'}" [panelStyle]="{'width':'90%', 'font-size':'10px', 'color':'white'}"></p-multiSelect>
					</div>
				</ng-container>	
			
			</ng-container>
			<div style="height:77%; overflow: auto;padding:0">
			<table class="editTable" style="font-family:Arial, sans-serif;width:100%; position: relative;">
				<thead>
					<tr  style="background-color:#eeeeee; ">
						<th style="width:30px;position: sticky;top: 0;background-color:#eeeeee; "></th>
						<ng-container *ngFor="let h of curErisData.cols; let o=index; trackBy:trackByFuntion">
						<th *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':curErisData.cols[o].colAlign}" style="position: sticky;top: 0;background-color:#eeeeee; ">
							<a class="sortHeader" (click)="sortBy(h)">{{h.NAME}} <span style="opacity:.8;">{{sortIcon(h.INTERNALNAME)}}</span></a>
						</th>
						</ng-container>
					</tr>
				</thead>
				<tbody cdkDropList [cdkDropListData]="curErisData.rows|slice:erisstart:erisend" (cdkDropListDropped)="dropRow($event)">
					<ng-container *ngFor="let r of curErisData.rows|slice:erisstart:erisend; let h=index; trackBy:trackByFuntion">
					<tr cdkDrag *ngIf="!r[0]['SUBHEADER']||r[0]['SUBHEADER']!='Y'" [ngStyle]="{'background-color':r[0]['HIDDEN_FLAG']=='Y'?'#666':'white'}">
					<td [ngStyle]="{'background-color':r[0]['HIDDEN_FLAG']=='Y'?'#666':'white'}">
					<a href="javascript:void(0)" class="btn btn-sm btn-link" (click)="op100.show($event); selectedRow=h;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'white':'rgb(195,212,47)'}">{{erisstart+h+1}}</a>
					<p-overlayPanel #op100 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
							<ng-template pTemplate>                                                    
								<div *ngIf="selectedRow>-1"  style="color:#C2D63F; ">
									<label style="font-weight:bold">Row: {{(curerispage-1)*50+selectedRow+1}}</label>
									<!--<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right"(click)="erismoveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up" style="pointer-events:none"></i></a>
									<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="erismoveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon" style="pointer-events:none"></i></a>-->
									<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="deleteerisRow(selectedRow, r[0].DATA)" title="Delete Row"><i class="fas fa-trash iconBtn smIcon" style="pointer-events:none"></i></a>
									<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" [ngStyle]="{'background-color':r[0]['HIDDEN_FLAG']=='Y'?'white':'transparent'}" (click)="hideerisRow(r[0], selectedRow)"  title="Hide Row"><i class="far fa-eye-slash iconBtn smIcon" style="pointer-events:none"></i></a>
									<br>
									<div>
										<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
										<input type="number" value="1"  min="0" disabled  max="1000000000" style="width:70px; height:20px;"/>
										<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addErisRows($event, selectedRow, r[0].DATA)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
										<select style="width:70px; height:26px;font-size: 12px;">
											<option>Left</option>
											<option selected>Center</option>
											<option>Right</option>
										</select>
										<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addErisSub($event, selectedRow, r[0].DATA)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
									</div>
								</div>                                       
							</ng-template>
							</p-overlayPanel>		
					</td>
					<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
						<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':curErisData.cols[q].celAllign, 'background-color':r[0]['HIDDEN_FLAG']=='Y'?'#666':'white'}" [ngClass]="{'active':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j}" (dblclick)="selectErisCell(k,h,q)">
							<i *ngIf="k.suggestions&&k.suggestions.length>0" class="celltcicon">TC</i>
							<span *ngIf="!k.index&&!k.HTML" [innerHTML]="k.DATA"></span>
							<span *ngIf="!k.index&&k.HTML" [innerHTML]="k.SEC.changingThisBreaksApplicationSecurity|safeHtml"></span>				
						</td>			
					</ng-container>
					</tr>
					<tr *ngIf="r[0]['SUBHEADER']=='Y'">
					<td  [ngStyle]="{'background-color':r[0]['HIDDEN_FLAG']=='Y'?'#666':'white'}" style="font-size:.8em; background-color:#eeeeee; width:30px" >
					<a  href="javascript:void(0)" class="btn btn-sm btn-link" (click)="op101.show($event); selectedRow=h;;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'white':'rgb(195,212,47)'}">{{(curerispage-1)*50+h+1}}</a>
						<p-overlayPanel #op101 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
							<ng-template pTemplate>                                                    
								<div *ngIf="selectedRow>-1"  style="font-size:.8em; color:#C2D63F; ">
									<label style="font-weight:bold">Row: {{(curerispage-1)*50+selectedRow+1}}</label>
									<!--<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveUp(selectedRow,curErisData )"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up" style="pointer-events:none"></i></a>
									<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveDown(selectedRow,curErisData)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon" style="pointer-events:none"></i></a>-->
									<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="deleteerisRow(selectedRow, r[0].DATA)"  title="Delete Row"><i class="fas fa-trash iconBtn smIcon" style="pointer-events:none"></i></a>
									<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="hideerisRow(r[0], selectedRow)"  [ngStyle]="{'background-color':r[0].HIDDEN_FLAG=='Y'?'white':'transparent'}" title="Hide Row"><i class="far fa-eye-slash iconBtn smIcon" style="pointer-events:none"></i></a>
							<br>
									<div>
										<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
										<input type="number" value="1"  min="0" disabled  max="1000000000" style="width:70px; height:20px;"/>
										<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addErisRows($event, selectedRow, r[0].DATA)"><span style="pointer-events:none; font-size:.8em">Add Row</span></a><br>
										<select style="width:70px; height:26px;font-size: 12px; " >
											<option>Left</option>
											<option selected>Center</option>
											<option>Right</option>
										</select>
										<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addErisSub($event, selectedRow, r[0].DATA)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
									</div>
								</div>                                       
							</ng-template>
							</p-overlayPanel>
					
					</td>
						<td colSpan='{{curErisData.cols.length-1}}' [ngStyle]="{'background-color':r[0]['HIDDEN_FLAG']=='Y'?'#666':'white','text-align':r[0]['celAllign']?r[0]['celAllign']:'Center'}"  style="font-weight:bold; text-align: center;"  (dblclick)="selectErisCell(r[1],h,1)">
							<i *ngIf="r[1].suggestions&&r[1].suggestions.length>0" class="celltcicon">TC</i>
							<span *ngIf="!r[1].HTML" [innerHTML]="r[1].DATA"></span>
							<span *ngIf="r[1].HTML" [innerHTML]="r[1].SEC.changingThisBreaksApplicationSecurity|safeHtml"></span>	
						</td>
					</tr>
					</ng-container>
				</tbody>
			  </table>
			</div>		
			<div style="width:98%; height:7%; overflow: auto;">
					<ng-container *ngFor="let order of erispage|fill; let i=index; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style='display: inline-block;' class="btn-black btn-sm mr-2  mb-1 pt-0 pb-0 pl-1 pr-1" [ngClass]='{"active":curerispage==(i+1), "disabled":curerispage===(i+1)}' (click)="getPageData(i)">{{i+1}}</a>
					</ng-container>
				</div>
			</div>
			
				
			<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1" [ngStyle]="{'background-color':showHidden?'white':'transparent'}" (click)="hiddenToggle()"  title="Hide Row"><i class="far fa-eye-slash iconBtn smIcon" style="pointer-events:none"></i></a><label style="color:white; margin-left: 10px; font-weight: bold;">Show Hidden Rows</label>
											
			<!--<button class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="resetErisTable()">Reset ERIS Table</button>
			<span *ngIf="filtering" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47);display:inline"></span>
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="saveErisEdit();">Save</button>
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="resetErisFilter()">Reset Filter</button>
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="tableFilter(filterData)">Apply Filter</button>
		-->
								<!--<span *ngIf="filtering" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47);display:inline"></span>
								<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="tableFilter($event, filterData)">Apply Filter</button>
								<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="resetTable(filterData)">Reset Filter</button>
							<button *ngIf="curDoc.data?.filters&&curDoc.data?.filters.length>0" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="slotToLib=false; filteredData=null; selectedRow=-1;selectedCell=null; resetFilters(curDoc.data?.filters, curDoc.data?.SLOT_ID)">Filter ERIS Table</button>-->
											
		</div>					
</div>
<div *ngIf="coversignShow" id="task-box" class="task-box" style="width:700px; top:300px;  right:200px; max-height:80vh" cdkDrag>
	<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
		<label>Sign the Cover Page</label>
		<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" (click)="coversignShow=false;coverSigns=[];selectedCoverSign=''"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
			<hr>
		<div style="width:100%">
			<label>Please click on a signature below</label>
				<ul class="widget-item-list">
					<li class="item1" *ngFor="let sign of coverSigns; let i=index">
						<label *ngIf="coverSigns[i].label&&coverSigns[i].label.length>0" style="color:rgb(195,212,47);">{{coverSigns[i].label}}</label>
						<div class="img-wrapper" (click)="getSigns(coverSigns[i].set)">
							<img *ngIf="sign.img&&sign.img.length>0" [src]="sign.img" class="img img-fluid"/>
						</div>
						<div *ngIf="coverSigns[i].name&&coverSigns[i].name.length>0" class="title1" >
						<label  title="Click to Edit">{{coverSigns[i].name}}</label>
						<app-edit-input [text]="coverSigns[i].name" (edited)="coverSigns[i].name=$event"></app-edit-input>
						</div>
						<div *ngIf="coverSigns[i].title&&coverSigns[i].title.length>0" class="title1" >
							<label  title="Click to Edit">{{coverSigns[i].title}}</label>
							<app-edit-input [text]="coverSigns[i].title" (edited)="coverSigns[i].title=$event"></app-edit-input>
							</div>						
					</li>
				</ul>
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op" (click)="updateCoverSign()">Apply</button>
								
		</div>		
	</div>					
</div>
	<div *ngIf="sealShow" id="task-box" class="task-box" style="width:800px; top:200px;  right:250px; max-height:80vh" cdkDrag>
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
			<label *ngIf="curtype=='seal'">Company Seal</label>
			<label *ngIf="curtype=='sign'">Signatures</label>
			<hr class="line5">
			<div style="width:100%">
				<div *ngIf="curSign&&curSign.signatureTemplate" style="width:100%;position: relative;display:flex;">
					<div style="flex-basis: 80%;">
					<div>
						<label  class="col-md-5 pl-0">Signature Label: </label>
						<span>{{curSign['label']}}</span>
						<app-edit-input [text]="curSign['label']" (edited)="curSign['label']=$event"></app-edit-input><br>
					</div>
				<div>
				<label  class="col-md-5 pl-0">Signature Role:</label>
					<select  class="col-md-7" [(ngModel)]="curSign['role']" (click)="setSignRoleName($event)">
						<option *ngFor="let role of signInfo.RW_SIGNATURE_LABELS" [value]="role.SIGNATURE_LABEL_ID">{{role.SIGNATURE_LABEL_NAME}}</option>
					</select>
				</div>					
				<div>
					<label class="col-md-5 pl-0">Align</label>
					<select [(ngModel)]="curSign['ALIGN']"  class="col-md-7">
						<option value="D">Default(2 per line)</option>
						<option value="L">Left(1 per line)</option>
						<option value="C">Center(1 per line)</option>
					</select>	
				</div>
				</div>
				<div style="flex-basis: 20%; vertical-align: middle;line-height: 100px;">
					<button type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op m-2" (click)="saveSign()">Save</button>		
				</div>											
			</div>
			<div *ngIf="!curSign&&newsign" style="width:100%;position: relative;display:flex;">
					<div style="flex-basis: 80%;">
					<div>
						<label  class="col-md-5 pl-0">Signature Label: </label>
						<span>{{newsign['label']}}</span>
						<app-edit-input [text]="newsign['label']" (edited)="newsign['label']=$event"></app-edit-input><br>
					</div>
				<div>
				<label  class="col-md-5 pl-0">Signature Role:</label>
					<select  class="col-md-7" [(ngModel)]="newsign['role']" (click)="setnewSignRoleName($event)">
						<option></option>
						<option *ngFor="let role of signInfo.RW_SIGNATURE_LABELS" [value]="role.SIGNATURE_LABEL_ID">{{role.SIGNATURE_LABEL_NAME}}</option>
					</select>
				</div>					
				<div>
					<label class="col-md-5 pl-0">Align</label>
					<select [(ngModel)]="newsign['ALIGN']"  class="col-md-7">
						<option value="D">Default(2 per line)</option>
						<option value="L">Left(1 per line)</option>
						<option value="C">Center(1 per line)</option>
					</select>	
				</div>
				</div>
				<div style="flex-basis: 20%; vertical-align: middle;line-height: 100px;">
						
				</div>											
			</div>
			<hr class="line5">
			<ng-container *ngIf="curSign&&curSign.signatureTemplate">
				<input id='allSigRole' [disabled]="rptUser.length>1" [checked]="rptUser.length<=1" style="margin-right:6px" type='checkbox'/>
				<label>Update All Signatures with Same Role</label><i *ngIf="rptUser.length>1" class="ml-1 fas fa-info-circle iconBtn" style="color:#F78181" title="This feature is disabled when there are more than one users in a report"></i>
				<!--<input id='draftSigRole' [disabled]="isSignAsDraftDisabled" [checked]="false" style="margin-left:60px; margin-right:6px" type='checkbox'/>-->
				<input id='draftSigRole' [checked]="false" style="margin-left:60px; margin-right:6px" type='checkbox'/>
				<label>Sign as Draft</label>
				<input id='hideDate' [checked]="curSign?.hideDate" style="margin-left:60px; margin-right:6px" type='checkbox'/>
				<label>Exclude date from signature</label><i class="ml-1 fas fa-info-circle iconBtn" title="When enabled, the date will be removed from the signature.
This option only applies if the selected signature style includes a date"></i>
			</ng-container>
							
			<div *ngIf="seals.length==0&&signs.length==0" style="color:#F78181">
			<p>Have not assigned a Writer or Reviewer</p>
			<p>Please assign a User to this role on the Dashboard.</p>
			</div>
					
			<ul class="widget-item-list">
					<li class="item1" *ngFor="let photo of seals; let u=index">
							<div class="img-wrapper">
								<img *ngIf="photo.SEAL_URL&&photo.SEAL_URL.length>0" [src]="photo.SEAL_URL" class="img img-fluid"/>
								<ng-container *ngIf="!photo.SEAL_URL||photo.SEAL_URL.length==0">
									<p style="color:#F78181; font-size:10px; margin:4px">User did not upload digital seal file<br>
									Please upload a digital seal file for this User in the Company Module/Users area.</p>
								</ng-container>
							</div>
							<div class="title1" >
								<label *ngIf="photo.FULL_NAME.length>0" title="Click to Edit" style="color:rgb(195,212,47);">{{photo.FULL_NAME}}</label>
							</div>
							<div class="title1" >
								<label *ngIf="photo.JOB_TITLE.length>0" title="Click to Edit">{{photo.JOB_TITLE}}</label>
							</div>
							
							<hr class="line">
							<label style="margin-left:4px; margin-right:4px; font-size:11px">Align</label>
							<select [id]="'sealposi_' + u" style="font-size:11px; width:80px">
							<option value="D">Default(2 per line)</option>
							<option value="L">Left(1 per line)</option>
							<option value="C">Center(1 per line)</option>							
							</select>
							<br>
							<ng-container *ngIf="photo.SEAL_URL.length>0" >
							<a *ngIf="!curSign" href="javascript:void(0);"  title="add" class="btn iconBtn2 ml-1" (click)="addSeal($event, 'seal', photo, 'sealposi_' + u)">Add</a>
							<a *ngIf="curSign" href="javascript:void(0);"  title="update" class="btn iconBtn2 ml-1" (click)="updateSeal($event, 'seal', photo, 'sealposi_' + u)">Update</a>
							</ng-container>
							<!--<a *ngIf="ifPhoto&&addedPhotos.indexOf(photo.FILE_ID)>-1" href="javascript:void(0);" class="add" (click)="removePhoto(photo)"><i class="far fa-check-square" style="font-size: 11px;"></i></a>-->
							<!--<a href="javascript:void(0);" class="remove" (click)="op44.toggle($event)"><i class="far fa-edit" style="font-size: 11px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(photo, 'PHOTO')"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a>
							<p-overlayPanel #op44 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{photo.FULL_NAME}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(photo, 'PHOTO', $event)">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>-->	
						</li>
					</ul>
					<ul class="widget-item-list">
						<li class="item1" *ngFor="let photo of signs">
							<div class="img-wrapper">
								<img *ngIf="photo.SIGNATURE_URL.length>0" [src]="photo.SIGNATURE_URL" class="img img-fluid"/>
								<ng-container *ngIf="!photo.SIGNATURE_URL||photo.SIGNATURE_URL.length==0">
									<p style="color:#F78181; font-size:10px; margin:4px">User did not upload digital signature file<br>
									Please upload a digital signature file for this User in the Company Module/Users area.</p>
								</ng-container>
							</div>
							<div class="title1" >
							<label *ngIf="photo.FULL_NAME.length>0" title="Click to Edit" style="color:rgb(195,212,47);">{{photo.FULL_NAME}}</label>
							<app-edit-input [text]="photo.FULL_NAME" (edited)="photo.FULL_NAME=$event"></app-edit-input><br>
							</div>
							<div class="title1" >
							<label *ngIf="photo.JOB_TITLE.length>0" title="Click to Edit">{{photo.JOB_TITLE}}</label>
							<app-edit-input [text]="photo.JOB_TITLE" (edited)="photo.JOB_TITLE=$event"></app-edit-input>
							</div>
							<div class="title1">
							<input *ngIf="!((curSign&&curSign.signatureTemplate)||(newsign&&newsign.signatureTemplate))" style="margin-right:6px" [disabled]="reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'" title="Add Date" type='checkbox'/>
							<label title="Click to Edit" >{{date}}</label>
							<app-edit-input [text]="date" (edited)="date=$event"></app-edit-input>
							</div>
							<!--<ng-container *ngIf="!curSign?.DATE">
									<input style="margin-right:6px" title="Add Date" type='checkbox'/>
									<label title="Click to Edit">{{date}}</label>
									<app-edit-input [text]="date" (edited)="date=$event"></app-edit-input>
								</ng-container>
								<ng-container *ngIf="curSign?.DATE">
									<input style="margin-right:6px" title="Add Date" type='checkbox'/>
									<label title="Click to Edit">{{curSign.DATE}}</label>
									<app-edit-input [text]="curSign.DATE" (edited)="curSign.DATE=$event"></app-edit-input>
								</ng-container>-->
							<hr class="line">
							<!--<ng-container *ngIf="photo.SIGNATURE_URL.length>0" >							
							<a *ngIf="!curSign" href="javascript:void(0);" class="add btn iconBtn2 mb-1" title="add"  (click)="addSeal($event, 'signature', photo)">Add</a>
							<a *ngIf="curSign" href="javascript:void(0);" title="update" class="add btn iconBtn2 mb-1" (click)="updateSeal($event, 'signature', photo)">Update</a>
							</ng-container>
							<input style="margin-left:6px" type='checkbox'/><label class="cplabel" style="vertical-align:middle; line-height:14px">Align Center</label>
							-->		
							<ng-container *ngIf="!((curSign&&curSign.signatureTemplate)||(newsign&&newsign.signatureTemplate))">					
							<label style="margin-left:4px; margin-right:4px; font-size:11px">Align</label>
							<select  id="signposi" style="font-size:11px; width:80px" [disabled]="reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'||reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'">
							<option value="D">Default(2 per line)</option>
							<option value="L" [selected]="reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'||reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'">Left(1 per line)</option>
							<option value="C">Center(1 per line)</option>
							<!--<option value="R">Right(1 per line)</option>-->
							</select><br>
							</ng-container>
							<ng-container *ngIf="photo.SIGNATURE_URL.length>0" >							
							<a *ngIf="!curSign" href="javascript:void(0);" class="btn iconBtn2 ml-1" title="add"  (click)="addSeal($event, 'signature', photo, 'signposi')">Add</a>
							<a *ngIf="curSign" href="javascript:void(0);" title="update" class="btn iconBtn2 ml-1" (click)="updateSeal($event, 'signature', photo, 'signposi')">Update</a>
							</ng-container>
							<ng-container *ngIf="reportInfo?.PCA_INDICATOR=='frm1105'||reportInfo?.PCA_INDICATOR=='frm1104'||reportInfo?.PHASE1_TYPE=='1103'" >
								<a href="javascript:void(0);"  title="add" class="btn iconBtn2 ml-2" title='Add to Freddie Mac Signature' (click)="addFrmSign(photo)">Freddie Mac</a>
							</ng-container>							
							<!--<label style="margin-left:20px; margin-right:4px">Align</label>
							<select style="width:24px">
							<option value="D">Default(2 per line)</option>
							<option value="L">Left(1 per line)</option>
							<option value="C">Center(1 per line)</option>
							<option value="R">Right(1 per line)</option>
							</select>-->
							<!--<a *ngIf="ifPhoto&&addedPhotos.indexOf(photo.FILE_ID)>-1" href="javascript:void(0);" class="add" (click)="removePhoto(photo)"><i class="far fa-check-square" style="font-size: 11px;"></i></a>-->
							<!--<a href="javascript:void(0);" class="remove" (click)="op44.toggle($event)"><i class="far fa-edit" style="font-size: 11px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(photo, 'PHOTO')"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a>
							<p-overlayPanel #op44 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{photo.FULL_NAME}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(photo, 'PHOTO', $event)">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>-->	
						</li>
					</ul>
					
					<hr class="line5">
					<button type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op mb-2" (click)="closeSign()">Close</button>									
			</div>		
		</div>					
	</div>
	<div *ngIf="fileShow" id="task-box" class="task-box" style="width:900px; top:200px;  right:150px; max-height:80vh" cdkDrag>
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
			<div style="width:100%">
	<ul class="nav nav-tabs">
    <li class="nav-item">
		<a class="nav-link" [ngClass]="{'active':uploadType=='FILE'}" data-toggle="tab" href="#files" (click)="uploadType='FILE'; getProjectFiles()">Project Documents</a>		
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':uploadType=='PHOTO'}" data-toggle="tab" href="#photos" (click)="uploadType='PHOTO'; getPhotos()">Photo Gallery</a>
    </li>
    <!--<li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':uploadType=='IMAGE'||uploadType=='BKIMAGE'||uploadType=='LOGO'}" data-toggle="tab" href="#images" (click)="uploadType='IMAGE'; getAllBk()">Company Images </a>
    </li>-->
	<li style="position:absolute; right:10px">
		<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="fileShow=false;">Close</button>
	</li>
  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    
		<div id="files" class="container tab-pane" [ngClass]="{'active':uploadType=='FILE','fade':uploadType!='FILE'}" style="width:100%; padding:0; max-height:600px; overflow:auto">
			<div class="row" style="width:98%">
				<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='FILE'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
					<div class="progress">
						<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
							{{uploadFiles}} of {{uploadNo}}
						</div>
					</div>
				</div>
				<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploading||(uploadTotal!==0&&uploadTotal!==100)}" (click)='upload("FILE")'>Upload</a>
				<span *ngIf="uploading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47); display:inline"></span>
			</div>			
			<p-table #dt [value]="projectFiles" [columns]="cols6">
				<ng-template pTemplate="caption">
					<i class="pi pi-search"></i>
                    <input type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" style="font-size:11px; padding:2px"/>
				</ng-template>
						<ng-template pTemplate="header"  let-columns>
                            <tr>
								<th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px">
									{{col.header}} <p-sortIcon field="code"></p-sortIcon>               
								</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px">
									<span *ngIf="col.field=='FILE_NAME'" style="word-break:break-all"><a [href]="rowData.FILE_URL" target=_blank>{{rowData[col.field]}}</a></span>
									<span *ngIf="col.field!=='FILE_NAME'">{{rowData[col.field]}}</span>																
									<!--<a *ngIf="col.field=='FILE_NAME'" href="javascript:void(0);" class="removeFile" (click)="deleteFile(rowData, 'FILE')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
									<i  *ngIf="col.field=='FILE_NAME'" class=" btn-outline-light btn-small far fa-trash-alt float-right mt-1"  style="color:#C2D63F; cursor:pointer" (click)="deleteFile(rowData, 'FILE')"></i>
									
									<i  *ngIf="ifAppPdf&&col.field=='FILE_NAME'" class="far fa-plus-square btn-outline-light btn-smal float-right mt-1 mr-1" style="color:#C2D63F" (click)="addFile(rowData)"></i>
									<i  *ngIf="ifAppPdf&&col.field=='FILE_NAME'" class="far fa-square btn-outline-light btn-small float-right mt-1 mr-1" style="color:#C2D63F" (click)="removeFile(rowData)"></i>
									<i  *ngIf="ifAppPdf&&col.field=='FILE_NAME'" class="far fa-check-square btn-outline-light btn-smal float-right mt-1 mr-1" style="color:#C2D63F" (click)="addFile(rowData)"></i>-->
								</td>																	
                            </tr>
                        </ng-template>
                    </p-table>					
				</div>					
				<!--<div id="images" class="container tab-pane" [ngClass]="{'active':uploadType=='IMAGE'||uploadType=='BKIMAGE'||uploadType=='LOGO', 'fade':!(uploadType=='IMAGE'||uploadType=='BKIMAGE'||uploadType=='LOGO')}">
					<div style="color:#C2D63F; font-size:.9em; padding-left:10px">
						<label class="radio-inline mr-2">
							<input type="radio" name="uploadimage" [checked]="imgGroup=='other'" (change)="imgGroup='other'"> 
							Images 
						</label> 
						<label class="radio-inline ml-3">
							<input type="radio" name="uploadimage" [checked]="imgGroup=='bk'" (change)="imgGroup='bk'">
							Background Images
						</label> 
						<label class="radio-inline ml-3"> 
							<input type="radio" name="uploadimage" [checked]="imgGroup=='logo'" (change)="imgGroup='logo'">
							Logos
						</label>
					</div>
				<div *ngIf="imgGroup=='other'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
				<div class="row" style="width:98%">
				<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='IMAGE'&&imgGroup=='other'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
					<div class="progress">
						<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
							{{uploadFiles}} of {{uploadNo}}
						</div>
					</div>
				</div>
				<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploading||(uploadTotal!==0&&uploadTotal!==100)}" (click)='upload("IMAGE")'>Upload</a>
				<span *ngIf="uploading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47); display:inline"></span>
			</div>				
				<ul class="widget-item-list">
						<li class="item" *ngFor="let other of others">
							<div class="img-wrapper">
								<img *ngIf="other.FILE_TN_URL" [src]="other.FILE_TN_URL" class="img img-fluid"/>
							</div>
							<div *ngIf="other.FILE_DESCRIPTION.length>0" class="title">{{other.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="other.FILE_DESCRIPTION.length>40"> . . . </span></div>
							<div *ngIf="other.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op41.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
							<hr class="line">
							<a href="javascript:void(0);" class="remove" (click)="op41.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(other, 'IMAGE')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
							
							<a *ngIf="ifImage&&selectedEditor" href="javascript:void(0);" class="add" title="Insert Image to Editor" (click)="selectInsert(other)"><i class="far fa-plus-square" style="font-size: 11px;"></i></a>
							<p-overlayPanel #op41 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{other.FILE_DESCRIPTION}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(other, 'IMAGE', $event)">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>
						</li>
                 
                  
					</ul>
				</div>
				
				<div *ngIf="imgGroup=='bk'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
				<div class="row" style="width:98%">
				<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='BKIMAGE'&&imgGroup=='bk'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
					<div class="progress">
						<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
							{{uploadFiles}} of {{uploadNo}}
						</div>
					</div>
				</div>
				<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploading||(uploadTotal!==0&&uploadTotal!==100)}" (click)='upload("BKIMAGE")'>Upload</a>
				<span *ngIf="uploading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47); display:inline"></span>
			</div>				
				<ul class="widget-item-list">
						<li class="item" *ngFor="let bk of bks">
							<div class="img-wrapper">
								<img *ngIf="bk.FILE_TN_URL" [src]="bk.FILE_TN_URL" class="img img-fluid"/>
							</div>
							<div *ngIf="bk.FILE_DESCRIPTION.length>0" class="title" >{{bk.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="bk.FILE_DESCRIPTION.length>40"> . . . </span></div>
							<div *ngIf="bk.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op42.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>title="Click to Edit Description"  (click)="op42.toggle($event)"
							<hr class="line">
							<a href="javascript:void(0);" class="remove" (click)="op42.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(bk, 'BKIMAGE')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
							<p-overlayPanel #op42 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{bk.FILE_DESCRIPTION}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(bk, 'BKIMAGE', $event)">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>
						</li>
                 
                  
					</ul>
				</div>
				
				<div *ngIf="imgGroup=='logo'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
					<div class="row" style="width:98%">
						<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='LOGO'&&imgGroup=='logo'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
							<div class="progress">
								<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
									{{uploadFiles}} of {{uploadNo}}
								</div>
							</div>
						</div>
						<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploading||(uploadTotal!==0&&uploadTotal!==100)}" (click)='upload("LOGO")'>Upload</a>
						<span *ngIf="uploading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47); display:inline"></span>
					</div>
					<ul class="widget-item-list">
						<li class="item" *ngFor="let logo of logos">
							<div class="img-wrapper">
								<img *ngIf="logo.FILE_TN_URL" [src]="logo.FILE_TN_URL" class="img img-fluid"/>
							</div>
							<div *ngIf="logo.FILE_DESCRIPTION.length>0" class="title" >{{logo.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="logo.FILE_DESCRIPTION.length>40"> . . . </span></div>
							<div *ngIf="logo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op43.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
							<hr class="line">
							<a href="javascript:void(0);" class="remove" (click)="op43.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>title="Click to Edit Description"  (click)="op43.toggle($event)"
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(logo, 'LOGO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
							<p-overlayPanel #op43 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{logo.FILE_DESCRIPTION}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(logo, 'LOGO', $event)">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>
						</li>
                 
                  
					</ul>
					</div>
				</div>-->
				<div id="photos" class="container tab-pane" [ngClass]="{'active':uploadType=='PHOTO','fade':uploadType!='PHOTO' }"  style="width:100%; padding:0; margin:0; max-height:600px; overflow-y: auto;overflow-x: hidden;">
					<div class="row" style="width:98%">
						<a  *ngIf="photos.length>0" href='javascript:void(0)' class="btn uploadBtn  m-1 ml-2"  (click)='generateKml(photos)'>Generate Mobile KML File</a>
						<span *ngIf="processing" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline"></span>
						<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='PHOTO'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
							<div class="progress">
								<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
									{{uploadFiles}} of {{uploadNo}}
								</div>
							</div>
						</div>
						<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploading||(uploadTotal!==0&&uploadTotal!==100)}" (click)='upload("PHOTO")'>Upload</a>
						<span *ngIf="uploading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47); display:inline"></span>
					</div>
					

					<ul class="widget-item-list">
						<li class="item" *ngFor="let photo of photos">
							<div class="img-wrapper">
								<img *ngIf="photo.FILE_TN_URL" [src]="photo.FILE_TN_URL" class="img img-fluid"/>
							</div>
							<div *ngIf="photo.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op44.toggle($event)">{{photo.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="photo.FILE_DESCRIPTION.length>40"> . . . </span></div>
							<div *ngIf="photo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op44.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
							<hr class="line">
							<a *ngIf="ifPhoto&&addedPhotos.indexOf(photo.FILE_ID)==-1" href="javascript:void(0);" class="add" (click)="addPhoto(photo)"><i class="far fa-square" style="font-size: 11px;"></i></a>
							<a *ngIf="ifPhoto&&addedPhotos.indexOf(photo.FILE_ID)>-1" href="javascript:void(0);" class="add" (click)="removePhoto(photo)"><i class="far fa-check-square" style="font-size: 11px;"></i></a>
							<a *ngIf="coverChange&&coverImages?.length>0" href="javascript:void(0);" class="add" title="Change Cover Image" (click)="changeImage(photo)"><i class="far fa-plus-square" style="font-size: 11px;"></i></a>
							<a href="javascript:void(0);" class="add" (click)="copyUrl(photo.FILE_TN_URL)" title="Copy Photo URL"><i class="fas fa-link" style="font-size: 11px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="op44.toggle($event)"><i class="far fa-edit" style="font-size: 11px;"></i></a>
							<p-overlayPanel #op44 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea id='imagelabbel' class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{photo.FILE_DESCRIPTION}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(photo, 'PHOTO')">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>	
						</li>
                 
                  
					</ul>
				</div>
        </div>
	
	</div>
		
		</div>					
	</div>
	<!--<div *ngIf="libInfoShow" class="task-box1" style="width:220px; top:30vh;  left:0; max-height:60vh" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 4px; padding:10px; color:#C2D63F;font-size:12px"> 
			<label style="font-weight:bold; font-size:14px">Add Libraries</label>
			<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="libInfoShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
			<br>
			<div style="width: 220px; max-height: 300px; overflow:auto; margin:0; padding-right:4px; color:#C2D63F;font-size:.8em"> 
				<ng-container *ngFor="let item of curDoc.libs; trackBy:trackByFuntion"> 
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-1" href="javascript:void(0)" title="Preview" (click)="op401.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
					
					<p-overlayPanel #op401 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
					<ng-template pTemplate>
						<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
							<h6>{{item.ITEM_TITLE}}</h6>
							<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
								<label class="tag">{{label}}</label>
							</ng-container>	
							<div *ngIf="item.LIBRARY_ID>-1">
								<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
							</div>
							<div *ngIf="!item.COST_LIBRARY_ID">
								<strong>Content :</strong>
								<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
								<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
								</div>
								<div *ngIf="item.COST_LIBRARY_ID>-1">
									<strong>Cost :</strong> {{item.COST}}
								</div>
							</div>																	
						</ng-template>
					</p-overlayPanel>
				</ng-container>										
			</div>
			<button type="button" class="btn btn-outline-light btn-sm mr-4  mb-1 pt-0 pb-0 pl-1 pr-1" (click)="autoSave('modify',curDoc.id, curDoc.SECTION_TITLE,selectedEditor); libInfoShow=false;"><span style="font-size:.8em;">Save</span></button>
		</div>	
	</div> [attr.contenteditable]="checkOnAll" [attr.data-wsc-autocreate]="checkOnAll"-->
	
	<div [style.padding-top.px]="pageMargin.top" [style.padding-bottom.px]="pageMargin.bottom" [style.padding-left.px]="pageMargin.left" [style.padding-right.px]="pageMargin.right"  style="position:relative">
	<div id='inputContent'>
		
	<div *ngIf="!onlyCost&&(!onlyWCompete)&&(!onlyRCompete)"> 
	<div *ngFor="let page of frontpages; let s=index; trackBy:trackByFuntion" [ngClass]="{'hideSec':page.HIDE}"  style="position:relative; clear:both" [style.pointer-events]="tableShow ? 'none' : 'auto'">
		
		<button  *ngIf="page.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
		<i *ngIf="page.suggestions&&page.suggestions.length>0" class="tcicon">TC</i>
		<label [id]="page.id+'content'" style="font-weight:bold; width: 80%;"  [ngClass]="{'blue':listid==page.id, 'hideSec':page.OSNAME}" (click)="addLib=false; getFPosition(page, $event,s); curDoc=page"><span style="color:white">.</span>
			<span *ngIf="page.SECTION_TITLE&&page.SECTION_TITLE.length>0"  class="replaceContainer" [attr.data-id]="page.id" data-type="title"  [innerHTML]="page.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
			<app-edit-input *ngIf="page.id==listid&&page.id==onlock" [text]="page.SECTION_TITLE" (edited)="addLib=false; changeTitle('front',$event,s)"></app-edit-input>
		</label>
		<i class="btn-blue fa-comment-alt btncomm" [ngStyle]="{'color':commIds.indexOf(page.id)>-1? '#6BB10F':'#686868'}" [ngClass]="{'fas':commIds.indexOf(page.id)>-1, 'far':commIds.indexOf(page.id)==-1}" title="User Comments" (click)="secComments=[]; secCommId=page.id; getSecComments(page, page.id);curDoc=page; commShow=true"></i>
		<ng-container *ngIf="page.id==listid&&page.id==onlock">
			<span class="opBtn" style="right:20px" (click)="pageOPShow=true">Options <i class="fas fa-angle-down"></i></span>
			<div *ngIf="page.pageSrc!='pdf'"  class="ckContainer">
				<app-paragraph [ifReadOnly]='page.id!=onlock' [insertSign]='page.insert' [addedSlot]="page.addedItem"  class="docItem" [users]="page.tcusers"  [suggests]="page.suggestions" [comments]="page.comments" [content]="page.text"  [getText]="page['reqIndex']"  (selected)="selectedRow=-1;selectedCell=null;listid=page.id;addLib=true; selectedEditor='F'; selectIndex=s;" (onExit)='pageData($event, s);'  (onTrackChange)="pageSuggest($event, s)" (rfSelected)="selectedRF($event)"></app-paragraph>
				<button  [ngClass]="{'hasLibs':page.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;filteredData=null;selectedRow=-1;selectedCell=null;showSavedLib(page.libs);op40.toggle($event);">Libraries</button>
				<button  [ngClass]="{'hasLibs':page.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; filteredData=null;selectedRow=-1;selectedCell=null; showsavedSlot(page.slots)">Repeat Fields</button>					
				<p-overlayPanel #op40 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; max-height: 300px; overflow:auto; margin:0; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<ng-container *ngFor="let item of page.libs; trackBy:trackByFuntion"> 
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op401.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
					
					<p-overlayPanel #op401 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> {{item.COST}}
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</ng-container>										
				</div>
				</ng-template>
			</p-overlayPanel>
			</div>
			
		</ng-container>		
		<div *ngIf="page.id!=listid||page.id!=onlock" class="puretext" (click)="getFPosition(page, $event,s);curDoc=page" style="position: relative;">
			<div *ngIf='page.text&&page.text.length>0' style="width:100%; padding:10px; margin:0"  class="replaceContainer ck-content" [attr.data-id]="page.id" data-type="text" [innerHTML]="page.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
			</div>
		</div>
		
		<div *ngFor="let page1 of page.SUB_SECTIONS; let t=index; trackBy:trackByFuntion" [ngClass]="{'hideSec':page1.HIDE}" style="position:relative; clear:both">
			<button  *ngIf="page1.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
			<i *ngIf="(page1.suggestions&&page1.suggestions.length>0)||page1.tcflag" class="tcicon">TC</i>
			<label [id]="page1.id+'content'" style="font-weight:bold; width: 80%;"  [ngClass]="{'blue':listid==page1.id, 'hideSec':(page1.TYPE=='TABLE'&&page1.OTNAME)||(page1.TYPE=='PHOTOS'&&page1.OPNAME)||(page1.OSNAME&&(page1.TYPE=='PARA'||page1.TYPE=='SEALS'||page1.TYPE=='SIGNS'))}" (click)="addLib=false; getFPosition(page1, $event,s, t); curDoc=page1"><span style="color:white">.</span>
				<span *ngIf="page1.SECTION_TITLE&&page1.SECTION_TITLE.length>0"  class="replaceContainer" [attr.data-id]="page1.id" data-type="title"  [innerHTML]="page1.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
				<app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" [text]="page1.SECTION_TITLE" (edited)="addLib=false; changeTitle('front',$event,s, t)"></app-edit-input>
				<ng-container *ngIf="page1.id==listid&&page1.id==onlock">
					<i *ngIf="(!(page1.text&&page1.text.length>0))&&(!(allEditor.indexOf(page1.id)>-1))&&otherTypes.indexOf(page1.TYPE)==-1"  class=" btn-blue far fa-edit " (click)="getFPosition(page1,$event,s, t);addEditor(page1.id)"></i>
					<i *ngIf="page1.TYPE=='PHOTOS'" [ngClass]="{'disabled':page1.id!=onlock}" class="btn-blue fas fa-camera-retro" (click)="getFPosition(page1, $event, s,t); selectPhoto()"></i>
					<i *ngIf="page1.TYPE=='TABLE'" title="Table Property" class="btn-blue fas fa-table" (click)="selectedRow=-1;selectedCell=null;getFPosition(page1,$event,s, t); toCreateTable(s,t)"></i>
					<i *ngIf="page1.TYPE=='TABLE'&&(!page1.data?.erisName)"  class="btn-blue" title='Modify Table' (click)="modifyTable(page1); selectedEditor='F'"><img src="/assets/images/icons8-edit-property-32.png" class="imageIcon1"></i>

				</ng-container>		
			</label>
			<ng-container *ngIf="page1.id==listid&&page1.id==onlock">
			<span *ngIf='page1.TYPE!="PITABLE"' class="opBtn" [ngClass]="{'disabled':page1.id!=listid||page1.id!=onlock}" (click)="noSeq=false;optionShow=true">Options <i class="fas fa-angle-down"></i></span>
			<!--<i *ngIf="(!page1?.data?.erisName&&page1.TYPE=='TABLE')&&(listid==page1.id)&&page1.id==onlock" class="btn-blue fas fa-toolbox tablebtn" (click)="tableToolShow=true; curSec=page1"></i>-->
			<div *ngIf="page1.TYPE=='PARA'" class="ckContainer">
					<app-paragraph [addedSlot]="page1.addedItem" [insertSign]='page1.insert' class="docItem"  [getText]="page1['reqIndex']" [users]="page1.tcusers"  [suggests]="page1.suggestions" [comments]="page1.comments" [content]="page1.text" (selected)="selectedRow=-1;selectedCell=null;getFPosition(page1, $event,s, t);addLib=true;selectedEditor='F';" (onExit)='pageData($event, s, t)'  (onTrackChange)="pageSuggest($event, s, t)" (rfSelected)="selectedRF($event)"></app-paragraph>
					<button [ngClass]="{'hasLibs':page1.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;getFPosition(page1, $event,s, t);  filteredData=null;selectedRow=-1;selectedCell=null;showSavedLib(page1.libs);op41.toggle($event);">Libraries</button>
					<button [ngClass]="{'hasLibs':page1.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; getFPosition(page1, $event,s, t); filteredData=null;selectedRow=-1;selectedCell=null; showsavedSlot(page1.slots)">Repeat Fields</button>					
					<p-overlayPanel #op41 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; margin:0; max-height: 300px; overflow:auto; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<ng-container *ngFor="let item of page1.libs; trackBy:trackByFuntion"> 
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op411.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
					
					<p-overlayPanel #op411 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> {{item.COST}}
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</ng-container>										
				</div>
				</ng-template>
			</p-overlayPanel>
				</div>
			</ng-container>
			<div *ngIf="page1.id!=listid||page1.id!=onlock" class="puretext" (click)="getFPosition(page1, $event,s, t); curDoc=page1" style="position: relative;">
				<div *ngIf='page1.text&&page1.text.length>0' style="width:100%; padding:10px; margin:0"  class="replaceContainer ck-content" [attr.data-id]="page1.id" data-type="text" [innerHTML]="page1.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
				</div>
			</div>
			
			<div *ngIf="page1.id==listid&&page1.id==onlock" [ngClass]="{'hideSec':page1.OTABLE}">
			
		<div  class="editTable1" *ngIf="page1?.data&&(!page1?.data?.erisName)&&page1.TYPE!='PITABLE'" style="position: relative;">
			<table *ngIf="page1.TYPE=='TABLE'&&page1.data&&(!page1.data?.erisName)&&page1.id!='phaseI_project_summary_table'" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
				<!--<caption *ngIf="page1.data['caption']" [ngStyle]="{'border':page1.data['caption']['border']?'solid 1px black':'none', 'text-align':page1.data['caption']['align']?page1.data['caption']['align']:'center'}">
					<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-v]='t' [innerHTML]="page1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				</caption>-->
				<thead>
					<ng-container *ngFor="let brow of page1.data.beforeHeaders; let bindex=index">
						<tr>
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<i *ngIf="page1.data['locked']&&page1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
									<i *ngIf="page1.data['locked']&&page1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
					<tr>
						<ng-container *ngFor="let h of page1.data?.cols; let o=index; trackBy:trackByFuntion">
							<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
								<i *ngIf="page1.data['locked']&&page1.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" [ngStyle]="{'color':page1.OHEADER?'#C4C4C4':'#444'}" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='o' [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
					<ng-container *ngFor="let brow of page1.data.afterHeaders; let bindex=index">
						<tr>
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<i *ngIf="page1.data['locked']&&page1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
									<i *ngIf="page1.data['locked']&&page1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
				</thead>
				<tbody>
					<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
						<tr *ngIf="r.items?.length>1">
							<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
								<td [ngStyle]="{'text-align':page1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
									<i *ngIf="page1.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
									<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>										
									<span *ngIf="k.DATA" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='h' [attr.data-y] ="q" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							
								</td>														
							</ng-container>
						</tr>
						<tr *ngIf="r.items?.length==1">
							<td [attr.colspan]='page1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
								<span *ngIf="r.items[0].DATA" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='h' data-y="0" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								<i *ngIf="page1.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
			<!--<p-table [value]="page1.data.rows" [columns]="page1.data.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, page1.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, page1)">
 	<ng-template pTemplate="header" let-columns>
        <tr>
            <th class="cellItem" style="width:24px; background:white !important;vertical-align:middle" ></th>
            <th *ngFor="let col of columns; let u=index" style="background:white !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" pReorderableColumn pResizableColumn class="cellItem">
                <span class="headerCell" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" [ngStyle]="{'color':page1.OHEADER?'#C4C4C4':'#444'}"></span>
				<a (click)="selectCol(page1, u, col); getFPosition(page1,$event,s,t)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
			</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, page1, index);selectedCell=null;" [ngClass]="{'selected':rowData.selected}">
                <span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>				
            </td>			
 			<ng-container *ngIf="rowData.items[0].colspan">
				<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(page1, index, columns[0], rowData.items[0])" [ngClass]="{'rowHide':rowData.hide}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
					<span class="innerCell" *ngIf="rowData.items[0].DATA" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='index' data-y="0" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					<a (click)="op504.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op504 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
                <ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[0])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[0])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[0])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[0])">Clear</a>
					</div>					
				</ng-template>
            </p-overlayPanel>
				</td>
			</ng-container>	
			<ng-container *ngIf="!rowData.items[0].colspan">
				<td *ngFor="let col of columns; let u=index" [ngStyle]="{'text-align':col.celAllign, 'background':rowData.items[u].bkcolor? rowData.items[u].bkcolor:'white'}"  class="cellItem" (dblclick)="selectCell(page1, index, col, rowData.items[u])" [ngClass]="{'rowHide':rowData.hide}">
					<span class="innerCell" *ngIf="rowData.items[u].DATA" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='index'[attr.data-y] ="u" [innerHTML]="rowData.items[u].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					<a (click)="op501.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[u].libs&&rowData.items[u].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op501 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
                <ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[u])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[u])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[u])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[u])">Clear</a>
					</div>					
				</ng-template>
            </p-overlayPanel>
				</td>
			</ng-container>			
        </tr>
    </ng-template>
</p-table>--> 
</div>
<table *ngIf="page1.TYPE=='PITABLE'&&page1.data" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
	<thead>
	<tr>
		<ng-container *ngFor="let h of page1.data?.cols; let o=index; trackBy:trackByFuntion">
			<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
				<span style="font-weight:bold" [ngStyle]="{'color':page1.OHEADER?'#C4C4C4':'#444'}">{{h.NAME}}</span>
			</th>
		</ng-container>
	</tr>
	</thead>
	<tbody>
	<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
		<tr *ngIf="r.length>1">
			<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
				<td [ngStyle]="{'text-align':page1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
					<span *ngIf="!k.refId&&(!k.secHtml)">{{k.data}}</span>
					<span *ngIf="!k.refId&&k.secHtml"   class="replaceContainer" [attr.data-id]="page1.id" data-type="pitable" [attr.data-x]='q' [innerHTML]="k.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
					<a *ngIf="k.refId" href="javascript:void(0)" (click)="scrollTo(k.refId)" style="color:#000; margin-left: 2px;">{{k.data}}</a>
				</td>														
			</ng-container>
		</tr>
		<tr *ngIf="r.colspan">
			<td [attr.colspan]='page1.data.cols.length' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
				{{k.data}}
			</td>
		</tr>
	</ng-container>
	</tbody>
</table>
</div>
<div *ngIf="page1.id!=listid||page1.id!=onlock" class="puretext" (click)="getFPosition(page1,$event,s,t);resetProp(page1);curDoc=page1" style="position: relative;" [ngClass]="{'hideSec':page1.OTABLE}">
	<table *ngIf="page1.TYPE=='TABLE'&&page1.data&&(!page1.data?.erisName)&&page1.id!='phaseI_project_summary_table'" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
		<!--<caption *ngIf="page1.data['caption']" [ngStyle]="{'border':page1.data['caption']['border']?'solid 1px black':'none', 'text-align':page1.data['caption']['align']?page1.data['caption']['align']:'center'}">
			<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-v]='t' [innerHTML]="page1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
		</caption>-->
		<thead>
			<ng-container *ngFor="let brow of page1.data.beforeHeaders; let bindex=index">
				<tr>
					<ng-container *ngFor="let col of brow; let u=index">
						<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
							<i *ngIf="page1.data['locked']&&page1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
						<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
							<i *ngIf="page1.data['locked']&&page1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
			</ng-container>
			<tr>
				<ng-container *ngFor="let h of page1.data?.cols; let o=index; trackBy:trackByFuntion">
					<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
						<i *ngIf="page1.data['locked']&&page1.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" [ngStyle]="{'color':page1.OHEADER?'#C4C4C4':'#444'}" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='o' [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
				</ng-container>
			</tr>
			<ng-container *ngFor="let brow of page1.data.afterHeaders; let bindex=index">
				<tr>
					<ng-container *ngFor="let col of brow; let u=index">
						<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
							<i *ngIf="page1.data['locked']&&page1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
						<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
							<i *ngIf="page1.data['locked']&&page1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
			</ng-container>
		</thead>
		<tbody>
			<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
				<tr *ngIf="r.items?.length>1">
					<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
						<td [ngStyle]="{'text-align':page1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
							<!--<span *ngIf="k.DATA" [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|safeHtml'></span>-->
							<i *ngIf="page1.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
							<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>										
							<span *ngIf="k.DATA" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='h' [attr.data-y] ="q" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					
						</td>														
					</ng-container>
				</tr>
				<tr *ngIf="r.items?.length==1">
					<td [attr.colspan]='page1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
						<span *ngIf="r.items[0].DATA" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='h' data-y="0" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						<i *ngIf="page1.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
					</td>
				</tr>
			</ng-container>
		</tbody>
	</table>
	<div *ngIf="page1.id=='phaseI_project_summary_table'">
					
		<table style="width:100%; font-family:Arial, sans-serif;border: none;border-collapse: collapse;margin-top: 10px" >
			<thead>
				<tr>
					<ng-container *ngFor="let h of page1.data.cols; let o=index; trackBy:trackByFuntion">
						<th *ngIf='!h["hide"]' [ngStyle]="{'width':h.width+h.unit}" style="font-weight: bold;text-align: center;">
							{{h.NAME}}
						</th>	
					</ng-container>
				</tr>
			</thead>
		<tbody>
		<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
			<tr>
			   <ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
					
						<td *ngIf='!k.secHtml' [ngStyle]="{'text-align':page1.data.cols[q].celAllign}">
							{{k.data}}
						</td>
						<td *ngIf='k.secHtml' [ngStyle]="{'text-align':page1.data.cols[q].celAllign}">
							<span  class="replaceContainer" data-type="pitable" [attr.data-id]="page1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</td>
					
				</ng-container>
			</tr>
		</ng-container> 
	</tbody> 
		</table>

	  </div>
	</div>
	<!--<div style="width:100%; padding:8px 16px" *ngIf="page1.TYPE=='PHOTOS'&&page1.photos&&page1.photos.length>0">
		<div class="row">
			<ng-container *ngFor="let photo of page1.photos; let u=index; trackBy:trackByFuntion">
				<div class="column">
					<div class="gallery">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:90%">
						<p class="desc">{{photo.JOB_TITLE}}: {{photo.FULL_NAME}}<app-edit-input [text]="photo.JOB_TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('photos','FILE_DESCRIPTION',u, $event,s,t)"></app-edit-input>
						<a href="javascript:void(0);" class="removeFile" (click)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t);removePhoto(photo)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
					</div>
				</div>
			</ng-container>
			</div>
		</div>-->
		<div *ngIf="page1.TYPE=='SEALS'&&page1.seals&&page1.seals.length>0" style="width:100%; padding:0" >
		<div class="row">
			<ng-container *ngFor="let photo of page1.seals; let u=index; trackBy:trackByFuntion">
				<div *ngIf="photo.TYPE=='seal'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
					</div>
					<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="removeFile1" title="Update Seal" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0)" [ngClass]="{'disable':page1.id!=onlock}" title="Remove Seal" style="margin:0 4px" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('seals',photo, u)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a>
					
				</div>
				<div *ngIf="photo.TYPE=='seal'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'sealAlignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
					</div>
				<p class="desc1"><a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}"  class="removeFile1" title="Update Seal" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0)" [ngClass]="{'disable':page1.id!=onlock}" title="Remove Seal" style="margin:0 4px" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('seals',photo, u)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a>
					
				</div>
			</ng-container>
			</div>
		</div>
		<div *ngIf="page1.TYPE=='SIGNS'&&page1.signs&&page1.signs.length>0" style="width:100%; padding:0" >
		<div class="row">
			<ng-container *ngFor="let photo of page1.signs; let u=index; trackBy:trackByFuntion">
			<div *ngIf="photo.TYPE=='signature'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1">
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='N'"  style="padding-left: 30px;">
					<div class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
					</div>
					<p class="desc1">{{photo.NAME}}</p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
					<p class="desc1" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo.DATE" class="desc1">Date: {{photo.DATE}}</p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p class="desc1"><a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></p>
					
				</div>
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'" style="width:50%" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
					<p *ngIf="photo['signlabel']" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}">{{photo['signlabel']}}</p>
					<div *ngIf="photo['signImgLabel']" style="display:flex;width:50%" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
						<span *ngIf="photo['signImgLabel']" style="align-self: flex-end"><label>{{photo['signImgLabel']}}</label><app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span *ngIf="photo['signImgLabel']" [ngClass]="{'under-line':photo['labelImgunderline']}">
							<div [ngStyle]="{'height':photo['height'],'line-height':photo['lineheight'],'margin':photo['signmargin']}">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<div *ngIf="!photo['signImgLabel']" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" [ngStyle]="{'height':photo['height']?photo['height']:'60px','line-height':photo['lineheight']?photo['lineheight']:'60px','margin':photo['signmargin']?photo['signmargin']:'0', 'border-bottom': photo['underline']?'2px solid black':'none'}">
							<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:90%;width:auto;vertical-align:bottom; margin: 4px;">
						</div>
						<p style="margin-top: 10px;" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}">{{photo.NAME}}</p>
						<p [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
						
						<p class="desc1"><a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
							<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></p>
							
										
				</div>
				<div *ngIf="photo.signatureTemplate" class="col-md-12">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>	
			</div>
			<div *ngIf="photo.TYPE=='signature'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="font-size: 10pt;">
					<div style="display:flex;width:50%">
						<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span class="under-line1">
							<div *ngIf="reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p style="margin-top: 10px;"><span class="desc3" style="font-weight: bold;font-size: 10pt;">{{photo.NAME}}</span></p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='C'" style="font-weight: bold;font-size: 10pt;"><span class="desc3" [innerHTML]="photo.TITLE"></span></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='L'"  style="font-weight: bold;font-size: 10pt;"class="desc3" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p><span class="desc3"><a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='N'" class="gallery1" style="display:block" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}" >
					<div class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
					</div>						
					<p><span class="desc2">{{photo.NAME}}</span></p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='C'"><span class="desc2" [innerHTML]="photo.TITLE"></span></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='L'" class="desc2" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo.DATE"><span class="desc2">Date: {{photo.DATE}}</span></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p><span class="desc2"><a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'" style="width:40%" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
					<p *ngIf="photo['signlabel']" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}">{{photo['signlabel']}}</p>
					<div *ngIf="photo['signImgLabel']" style="display:flex;width:50%" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
						<span *ngIf="photo['signImgLabel']" style="align-self: flex-end"><label>{{photo['signImgLabel']}}</label><app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span *ngIf="photo['signImgLabel']" [ngClass]="{'under-line':photo['labelImgunderline']}">
							<div [ngStyle]="{'height':photo['height'],'line-height':photo['lineheight'],'margin':photo['signmargin']}">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<div *ngIf="!photo['signImgLabel']" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" [ngStyle]="{'height':photo['height']?photo['height']:'60px','line-height':photo['lineheight']?photo['lineheight']:'60px','margin':photo['signmargin']?photo['signmargin']:'0', 'border-bottom': photo['underline']?'2px solid black':'none'}">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:90%;width:auto;vertical-align:bottom; margin: 4px;">
					</div>
					<p style="margin-top: 10px;" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}">{{photo.NAME}}</p>
					<p *ngIf="photo['ALIGN']=='C'" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
					<p *ngIf="photo['ALIGN']=='L'" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
					
					<p><span class="desc3"><a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
					
									
				</div>
				<div *ngIf="photo.signatureTemplate&&(!(reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" class="gallery1">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				<div *ngIf="photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;">
					<div  style="padding:0; margin: 0; width:50%" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
					<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);replaceSeal(photo, u)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':page1.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getFPosition(page1,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
				</div>	
				</div>
				<!--<div [innerHTML]="signhtml"></div>-->
				</ng-container>
			</div>
		</div>
		</div>
	</div>
	</div>
	<ng-container  *ngIf="reportInfo?.PCA_INDICATOR!='frm1104'&&reportInfo?.PHASE1_TYPE!='1103'">
	<div *ngFor="let doc of contents; let i=index; trackBy:trackByFuntion" [ngClass]="{'hideSec':doc.HIDE}"  style="position:relative;clear:both" [style.pointer-events]="tableShow ? 'none' : 'auto'">
		<ng-container *ngIf="(!onlyCost||costParents.indexOf(doc.id)>-1)&&(!onlyWCompete||(!doc.wcompleted&&onlyWCompete))&&(!onlyRCompete||(!doc.rcompleted&&onlyRCompete))&&(!hideSection||(!doc.HIDE&&hideSection))">
		<button  *ngIf="doc.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
		<!--<label [ngClass]="{'blue':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1)}" (click)="addLib=false; getPosition(doc, $event, i); curDoc=doc">{{doc.SECTION_SEQUENCE}}</label>
		-->
		<i *ngIf="doc.suggestions&&doc.suggestions.length>0" class="tcicon">TC</i>
		<label [id]="doc.id+'content'" style="font-weight:bold; width: 80%;"  [ngClass]="{'blue':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1), 'hideSec':doc?.OSNAME||doc?.OPNAME}" (click)="addLib=false; getPosition(doc,$event, i); curDoc=doc">
			{{doc.SECTION_SEQUENCE}}
			<ng-container *ngIf="doc.DISPLAY_SEQUENCE=='Y'">
				<ng-container *ngFor="let i of head1Space|fill">
					&nbsp;
				</ng-container>
			</ng-container>
			<span style="color:white" [ngClass]="{'blue':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1)}">.</span><span  *ngIf="doc.SECTION_TITLE&&doc.SECTION_TITLE.length>0" class="replaceContainer" [attr.data-id]="doc.id" data-type="title" [innerHTML]="doc.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
			<ng-container *ngIf="doc.id==onlock&&doc.id==curId">
				<app-edit-input [text]="doc.SECTION_TITLE" (edited)="addLib=false; getPosition(doc,$event,i);changeTitle('content',$event,i)"></app-edit-input>
				<i *ngIf="(!(doc.text&&doc.text.length>0))&&(!(allEditor.indexOf(doc.id)>-1))&&(otherTypes.indexOf(doc.TYPE)==-1||doc.TYPE=='PISUMMARY')" class=" btn-blue far fa-edit" (click)="getPosition(doc,$event, i); addEditor(doc.id)"></i>
				<i *ngIf="doc.TYPE=='PHOTOS'" [ngClass]="{'disabled':doc.id!=listid||doc.id!=onlock}" class="btn-blue fas fa-camera-retro" (click)="getPosition(doc,$event, i); selectPhoto()"></i>
			</ng-container>		
		</label>
		</ng-container>
		<label style="width: 19%;vertical-align: top;">
		<ng-container *ngIf="(!onlyCost||costParents.indexOf(doc.id)>-1)&&(!onlyWCompete||(!doc.wcompleted&&onlyWCompete))&&(!onlyRCompete||(!doc.rcompleted&&onlyRCompete))&&(!hideSection||(!doc.HIDE&&hideSection))">
		<i class="btn-blue fa-comment-alt btncomm" [ngStyle]="{'color':commIds.indexOf(doc.id)>-1? '#6BB10F':'#686868'}" [ngClass]="{'fas':commIds.indexOf(doc.id)>-1, 'far':commIds.indexOf(doc.id)==-1}" title="User Comments" (click)="secComments=[]; secCommId=doc.id; getSecComments(doc, doc.id);curDoc=doc; commShow=true"></i>
		<a class="btn btnComplete rCheck rbtn" title="Review Complete" [ngClass]="{'active1':doc.rcompleted, 'disable':doc.id!=listid}" (click)="slotToLib=false; getPosition(doc,$event,i); filteredData=null; selectedRow=-1;selectedCell=null;rComplete(doc)"><i *ngIf="doc.rcompleted" class="pi pi-check-circle" style="font-size:12px; margin-right:4px;"></i>R</a>
		<a class="btn btnComplete wCheck wbtn" title="Writing Complete" [ngClass]="{'active':doc.wcompleted, 'disable':doc.id!=listid}"(click)="slotToLib=false; getPosition(doc,$event,i); filteredData=null; selectedRow=-1;selectedCell=null;wComplete(doc)"><i *ngIf="doc.wcompleted" class="pi pi-check-circle" style="font-size:12px; margin-right:4px;"></i>W</a>
		</ng-container>
		<br>
		<ng-container *ngIf="!onlyCost&&(!onlyWCompete||(!doc.wcompleted&&onlyWCompete))&&(!onlyRCompete||(!doc.rcompleted&&onlyRCompete))&&(!hideSection||(!doc.HIDE&&hideSection))">
			<ng-container *ngIf="doc.id==onlock&&doc.id==curId">
				<span class="opBtn" (click)="noSeq=false; optionShow=true">Options <i class="fas fa-angle-down"></i></span>
				<a *ngIf="(otherTypes.indexOf(doc.TYPE)==-1&&((!doc.OSNAME&&doc.SECTION_TITLE.length>0)||doc.SECTION_SEQUENCE.length>0))&&summaryStatus" class="psBtn" [ngStyle]="{'color':doc.pisummarydata||doc.pcasummarydata?'#c2d63e':'#999','border-color':doc.pisummarydata||doc.pcasummarydata?'#c2d63e':'#999'}" title="Project Summary" (click)="editPs(doc)">PS</a>
			</ng-container>
		</ng-container>
	</label>
		<ng-container *ngIf="!onlyCost&&(!onlyWCompete||(!doc.wcompleted&&onlyWCompete))&&(!onlyRCompete||(!doc.rcompleted&&onlyRCompete))&&(!hideSection||(!doc.HIDE&&hideSection))">
			<ng-container *ngIf="doc.id==onlock&&doc.id==curId">		
		<div class="ckContainer" *ngIf='(allEditor.indexOf(doc.id)>-1||(doc.text&&doc.text.length>0))&&!doc?.intro'>
			<app-paragraph [ifReadOnly]='doc.id!=onlock' [insertSign]='doc.insert' [addedSlot]="doc.addedItem"  class="docItem"  [users]="doc.tcusers" [suggests]="doc.suggestions" [comments]="doc.comments" [content]="doc.text" [getText]="doc['reqIndex']"  (selected)="selectedRow=-1;selectedCell=null;getPosition(doc,$event,i);addLib=true;logUsers(doc.id, doc.SECTION_TITLE)" (onExit)='textData($event, doc.id, doc.SECTION_TITLE)' (onTrackChange)="textSuggest($event, doc.id, doc.SECTION_TITLE)" (rfSelected)="selectedRF($event)"></app-paragraph>
			<button  *ngIf="doc.id==onlock" [ngClass]="{'hasLibs':doc.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;getPosition(doc,$event,i);  filteredData=null;selectedRow=-1;selectedCell=null;showSavedLib(doc.libs);op43.toggle($event);">Libraries</button>
			<button  *ngIf="doc.id==onlock" [ngClass]="{'hasLibs':doc.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; getPosition(doc,$event,i); filteredData=null;selectedRow=-1;selectedCell=null; showsavedSlot(doc.slots)">Repeat Fields</button>					
			<p-overlayPanel #op43 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; margin:0; max-height: 300px; overflow:auto; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<ng-container *ngFor="let item of doc.libs; trackBy:trackByFuntion"> 
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op431.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
					
					<p-overlayPanel #op431 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> {{item.COST}}
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</ng-container>										
				</div>
				</ng-template>
			</p-overlayPanel>
		</div>
		</ng-container>
		<!--<ng-container *ngIf="doc.TYPE=='SUMMARY'">
			<app-summary *ngIf="doc.id=='project_summary'" [inputData]="doc.summaryData" [costs]="costTables" [category]='summaryCategory' [pcaData]='pcaOp' [pcaRate]='pcaOp.inflation' [pcaMultiplier]='pcaOp.multiplier' [pcaTerm]='pcaOp.reserve'  [summarys]='allSummarys' (toRF)="summaryShow=true; showSlots(); curSummary=$event" [rfinfo]="curSummary"  (toAction)='toSummaryAction($event)' (naviToSec)="scrollTo($event)" (summaryOutput)="addToSummary($event, doc)"></app-summary>
		</ng-container>-->
		<ng-container *ngIf="doc.TYPE=='1105'">
			<app-frm *ngIf="doc.id=='frm_sec'" [src]='"rpt"' [frmSign]="frmSign" [inputData]="doc.frmData" [updateFrmData]="updateFrmData" [users]="rptUser.length" [costs]="costTables" [ulProp]='ulProp' [lockId]='onlock' [pcaData]='pcaOp' [rterm]='reserveTerm' [pquan]='pcaQuantity' (toRF)="frmShow=true;showSlots(); curFrm=$event" [rfinfo]="curFrm.html" (costItem)="toCost($event)" (frmOutput)="saveFrmData($event, doc)" (toSign)="getSign()" (scrollOutput)="scroll($event)" (zoom)="frmTableZoom($event)" (click)="listid='frm_sec'" (secSwitch)="frmSwitch($event)"></app-frm><!--(frmOutput)="doc.frmData=$event"--> 
		</ng-container>
		<div *ngIf="doc.id!=curId||doc.id!=onlock" (click)="getPosition(doc,$event,i); curDoc=doc" class="puretext" style="position: relative;">
			<div *ngIf='(allEditor.indexOf(i.toString()+"--")>-1||(doc.text&&doc.text.length>0))&&!doc?.intro' class="replaceContainer ck-content" [attr.data-id]="doc.id" data-type="text" style="width:100%; padding:10px; margin:0" [innerHTML]="doc.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
			</div>
		</div>
		
		<div class="intro" *ngIf='doc?.intro'>
			<button class="intro-btn btn btn-sm">Instruction Only</button>
			<div [innerHTML]='doc.text' style="width:100%; margin:0"></div>
		</div>
		
		<div style="width:100%; padding:8px 16px" *ngIf="doc.TYPE=='PHOTOS'&&doc.photos&&doc.photos.length>0">
			<div class="row">
			<ng-container *ngFor="let photo of doc.photos; let s=index">
				<div class="column">
					<!--<div class="gallery">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:90%">
						<p class="desc">{{photo.FILE_DESCRIPTION}}<app-edit-input [text]="photo.FILE_DESCRIPTION" [maxlength]='100' (edited)="addLib=false; getPosition(doc,$event,i); changeDesc('photos','FILE_DESCRIPTION',s, $event,i)"></app-edit-input>
						<a href="javascript:void(0);" class="removeFile" (click)="addLib=false; getPosition(doc,$event,i); removePhoto(photo)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
									
					</div>-->
					<div class="gallery" style="text-align: center;height:240px;line-height: 240px;">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="max-height: 100%;max-width: 100%;vertical-align: middle;">
					</div>
					<div style="height:60px">
						<p class="desc"><span  class="replaceContainer" [attr.data-id]="doc.id" data-type="photo" [attr.data-x]='s' [innerHTML]="photo.FILE_DESCRIPTION|highlighter:searchText:caseOn:allMatchtext"></span><app-edit-input *ngIf='doc.id==curId&&doc.id==onlock' [text]="photo.FILE_DESCRIPTION" [maxlength]='100' (edited)="addLib=false; getPosition(doc1,$event,i, j); changeDesc('photos','FILE_DESCRIPTION',s, $event,i,j)"></app-edit-input>
						<a *ngIf='doc.id==curId&&doc.id==onlock' href="javascript:void(0);" class="removeFile" (click)="addLib=false; getPosition(doc1,$event,i,j); removePhoto(photo)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				
					</div>
				</div>
			</ng-container>
			</div>
		</div>
		</ng-container>
		<div *ngFor="let doc1 of doc.SUB_SECTIONS; let j=index; trackBy:trackByFuntion"  [ngClass]="{'hideSec':doc1.HIDE, 'hidefrm':doc1['HIDEFRM']}" style="position:relative;clear:both">
			<ng-container *ngIf="(!onlyCost||(costParents.indexOf(doc1.id)>-1||doc1.TYPE=='COSTTABLE'))&&(!onlyWCompete||(!doc1.wcompleted&&onlyWCompete))&&(!onlyRCompete||(!doc1.rcompleted&&onlyRCompete))&&(!hideSection||((!doc.HIDE&&!doc1.HIDE&&!doc1.OTABLE)&&hideSection))&&(doc1.TYPE!=='1105')">
			<button  *ngIf="doc1.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
			<i *ngIf="(doc1.suggestions&&doc1.suggestions.length>0)||doc1.tcflag" class="tcicon">TC</i>
			<!--<label  style="margin-left:10px; flex: 0 0 auto;" [ngClass]="{'blue':curIndex[0]==i&&(curIndex[1]==j)&&!(curIndex[2]>-1)}"   (click)="addLib=false; getPosition(doc1,$event, i, j); curDoc=doc1">. {{doc1.SECTION_SEQUENCE}} </label>
			-->
			<label [id]="doc1.id+'content'" style="font-weight:bold;width: 80%;"  [ngClass]="{'blue':curIndex[0]==i&&(curIndex[1]==j)&&!(curIndex[2]>-1), 'hideSec':doc1?.OTNAME||doc1?.OSNAME||doc1?.OPNAME}"   (click)="addLib=false; getPosition(doc1,$event, i, j); curDoc=doc1">
				. {{doc1.SECTION_SEQUENCE}}
				<ng-container *ngIf="doc1.DISPLAY_SEQUENCE=='Y'">
					<ng-container *ngFor="let i of head2Space|fill">
							&nbsp;
						</ng-container>
					</ng-container>
				<span style="color:white" [ngClass]="{'blue':curIndex[0]==i&&(curIndex[1]==j)&&!(curIndex[2]>-1)}">.</span><span  *ngIf="doc1.SECTION_TITLE&&doc1.SECTION_TITLE.length>0" class="replaceContainer" [attr.data-id]="doc1.id" data-type="title" [innerHTML]="doc1.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
				<ng-container *ngIf="doc1.id==onlock&&doc1.id==curId" >
					<app-edit-input *ngIf="doc1.id==listid" [text]="doc1.SECTION_TITLE" [id]="doc1.id+'content'" (edited)="changeTitle('content',$event,i,j)"></app-edit-input>
					<i *ngIf="(!(doc1.text&&doc1.text.length>0))&&(!(allEditor.indexOf(doc1.id)>-1))&&otherTypes.indexOf(doc1.TYPE)==-1&&(!doc1.tableClass)"  class=" btn-blue far fa-edit " (click)="getPosition(doc1,$event,i, j);addEditor(doc1.id)"></i>
					<i *ngIf="doc1.TYPE=='PDFSEC'" class=" btn-blue far fa-file-pdf" (click)="getPosition(doc1,$event, i,j);"></i>
					<i *ngIf="doc1.TYPE=='PHOTOS'" class="btn-blue fas fa-camera-retro" (click)="getPosition(doc1,$event, i,j); selectPhoto()"></i>
					<i *ngIf="doc1.TYPE=='TABLE'&&(!doc1.data?.disableCopiedEris)" title="Table Property" class="btn-blue fas fa-table" (click)="selectedRow=-1;selectedCell=null;getPosition(doc1,$event,i,j);toCreateTable(i,j)"></i>
					<ng-container *ngIf="doc1.TYPE=='COSTTABLE'">
						<i class="btn-blue far fa-plus-square" title="Add Cost Recommendation Item" (click)="getPosition(doc1,$event,i,j); selectedRow=-1;selectedCell=null;getCostData(doc1.id)"></i>
					</ng-container>
					<i *ngIf="!doc1.data?.disableCopiedEris&&reportInfo?.ORDER_NUM&&doc1.TYPE=='TABLE'&&doc1.data?.erisName&&doc1.data?.erisName.length>0"  class="btn-blue" title='Modify ERIS Table' (click)="modifyEris(doc1)"><img src="/assets/images/edit-table-2.png" class="imageIcon"></i>
					<i *ngIf="doc1.TYPE=='TABLE'&&(!doc1.data?.erisName)"  class="btn-blue" title='Modify Table' (click)="modifyTable(doc1); selectedEditor='O'"><img src="/assets/images/icons8-edit-property-32.png" class="imageIcon1"></i>
				</ng-container>
			
			</label>
		
			</ng-container>
			
			<ng-container *ngIf="(!onlyCost||doc1.TYPE=='COSTTABLE')&&(!onlyWCompete||(!doc1.wcompleted&&onlyWCompete))&&(!onlyRCompete||(!doc1.rcompleted&&onlyRCompete))&&(!hideSection||((!doc.HIDE&&!doc1.HIDE&&!doc1.OTABLE)&&hideSection))&&(doc1.TYPE!=='1105')">
				<label style="width: 19%;vertical-align: top;float: right;"><i class="btn-blue far fa-comment-alt btncomm" [ngStyle]="{'color':commIds.indexOf(doc1.id)>-1? '#6BB10F':'#686868'}" [ngClass]="{'fas':commIds.indexOf(doc1.id)>-1, 'far':commIds.indexOf(doc1.id)==-1}" title="User Comments" (click)="secComments=[]; secCommId=doc1.id; getSecComments(doc1, doc1.id);curDoc=doc1; commShow=true;"></i>
					<a class="btn btnComplete rCheck rbtn"  title="Review Complete" [ngClass]="{'active1':doc1.rcompleted, 'disable':doc1.id!=listid}" (click)="slotToLib=false; getPosition(doc1,$event,i,j); filteredData=null; selectedRow=-1;selectedCell=null;rComplete(doc1)"><i *ngIf="doc1.rcompleted" class="pi pi-check-circle" style="font-size:12px; margin-right:4px;"></i>R</a>
					<a class="btn btnComplete wCheck wbtn"  title="Writing Complete" [ngClass]="{'active':doc1.wcompleted, 'disable':doc1.id!=listid}" (click)="slotToLib=false; getPosition(doc1,$event,i,j); filteredData=null; selectedRow=-1;selectedCell=null;wComplete(doc1)"><i *ngIf="doc1.wcompleted" class="pi pi-check-circle" style="font-size:12px; margin-right:4px; margin-bottom:0"></i>W</a>
					<i *ngIf="doc1['ZOOM']" title="Click to See the Full Table" class="btn-blue fas fa-search-plus zoombtn" (click)="tableZoom(doc1.data);"></i>
					<i *ngIf="doc1.TYPE=='TABLE'&&doc1.data?.erisName&&doc1.data?.erisName.length>0"  class="btn-blue fas fa-minus-square erisbtn" title="Show ERIS Table" [ngClass]="{'active':!doc1['HIDEERIS']}" (click)="erisToggle(doc1)"></i>
					
					<ng-container *ngIf="doc1.id==onlock&&doc1.id==curId" >
						<br><span *ngIf="(!doc1['tableClass']||doc1.id=='pca_summary_0')&&doc1.TYPE!='PITABLE'" class="opBtn" (click)="checkParentSeq(doc.DISPLAY_SEQUENCE); optionShow=true">Options <i class="fas fa-angle-down"></i></span>
						<a *ngIf="(otherTypes.indexOf(doc1.TYPE)==-1&&((!doc1.OSNAME&&doc1.SECTION_TITLE&&doc1.SECTION_TITLE.length>0)||doc1.SECTION_SEQUENCE.length>0))&&summaryStatus&&!doc1.data&&(!doc1['tableClass'])" class="psBtn" [ngStyle]="{'color':doc1.pisummarydata||doc1.pcasummarydata?'#c2d63e':'#999','border-color':doc1.pisummarydata||doc1.pcasummarydata?'#c2d63e':'#999'}" title="Project Summary" (click)="editPs(doc1)">PS</a>
						<!--<i *ngIf="((!doc1?.data?.erisName&&doc1.TYPE=='TABLE')||(doc1.id=='pca_summary_0'))&&(curId==doc1.id)&&doc1.id==onlock" class="btn-blue fas fa-toolbox tablebtn" (click)="tableToolShow=true;curSec=doc1"></i>-->
					</ng-container>
				</label>
				<br>
			</ng-container>
		
		<ng-container *ngIf="(!onlyCost||doc1.TYPE=='COSTTABLE')&&(!onlyWCompete||(!doc1.wcompleted&&onlyWCompete))&&(!onlyRCompete||(!doc1.rcompleted&&onlyRCompete))&&(!hideSection||((!doc.HIDE&&!doc1.HIDE&&!doc1.OTABLE)&&hideSection))&&(doc1.TYPE!=='1105')">
			<ng-container *ngIf="summaryStatus&&doc1.TYPE=='COSTTABLE'">
				
				<select class="costInput mr-1" style="width:40%; font-size: 11px;" [disabled]="doc1.id!=curId||doc1.id!=onlock" [ngStyle]="{'border':doc1['summaryCat']? 'none':'2px solid #F78181'}" (change)="selCostCat('summaryCat', $event, doc1)">
					<option></option>
					<option *ngFor="let item of summaryCategory; let i=index" [value]="item" [selected]="item==doc1['summaryCat']">{{item}}</option>
				</select>
			
		</ng-container>
			<select  *ngIf="reportInfo?.PCA_INDICATOR=='4099e'&&doc1.TYPE=='COSTTABLE'" [disabled]="doc1.id!=curId||onlock!=doc1.id" class="costInput" [ngStyle]="{'border':doc1.long?.length>0? 'none':'2px solid #F78181'}" style="width:40%; font-size: 11px;" (change)="selFmeCost('long', $event, doc1)">
				<option>Please Select Fannie Mae Category</option>
				<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.id==doc1.long">{{item.label}}</option>
			</select>
			<select *ngIf="doc1.TYPE=='COSTTABLE'&&reportInfo?.PCA_INDICATOR=='frm1105'" [disabled]="doc1.id!=curId" class="costInput" [ngStyle]="{'border':doc1.cat?.length>0? 'none':'2px solid #F78181'}" style="width:40%; font-size: 11px;"  (change)="selFrmUl(doc1, $event, 'cat')">
				<option value="-1">Please Select Freddie Mac Category</option>
				<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.tag==doc1.cat">{{item.label}}</option>
			</select>
			
			<!--<ng-container *ngIf="doc1.id==onlock&&doc1.id==curId" >
			<ng-container *ngIf="doc1.TYPE!='PCATABLE'&&doc1.TYPE!='UNITTABLE'">
			</ng-container>
			</ng-container>
			<p-overlayPanel #op62  [appendTo]="'body'" [dismissable]="false" [style]="{width: '340px'}">
					<ng-template pTemplate>
						<div *ngIf="doc1.id==secCommId" style="width: 300px; margin:0; color:#C2D63F;font-size:.9em;">
							<b>Comments</b>
							<a class="float-sm-right m-1 iconBtn" titie='close' pTooltip="Close" tooltipZIndex='auto' (click)="op62.hide();"><i class="far fa-window-close"></i></a>
							<a class="float-sm-right m-1 iconBtn" pTooltip="Add New Comment"  tooltipZIndex='auto' (click)="op72.toggle($event);"><i class="far fa-comment-dots"></i></a>
							<p-overlayPanel #op72  [appendTo]="'body'" [dismissable]="true" [style]="{width: '320px'}">
								<ng-template pTemplate>
									<div style="width: 300px; padding:10px; color:#C2D63F;font-size:.8em"> 
										<textarea [(ngModel)]='secComment' class="form-control" style="background-color:#222; color:white;"></textarea>
										<button type="button" class="btn btn-dark btn-sm float-sm-right" (click)="op72.hide();"><span style="font-size:.8em;">Close</span></button>
										<button [disabled]="secComment.length==0" type="button" class="btn btn-dark btn-sm float-sm-right" (click)='getPosition(doc1.id, doc1.SECTION_TITLE,$event,i, j); reComment(doc1.id, doc1.SECTION_TITLE);op72.hide();'>Save</button>							
							
									</div>
								</ng-template>
							</p-overlayPanel>
							<hr class='line'>
							<div style="height:300px; overflow:auto;">
							<ng-container *ngFor='let comm of secComments'>								
							<div class="card" style="margin-bottom:4px; border:1px solid #C3D42F; padding:2px">
								
								<div [style.color]="'dedede'">
									<i class="fas fa-user-circle m-1" style="font-size:1.4em; color:rgb(195,212,47)"></i>
									<span style="font-weight:bold">{{comm.CREATED_BY}}</span><span style="font-size:.em; margin-left:10px">{{comm.CREATED_TIMESTAMP}}</span>
									<p style="margin:0 0 0 24px">{{comm.COMMENT_CONTENT}}</p>									
									<i *ngIf="comm.COMMENT_STATUS=='Resolved'"  pTooltip="Resolved" tooltipZIndex='auto' class="fas fa-check-circle  float-sm-right m-0" style="font-size:1.4em; color:rgb(195,212,47)"></i>
									<a *ngIf="comm.COMMENT_STATUS=='New'"  pTooltip="Not Resolved" tooltipZIndex='auto' class="btn btn-dark btn-sm float-sm-right m-0" style="padding:0 2px" (click)="updateStatus(comm.COMMENT_ID)"><i class="far fa-check-circle" style="font-size:1.2em;"></i>
									</a>
								</div>
							</div>
							</ng-container>
							</div>						
						</div>
					</ng-template>
				</p-overlayPanel>-->		
			<br>
			<ng-container *ngIf="doc1.id==onlock&&doc1.id==curId" >
			
			<div  [ngClass]="{'hideSec':doc1.OTABLE}"  style="overflow: hidden;">
			
			<button  *ngIf="doc1.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
			<table *ngIf="doc1.id=='phaseI_project_summary_table'" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
				<thead>
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
							<span style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}">{{h.NAME}}</span>
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.length>1">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="!k.refId&&(!k.secHtml)">{{k.data}}</span>
								<span *ngIf="!k.refId&&k.secHtml" [innerHTML]="k.secHtml?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								<a *ngIf="k.refId" href="javascript:void(0)" (click)="scrollTo(k.refId)" style="color:#000; margin-left: 2px;">{{k.data}}</a>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.colspan">
						<td [attr.colspan]='doc1.data.cols.length' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
							{{k.data}}
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
			<ng-container *ngIf="doc1['tableClass']=='PCA'&&doc1.data">
				<table style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: none;border-collapse: collapse;margin-top: 10px" [ngClass]="{'pcasummary':headerClass=='PCA', 'phase1summary':headerClass=='PHASE1'}">
					<thead>
						<tr *ngIf="!doc1.OHEADER">
							<ng-container *ngFor="let h of doc1.data.cols; let o=index; trackBy:trackByFuntion">
								<th *ngIf='!h["hide"]' [ngStyle]="{'width':h.width+h.unit}" style="font-weight: bold;text-align: center;" [ngClass]="h.bk">{{h.NAME}}
									<!--<app-editable [text]="h.NAME" style="font-weight:bold" (edited)="changeLabel1($event, doc1, o)"></app-editable>-->
								</th>	
							</ng-container>
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
							<tr *ngIf="!r[0]['rowhide']">
								<td *ngIf="doc1.id=='pca_summary_0'" style="color:#555; background:white; padding:4px; font-size:11px; cursor: pointer;" (click)="getPosition(doc1,$event,i,j);selectToggle($event, doc1, h);selectedCell=null;" [ngClass]="{'selected':r.selected}">
									<span class="pi pi-bars" (click)="selectedRow=h;selectedCell=null"></span>
								</td>
								<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
									<ng-container *ngIf="!k.colspan">
										<td *ngIf='(!k.secHtml||doc1.id!="pca_summary_0")&&(!(k["hide"]&&doc1.id=="pca_summary_1")||doc1.id!="pca_summary_1")' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':doc1.id!='pca_summary_0'?k.border:'1px #ddd solid','padding-left':k.sub}" (dblclick)="selectCell(doc1, h, doc1.data.cols[q], k)">
										   <a *ngIf="q==0&&k.refId" href="javascript:void(0)" style="color:black" (click)="scrollTo(k.refId)">{{k.data}}</a>
										   <ng-container *ngIf="!k.refId||q>0">
												<ng-container *ngIf="k.data=='NaN'||k.data==''">
												</ng-container>
												<ng-container *ngIf="k.data!='NaN'&&k.data!=''">
													<ng-container *ngIf="k.sign">
														{{k.sign}}
													</ng-container>
													<span class="replaceContainer" data-type="pitable" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.data|highlighter:searchText:caseOn:allMatchtext"></span>
												</ng-container>
										   </ng-container>
										</td>
										<td *ngIf='k.secHtml&&doc1.id=="pca_summary_0"' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'padding-left':k.sub}" style='border:1px #ddd solid' (dblclick)="selectCell(doc1, h, doc1.data.cols[q], k)">
											<span class="replaceContainer" data-type="pstable" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
										</td>
									</ng-container>
									<ng-container  *ngIf="k.colspan">
										<td [attr.colspan]='k.colspan' [ngStyle]="{'text-align':k.celAllign, 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':k.border}">
											<ng-container *ngIf="k.sign">
												{{k.sign}}
											</ng-container>
											{{k.data}}
										</td>
									</ng-container>		
								</ng-container>
							</tr>
						</ng-container> 
					</tbody> 
				</table>
			</ng-container>
			<div style="position: relative;">
			<p *ngIf="(reportInfo?.ORDER_NUM||doc1?.data?.disableCopiedEris)&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length>100" class="erislabel">100 of {{doc1.data.rows.length}} total records shown</p>
			<p *ngIf="(reportInfo?.ORDER_NUM||doc1?.data?.disableCopiedEris)&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length<101" class="erislabel">{{doc1.data.rows.length}} of {{doc1.data.rows.length}} total records shown</p>
			<p *ngIf="!reportInfo?.ORDER_NU&&!doc1?.data?.disableCopiedEris&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length==1" class="erislabel">0 of 0 total records shown</p>
			
			<table *ngIf="doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName" style="width:100%; border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif">
				<thead>
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th *ngIf="(!h.hide||h.hide=='N')" [ngStyle]="{'width':h.width+h.unit,'text-align':doc1.data.cols[o].colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
							<span style="font-weight:bold"><span class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='o' [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span></span>
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data?.rows|slice: 0:100; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r[0]['SUBHEADER']!='Y'&&(r[0].DATA&&r[0].DATA.length>0)">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
								<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>
								<span *ngIf="!k.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.DATA|highlighter:searchText:caseOn:allMatchtext"></span>
								<span *ngIf="k.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q'  [innerHTML]="k.SEC.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
							</td>
						</ng-container>		
					</tr>
					<tr *ngIf="r[0]['SUBHEADER']=='Y'">
						<td colSpan='{{doc1.data.cols.length-1}}' [ngStyle]="{'text-align':r[0]['celAllign']?r[0]['celAllign']:'Center'}" style="border: 1px solid #ccc; text-align: center; border-collapse: collapse;vertical-align:top;">
							<span *ngIf="!r[1]?.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='h' data-y='1'[innerHTML]="r[1].DATA"></span>
							<span *ngIf="r[1]?.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='h' data-y='1' [innerHTML]="r[1].SEC.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>			
			</div>
			<table class="editTable" *ngIf="doc1.data&&(doc1.TYPE=='COSTTABLE'||doc1.TYPE=='PCATABLE'||doc1.TYPE=='UNITTABLE')" [ngStyle]="{'width':doc1.TYPE=='UNITTABLE'?'50%':'100%'}" style="font-size:10px; font-family:Arial, sans-serif;">
  <tr *ngIf="doc1.TYPE!='UNITTABLE'" style="background-color:#eeeeee; ">
  <th *ngIf="doc1.TYPE=='TABLE'||doc1.TYPE=='COSTTABLE'" style="width:36px"></th>
    <ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
	<th *ngIf="(!h.hide||h.hide=='N')&&(!doc1['ZOOM'])" [ngStyle]="{'width':h.width+h.unit,'text-align':'center'}">
	<!--<app-editable [text]="h.NAME" style="font-weight:bold" (focused)="addLib=false" (edited)="getPosition(doc1.id,doc1.SECTION_TITLE,$event,i, j);selCell(o); changeLabel($event)" [defaultText]='"Header"'></app-editable>-->
	<span>{{h.NAME}}</span>
		<app-edit-input [text]="h.NAME" (edited)="getPosition(doc1,$event,i, j);selCell(o); changeLabel($event)"></app-edit-input>
	</th>
	<th *ngIf="(!h.hide||h.hide=='N')&&doc1['ZOOM']">
		<p style="font-weight:bold;margin: 0;text-align: center;"> {{h.NAME.split(' ')[0]}}</p>
		<p *ngIf="h.NAME.split(' ').length>0" style="font-weight:bold; margin: 0;text-align: center">{{h.NAME.split(' ')[1]}}</p>
		<app-edit-input [text]="h.NAME" (edited)="getPosition(doc1,$event,i, j);selCell(o); changeLabel($event)"></app-edit-input>
	</th>
	<!--<th *ngIf="h.type=='dropdown'">
	
	</th>-->
	</ng-container>
  </tr>
  <ng-container *ngFor="let r of doc1.data?.rows; let h=index; trackBy:trackByFuntion">
  <tr *ngIf="r.length>1&&!((doc1.TYPE=='COSTTABLE')&&h==0)&&(!doc1.filted||doc1.filted.indexOf(r[0].DATA)>-1)" [ngStyle]="{'background-color':r?.hide=='Y'?'#666':'white'}">
	<td *ngIf="doc1.TYPE=='TABLE'||doc1.TYPE=='COSTTABLE'" [ngStyle]="{'background-color':r?.hide=='Y'?'#666':'white'}" style="font-size:.8em; width:30px">
	<i class="btn iconBtn1 far fa-edit" *ngIf="doc1.TYPE=='COSTTABLE'&&((!doc1.data.version)||(r[0].KEEP&&doc1.data.version&&doc1.data.version=='2'))&&(reportInfo.PCA_INDICATOR!='frm1105')" (click)="getPosition(doc1,$event,i, j);editCostRow(h)"></i>
	<i class="btn iconBtn1 fas fa-trash-alt" *ngIf="doc1.TYPE=='COSTTABLE'&&((!doc1.data.version)||(r[0].KEEP&&doc1.data.version&&doc1.data.version=='2'))&&(!r[0].FRM)" (click)="getPosition(doc1,$event,i, j);deleteRow(h,doc1)"></i>
	<i class="btn iconBtn1 far fa-edit" *ngIf="doc1.TYPE=='COSTTABLE'&&(r[0].KEEP||r[0].FRM)&&reportInfo?.PCA_INDICATOR=='frm1105'" (click)="getPosition(doc1,$event,i, j);editFrmCostRow(doc1, h)"></i>
	<a *ngIf="doc1.TYPE=='TABLE'" href="javascript:void(0)" class="btn btn-sm btn-link" (click)="op100.show($event);getPosition(doc1,$event,i, j);selectedRow=h;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'white':'rgb(195,212,47)'}">{{h+1}}</a>
	<!--<i *ngIf="r?.hide=='Y'" class="far fa-eye-slash" style="font-size:9px; color:white"></i>-->
	<p-overlayPanel #op100 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
            <ng-template pTemplate>                                                    
				<div *ngIf="selectedRow>-1"  style="font-size:.8em; color:#C2D63F; ">
					<label style="font-weight:bold">Row: {{selectedRow+1}}</label>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right"(click)="moveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="deleteRow(selectedRow)" title="Delete Row"><i class="fas fa-trash iconBtn smIcon" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" [ngStyle]="{'background-color':r.hide=='Y'?'white':'transparent'}" (click)="hideRow(selectedRow)"  title="Hide Row"><i class="far fa-eye-slash iconBtn smIcon" style="pointer-events:none"></i></a>
					<br>
					<div>
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
						<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addRows($event)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
						<select style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>                                       </ng-template>
            </p-overlayPanel>		
	</td>
    <ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
		<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" [ngClass]="{'active':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j}">
			
			<span *ngIf="!k.index&&doc1.TYPE=='TABLE'" [innerHTML]="k.DATA"></span>
			<!--<app-editable *ngIf="doc1.TYPE=='TABLE'" [text]="k.DATA" (edited)="selCell(h,q); changeLabel($event)" (focused)="addLib=false;getPosition(doc1.id,doc1.SECTION_TITLE,$event,i, j);" [defaultText]='"Text"'></app-editable>-->
			<app-edit-input *ngIf="doc1.TYPE=='TABLE'" [text]="k.DATA" (edited)="addLib=false;getPosition(doc1,$event,i, j);selCell(h,q); changeLabel($event)"></app-edit-input>
			<span *ngIf="doc1.TYPE!='TABLE'&&!k?.index" [ngStyle]="{'font-weight':k.bold}"><span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>{{k.DATA}}<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span></span>
			<a *ngIf="doc1.TYPE=='PCATABLE'&&k?.index" href="javascript:void(0)" [ngStyle]="{'font-weight':k.bold}" (click)="scrollTo(k.id, k?.index)">{{k.DATA}}</a>
			<a *ngIf="doc1.TYPE=='TABLE'&&doc1.TYPE!='PCATABLE'&&doc1.TYPE!='COSTTABLE'&&doc1.TYPE!='UNITTABLE'&&!doc1.data.SLOT_ID"><i class="fas fa-pencil-alt iconBtn"></i></a>
		</td>			
	</ng-container>
  </tr>
  <tr *ngIf="r.length==1&&doc1.data">
  <td *ngIf="doc1.TYPE!='PCATABLE'" style="font-size:.8em; background-color:#eeeeee; width:40px">
	<a  href="javascript:void(0)" class="btn btn-sm btn-link" (click)="op101.show($event); getPosition(doc1,$event,i, j);selectedRow=h;;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'white':'rgb(195,212,47)'}">{{h+1}}</a>
		<!--<i class="fas fa-long-arrow-alt-up iconBtn" (click)="getPosition($event,i, j);moveUp(h)"></i>
		<i class="fas fa-long-arrow-alt-down iconBtn" (click)="getPosition($event,i, j);moveDown(h)"></i>
		<i class="fas fa-trash iconBtn" (click)="getPosition($event,i, j);deleteRow(h)"></i>-->
		<p-overlayPanel #op101 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
            <ng-template pTemplate>                                                    
				<div *ngIf="selectedRow>-1"  style="font-size:.8em; color:#C2D63F; ">
					<label style="font-weight:bold">Row: {{selectedRow+1}}</label>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="deleteRow(selectedRow)"  title="Delete Row"><i class="fas fa-trash iconBtn smIcon" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="hideRow(selectedRow)"  [ngStyle]="{'background-color':r.hide=='Y'?'white':'transparent'}" title="Hide Row"><i class="far fa-eye-slash iconBtn smIcon" style="pointer-events:none"></i></a>
			<br>
					<div>
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
						<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addRows($event)"><span style="pointer-events:none; font-size:.8em">Add Row</span></a><br>
						<select style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>                                       </ng-template>
            </p-overlayPanel>
	
	</td>
		<td *ngIf="doc1.TYPE!='PCATABLE'" colSpan='{{doc1.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}"  style="font-weight:bold">
			<app-editable [text]="r[0].DATA" (edited)="selCell(h,0); changeLabel($event)" (focused)="addLib=false; getPosition(doc1,$event,i, j);" [defaultText]='"Sub-Header"'></app-editable>
		</td>
		<td *ngIf="doc1.TYPE=='PCATABLE'" colSpan='{{r[0]["colspan"]}}' [ngStyle]="{'text-align':r[0].celAllign}"  style="font-weight:bold">
			<a *ngIf="doc1.TYPE=='PCATABLE'&&r[0]?.index" href="javascript:void(0)" [ngStyle]="{'font-weight':r[0].bold}" (click)="scrollTo(r[0].id, r[0]?.index)">{{r[0].DATA}}</a>
		</td>
  </tr>
  </ng-container>
</table>
<div  class="editTable1" *ngIf="doc1?.data&&(!doc1?.data?.erisName&&doc1.TYPE=='TABLE')"  style="position: relative;">
	<table style="width:100%; border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;">
		<!--<caption *ngIf="doc1.data['caption']" [ngStyle]="{'border':doc1.data['caption']['border']?'solid 1px black':'none', 'text-align':doc1.data['caption']['align']?doc1.data['caption']['align']:'center'}">
			<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-v]='j' [innerHTML]="doc1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
		</caption>-->
		<thead>
			<ng-container *ngFor="let brow of doc1.data.beforeHeaders; let bindex=index">
				<tr>
					<ng-container *ngFor="let col of brow; let u=index">
						<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
						<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
			</ng-container>
		<tr>
			<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
				<th *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
					<i *ngIf="doc1.data['locked']&&doc1.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
					<span style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='o' [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				</th>
			</ng-container>
		</tr>
		<ng-container *ngFor="let brow of doc1.data.afterHeaders; let bindex=index">
			<tr>
				<ng-container *ngFor="let col of brow; let u=index">
					<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
						<i *ngIf="doc1.data['locked']&&doc1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
					<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
						<i *ngIf="doc1.data['locked']&&doc1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
				</ng-container>
			</tr>
		</ng-container>
		</thead>
		<tbody>
		<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
			<tr *ngIf="r.items?.length>1">
				<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
					<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
						<i *ngIf="doc1.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
						<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>	
						<span *ngIf="k.DATA"  class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</td>														
				</ng-container>
			</tr>
			<tr *ngIf="r.items?.length==1">
				<td [attr.colspan]='doc1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
					<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					<i *ngIf="doc1.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
				</td>
			</tr>
		</ng-container>
		</tbody>
	</table>
  <!--<p-table [value]="doc1.data.rows" [columns]="doc1.data.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, doc1.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, doc1)">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="cellItem" style="width:24px; background:white !important;vertical-align:middle"></th>
            <th *ngFor="let col of columns; let s=index" style="background:white !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" pReorderableColumn pResizableColumn class="cellItem">
				<span class="headerCell" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='o' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="selectCol(doc1, s, col); getPosition(doc1,$event,i,j)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
	            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, doc1, index);selectedCell=null;" [ngClass]="{'selected':rowData.selected}">
                <span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>
            </td>			
       		<ng-container *ngIf="rowData.items[0].colspan">
			<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(doc1, index, columns[0], rowData.items[0])" [ngClass]="{'rowHide':rowData.hide}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
				<span class="innerCell" *ngIf="rowData.items[0].DATA" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="op505.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op505 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
                <ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[0])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[0])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[0])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[0])">Clear</a>
					</div>					
				</ng-template>
            </p-overlayPanel>
			</td>
			</ng-container>	
			<ng-container *ngIf="!rowData.items[0].colspan">
			<td *ngFor="let col of columns; let u=index" [ngStyle]="{'text-align':col.celAllign, 'background':rowData.items[u].bkcolor? rowData.items[u].bkcolor:'white'}"  class="cellItem" (dblclick)="selectCell(doc1, index, col, rowData.items[u])" [ngClass]="{'rowHide':rowData.hide}">
				<span class="innerCell" *ngIf="rowData.items[u].DATA" [innerHTML]="rowData.items[u].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
 				<a (click)="op502.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[u].libs&&rowData.items[u].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op502 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
                <ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[u])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[u])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[u])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[u])">Clear</a>
					</div>					
				</ng-template>
            </p-overlayPanel>
			</td>
			</ng-container>			
        </tr>
    </ng-template>
</p-table>--> 
</div>
</div>
</ng-container>
<div *ngIf="doc1.id!=curId||doc1.id!=onlock" [ngClass]="{'hideSec':doc1.OTABLE}" class="puretext" (click)="getPosition(doc1,$event,i,j);resetProp(doc1); curDoc=doc1"  style="overflow: hidden;">
	<button  *ngIf="doc1.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
	<div *ngIf="doc1.id=='phaseI_project_summary_table'">
					
		<table style="width:100%; font-family:Arial, sans-serif;border: none;border-collapse: collapse;margin-top: 10px" >
			<thead>
				<tr>
					<ng-container *ngFor="let h of doc1.data.cols; let o=index; trackBy:trackByFuntion">
						<th *ngIf='!h["hide"]' [ngStyle]="{'width':h.width+h.unit}" style="font-weight: bold;text-align: center;">
							{{h.NAME}}
						</th>	
					</ng-container>
				</tr>
			</thead>
		<tbody>
		<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
			<tr>
			   <ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
					
						<td *ngIf='!k.secHtml' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign}">
							{{k.data}}
						</td>
						<td *ngIf='k.secHtml' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign}">
							<!--<span  [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>-->
							<span  class="replaceContainer" data-type="pstable" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</td>
					
				</ng-container>
			</tr>
		</ng-container> 
	</tbody> 
		</table>

	  </div>
	  <ng-container *ngIf="doc1['tableClass']=='PCA'&&doc1.data">
		<table style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: none;border-collapse: collapse;margin-top: 10px" [ngClass]="{'pcasummary':headerClass=='PCA', 'phase1summary':headerClass=='PHASE1'}">
			<thead>
				<tr *ngIf="!doc1.OHEADER">
					<ng-container *ngFor="let h of doc1.data.cols; let o=index; trackBy:trackByFuntion">
						<th *ngIf='!h["hide"]' [ngStyle]="{'width':h.width+h.unit}" style="font-weight: bold;text-align: center;" [ngClass]="h.bk">{{h.NAME}}
							
						</th>	
					</ng-container>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="!r[0]['rowhide']">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<ng-container *ngIf="!k.colspan">
								<td *ngIf='(!k.secHtml||doc1.id!="pca_summary_0")&&(!k["hide"]||doc1.id!="pca_summary_1")' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':doc1.id!='pca_summary_0'?k.border:'1px #ddd solid','padding-left':k.sub}">
									<span *ngIf="q==0&&k.refId">{{k.data}}</span>
								   <ng-container *ngIf="!k.refId||q>0">
										<ng-container *ngIf="k.data=='NaN'||k.data==''">
										</ng-container>
										<ng-container *ngIf="k.data!='NaN'&&k.data!=''">
											<ng-container *ngIf="k.sign">
												{{k.sign}}
											</ng-container>
											<span class="replaceContainer" data-type="pitable" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.data|highlighter:searchText:caseOn:allMatchtext"></span>
									</ng-container>
								   </ng-container>
								</td>
								<td *ngIf='k.secHtml&&doc1.id=="pca_summary_0"' style='border:1px #ddd solid' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'padding-left':k.sub}" >
									<span  class="replaceContainer" data-type="pstable" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</td>
							</ng-container>
							<ng-container  *ngIf="k.colspan">
								<td [attr.colspan]='k.colspan' [ngStyle]="{'text-align':k.celAllign, 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':k.border}">
									<ng-container *ngIf="k.sign">
										{{k.sign}}
									</ng-container>
									{{k.data}}
								</td>
							</ng-container>		
						</ng-container>
					</tr>
				</ng-container> 
			</tbody> 
		</table>
	</ng-container>
	<div style="position: relative;">
	<p *ngIf="(reportInfo?.ORDER_NUM||doc1?.data?.disableCopiedEris)&&doc1['HIDEERIS']&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length>100" class="erislabel">100 of {{doc1.data.rows.length}} total records shown</p>
	<p *ngIf="(reportInfo?.ORDER_NUM||doc1?.data?.disableCopiedEris)&&doc1['HIDEERIS']&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length<101" class="erislabel">{{doc1.data.rows.length}} of {{doc1.data.rows.length}} total records shown</p> 
	<p *ngIf="!reportInfo?.ORDER_NUM&&!(doc1?.data?.disableCopiedEris)&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1['HIDEERIS']&&doc1.data.rows.length==1" class="erislabel">0 of 0 total records shown</p>
	<table *ngIf="doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1['HIDEERIS']" style="width:100%; border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif">
		<thead>
		<tr>
			<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
				<th *ngIf="(!h.hide||h.hide=='N')" [ngStyle]="{'width':h.width+h.unit,'text-align':doc1.data.cols[o].colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
					<span style="font-weight:bold"><span class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='o' [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span></span>
				</th>
			</ng-container>
		</tr>
		</thead>
		<tbody>
		<ng-container *ngFor="let r of doc1.data?.rows|slice: 0:100; let h=index; trackBy:trackByFuntion">
			<tr *ngIf="r[0]['SUBHEADER']!='Y'&&(r[0].DATA&&r[0].DATA.length>0)">
				<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
					<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
						<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>
						<span *ngIf="!k.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.DATA|highlighter:searchText:caseOn:allMatchtext"></span>
						<span *ngIf="k.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.SEC.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
					</td>
				</ng-container>		
			</tr>
			<tr *ngIf="r[0]['SUBHEADER']=='Y'">
				<td colSpan='{{doc1.data.cols.length-1}}'[ngStyle]="{'text-align':r[0]['celAllign']?r[0]['celAllign']:'Center'}" style="border: 1px solid #ccc; text-align: center; border-collapse: collapse;vertical-align:top;">
					<span *ngIf="!r[1]?.HTML" [innerHTML]="r[1].DATA|highlighter:searchText:caseOn:allMatchtext"></span>
					<span *ngIf="r[1]?.HTML" [innerHTML]="r[1].SEC.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				</td>
			</tr>
		</ng-container>
		</tbody>
	</table>					
</div>
	<table *ngIf="(doc1.TYPE=='COSTTABLE'||doc1.TYPE=='PCATABLE'||doc1.TYPE=='UNITTABLE')&&doc1.data" [ngStyle]="{'width':doc1.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;">
				<thead>
				<tr *ngIf="doc1.TYPE!='UNITTABLE'">
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th *ngIf="(!h.hide||h.hide=='N')&&(!doc1['ZOOM'])" [ngStyle]="{'width':h.width+h.unit,'text-align':'center'}" style="border: 1px solid #ccc;  border-collapse: collapse;">
							<span style="font-weight:bold"> {{h.NAME}}</span>
						</th>
						<th *ngIf="(!h.hide||h.hide=='N')&&doc1['ZOOM']" style="border: 1px solid #ccc;  border-collapse: collapse;">
							<p style="font-weight:bold;margin: 0;text-align: center;"> {{h.NAME.split(' ')[0]}}</p>
							<p *ngIf="h.NAME.split(' ').length>0" style="font-weight:bold; margin: 0;text-align: center">{{h.NAME.split(' ')[1]}}</p>							
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data?.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="(r.length>1&&r.hide!='Y')&&(!(doc1.TYPE=='COSTTABLE'&&h==0))">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
								<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span><span [innerHTML]="k.DATA"></span><span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
							</td>
						</ng-container>		
					</tr>
					<tr *ngIf="r.length==1&&doc1.data&&r.hide!='Y'">
						<td colSpan='{{doc1.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
							<span> {{r[0]?.DATA}}</span>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
			<div *ngIf="doc1.TYPE=='TABLE'&&doc1.data&&(!doc1.data?.erisName)"  style="position: relative;">
			<table style="width:100%; border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;">
				<!--<caption *ngIf="doc1.data['caption']" [ngStyle]="{'border':doc1.data['caption']['border']?'solid 1px black':'none', 'text-align':doc1.data['caption']['align']?doc1.data['caption']['align']:'center'}">
					<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-v]='j' [innerHTML]="doc1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				</caption>-->
				<thead>
					<ng-container *ngFor="let brow of doc1.data.beforeHeaders; let bindex=index">
						<tr>
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<i *ngIf="doc1.data['locked']&&doc1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
									<i *ngIf="doc1.data['locked']&&doc1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='o' [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
				<ng-container *ngFor="let brow of doc1.data.afterHeaders; let bindex=index">
					<tr>
						<ng-container *ngFor="let col of brow; let u=index">
							<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
								<i *ngIf="doc1.data['locked']&&doc1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
							<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
								<i *ngIf="doc1.data['locked']&&doc1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
				</ng-container>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.items?.length>1">
						<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
								<i *ngIf="doc1.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
								<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>	
								<span *ngIf="k.DATA"  class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.items?.length==1">
						<td [attr.colspan]='doc1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
							<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							<i *ngIf="doc1.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
		</div>		
			</div>
		<ng-container *ngIf="doc1.id==onlock&&doc1.id==curId">
			<div class="ckContainer" *ngIf='(allEditor.indexOf(doc1.id)>-1&&otherTypes.indexOf(doc1.TYPE)==-1||(doc1.text&&doc1.text.length>0))&&!doc1?.intro'>
					
				<app-paragraph [ifReadOnly]='doc1.id!=onlock' [insertSign]='doc1.insert' [addedSlot]="doc1.addedItem"  class="docItem"  [getText]="doc1['reqIndex']" [users]="doc1.tcusers" [suggests]="doc1.suggestions" [comments]="doc1.comments" [content]="doc1.text" (selected)="selectedRow=-1;selectedCell=null;getPosition(doc1,$event,i,j);addLib=true;logUsers(doc1.id, doc1.SECTION_TITLE)"  (onExit)='textData($event, doc1.id, doc1.SECTION_TITLE)'  (onTrackChange)="textSuggest($event, doc1.id, doc1.SECTION_TITLE)" (rfSelected)="selectedRF($event)"></app-paragraph>
				<button *ngIf="doc1.id==onlock" [ngClass]="{'hasLibs':doc1.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="getPosition(doc1,$event,i,j);  filteredData=null;selectedRow=-1;selectedCell=null;showSavedLib(doc1.libs);op45.toggle($event);">Libraries
				</button>
				<button *ngIf="doc1.id==onlock" [ngClass]="{'hasLibs':doc1.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; getPosition(doc1,$event,i,j); filteredData=null;selectedRow=-1;selectedCell=null;showsavedSlot(doc1.slots)">Repeat Fields
				</button>
				<p-overlayPanel #op45 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; margin:0; max-height: 300px; overflow:auto; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<ng-container *ngFor="let item of doc1.libs; trackBy:trackByFuntion"> 
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op451.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
					
					<p-overlayPanel #op451 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> {{item.COST}}
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</ng-container>										
				</div>
				</ng-template>
			</p-overlayPanel>
				
			</div>
			</ng-container>
			<div *ngIf="doc1.id!=curId||doc1.id!=onlock"  class="puretext" (click)="getPosition(doc1,$event,i,j); curDoc=doc1" style="position: relative;">
				<div *ngIf='(allEditor.indexOf(i.toString()+"-"+j.toString()+"-")>-1&&otherTypes.indexOf(doc1.TYPE)==-1||(doc1.text&&doc1.text.length>0))&&!doc1?.intro' class="replaceContainer ck-content" [attr.data-id]="doc1.id" data-type="text" style="width:100%; padding:10px; margin:0" [innerHtml]="doc1.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
			</div>
			
			</div>
			<div class="intro"  *ngIf='doc1?.intro'>
				<button class="intro-btn btn btn-sm">Instruction Only</button>
				<div [innerHTML]='doc1.text' style="width:100%; margin:0"></div>
			</div>
			<div *ngIf="(doc1.TYPE=='SEALS'&&doc1.seals&&doc1.seals.length>0)||(doc1.TYPE=='SIGNS'&&doc1.signs&&doc1.signs.length>0)" style="width:100%; padding:0" >
			<div class="row">
			<ng-container *ngFor="let photo of doc1.signs; let s=index; trackBy:trackByFuntion">
				
				<div *ngIf="photo.TYPE=='signature'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
					<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='N'"   style="padding-left: 30px;">
						<div class="gallery2">
							<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
						</div>
						<p class="desc1">{{photo.NAME}}</p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
						<p class="desc1" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
						<p *ngIf="photo.DATE" class="desc1">Date: {{photo.DATE}}</p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
						
						<p class="desc1"><a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
						<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></p>
					</div>
					<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'" style="width:50%" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
						<p *ngIf="photo['signlabel']" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}">{{photo['signlabel']}}</p>
						<div *ngIf="photo['signImgLabel']" style="display:flex;width:50%" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
							<span *ngIf="photo['signImgLabel']" style="align-self: flex-end"><label>{{photo['signImgLabel']}}</label><app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
							<span *ngIf="photo['signImgLabel']" [ngClass]="{'under-line':photo['labelImgunderline']}">
								<div [ngStyle]="{'height':photo['height'],'line-height':photo['lineheight'],'margin':photo['signmargin']}">
									<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
								</div>
							</span>
						</div>
						<div *ngIf="!photo['signImgLabel']" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" [ngStyle]="{'height':photo['height']?photo['height']:'60px','line-height':photo['lineheight']?photo['lineheight']:'60px','margin':photo['signmargin']?photo['signmargin']:'0', 'border-bottom': photo['underline']?'2px solid black':'none'}">
							<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:90%;width:auto;vertical-align:bottom; margin: 4px;">
						</div>
						<p style="margin-top: 10px;" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}">{{photo.NAME}}</p>
						<p [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
						
						<p class="desc1"><a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
							<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></p>
							
										
					</div>
					<div *ngIf="photo.signatureTemplate" class="col-md-12">
						<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
							<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
							<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
						</div>
					</div>	
				</div>
				<div *ngIf="photo.TYPE=='signature'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
					<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="font-size: 10pt;">
						<div style="display:flex;width:50%">
							<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input *ngIf="doc1.id==onlock&&doc1.id==curId" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
							<span class="under-line1">
								<div *ngIf="reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
									<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
								</div>
							</span>
						</div>
						<p style="margin-top: 10px;"><span class="desc3" style="font-weight: bold;font-size: 10pt;">{{photo.NAME}}</span></p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='C'" style="font-weight: bold;font-size: 10pt;"><span class="desc3" [innerHTML]="photo.TITLE"></span></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='L'"  style="font-weight: bold;font-size: 10pt;"class="desc3" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					
					<p><span class="desc3"><a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
									
					</div>
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='N'" class="gallery1" style="display:block" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}">
					<div class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
					</div>
					<p><span class="desc2">{{photo.NAME}}</span></p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='C'"><span class="desc2" [innerHTML]="photo.TITLE"></span></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='L'" class="desc2" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					
					<p *ngIf="photo.DATE"><label class="desc2">Date: {{photo.DATE}}</label></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					
					<p><span class="desc2"><a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'" style="width:40%" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
					<p *ngIf="photo['signlabel']" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}">{{photo['signlabel']}}</p>
					<div *ngIf="photo['signImgLabel']" style="display:flex;width:50%" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
						<span *ngIf="photo['signImgLabel']" style="align-self: flex-end"><label>{{photo['signImgLabel']}}</label><app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span *ngIf="photo['signImgLabel']" [ngClass]="{'under-line':photo['labelImgunderline']}">
							<div [ngStyle]="{'height':photo['height'],'line-height':photo['lineheight'],'margin':photo['signmargin']}">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<div *ngIf="!photo['signImgLabel']" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" [ngStyle]="{'height':photo['height']?photo['height']:'60px','line-height':photo['lineheight']?photo['lineheight']:'60px','margin':photo['signmargin']?photo['signmargin']:'0', 'border-bottom': photo['underline']?'2px solid black':'none'}">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:90%;width:auto;vertical-align:bottom; margin: 4px;">
					</div>
					<p style="margin-top: 10px;" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}">{{photo.NAME}}</p>
					<p *ngIf="photo['ALIGN']=='C'" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
					<p *ngIf="photo['ALIGN']=='L'" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
					
					<p><span class="desc3"><a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" title="Remove Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
					
									
				</div>
				<div *ngIf="photo.signatureTemplate&&(!(reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" class="gallery1">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				<div *ngIf="photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;">
					<div  style="padding:0; margin: 0;width:50%" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
				</div>	
				</div>
				</ng-container>
			<ng-container *ngFor="let photo of doc1.seals; let s=index; trackBy:trackByFuntion">
				
				<div *ngIf="photo.TYPE=='seal'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
					</div>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="removeFile1" title="Update Seal" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0)" [ngClass]="{'disable':doc1.id!=onlock}" title="Remove Seal" style="margin:0 4px" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('seals',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a>
					
				</div>
				<div *ngIf="photo.TYPE=='seal'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'sealAlignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
					</div>
					<p class="desc1"><a href="javascript:void(0);" [ngClass]="{'disable':doc1.id!=onlock}" class="removeFile1" title="Update Seal" (click)="addLib=false; getPosition(doc1,$event,i,j);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0)" [ngClass]="{'disable':doc1.id!=onlock}" title="Remove Seal" style="margin:0 4px" (click)="addLib=false; getPosition(doc1,$event,i,j);removeSeal('seals',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a>
					
				</div>
				
				
			</ng-container>
			</div>
		</div>
			<div style="width:100%; padding:8px 16px" *ngIf="doc1.TYPE=='PHOTOS'&&doc1.photos&&doc1.photos.length>0">
			<div class="row">
			<ng-container *ngFor="let photo of doc1.photos; let s=index; trackBy:trackByFuntion">
				<div class="column">
					<div class="gallery" style="text-align: center;height:240px;line-height: 240px;">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="max-height: 100%;max-width: 100%;vertical-align: middle;">
					</div>
					<div style="height:60px">
						<p class="desc"><span  class="replaceContainer" [attr.data-id]="doc1.id" data-type="photo" [attr.data-x]='s' [innerHTML]="photo.FILE_DESCRIPTION|highlighter:searchText:caseOn:allMatchtext"></span><app-edit-input *ngIf='doc1.id==curId&&doc1.id==onlock'  [text]="photo.FILE_DESCRIPTION" [maxlength]='100' (edited)="addLib=false; getPosition(doc1,$event,i, j); changeDesc('photos','FILE_DESCRIPTION',s, $event,i,j)"></app-edit-input>
						<a *ngIf='doc1.id==curId&&doc1.id==onlock' href="javascript:void(0);" class="removeFile" (click)="addLib=false; getPosition(doc1,$event,i,j); removePhoto(photo)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				
					</div>
				</div>
			</ng-container>
			</div>
		</div>
		</ng-container>
			<!--<app-paragraph class="docItem"  (outHtml)=ckData($event,doc1)></app-paragraph>-->
			<div *ngFor="let doc2 of doc1.SUB_SECTIONS; let k=index; trackBy:trackByFuntion"  [ngClass]="{'hideSec':doc2.HIDE}"  style="position:relative;clear:both">
			<ng-container *ngIf="(!onlyCost||doc2.TYPE=='COSTTABLE')&&(!onlyWCompete||(!doc2.wcompleted&&onlyWCompete))&&(!onlyRCompete||(!doc2.rcompleted&&onlyRCompete))&&(!hideSection||((!doc.HIDE&&!doc1.HIDE&&!doc2.HIDE&&!doc2.OTABLE)&&hideSection))&&(doc2.TYPE!=='1105')">
			<button *ngIf="doc2.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
			<i *ngIf="(doc2.suggestions&&doc2.suggestions.length>0)||doc2.tcflag" class="tcicon">TC</i>
			<!--<label style="margin-left:20px;" [ngClass]="{'blue':curIndex[0]==i&&(curIndex[1]==j)&&(curIndex[2]==k)}" (click)="addLib=false; getPosition(doc2,$event,i, j,k);curDoc=doc2">. . {{doc2.SECTION_SEQUENCE}}</label>
			-->
				<label  [id]="doc2.id+'content'" style="font-weight:bold; width: 80%;"  [ngClass]="{'blue':curIndex[0]==i&&(curIndex[1]==j)&&(curIndex[2]==k), 'hideSec':doc2.OTNAME||doc2.OSNAME||doc2.OPNAME}" (click)="addLib=false; getPosition(doc2,$event,i, j,k);curDoc=doc2">
					. . {{doc2.SECTION_SEQUENCE}}
					<ng-container *ngIf="doc2.DISPLAY_SEQUENCE=='Y'">
						<ng-container *ngFor="let i of head3Space|fill">
							&nbsp;
						</ng-container>
					</ng-container>
					<span style="color:white" [ngClass]="{'blue':curIndex[0]==i&&(curIndex[1]==j)&&(curIndex[2]==k)}">.</span><span *ngIf="doc2.SECTION_TITLE&&doc2.SECTION_TITLE.length>0" class="replaceContainer" [attr.data-id]="doc2.id" data-type="title" [innerHTML]="doc2.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
					<ng-container *ngIf="doc2.id==onlock&&doc2.id==curId">
						<app-edit-input *ngIf="doc2.id==listid" [text]="doc2.SECTION_TITLE" (edited)="addLib=false; getPosition(doc2,$event,i, j,k);changeTitle('content',$event,i,j,k)"></app-edit-input>
						<i *ngIf="(!(doc2.text&&doc2.text.length>0))&&(!(allEditor.indexOf(doc2.id)>-1))&&otherTypes.indexOf(doc2.TYPE)==-1"  class="btn-blue far fa-edit" (click)="getPosition(doc2,$event,i, j,k); addEditor(doc2.id)"></i>
						<i *ngIf="doc2.TYPE=='PDFSEC'" class=" btn-blue far fa-file-pdf" (click)="getPosition(doc2, $event, i, j, k);"></i>
						<i *ngIf="doc2.TYPE=='PHOTOS'" class="btn-blue fas fa-camera-retro" (click)="getPosition(doc2, $event, i, j, k); selectPhoto()"></i>
						<i *ngIf="doc2.TYPE=='TABLE'&&(!doc2.data?.disableCopiedEris)" title="Table Property" class=" btn-blue fas fa-table" (click)="selectedRow=-1;selectedCell=null; getPosition(doc2,$event,i,j,k);toCreateTable(i,j,k)"></i>
						<ng-container *ngIf="doc2.TYPE=='COSTTABLE'">
							<i class="btn-blue far fa-plus-square" title="Add Cost Recommendation Item" (click)="getPosition(doc2,$event,i,j,k);selectedRow=-1;selectedCell=null;getCostData(doc2.id)"></i>
						</ng-container>
						<i *ngIf="!doc2.data?.disableCopiedEris&&reportInfo?.ORDER_NUM&&doc2.TYPE=='TABLE'&&doc2.data?.erisName&&doc2.data?.erisName.length>0" class="btn-blue" title='Modify ERIS Table' (click)="modifyEris(doc2)"><img src="/assets/images/edit-table-2.png" class="imageIcon"></i>
						<i *ngIf="doc2.TYPE=='TABLE'&&(!doc2.data?.erisName)"  class="btn-blue" title='Modify Table' (click)="modifyTable(doc2); selectedEditor='O'"><img src="/assets/images/icons8-edit-property-32.png" class="imageIcon1"></i>

					</ng-container>
				
				</label>
			<label style="width: 19%;vertical-align: top;" >	
					<i class="btn-blue far fa-comment-alt btncomm" [ngStyle]="{'color':commIds.indexOf(doc2.id)>-1? '#6BB10F':'#686868'}" [ngClass]="{'fas':commIds.indexOf(doc2.id)>-1, 'far':commIds.indexOf(doc2.id)==-1, 'unlockedSec':rptUser.length>1&&noEditableFmeSec.indexOf(doc2.id)>-1}" title="User Comments" (click)="secComments=[]; secCommId=doc2.id; getSecComments(doc2, doc2.id);curDoc=doc2;commShow=true"></i>
						
					<a class="btn btnComplete rCheck rbtn"  title="Review Complete" [ngClass]="{'active1':doc2.rcompleted, 'disable':doc2.id!=listid, 'unlockedSec':rptUser.length>1&&noEditableFmeSec.indexOf(doc2.id)>-1}" (click)="slotToLib=false; getPosition(doc2,$event,i,j,k); filteredData=null; selectedRow=-1;selectedCell=null;rComplete(doc2)"><i *ngIf="doc2.rcompleted" class="pi pi-check-circle" style="font-size:12px; margin-right:4px;"></i>R</a>
					<a class="btn btnComplete wCheck wbtn"  title="Writing Complete" [ngClass]="{'active':doc2.wcompleted, 'disable':doc2.id!=listid, 'unlockedSec':rptUser.length>1&&noEditableFmeSec.indexOf(doc2.id)>-1}"(click)="slotToLib=false; getPosition(doc2,$event,i,j,k); filteredData=null; selectedRow=-1;selectedCell=null;wComplete(doc2)"><i *ngIf="doc2.wcompleted" class="pi pi-check-circle" style="font-size:12px; margin-right:4px; margin-bottom:0"></i>W</a>
					<i *ngIf="doc2['ZOOM']" title="Click to See the Full Table" class="btn-blue fas fa-search-plus zoombtn" (click)="tableZoom(doc2.data,'4099e');"></i>
				<i *ngIf="doc2.TYPE=='TABLE'&&doc2.data?.erisName&&doc2.data?.erisName.length>0"  class="btn-blue fas fa-minus-square erisbtn" title="Show ERIS Table" [ngClass]="{'active':!doc2['HIDEERIS']}" (click)="erisToggle(doc2)"></i>
				
					<br>
				<ng-container *ngIf="doc2.id==onlock&&doc2.id==curId">			
					<span class="opBtn" (click)="checkParentSeq(doc.DISPLAY_SEQUENCE, doc1.DISPLAY_SEQUENCE); optionShow=true" [ngClass]="{'unlockedSec':rptUser.length>1&&noEditableFmeSec.indexOf(doc2.id)>-1}">Options <i class="fas fa-angle-down"></i></span>
					<a *ngIf="(otherTypes.indexOf(doc2.TYPE)==-1&&((!doc2.OSNAME&&doc2.SECTION_TITLE&&doc2.SECTION_TITLE.length>0)||doc2.SECTION_SEQUENCE.length>0))&&summaryStatus&&!doc2.data" class="psBtn" [ngStyle]="{'color':doc2.pisummarydata||doc2.pcasummarydata?'#c2d63e':'#999','border-color':doc2.pisummarydata||doc2.pcasummarydata?'#c2d63e':'#999'}" title="Project Summary" (click)="editPs(doc2)">PS</a>
					</ng-container>
				<!--<i *ngIf="(!doc2?.data?.erisName&&doc2.TYPE=='TABLE'&&(curId==doc2.id)&&doc2.id==onlock)" class="btn-blue fas fa-toolbox tablebtn" (click)="tableToolShow=true; curSec=doc2"></i>-->
				<i *ngIf="doc2.TYPE=='4099e'&&doc2['append']&&(curId==doc2.id)&&doc2.id==onlock" class="btn-blue fas fa-toolbox tablebtn" (click)="tableToolShow=true; curSec=doc2" [ngClass]="{'unlockedSec':rptUser.length>1&&noEditableFmeSec.indexOf(doc2.id)>-1}"></i>
				
			</label>
				<ng-container *ngIf="summaryStatus&&doc2.TYPE=='COSTTABLE'">
						<select class="costInput mr-1" style="width:40%; font-size: 11px;" [disabled]="doc2.id!=curId||doc2.id!=onlock" [ngStyle]="{'border':doc2['summaryCat']? 'none':'2px solid #F78181'}" (change)="selCostCat('summaryCat', $event, doc2)">
							<option></option>
							<option *ngFor="let item of summaryCategory; let i=index" [value]="item" [selected]="item==doc2['summaryCat']">{{item}}</option>
						</select>
					
				</ng-container>
				<select *ngIf="reportInfo?.PCA_INDICATOR=='4099e'&&doc2.TYPE=='COSTTABLE'" class="costInput" [disabled]="doc2.id!=curId||onlock!=doc2.id" [ngStyle]="{'border':doc2.long?.length>0||doc2.id=='fme_exec_sum_title_0'? 'none':'2px solid #F78181'}" style="width:40%; font-size: 11px;" (change)="selFmeCost('long', $event, doc2)">
					<option>Please Select Fannie Mae Category</option>
					<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.id==doc2.long">{{item.label}}</option>
				</select>
				<select *ngIf="doc2.TYPE=='COSTTABLE'&&reportInfo?.PCA_INDICATOR=='frm1105'" class="costInput" [disabled]="doc2.id!=curId" [ngStyle]="{'border':doc2.cat?.length>0? 'none':'2px solid #F78181'}"  style="width:40%; font-size: 11px"  (change)="selFrmUl(doc2, $event, 'cat')">
					<option value="-1">Please Select Freddie Mac Category</option>
					<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.tag==doc2.cat">{{item.label}}</option>
				</select>
					
				<ng-container *ngIf="doc2.id==onlock&&doc2.id==curId">				
				<div class="ckContainer" *ngIf='(allEditor.indexOf(doc2.id)>-1||(doc2.text&&doc2.text.length>0))&&!doc2?.intro'>
					<app-paragraph [ifReadOnly]='doc2.id!=onlock' [insertSign]='doc2.insert' [addedSlot]="doc2.addedItem"  class="docItem"  [getText]="doc2['reqIndex']" [users]="doc2.tcusers" [suggests]="doc2.suggestions" [comments]="doc2.comments" [content]="doc2.text" (selected)="selectedRow=-1;selectedCell=null;getPosition(doc2,$event,i,j,k);addLib=true;logUsers(doc2.id, doc2.SECTION_TITLE)"  (onExit)='textData($event, doc2.id, doc2.SECTION_TITLE)' (onTrackChange)="textSuggest($event, doc2.id, doc2.SECTION_TITLE)" (rfSelected)="selectedRF($event)"></app-paragraph>
					<button *ngIf="doc2.id==onlock" [ngClass]="{'hasLibs':doc2.libs?.length>0}" class="btn btn-outline-light rf-btn"  (click)="libToSlot=false;getPosition(doc2,$event,i,j,k);  filteredData=null;selectedRow=-1;selectedCell=null;showSavedLib(doc2.libs);op46.toggle($event);">Libraries
					</button>
					<button *ngIf="doc2.id==onlock" [ngClass]="{'hasLibs':doc2.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; getPosition(doc2,$event,i,j,k); filteredData=null; selectedRow=-1;selectedCell=null;showsavedSlot(doc2.slots)">Repeat Fields
					</button>
					<p-overlayPanel #op46 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; margin:0; max-height: 300px; overflow:auto; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<ng-container *ngFor="let item of doc2.libs; trackBy:trackByFuntion"> 
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op461.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
					
					<p-overlayPanel #op461 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> {{item.COST}}
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</ng-container>										
				</div>
				</ng-template>
			</p-overlayPanel>
				</div>
				</ng-container>
				<div *ngIf="doc2.id!=curId||doc2.id!=onlock" [ngClass]="{'hideSec':doc2.OTABLE}"  class="puretext"   (click)="getPosition(doc2,$event,i, j,k);resetProp(doc2); curDoc=doc2"  style="overflow: hidden;">
				<button  *ngIf="doc2.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
				<table *ngIf="doc2.TYPE=='4099e'" [ngStyle]="{'border':doc2.id=='fme_exec_sum_capital_needs_1'?'none': '1px solid black', 'width':doc2.halfwidth?'50%':'100%'}" style="font-size:10px; font-family:Arial, sans-serif;border-collapse: collapse;">
					<tr *ngIf="doc2.data.titlerow">
						<th  [ngClass]="doc2.data.titlerow[0].bk" [colSpan]="doc2.data.cols.length" [ngStyle]="{'width':doc2.data.titlerow[0].width+doc2.data.titlerow[0].unit,'text-align':doc2.data.titlerow[0].colAlign}" style="font-weight: bold;border: 1px solid black">{{doc2.data.titlerow[0].NAME}}
						</th>	
					</tr>
					<tr *ngIf="doc2.header">
						<ng-container *ngFor="let h of doc2.data.cols; let o=index; trackBy:trackByFuntion">
							<th  *ngIf="!h['hide']" [ngClass]="h.bk" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="font-weight: bold;border: 1px solid black">{{h.NAME}}
							</th>	
						</ng-container>
					</tr>
					<ng-container *ngFor="let r of doc2.data?.rows; let l=index; trackBy:trackByFuntion">
						<tr>
							<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
								<td *ngIf="!k.colspan&&!k['hide']" [ngClass]="k.bk" class="cellItem1" (dblclick)="selectCell(doc2, l, doc2.data.cols[q], k);" [ngStyle]="{'text-align':doc2.data?.cols[q]?.celAllign, 'font-weight':k.weight, 'width':doc2.data.cols[q]?.width+doc2.data.cols[q]?.unit, 'border':k.border}">
									<!--<span *ngIf="k.sign">{{k.sign}}</span>
									<span class="innerCell" *ngIf="k.DATA" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
									<span class="innerCell" *ngIf="!k.DATA">{{k.data}}</span>-->
									<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
									<!--<span *ngIf="!k.sign">{{k.data}}</span>-->
									<span class="innerCell" *ngIf="!k.sign&&k.DATA"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='l' [attr.data-y]='q' [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									<span class="innerCell" *ngIf="!k.sign&&(!k.DATA)">{{k.data}}</span>
									<!--<a *ngIf="k.RF||k.Manual" style="float:right;"  (click)="selectCell(doc2, l, doc2.data.cols[q], k);"><i style="color:#ccc; margin-right: 4px;" class="far fa-list-alt"></i></a>-->
								</td>
								<td *ngIf="k.colspan&&!k['hide']"  [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'font-weight':k.weight, 'border':k.border}">
									<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
									<span class="innerCell" *ngIf="!k.sign&&k.DATA"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='l' [attr.data-y]='q' [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									<span class="innerCell" *ngIf="!k.sign&&(!k.DATA)">{{k.data}}</span>
									<!--<span *ngIf="k.sign">{{k.sign}}</span>{{k.data}}-->
								</td>			
							</ng-container>
						</tr>					
					</ng-container>  
				</table>
				<div style="position: relative;">
				<p *ngIf="(reportInfo?.ORDER_NUM||doc2?.data?.disableCopiedEris)&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2['HIDEERIS']&&doc2.data.rows.length>100" class="erislabel">100 of {{doc2.data.rows.length}} total records shown</p>
				<p *ngIf="(reportInfo?.ORDER_NUM||doc2?.data?.disableCopiedEris)&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2['HIDEERIS']&&doc2.data.rows.length<101" class="erislabel">{{doc2.data.rows.length}} of {{doc2.data.rows.length}} total records shown</p> 
				<p *ngIf="!reportInfo?.ORDER_NUM&&!doc2?.data?.disableCopiedEris&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2['HIDEERIS']&&doc2.data.rows.length==1" class="erislabel">0 of 0 total records shown</p>
				<table *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2['HIDEERIS']" [ngStyle]="{'width':doc2.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;">
					<thead>
					<tr>
						<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
							<th *ngIf="(!h.hide||h.hide=='N')" [ngStyle]="{'width':h.width+h.unit,'text-align':doc2.data.cols[o].colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
								<span style="font-weight:bold"><span  class="replaceContainer" data-type="eris" [attr.data-id]="doc2.id" [attr.data-x]='o' [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span></span>
							</th>
						</ng-container>
					</tr>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc2.data?.rows|slice: 0:100; let h=index; trackBy:trackByFuntion">
						<tr *ngIf="r[0]['SUBHEADER']!='Y'&&(r[0].DATA&&r[0].DATA.length>0)">
							<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
								<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
									<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>
									<span *ngIf="!k.HTML" class="replaceContainer" data-type="eris" [attr.data-id]="doc2.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.DATA|highlighter:searchText:caseOn:allMatchtext"></span>
									<span *ngIf="k.HTML" class="replaceContainer" data-type="eris" [attr.data-id]="doc2.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.SEC.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
								</td>
							</ng-container>		
						</tr>
						<tr *ngIf="r[0]['SUBHEADER']=='Y'">
							<td colSpan='{{doc2.data.cols.length-1}}' [ngStyle]="{'text-align':r[0]['celAllign']?r[0]['celAllign']:'Center'}" style="border: 1px solid #ccc; text-align: center; border-collapse: collapse;vertical-align:top;">
								<span *ngIf="!r[1]?.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='h' data-y='1'[innerHTML]="r[1].DATA|highlighter:searchText:caseOn:allMatchtext"></span>
								<span *ngIf="r[1]?.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc1.id" [attr.data-x]='h' data-y='1' [innerHTML]="r[1].SEC.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</td>
						</tr>
					</ng-container>
					</tbody>
				</table>
				
				</div>
				<table *ngIf="(doc2.TYPE=='COSTTABLE'||doc2.TYPE=='PCATABLE'||doc2.TYPE=='UNITTABLE')&&doc2.data" [ngStyle]="{'width':doc2.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid #999;  border-collapse: collapse; font-size:10px">
					<thead>
					<tr>
						<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
							<th  *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;">
								<span>{{h.NAME}}</span>
							</th>
						</ng-container>
					</tr>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
						<tr *ngIf="r.length>1&&r.hide!='Y'&&(!(doc2.TYPE=='COSTTABLE'&&h==0))&&(!doc2.filted||doc2.filted.indexOf(r[0].DATA)>-1)">
						    <ng-container *ngFor="let m of r; let q=index; trackBy:trackByFuntion">
								<td *ngIf="!m.hide||m.hide=='N'" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top;">
									<span *ngIf="m.sign&&m.sign==currSign">{{m.sign}}</span><span [innerHTML]="m.DATA"></span><span *ngIf="m.sign&&m.sign!=currSign">{{m.sign}}</span>
								</td>
							</ng-container>
						</tr>
						<tr *ngIf="r.length==1&&doc2.data&&r.hide!='Y'">					
							<td colSpan='{{doc2.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}"  style="font-weight:bold; border: 1px solid black;  border-collapse: collapse;vertical-align:top;">
								<span>{{r[0]?.DATA}}</span>
							</td>
						</tr>
					</ng-container>
					</tbody>
				</table>
				<div *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&(!doc2.data?.erisName)"  style="position: relative;">
				<table style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
					<!--<caption *ngIf="doc2.data['caption']" [ngStyle]="{'border':doc2.data['caption']['border']?'solid 1px black':'none', 'text-align':doc2.data['caption']['align']?doc2.data['caption']['align']:'center'}">
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-v]='k' [innerHTML]="doc2.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</caption>-->
					<thead>
						<ng-container *ngFor="let brow of doc2.data.beforeHeaders; let bindex=index">
							<tr>
								<ng-container *ngFor="let col of brow; let u=index">
									<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
										<i *ngIf="doc2.data['locked']&&doc2.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
										<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									</th>
									<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
										<i *ngIf="doc2.data['locked']&&doc2.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
										<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									</th>
								</ng-container>
							</tr>
						</ng-container>
					<tr>
						<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
							<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
								<i *ngIf="doc2.data['locked']&&doc2.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}" style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='o' [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
					<ng-container *ngFor="let brow of doc2.data.afterHeaders; let bindex=index">
						<tr>
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<i *ngIf="doc2.data['locked']&&doc2.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
									<i *ngIf="doc2.data['locked']&&doc2.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
					</thead>
				<tbody>
				<ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.items?.length>1">
						<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
								<i *ngIf="doc2.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
								<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>	
								<span *ngIf="k.DATA"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:"full"|safeHtml'></span>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.items?.length==1">
						<td [attr.colspan]='doc2.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
							<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							<i *ngIf="doc2.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
		</div>
				</div>
				
				
				
				<div *ngIf="doc2.id!=curId||doc2.id!=onlock" class="puretext" (click)="getPosition(doc2,$event,i, j,k); curDoc=doc2" style="position: relative;">
					<div *ngIf='(allEditor.indexOf(i.toString()+"-"+j.toString()+"-"+k.toString())>-1||(doc2.text&&doc2.text.length>0))&&!doc2?.intro' class="replaceContainer ck-content" [attr.data-id]="doc2.id" data-type="text"  style="width:100%; padding:10px; margin:0" [innerHtml]="doc2.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
					</div>
				</div>
			
				<div class="intro"  *ngIf='doc2?.intro'>
					<button class="intro-btn btn btn-sm">Instruction Only</button>
					<div [innerHTML]='doc2.text' style="width:100%; margin:0"></div>
				</div>
				<div *ngIf="(doc2.TYPE=='SEALS'&&doc2.seals&&doc2.seals.length>0)||(doc2.TYPE=='SIGNS'&&doc2.signs&&doc2.signs.length>0)" style="width:100%; padding:0" >
			<div class="row">
			<ng-container *ngFor="let photo of doc2.signs; let s=index; trackBy:trackByFuntion">
				<div *ngIf="photo.TYPE=='signature'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
					<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='N'"  style="padding-left: 30px;">	
						<div class="gallery2">
							<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
						</div>
						<p class="desc1">{{photo.NAME}}</p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
						<p class="desc1" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
						<p *ngIf="photo.DATE" class="desc1">Date: {{photo.DATE}}</p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
						
						<p class="desc1"><a href="javascript:void(0);" class="removeFile1" title="Update Signature" [ngClass]="{'disable':doc2.id!=onlock}" (click)="addLib=false; getPosition(doc2,$event,i, j,k);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
						<a href="javascript:void(0);"  title="Remove Signature" [ngClass]="{'disable':doc2.id!=onlock}" (click)="addLib=false; getPosition(doc2,$event,i, j,k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></p>
						</div>
					<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'" style="width:50%" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
						<p *ngIf="photo['signlabel']" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}">{{photo['signlabel']}}</p>
						<div *ngIf="photo['signImgLabel']" style="display:flex;width:50%" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
							<span *ngIf="photo['signImgLabel']" style="align-self: flex-end"><label>{{photo['signImgLabel']}}</label><app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
							<span *ngIf="photo['signImgLabel']" [ngClass]="{'under-line':photo['labelImgunderline']}">
								<div [ngStyle]="{'height':photo['height'],'line-height':photo['lineheight'],'margin':photo['signmargin']}">
									<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
								</div>
							</span>
						</div>
						<div *ngIf="!photo['signImgLabel']" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" [ngStyle]="{'height':photo['height']?photo['height']:'60px','line-height':photo['lineheight']?photo['lineheight']:'60px','margin':photo['signmargin']?photo['signmargin']:'0', 'border-bottom': photo['underline']?'2px solid black':'none'}">
							<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:90%;width:auto;vertical-align:bottom; margin: 4px;">
						</div>
						<p style="margin-top: 10px;" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}">{{photo.NAME}}</p>
						<p [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
						
						<p class="desc1"><a href="javascript:void(0);" class="removeFile1" title="Update Signature" [ngClass]="{'disable':doc2.id!=onlock}" (click)="addLib=false; getPosition(doc2,$event,i, j,k);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
							<a href="javascript:void(0);"  title="Remove Signature" [ngClass]="{'disable':doc2.id!=onlock}" (click)="addLib=false; getPosition(doc2,$event,i, j,k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></p>
							
										
					</div>
					<div *ngIf="photo.signatureTemplate" class="col-md-12">
						<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
							<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
							<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc2,$event,i, j, k);replaceSeal(photo, s)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc2,$event,i, j, k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
						</div>
					</div>	
				</div>
				<div *ngIf="photo.TYPE=='signature'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
					<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="font-size: 10pt;">
				
						<div style="display:flex;;width:50%">
							<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input *ngIf="doc2.id==curId&&doc2.id==onlock" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
							<span class="under-line1">
								<div *ngIf="reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
									<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
								</div>
							</span>
						</div>
						<p style="margin-top: 10px;"><span class="desc3" style="font-weight: bold;font-size: 10pt;">{{photo.NAME}}</span></p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='C'" style="font-weight: bold;font-size: 10pt;"><span class="desc3" [innerHTML]="photo.TITLE"></span></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='L'"  style="font-weight: bold;font-size: 10pt;"class="desc3" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					
					<p><span class="desc3"><a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getPosition(doc2,$event,i, j,k);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" title="Remove Signature" (click)="addLib=false; getPosition(doc2,$event,i, j,k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
				
				</div>
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='N'" class="gallery1" style="display:block" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}">
					<div class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
					</div>
					<p><span class="desc2">{{photo.NAME}}</span></p><!--<app-edit-input [text]="photo.NAME" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','NAME', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='C'"><span class="desc2" [innerHTML]="photo.TITLE"></span></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					<p *ngIf="photo['ALIGN']=='L'" class="desc2" [innerHTML]="photo.TITLE"></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					
					<p *ngIf="photo.DATE"><label class="desc2">Date: {{photo.DATE}}</label></p><!--<app-edit-input [text]="photo.TITLE" [maxlength]='100' (edited)="addLib=false; getFPosition(page1.id,page1.SECTION_TITLE,$event,s, t); changeDesc('signs','TITLE', u, $event,s,t)"></app-edit-input>-->
					
					<p><span class="desc2"><a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getPosition(doc2,$event,i, j,k);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" title="Remove Signature" (click)="addLib=false; getPosition(doc2,$event,i, j,k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&reportInfo['SPECIAL_SIGNATURE_FORMAT']!='N'" style="width:40%" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
					<p *ngIf="photo['signlabel']" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}">{{photo['signlabel']}}</p>
					<div *ngIf="photo['signImgLabel']" style="display:flex;width:50%" [ngStyle]="{'font-weight':photo['signlabelfontweight']?photo['signlabelfontweight']:'normal','font-size':photo['signlabelfontsize']?photo['signlabelfontsize']:'10px','font-family':photo['signlabelfontfamily']?photo['signlabelfontfamily']:'Arial'}" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" >
						<span *ngIf="photo['signImgLabel']" style="align-self: flex-end"><label>{{photo['signImgLabel']}}</label><app-edit-input *ngIf="page1.id==listid&&page1.id==onlock" [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span *ngIf="photo['signImgLabel']" [ngClass]="{'under-line':photo['labelImgunderline']}">
							<div [ngStyle]="{'height':photo['height'],'line-height':photo['lineheight'],'margin':photo['signmargin']}">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<div *ngIf="!photo['signImgLabel']" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}" [ngStyle]="{'height':photo['height']?photo['height']:'60px','line-height':photo['lineheight']?photo['lineheight']:'60px','margin':photo['signmargin']?photo['signmargin']:'0', 'border-bottom': photo['underline']?'2px solid black':'none'}">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:90%;width:auto;vertical-align:bottom; margin: 4px;">
					</div>
					<p style="margin-top: 10px;" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}">{{photo.NAME}}</p>
					<p *ngIf="photo['ALIGN']=='C'" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
					<p *ngIf="photo['ALIGN']=='L'" [ngStyle]="{'font-weight':photo['fontweight']?photo['fontweight']:'normal','font-size':photo['fontsize']?photo['fontsize']:'12px','font-family':photo['fontfamily']?photo['fontfamily']:'Arial','margin':photo['textmargin']?photo['textmargin']:'0'}" [innerHTML]="photo.TITLE"></p>
					
					<p><span class="desc3"><a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="removeFile1" title="Update Signature" (click)="addLib=false; getPosition(doc2,$event,i, j, k);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" title="Remove Signature" (click)="addLib=false; getPosition(doc2,$event,i, j, k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a></span></p>
					
									
				</div>
				<div *ngIf="photo.signatureTemplate&&(!(reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" class="gallery1">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc2,$event,i, j, k);replaceSeal(photo, s)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc2,$event,i, j, k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				<div *ngIf="photo.signatureTemplate&&reportInfo&&reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;">
					<div  style="padding:0; margin: 0;width:50%" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc2,$event,i, j, k);replaceSeal(photo, s)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc2,$event,i, j, k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
				</div>	
				</div>
				</ng-container>
				<ng-container *ngFor="let photo of doc2.seals; let s=index; trackBy:trackByFuntion">
			
				<div *ngIf="photo.TYPE=='seal'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
					</div>
					<a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="removeFile1" title="Update Seal" (click)="addLib=false; getPosition(doc2,$event,i, j,k);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0)"  [ngClass]="{'disable':doc2.id!=onlock}" title="Remove Seal" style="margin:0 4px" (click)="addLib=false; getPosition(doc2,$event,i, j,k);removeSeal('seals',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a>
					
				</div>
				<div *ngIf="photo.TYPE=='seal'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'sealAlignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
					</div>
					<p class="desc1"><a href="javascript:void(0);" [ngClass]="{'disable':doc2.id!=onlock}" class="removeFile1" title="Update Seal" (click)="addLib=false; getPosition(doc2,$event,i, j,k);replaceSeal(photo, s)"><i class="fas fa-user-edit" style="font-size: 11px;"></i></a>
					<a href="javascript:void(0)" [ngClass]="{'disable':doc2.id!=onlock}" title="Remove Seal" style="margin:0 4px" (click)="addLib=false; getPosition(doc2,$event,i, j,k);removeSeal('seals',photo, s)"><i class="far fa-trash-alt" style="font-size: 11px;"></i></a>
					
				</div>
			</ng-container>
			</div>
		</div>
				<div style="width:100%; padding:8px 16px" *ngIf="doc2.TYPE=='PHOTOS'&&doc2.photos&&doc2.photos.length>0">
			<div class="row">
			<ng-container *ngFor="let photo of doc2.photos; let s=index; trackBy:trackByFuntion">
				<div class="column">
					<!--<div class="gallery">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:90%">
						<p class="desc">{{photo.FILE_DESCRIPTION}}<app-edit-input [text]="photo.FILE_DESCRIPTION" [maxlength]='100' (edited)="addLib=false; getPosition(doc2,$event,i, j,k); changeDesc('photos','FILE_DESCRIPTION',s, $event,i,j,k)"></app-edit-input>
						<a href="javascript:void(0);" class="removeFile" (click)="addLib=false; getPosition(doc2,$event,i, j,k); removePhoto(photo)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				
					</div>-->
					<div class="gallery" style="text-align: center;height:240px;line-height: 240px;">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="max-height: 100%;max-width: 100%;vertical-align: middle;">
					</div>
					<div style="height:60px">
						<p class="desc"><span  class="replaceContainer" [attr.data-id]="doc2.id" data-type="photo" [attr.data-x]='s'  [innerHTML]="photo.FILE_DESCRIPTION|highlighter:searchText:caseOn:allMatchtext"></span><app-edit-input *ngIf='doc2.id==curId&&doc2.id==onlock' [text]="photo.FILE_DESCRIPTION" [maxlength]='100' (edited)="addLib=false; getPosition(doc2,$event,i, j, k); changeDesc('photos','FILE_DESCRIPTION',s, $event,i,j, k)"></app-edit-input>
						<a *ngIf='doc2.id==curId&&doc2.id==onlock' href="javascript:void(0);" class="removeFile" (click)="addLib=false; getPosition(doc2,$event,i,j,k); removePhoto(photo)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				
					</div>
				</div>
			</ng-container>
			</div>
		</div>
				<!--<app-paragraph class="docItem"  (outHtml)=ckData($event,doc2)></app-paragraph>-->	

				<div *ngIf="doc2.id==onlock&&doc2.id==curId" [ngClass]="{'hideSec':doc2.OTABLE}" style="overflow: hidden;">				
				<button  *ngIf="doc2.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
				<table *ngIf="doc2.TYPE=='4099e'" [ngClass]="{'unlockedSec':rptUser.length>1&&noEditableFmeSec.indexOf(doc2.id)>-1}" [ngStyle]="{'border':doc2.id=='fme_exec_sum_capital_needs_1'?'none': '1px solid black', 'width':doc2.halfwidth?'50%':'100%'}"  style="font-size:10px; font-family:Arial, sans-serif;border-collapse: collapse;">
					<tr *ngIf="doc2.data.titlerow">
						<th  [ngClass]="doc2.data.titlerow[0].bk" [colSpan]="doc2.data.cols.length" [ngStyle]="{'width':doc2.data.titlerow[0].width+doc2.data.titlerow[0].unit,'text-align':doc2.data.titlerow[0].colAlign}" style="font-weight: bold;border: 1px solid black">{{doc2.data.titlerow[0].NAME}}
						</th>	
					</tr>
					<tr *ngIf="doc2.header">
						<ng-container *ngFor="let h of doc2.data.cols; let o=index; trackBy:trackByFuntion">
							<th *ngIf="!h['hide']" [ngClass]="h.bk" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="font-weight: bold;border: 1px solid black">{{h.NAME}}
							</th>	
						</ng-container>
					</tr>
					<ng-container *ngFor="let r of doc2.data?.rows; let l=index; trackBy:trackByFuntion">
						<tr>
							<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
								<td *ngIf="!k.colspan&&!k['hide']&&doc2.header" [ngClass]="k.bk" class="cellItem1" (dblclick)="selectCell(doc2, l, doc2.data.cols[q], k)" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'font-weight':k.weight, 'border':k.border}">
									<a *ngIf="k.index" href="javascript:void(0)" [ngStyle]="{'font-weight':k.bold}" (click)="scrollTo(k.id, k.index)">{{k.data}}</a>
									<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
									<span class="innerCell" *ngIf="k.DATA&&(!k.ops)&&(!k.sign)&&(!k.index)"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='l' [attr.data-y]='q' [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									<span class="innerCell" *ngIf="!k.DATA&&(!k.ops)&&(!k.index)&&(!k.sign)">{{k.data}}</span>
									
									<a *ngIf="(k.RF||k.Manual)&&(!k.ops)" style="float:right;"  (click)="selectCell(doc2, l, doc2.data.cols[q], k)"><i style="color:#ccc; margin-right: 4px;" class="far fa-list-alt"></i></a>
									<!--<selected *ngIf="k.ops" style="float:right;"  [(ngModel)]="k.DATA">
										<option *ngFor="let op of ops" [value]="op" [selected]="k.DATA==op">

										</option>
									</selected>-->
									<select *ngIf="k.ops" style="float:right;" [(ngModel)]="k.data" (change)="fmeSelect($event, doc2.id)">
										<option></option>
										<option *ngFor="let op of k.ops" [value]="op" [selected]="k.data==op">{{op}}</option>
									</select>
								</td>
								<td *ngIf="!k.colspan&&!k['hide']&&(!doc2.header)" [ngClass]="k.bk" class="cellItem" (dblclick)="selectCell(doc2, l, doc2.data.cols[q], k)" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'font-weight':k.weight,'width':doc2.data.cols[q].width+doc2.data.cols[q].unit, 'border':k.border}">
									<a *ngIf="k.index" href="javascript:void(0)" [ngStyle]="{'font-weight':k.bold}" (click)="scrollTo(k.id, k.index)">{{k.data}}</a>
									<!--<span *ngIf="k.sign">{{k.sign}}</span>
									<span class="innerCell" *ngIf="k.DATA&&(!k.ops)" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
									<span class="innerCell" *ngIf="!k.DATA&&(!k.ops)&&!k.index">{{k.data}}</span>-->
									<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
									<span class="innerCell" *ngIf="!k.sign&&k.DATA"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='l' [attr.data-y]='q' [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									<span class="innerCell" *ngIf="!k.sign&&(!k.DATA)">{{k.data}}</span>
									
									<a *ngIf="(k.RF||k.Manual)&&(!k.ops)" style="float:right;"  (click)="selectCell(doc2, l, doc2.data.cols[q], k)"><i style="color:#ccc; margin-right: 4px;" class="far fa-list-alt"></i></a>
									<!--<selected *ngIf="k.ops" style="float:right;"  [(ngModel)]="k.DATA">
										<option *ngFor="let op of ops" [value]="op" [selected]="k.DATA==op">

										</option>
									</selected>-->
									<select *ngIf="k.ops" style="float:right;" [(ngModel)]="k.data" >
										<option></option>
										<option *ngFor="let op of k.ops" [value]="op" [selected]="k.data==op">{{op}}</option>
									</select>
								</td>
								<td *ngIf="k.colspan&&!k['hide']"  [ngClass]="k.bk" colSpan='{{k.colspan}}'  (dblclick)="selectCell(doc2, l, doc2.data.cols[q], k)" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'font-weight':k.weight, 'border':k.border}">
									<!--<span *ngIf="k.sign">{{k.sign}}</span>{{k.data}}-->
									<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
									<!--<span *ngIf="!k.sign">{{k.data}}</span>-->
									<span class="innerCell" *ngIf="!k.sign&&k.DATA" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='l' [attr.data-y]='q' [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									<span class="innerCell" *ngIf="!k.sign&&(!k.DATA)">{{k.data}}</span>
									<a *ngIf="(k.RF||k.Manual)&&(!k.ops)" style="float:right;"  (click)="selectCell(doc2, l, doc2.data.cols[q], k)"><i style="color:#ccc; margin-right: 4px;" class="far fa-list-alt"></i></a>
									
								</td>			
							</ng-container>
						</tr>					
					</ng-container>  
				</table>
				<div style="position: relative;">
			
				<p *ngIf="(reportInfo?.ORDER_NUM||doc2?.data?.disableCopiedEris)&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2.data.rows.length>100" class="erislabel">100 of {{doc2.data.rows.length}} total records shown</p>
				<p *ngIf="(reportInfo?.ORDER_NUM||doc2?.data?.disableCopiedEris)&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2.data.rows.length<101" class="erislabel">{{doc2.data.rows.length}} of {{doc2.data.rows.length}} total records shown</p> 
				<p *ngIf="!reportInfo?.ORDER_NUM&&!doc2?.data?.disableCopiedEris&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2.data.rows.length==1" class="erislabel">0 of 0 total records shown</p>
				<table *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName" [ngStyle]="{'width':doc2.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif">
					<thead>
					<tr>
						<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
							<th *ngIf="(!h.hide||h.hide=='N')" [ngStyle]="{'width':h.width+h.unit,'text-align':doc2.data.cols[o].colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
								<span style="font-weight:bold"><span class="replaceContainer" data-type="eris" [attr.data-id]="doc2.id" [attr.data-x]='o' [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span></span>
							</th>
						</ng-container>
					</tr>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc2.data?.rows|slice: 0:100; let h=index; trackBy:trackByFuntion">
						<tr *ngIf="r[0]['SUBHEADER']!='Y'&&(r[0].DATA&&r[0].DATA.length>0)">
							<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
								<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
									<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>
									<span *ngIf="!k.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc2.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.DATA|highlighter:searchText:caseOn:allMatchtext"></span>
									<span *ngIf="k.HTML"  class="replaceContainer" data-type="eris" [attr.data-id]="doc2.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.SEC.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
								</td>
							</ng-container>		
						</tr>
						<tr *ngIf="r[0]['SUBHEADER']=='Y'">
							<td colSpan='{{doc2.data.cols.length-1}}' [ngStyle]="{'text-align':r[0]['celAllign']?r[0]['celAllign']:'Center'}" style="border: 1px solid #ccc; text-align: center; border-collapse: collapse;vertical-align:top;">
								<span *ngIf="!r[1]?.HTML" [innerHTML]="r[1].DATA|highlighter:searchText:caseOn:allMatchtext"></span>
								<span *ngIf="r[1]?.HTML" [innerHTML]="r[1].SEC.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</td>
						</tr>
					</ng-container>
					</tbody>
				</table>					
			</div>
				<table  class="editTable" *ngIf="doc2.data&&(doc2.TYPE=='COSTTABLE'||doc2.TYPE=='PCATABLE')" style="width:100%;font-size:10px; font-family:Arial, sans-serif;">
  <tr style="background-color:#eeeeee;">
  <th *ngIf="doc2.TYPE=='TABLE'||doc2.TYPE=='COSTTABLE'" style="width:36px"></th>
    <ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
	<th *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}">
		<!--<app-editable [text]="h.NAME" style="font-weight:bold"  [defaultText]='"Header"' (edited)="selCell(o); changeLabel($event)" (focused)="getPosition(doc2.id,doc2.SECTION_TITLE,$event,i, j,k);addLib=false" [defaultText]='"Header"'></app-editable>-->
		<span>{{h.NAME}}</span>
		<app-edit-input [text]="h.NAME" (edited)="getPosition(doc2,$event,i, j,k);selCell(o); changeLabel($event)"></app-edit-input>
	</th>
	<!--<th *ngIf="h.type=='dropdown'">
	
	</th>-->
	</ng-container>
  </tr>
  <ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
  <tr  *ngIf="r.length>1&&!(doc2.TYPE=='COSTTABLE'&&h==0)&&(!doc2.filted||doc2.filted.indexOf(r[0].DATA)>-1)"  [ngStyle]="{'background-color':r?.hide=='Y'?'#666':'white'}">
	<td  *ngIf="doc2.TYPE=='TABLE'||doc2.TYPE=='COSTTABLE'"  [ngStyle]="{'background-color':r?.hide=='Y'?'#666':'white'}" style="font-size:.8em; width:36px">
		<i class="btn iconBtn1 far fa-edit" *ngIf="doc2.TYPE=='COSTTABLE'&&((!doc2.data.version)||(r[0].KEEP&&doc2.data.version&&doc2.data.version=='2'))&&reportInfo.PCA_INDICATOR!='frm1105'" (click)="getPosition(doc2,$event,i, j,k);editCostRow(h)"></i>
		<i class="btn iconBtn1 fas fa-trash-alt" *ngIf="doc2.TYPE=='COSTTABLE'&&((!doc2.data.version)||(r[0].KEEP&&doc2.data.version&&doc2.data.version=='2'))&&(!r[0].FRM)" (click)="getPosition(doc2,$event,i, j,k);deleteRow(h,doc2)"></i>
		<i class="btn iconBtn1 far fa-edit" *ngIf="doc2.TYPE=='COSTTABLE'&&(r[0].KEEP||r[0].FRM)&&reportInfo?.PCA_INDICATOR=='frm1105'" (click)="getPosition(doc2,$event,i, j, k);editFrmCostRow(doc2, h)"></i>
		<a *ngIf="doc2.TYPE=='TABLE'" href="javascript:void(0)" class="btn btn-sm btn-link"  (click)="op102.show($event);getPosition(doc2,$event,i, j, k);selectedRow=h;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k?'white':'rgb(195,212,47)'}">{{h+1}}</a>
		
		<!--<i *ngIf="r?.hide=='Y'" class="far fa-eye-slash" style="font-size:9px; color:white"></i>-->
		<!--<i class="fas fa-long-arrow-alt-up iconBtn" (click)="getPosition($event,i, j,k);moveUp(h)"></i>
		<i class="fas fa-long-arrow-alt-down iconBtn" (click)="getPosition($event,i, j,k);moveDown(h)"></i>
		<i class="fas fa-trash iconBtn" (click)="getPosition($event,i, j,k);deleteRow(h)"></i>-->
		<p-overlayPanel #op102 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
            <ng-template pTemplate>                                                    
				<div *ngIf="selectedRow>-1"   style="font-size:.8em; color:#C2D63F; ">
					<label style="font-weight:bold">Row: {{selectedRow+1}}</label>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="deleteRow(selectedRow)" title="Delete Row"><i class="fas fa-trash iconBtn smIcon" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="hideRow(selectedRow)" [ngStyle]="{'background-color':r.hide=='Y'?'white':'transparent'}"  title="Hide Row"><i class="far fa-eye-slash iconBtn smIcon" style="pointer-events:none"></i></a>
					<br>
					<div>
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
						<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addRows($event)"><span style="pointer-events:none; font-size:.8em">Add Row</span></a><br>
						<select style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>                                       </ng-template>
            </p-overlayPanel>
	</td>
    <ng-container *ngFor="let m of r; let q=index; trackBy:trackByFuntion">
		<td *ngIf="!m.hide||m.hide=='N'" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" [ngClass]="{'active':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k}" style="overflow:hidden">
			<span *ngIf="!m.index&&doc2.TYPE=='TABLE'" [innerHTML]="m.DATA"></span>
			<!--<app-editable *ngIf="doc2.TYPE=='TABLE'" [text]="m?.DATA" (edited)="selCell(h,q); changeLabel($event)" (focused)="addLib=false; getPosition(doc2.id,doc2.SECTION_TITLE,$event,i, j,k);" [defaultText]='"Text"'></app-editable>-->
			<app-edit-input *ngIf="doc2.TYPE=='TABLE'" [text]="m?.DATA" (edited)="addLib=false;getPosition(doc2,$event,i, j,k);selCell(h,q); changeLabel($event)"></app-edit-input>
			<span *ngIf="doc2.TYPE!='TABLE'&&!m?.index" [ngStyle]="{'font-weight':m.bold}"><span *ngIf="m.sign&&m.sign==currSign">{{m.sign}}</span>{{m.DATA}}<span *ngIf="m.sign&&m.sign!=currSign">{{m.sign}}</span></span>
			<!--<a *ngIf="doc2.TYPE=='PCATABLE'&&m?.index" href="javascript:void(0)" [ngStyle]="{'font-weight':m.bold}" (click)="scrollTo(m.id, m?.index)">{{m.DATA}}</a>-->
			<!--<ng-container *ngIf="doc2.TYPE=='TABLE'&&doc2.TYPE!='PCATABLE'&&doc2.TYPE!='COSTTABLE'&&doc2.TYPE!='UNITTABLE'&&!doc2.data.SLOT_ID">
				<span *ngIf="m.DATA" [innerHTML]="m.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				
			</ng-container>-->
			
		
		</td>			
	</ng-container>
  </tr>
  <tr *ngIf="r.length==1&&doc2.data">
  <td style="font-size:.8em; background-color:#eeeeee; width:40px">
	<a class="btn btn-sm btn-link"  (click)="op103.show($event);getPosition(doc2,$event,i, j,k);selectedRow=h;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k?'white':'rgb(195,212,47)'}">{{h+1}}</a>
		<!--<i class="fas fa-long-arrow-alt-up iconBtn" (click)="getPosition($event,i, j,k);moveUp(h)"></i>
		<i class="fas fa-long-arrow-alt-down iconBtn" (click)="getPosition($event,i, j, k);moveDown(h)"></i>
		<i class="fas fa-trash iconBtn" (click)="getPosition($event,i, j,k);deleteRow(h)"></i>-->
	<p-overlayPanel #op103 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
            <ng-template pTemplate>                                                    
				<div *ngIf="selectedRow>-1"   style="font-size:.8em; color:#C2D63F; ">
					<label style="font-weight:bold">Row: {{selectedRow+1}}</label>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="deleteRow(selectedRow)" title="Delete Row"><i class="fas fa-trash iconBtn smIcon" style="pointer-events:none"></i></a>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="hideRow(selectedRow)" [ngStyle]="{'background-color':r.hide=='Y'?'white':'transparent'}"  title="Hide Row"><i class="far fa-eye-slash iconBtn smIcon" style="pointer-events:none"></i></a>
			<br>
					<div>
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
						<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addRows($event)"><span style="pointer-events:none;font-size:.8em">Add Row</span></a><br>
						<select style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>                                       </ng-template>
            </p-overlayPanel>
	</td>
		<td colSpan='{{doc2.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold">
			<app-editable [text]="r[0].DATA" (edited)="selCell(h,0); changeLabel($event)" (focused)="addLib=false; getPosition(doc2,$event,i, j,k);" [defaultText]='"Sub-Header"'></app-editable>
		</td>
  </tr>
  </ng-container>
</table>
<div  class="editTable1" *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&(!doc2.data?.erisName)" style="position: relative;"> 
	<table style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
		<!--<caption *ngIf="doc2.data['caption']" [ngStyle]="{'border':doc2.data['caption']['border']?'solid 1px black':'none', 'text-align':doc2.data['caption']['align']?doc2.data['caption']['align']:'center'}">
			<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-v]='k' [innerHTML]="doc2.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
		</caption>-->
		<thead>
			<ng-container *ngFor="let brow of doc2.data.beforeHeaders; let bindex=index">
				<tr>
					<ng-container *ngFor="let col of brow; let u=index">
						<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
							<i *ngIf="doc2.data['locked']&&doc2.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
						<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
							<i *ngIf="doc2.data['locked']&&doc2.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
			</ng-container>
		<tr>
			<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
				<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
					<i *ngIf="doc2.data['locked']&&doc2.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
					<span [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}" style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='o' [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				</th>
			</ng-container>
		</tr>
		<ng-container *ngFor="let brow of doc2.data.afterHeaders; let bindex=index">
			<tr>
				<ng-container *ngFor="let col of brow; let u=index">
					<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
						<i *ngIf="doc2.data['locked']&&doc2.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
					<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
						<i *ngIf="doc2.data['locked']&&doc2.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
				</ng-container>
			</tr>
		</ng-container>
		</thead>
	<tbody>
	<ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
		<tr *ngIf="r.items?.length>1">
			<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
				<td [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
					<i *ngIf="doc2.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
					<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>	
					<span *ngIf="k.DATA"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:"full"|safeHtml'></span>
				</td>														
			</ng-container>
		</tr>
		<tr *ngIf="r.items?.length==1">
			<td [attr.colspan]='doc2.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top;">
				<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<i *ngIf="doc2.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
			</td>
		</tr>
	</ng-container>
	</tbody>
</table>  
  <!--<p-table [value]="doc2.data.rows" [columns]="doc2.data.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, doc2.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, doc2)">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="cellItem" style="width:2rem;background:white;"></th>
            <th *ngFor="let col of columns; let t=index" style="background:white;vertical-align:middle" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" pReorderableColumn pResizableColumn class="cellItem">
                <span class="headerCell" [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}"[attr.data-id]="doc2.id" data-type="table" [attr.data-x]='o' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="selectCol(doc2, t, col);getPosition(doc2,$event,i,j,k)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, doc2, index);selectedCell=null" [ngClass]="{'selected':rowData.selected}">
                <span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>			
            </td>			
        	<ng-container *ngIf="rowData.items[0].colspan">
			<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(doc2, index, columns[0], rowData.items[0])" [ngClass]="{'rowHide':rowData.hide}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
				<span class="innerCell" *ngIf="rowData.items[0].DATA" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a class="float-right" (click)="op506.toggle($event)" [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
				<p-overlayPanel #op506 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
                <ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[0])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[0])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[0])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[0])">Clear</a>
					</div>					
				</ng-template>
            </p-overlayPanel>
			</td>
			</ng-container>	
			<ng-container *ngIf="!rowData.items[0].colspan">
			<td *ngFor="let col of columns; let z=index" [ngStyle]="{'text-align':col.celAllign, 'background':rowData.items[z].bkcolor? rowData.items[z].bkcolor:'white'}"  class="cellItem" (dblclick)="selectCell(doc2, index, col, rowData.items[z])" [ngClass]="{'rowHide':rowData.hide}">
				<span class="innerCell" *ngIf="rowData.items[z].DATA" [innerHTML]="rowData.items[z].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a class="float-right" (click)="op503.toggle($event)" [ngStyle]="{'color':rowData.items[z].libs&&rowData.items[z].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
				<p-overlayPanel #op503 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
                <ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[z])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[z])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[z])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[z])">Clear</a>
					</div>					
				</ng-template>
            </p-overlayPanel>
			</td>
			</ng-container>			
        </tr>
    </ng-template>
</p-table> -->
</div>
</div>
	
				</ng-container>
			</div>
			
		</div>		
	
	</div>
	</ng-container>
	<ng-container *ngIf="reportInfo?.PCA_INDICATOR=='frm1104'&&contents.length>0">
		<h6 [id]='contents[0].id' [ngStyle]="{'background-color':listid==contents[0].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section I: General Information, Documentation and Certification</h6>
		<div style="font-size:10px"><!--Mortgage and Property Information-->
		<h6 [id]='contents[0].SUB_SECTIONS[0].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[0].SUB_SECTIONS[0].id)">{{contents[0].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[0].SUB_SECTIONS[0].id)">
		<div style="width:100%; display:inline; position:relative" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[0].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[0].id}">
			<div style="width:49.5%; display:inline-block;">
				<div style="width:49.5%;display:inline-block">
					<div style="height:4px; border:none"></div>
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<label for="frmloanNo" style="margin-left:4px">Freddie Mac loan number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FrmLoanNo', 0, 0 )"><i class="far fa-list-alt"></i></a>
						<div *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" disabled ="text" style="border:none;width:94%"/>
					
					</div>
				</div>
				<div style="width:49.5%;display:inline-block">
					<div style="height:4px; border:none"></div>
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<!--<label style="margin-left:4px">Report date</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FinalAsmntDate', 0, 0 )"><i class="far fa-list-alt"></i></a>
						<div *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" disabled ="text" style="border:none;width:94%"/>-->
						<label style="margin-left:4px">Report date</label><input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.FinalAsmntDate"><br>
						<p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.FinalAsmntDate|date:"MMMM dd, yyyy"}}</p>
						<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" disabled ="text" style="border:none;width:94%"/>
					</div>
				</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Property name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AsReportedName', 0, 0 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Seller/Servicer name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AccountName', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
		</div>
	
	<div style="width:49.5%; display:inline-block;">
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px"></div>
			<label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
	<div style="width:49.5%;display:inline-block">
	  <div style="height:4px; border:none"></div>
	  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
	 <label  style="margin-left:4px" for="frmloanNo">Seller/Servicer number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PartyBusinessAccountId', 0, 0 )"><i class="far fa-list-alt"></i></a>
	 <div *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
	 <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" disabled ="text" style="border:none;width:100%"/>
	</div>
	</div>
	<div style="width:49.5%;display:inline-block">
	</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
		<div style="width:22%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">City</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'CityName', 0, 0 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.CityName?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:35%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">State</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode', 0, 0 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:42.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Zip</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PostalCode', 0, 0 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
	</div>    
		</div>
	</div><!--Consultant Information-->
	<h6 [id]='contents[0].SUB_SECTIONS[1].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[0].SUB_SECTIONS[1].id)">{{contents[0].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
	<div (click)="frmSwitch(contents[0].SUB_SECTIONS[1].id)">
	<div style="width:100%; display:inline; position:relative" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[1].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[1].id}">
			
				<div style="width:49.5%;display:inline-block">
					<div style="height:4px; border:none"></div>
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<label for="frmloanNo" style="margin-left:4px">Firm name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmName', 0, 1 )"><i class="far fa-list-alt"></i></a>
						<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmName?.html" disabled ="text" style="border:none;width:94%"/>
					
					</div>
				</div>
				
		
		<div style="width:49.5%; display:inline-block;">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Inspector's name and title</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'InspectorName', 0, 1 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[1].data?.InspectorName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.InspectorName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.InspectorName?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmAddressLineText', 0, 1 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
		</div>
	
	<div style="width:49.5%; display:inline-block;">
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px"></div>
			<label style="margin-left:4px">Report writer's name and title</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'WriterName', 0, 1 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[1].data?.WriterName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.WriterName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.WriterName?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
		<div style="width:22%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">City</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmCityName', 0, 1 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmCityName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmCityName?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
				<div style="width:35%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">State</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmStateUspsCode', 0, 1 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
			<div style="width:42.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Zip</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmPostalCode', 0, 1 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
		
	</div>
	<div style="width:49.5%;display:inline-block">
	  <div style="height:4px; border:none"></div>
	  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
	 <label  style="margin-left:4px" for="frmloanNo">Environmental reviewer's name and title</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'ReviewerName', 0, 1 )"><i class="far fa-list-alt"></i></a>
	 <div *ngIf="contents[0].SUB_SECTIONS[1].data?.ReviewerName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.ReviewerName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
	 <input *ngIf="!contents[0].SUB_SECTIONS[1].data?.ReviewerName?.html" disabled ="text" style="border:none;width:100%"/>
	</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
		<div style="width:69.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label for="FirmPhoneNumber" style="margin-left:4px">Telephone number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmPhoneNumber', 0, 1 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmPhoneNumber?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPhoneNumber?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmPhoneNumber?.html" disabled ="text" style="border:none;width:94%"/>
			
			</div>
		</div>
		<div style="width:29.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Extension</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmPhoneExt', 0, 1 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
	</div><div style="width:49.5%; display:inline-block;">
	<div style="width:69.5%;display:inline-block">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label for="VisitDate" style="margin-left:4px">Date of visit</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'VisitDate', 0, 1 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[1].data?.VisitDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.VisitDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.VisitDate?.html" disabled ="text" style="border:none;width:94%"/>-->
			<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[1].data.VisitDate"><br>
			  <p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[1].data.VisitDate|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[1].data?.VisitDate" disabled ="text" style="border:none;width:94%"/>
		
		</div>
	</div>
	<div style="width:29.5%;display:inline-block">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Date of engagement</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'EngageDate', 0, 1 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[1].data?.EngageDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.EngageDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.EngageDate?.html" disabled ="text" style="border:none;width:94%"/>-->
			<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[1].data.EngageDate"><br>
			  <p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[1].data.EngageDate|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[1].data?.EngageDate" disabled ="text" style="border:none;width:94%"/>
		</div>
	</div>
	</div>
	
		
	</div>
	</div><!--Site Statistics-->
	<h6 [id]='contents[0].SUB_SECTIONS[2].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[0].SUB_SECTIONS[2].id)">{{contents[0].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
	<div (click)="frmSwitch(contents[0].SUB_SECTIONS[2].id)">	
	<div style="width:100%; display:inline; position:relative" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[2].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[2].id}">
			<div style="width:49.5%; display:inline-block;">
				<div style="width:49.5%;display:inline-block">
					<div style="height:4px; border:none"></div>
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<label for="BuildYear" style="margin-left:4px">Year(s) of construction</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'BuildYear', 0, 2 )"><i class="far fa-list-alt"></i></a>
						<div *ngIf="contents[0].SUB_SECTIONS[2].data?.BuildYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.BuildYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.BuildYear?.html" disabled ="text" style="border:none;width:94%"/>
					
					</div>
				</div>
				<div style="width:49.5%;display:inline-block">
					<div style="height:4px; border:none"></div>
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<label style="margin-left:4px">Year last renovated (with amount)</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'RenovYear', 0, 2 )"><i class="far fa-list-alt"></i></a>
						<div *ngIf="contents[0].SUB_SECTIONS[2].data?.RenovYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.RenovYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.RenovYear?.html" disabled ="text" style="border:none;width:94%"/>
						<div>$<input [(ngModel)]="contents[0].SUB_SECTIONS[2].data.RenovCost" (change)="validateInput($event, contents[0].SUB_SECTIONS[2].data, 'RenovCost')"></div>
					</div>
				</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label for="BuildingType" style="margin-left:4px">Construction type</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'BuildingType', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.BuildingType?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.BuildingType?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.BuildingType?.html" disabled ="text" style="border:none;width:94%"/>
				
				</div>
			</div>
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Acreage</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Acre', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div class="row">
						<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Acre?.html"  style="width:94%" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Acre?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Acre?.html" disabled ="text" style="border:none;width:94%"/>
					</div>
				</div>
			</div>
	</div>
		<div style="width:49.5%; display:inline-block;">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Topography</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Topo', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Topo?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Topo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Topo?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label for="FloodZone" style="margin-left:4px">Flood zone</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FloodZone', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.FloodZone?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.FloodZone?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.FloodZone?.html" disabled ="text" style="border:none;width:94%"/>
				
				</div>
			</div>
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Peak ground acceleration</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PeakGround', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div class="row">
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.PeakGround?.html"  style="width:94%" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.PeakGround?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.PeakGround?.html" disabled ="text" style="border:none;width:94%"/><span style="float:right">g</span>
				</div>
				</div>
			</div>
	</div>
		<div style="width:99.5%; display:inline-block;">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Amenities</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Amenities', 0, 2 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Amenities?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Amenities?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Amenities?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
		</div>
	<div style="margin-top: 20px; width: 100%;">
	<!--<div style="width:49.5%; display:inline-block;">
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px"></div>
			<label style="margin-left:4px">units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
	</div>-->
	<p style="width:72%; display:inline-block;">Number of:</p><p style="width:28%; display:inline-block;">Number of parking spaces:</p>
	<div style="width:72%; display:inline-block;">
		<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Units', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Units?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Units?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Units?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
			<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Apartment buildings</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'ApartmentUnits', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
			<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Other buildings</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'OtherUnits', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.OtherUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.OtherUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.OtherUnits?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
		
	</div>
	
	<div style="width:28%; display:inline-block;">
		<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Surface</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Surface', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Surface?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Surface?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Surface?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
			<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Garage</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Garage', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Garage?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Garage?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Garage?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
			<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Carports</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Carports', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Carports?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Carports?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Carports?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
		
	</div>
	<div style="width:72%; display:inline-block;">
		<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Ground floor units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'GroundUnits', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.GroundUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.GroundUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.GroundUnits?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
			<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Elevators</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Elevators', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Elevators?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Elevators?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Elevators?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
			<div style="width:33%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Floors</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Floors', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Floors?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Floors?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Floors?.html" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
		
	</div>
	<div style="width:28%; display:inline-block;">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Other:</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Other', 0, 2 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Other?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Other?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Other?.html" disabled ="text" style="border:none;width:94%"/>
		</div>
	</div>
	<div style="width: 100%; margin-bottom: 4px;">
		<p>Discuss other features:</p>
		<textarea style="width: 100%;" [(ngModel)]="contents[0].SUB_SECTIONS[2].data.discuss"></textarea>
	</div>
	</div>
		
	</div>
	</div><!--End Site Statistics-->
	<div style="margin-top: 6px;font-size: 11px;"><!--List of Parties Present-->
		<h6 [id]="contents[0].SUB_SECTIONS[3].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[3].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;" (click)="frmSwitch(contents[0].SUB_SECTIONS[3].id)">{{contents[0].SUB_SECTIONS[3].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[0].SUB_SECTIONS[3].id)">
		<p style="margin-bottom: 10px;">Provide a listing of parties involved in the site visit (including the consultants).</p>
		<div [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[3].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[3].id}">
			<ng-container *ngFor="let row of contents[0].SUB_SECTIONS[3].data; let i=index" >
				<table class="partiesTable" style="border:2px solid black">
					<tbody>
						<tr style="height: 14px;">
							<td rowspan="2" style="background-color: black;color: #FFFFFF;vertical-align: middle;width:4%; text-align: center;">
								{{i+1}}
							</td>
							<td style="background-color: #C0C0C0;width:10%; text-align: right">Company
							</td>
							<td style="width:38%;"><input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Company.text">
							</td>
							<td style="background-color: #C0C0C0;width:10%; text-align: right">Name
							</td>
							<td style="width:38%"> <input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Name.text">
							</td>
						</tr>
						<tr style="height: 14px;">
							<td style="background-color: #C0C0C0;width:10%; text-align: right">Title
							</td>
							<td style="width:38%"><input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Title.text">
							</td>
							<td style="background-color: #C0C0C0;width:10%; text-align: right">Affiliation
							</td>
							<td style="width:38%"><input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Affiliation.text">
							</td>
						</tr>
						<tr style="border-top: double 2px black;height: 14px;">
							<td colspan="5" style="background-color: #C0C0C0;">Comments
							</td>
						</tr>
						<tr>
							<td colspan="5" ><input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Comment.text">
							</td>
						</tr>
					</tbody>
				</table>
			</ng-container>
			<div style="position:relative; height:20px">
				<button class="frmBtn" style="float: right;" (click)="addListParties(contents[0].SUB_SECTIONS[3].data)">Add</button>
				<button class="frmBtn" style="float: right;" (click)="deleteListParties(contents[0].SUB_SECTIONS[3].data)">Delete Last Entry</button>
			</div>
		</div>	
		</div>
	</div>
	<div style="margin-top: 6px;font-size: 12px;"><!--Documentation-->
		<h6 [id]="contents[0].SUB_SECTIONS[4].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[4].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;" (click)="frmSwitch(contents[0].SUB_SECTIONS[4].id)">{{contents[0].SUB_SECTIONS[4].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[0].SUB_SECTIONS[4].id)">
		<p style="margin-bottom: 10px;">Indicate if the below are attached or not attached. If they are not attached, then additional information should be provided in the comments</p>
		<div style="width:100%" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[4].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[4].id}">
			<div class='klistItem' style="width:86%;">
				<p style="border-bottom:solid 1px black;margin-bottom: 4px;">Document</p>
				<p >Limiting conditions</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				  <p style="border-bottom:solid 1px black;margin-bottom: 4px;">Status</p>
				  <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[0]">
					<option value="Y" >Attached</option>
					<option value="N" >Not attached</option>
					<option value="NA" >NA</option>                     
				</select>
			</div>
			<div class='klistItem' style="width:86%;">
				<p>Site plan</p>
			 </div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[1]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Renovation scope of work and budgets</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[2]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Information provided by borrower (specified in appendix)</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[3]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Building and health code violations</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[4]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Environmental transaction screen</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[5]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Test and study results (e.g., structural, civil, asbestos, etc. - specified in appendix)</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[6]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Other records and data reviewed (specified in appendix)</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[7]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Resume of inspector</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[8]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Resume of report writer/reviewer (if different from the inspector)</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[9]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				<p>Resume of environmental reviewer (if different from the inspector and/or report reviewer)</p>
			 </div>
			 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[10]">
					 <option value="Y" >Attached</option>
					 <option value="N" >Not attached</option>
					 <option value="NA" >NA</option>                     
				 </select>
			 </div>
			 <div class='klistItem' style="width:86%;">
				 <p>Identification of any deviations from the Guide requirements and the most recent versions of the ASTM standards E2018 and E1528 as well as applicable environmental regulations established by the Environmental Protection Agency</p>
			  </div>
			  <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				  <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[11]">
					  <option value="Y" >Attached</option>
					  <option value="N" >Not attached</option>
					  <option value="NA" >NA</option>                     
				  </select>
			  </div>
			  <div style="width: 100%; margin-bottom: 4px;">
				<p>Additional Comments:</p>
				<textarea style="width: 100%;"  [(ngModel)]="contents[0].SUB_SECTIONS[4].data.additionalInfo"></textarea>
			</div>			  
		</div>	
		</div>
	</div>
	<div style="margin-top: 6px;font-size: 12px;"><!--Data Collection and Records Inquiry-->
		<h6 [id]="contents[0].SUB_SECTIONS[5].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[5].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;" (click)="frmSwitch(contents[0].SUB_SECTIONS[5].id)">{{contents[0].SUB_SECTIONS[5].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[0].SUB_SECTIONS[5].id)">
		<div style="width:100%" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[5].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[5].id}">
			<div class='klistItem' style="width:86%;">
				<p style="width:75%;">Was information pertaining to the maintenance, repair and replacement of major building components or systems reviewed?</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[0].status">
					<option value="YES" >Yes</option>
					<option value="NO" >No</option>					                  
				</select>
			</div>
			<div   *ngIf="contents[0].SUB_SECTIONS[5].data[0].status=='NO'" style="width: 100%; margin-left: 4%;margin-bottom: 4px;">
				<p>Explain why not:</p>
				<textarea style="width: 95%;" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[0].Explanation"></textarea>
			</div>
			<div class='klistItem' style="width:86%;">
				<p style="width:75%;">Were all significant maintenance reports, repair receipts and replacement items completed within the past 12 months, as well as elevator, boiler and safety inspection records and certificates reviewed?</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[1].status">
					<option value="YES" >Yes</option>
					<option value="NO" >No</option>					                  
				</select>
			</div>
			<div   *ngIf="contents[0].SUB_SECTIONS[5].data[1].status=='NO'"style="width: 100%; margin-left: 4%;margin-bottom: 4px;">
				<p>Explain why not:</p>
				<textarea style="width: 95%;" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[1].Explanation"></textarea>
			</div>
			<div class='klistItem' style="width:86%;">
				<p style="width:75%;">Was all available information related to planned capital improvements, inclusive of renovation/rehabilitation scope or work, and/or such work in progress reviewed?</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[2].status">
					<option value="YES" >Yes</option>
					<option value="NO" >No</option>					                  
				</select>
			</div>
			<div   *ngIf="contents[0].SUB_SECTIONS[5].data[2].status=='NO'"style="width: 100%; margin-left: 4%;margin-bottom: 4px;">
				<p>Explain why not:</p>
				<textarea style="width: 95%;" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[2].Explanation"></textarea>
			</div>
			<div class='klistItem' style="width:86%;">
				<p style="width:75%;">Was evidence of completed capital expenditures or construction costs reviewed?</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[3].status">
					<option value="YES" >Yes</option>
					<option value="NO" >No</option>					                  
				</select>
			</div>
			<div  *ngIf="contents[0].SUB_SECTIONS[5].data[3].status=='NO'" style="width: 100%; margin-left: 4%;margin-bottom: 4px;">
				<p>Explain why not:</p>
				<textarea style="width: 95%;" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[3].Explanation"></textarea>
			</div>
			<div class='klistItem' style="width:86%;">
				<p style="width:75%;">Were there any records of violations of any federal, State or local laws, ordinances or codes that remain open for the Property, including any violations related to zoning, subdivision and use, building and housing accessibility (including the Americans with Disabilities and Fair Housing Acts), health matters, fire safety or energy-related requirements?</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[4].status">
					<option value="YES" >Yes</option>
					<option value="NO" >No</option>					                  
				</select>
			</div>
			<div *ngIf="contents[0].SUB_SECTIONS[5].data[4].status=='YES'" style="width: 100%; padding-left: 4%;margin-top: 4px;">
				<p class='klistItem' style="width:75%">Provide details regarding the violations in Section III. Only violations that are considered to be life/safety issues or significant deficiencies, and that should be corrected as part of the Priority Repairs scope, need to be included</p>
				<button class='navBtn' (click)="scroll('frm1104-2'); listid='frm1104-2'">Enter Violations</button>
			</div>
						  
		</div>	
		</div>
	</div>
	<div style="margin-top: 6px;font-size: 12px;"><!--Reliance-->
		<h6 [id]="contents[0].SUB_SECTIONS[6].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[6].id?'rgb(195, 212, 47)':'white'}"  style="padding:4px; background-color: black;" (click)="frmSwitch(contents[0].SUB_SECTIONS[6].id)">{{contents[0].SUB_SECTIONS[6].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[0].SUB_SECTIONS[6].id)">
		<div style="width:100%;" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[6].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[6].id}">
			<p>This report is for the use and benefit of, and may be relied upon by</p>
			<ol style="list-style-type: lower-alpha; font-size: 14px;">
				<li style="list-style:symbol('(a)');font-weight: normal;">the Seller/Servicer, Freddie Mac and any successors and assigns (“Lender”);</li>
				<li style="list-style:symbol('(a)');font-weight: normal;">independent auditors, accountants, attorneys and other professionals acting on behalf of Lender;</li>
				<li style="list-style:symbol('(a)');font-weight: normal;">governmental agencies having regulatory authority over Lender;</li>
				<li style="list-style:symbol('(a)');font-weight: normal;">designated persons pursuant to an order or legal process of any court or governmental agency;</li>
				<li style="list-style:symbol('(a)');font-weight: normal;">prospective purchasers of the Mortgage; and</li>
				<li style="list-style:symbol('(a)');font-weight: normal;"> with respect to any debt (or portion thereof) and/or securities secured, directly or indirectly, by the Property which is the subject of this report, the following parties and their respective successors and assigns:</li>
				<ul style="list-style-type:disc;">
					<li style="font-weight: normal;">any placement agent or broker/dealer and any of their respective affiliates, agents and advisors;</li>
					<li style="font-weight: normal;">any initial purchaser or subsequent holder of such debt and/or securities;</li>
					<li style="font-weight: normal;">any Servicer or other agent acting on behalf of the holders of such debt and/or securities;</li>
					<li style="font-weight: normal;">any indenture trustee;</li>
					<li style="font-weight: normal;">any rating agency; and</li>
					<li style="font-weight: normal;">any institutional provider from time to time of any liquidity facility or credit support for such financings.</li>
				</ul>
			</ol>
			<p>In addition, this report, or a reference to this report, may be included or quoted in any offering circular, information circular, offering memorandum, registration statement, private placement memorandum, prospectus or sales brochure (in either electronic or hard copy format) in connection with a securitization or transaction involving such debt (or portion thereof) and/or securities.</p>
		</div>
		</div>
	</div>
	<div style="margin-top: 6px;font-size: 12px;"><!--Certification-->
		<h6 [id]="contents[0].SUB_SECTIONS[7].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[7].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;" (click)="frmSwitch(contents[0].SUB_SECTIONS[7].id)">{{contents[0].SUB_SECTIONS[7].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[0].SUB_SECTIONS[7].id)">
		<div style="width:100%;" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[7].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[7].id}">
		<div style="width:100%">
			<p>The undersigned hereby certifies that:</p>
			<ul>
				<li>The attached physical risk report was prepared in accordance with all applicable requirements in the Freddie Mac Multifamily</li>
				<li>The inspection and report was prepared in a manner consistent with generally accepted industry practices and standards</li>
				<li>All information is true and correct, to the best of the undersigned's knowledge, and reflects the consultant's best professional opinion and</li>
				<li>No changes or additions have been made to the standard provisions of this form other than those expressly approved in writing by Freddie Mac</li>
			</ul>
		</div>
	
	
	<div style="width:100%; display:inline; position:relative">
		<div style="width:49%; display:inline-block;">
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<div style="height:4px;"></div>
				<label style="margin-left:4px">Signature of property inspector</label><br>
				<input type="text" style="border:none;width:90%"/>
				<ng-container *ngIf="!contents[0].SUB_SECTIONS[7].data['inspector']['sign']">
                    <input type="text" style="border:none;width:90%"/>
                    <i class="far fa-edit fa-sm float-sm-right iconBtn m-0" (click)="getSign('inspector')"></i>
                    </ng-container>
                  <ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['inspector']['sign']">
                    <img [src]="contents[0].SUB_SECTIONS[7].data['inspector']['sign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
                    <i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeSign('inspector')"></i>
                  </ng-container>					
			</div>
		</div>
		
		<div style="width:49%; display:inline-block;;margin-left:10px">
		<div style="display:inline-block;;margin:0;width:100%;">
			<div style="height:4px; border:none; "></div>
			<label style="margin-left:4px">Date</label>
			<!--<input type="text" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['inspector']['date']" (change)="addTitle($event, 'date','inspector')" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>-->
			<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['inspector']['date']"><br>
			  <p *ngIf="contents[0].SUB_SECTIONS[7].data['inspector']['date']" style="padding-left: 10px;border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%">{{contents[0].SUB_SECTIONS[7].data['inspector']['date']|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[7].data['inspector']['date']" disabled type="text" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%" />
		</div>
		</div>
		<div style="width:49%; display:inline-block;">
		<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px;"></div>
			<label style="margin-left:4px">Name (typed or printed)</label><br>
			<input *ngIf="!contents[0].SUB_SECTIONS[7].data['inspector']['name']" type="text" style="border:none;width:100%"/>
			<ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['inspector']['name']">
				<label  style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">{{contents[0].SUB_SECTIONS[7].data['inspector']['name']}}</label>
				<i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeName('inspector')"></i>
		  </ng-container>
		</div>
		</div>
		<div style="width:49%; display:inline-block;margin-left:10px">
		<div style="display:inline-block;margin:0;width:100%;">
			<div style="height:4px; border:none; "></div>
			<label style="margin-left:4px">Title</label><br>
			<input type="text" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['inspector']['title']" (change)="addTitle($event, 'title','inspector')" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
		</div>
		</div>
	</div>
	<div style="width: 100%;margin-top: 20px;">
		<div class='klistItem' style="width:86%;">
			<p style="width:75%;">Did a separate individual write or review the report?</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherRptReviewer'].required" (change)="removeSign('otherRptReviewer')">
				<option value="Y" >Yes</option>
				<option value="N" >No</option>					                  
			</select>
		</div>
	</div>
	<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer'].required=='Y'" style="width:100%; display:inline; position:relative">
		<div style="width:49%; display:inline-block;">
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<div style="height:4px;"></div>
				<label style="margin-left:4px">Signature of writer/reviewer</label><br>
				<input type="text" style="border:none;width:90%"/>
				<ng-container *ngIf="!contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['sign']">
                    <input type="text" style="border:none;width:90%"/>
                    <i class="far fa-edit fa-sm float-sm-right iconBtn m-0" (click)="getSign('otherRptReviewer')"></i>
                    </ng-container>
                  <ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['sign']">
                    <img  id='frmsign' [src]="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['sign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
                    <i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeSign('otherRptReviewer')"></i>
                  </ng-container>				
			</div>
		</div>
		
		<div style="width:49%; display:inline-block;;margin-left:10px">
		<div style="display:inline-block;;margin:0;width:100%;">
			<div style="height:4px; border:none; "></div>
			<label style="margin-left:4px">Date</label>
			<!--<input type="text" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['date']" (change)="addTitle($event, 'date','otherRptReviewer')" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>-->
			<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['date']"><br>
			  <p *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['date']"  style="padding-left: 10px;border-left:4px solid black;border-bottom:1px solid black;width:100%">{{contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['date']|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['date']" disabled type="text" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%" />
			</div>
		</div>
		<div style="width:49%; display:inline-block;">
		<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px;"></div>
			<label style="margin-left:4px">Name (typed or printed)</label><br>
			<input *ngIf="!contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['name']" type="text" style="border:none;width:100%"/>
            <ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['name']">
                <label  style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">{{contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['name']}}</label>
                <i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeName('otherRptReviewer')"></i>
            </ng-container>
			
		</div>
		</div>
		<div style="width:49%; display:inline-block;margin-left:10px">
		<div style="display:inline-block;margin:0;width:100%;">
			<div style="height:4px; border:none; "></div>
			<label style="margin-left:4px">Title</label><br>
			<input type="text" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['title']" (change)="addTitle($event, 'title', 'otherRptReviewer')" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
		</div>
		</div>
	</div>
	<div style="width: 100%;margin-top: 20px;">
		<div class='klistItem' style="width:86%;">
			<p style="width:75%;">Was a separate individual required to review the environmental section?</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherEvReviewer'].required" (change)="removeSign('otherEvReviewer')">
				<option value="Y" >Yes</option>
				<option value="N" >No</option>					                  
			</select>
		</div>
	</div>
	<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer'].required=='Y'" style="width:100%; display:inline; position:relative">
		<div style="width:49%; display:inline-block;">
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<div style="height:4px;"></div>
				<label style="margin-left:4px">Signature of reviewer</label><br>
				<ng-container *ngIf="!contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['sign']">
                    <input type="text" style="border:none;width:90%"/>
                    <i class="far fa-edit fa-sm float-sm-right iconBtn m-0" (click)="getSign('otherEvReviewer')"></i>
                    </ng-container>
                  <ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['sign']">
                    <img [src]="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['sign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
                    <i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeSign('otherEvReviewer')"></i>
                  </ng-container>				
			</div>
		</div>
		
		<div style="width:49%; display:inline-block;;margin-left:10px">
		<div style="display:inline-block;;margin:0;width:100%;">
			<div style="height:4px; border:none; "></div>
			<label style="margin-left:4px">Date</label>
			<!--<input type="text" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['date']" (change)="addTitle($event, 'date','otherEvReviewer')" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>-->
			<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['date']"><br>
			  <p *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['date']" style="padding-left: 10px;border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%">{{contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['date']|date:"MMMM dd, yyyy"}}</p>
				<input *ngIf="!contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['date']" disabled type="text" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%" />
			</div>
		</div>
		<div style="width:49%; display:inline-block;">
		<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px;"></div>
			<label style="margin-left:4px">Name (typed or printed)</label><br>
			<input *ngIf="!contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['name']" type="text" style="border:none;width:100%"/>
			<ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['name']">
				<label  style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">{{contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['name']}}</label>
				<i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeName('otherEvReviewer')"></i>
		  </ng-container>
		</div>
		</div>
		<div style="width:49%; display:inline-block;margin-left:10px">
		<div style="display:inline-block;margin:0;width:100%;">
			<div style="height:4px; border:none; "></div>
			<label style="margin-left:4px">Title</label><br>
			<input type="text" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['title']" (change)="addTitle($event, 'title','otherEvReviewer')" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
		</div>
		</div>
	</div>
	</div>
	</div>
	</div>
	</div>
	<div style="margin-top: 6px;font-size: 12px;">
		<h6 [id]="contents[1].id" [ngStyle]="{'background-color':listid==contents[1].id?'rgb(195, 212, 47)':'white'}"  style="text-align: right; padding:4px">Section II: Unit Details</h6>
		<div style="width:100%"><!--Unit Mix and Inspection-->
			<h6 [id]="contents[1].SUB_SECTIONS[0].id" [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px" (click)="frmSwitch(contents[1].SUB_SECTIONS[0].id)">{{contents[1].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
			<div (click)="frmSwitch(contents[1].SUB_SECTIONS[0].id)">
			<div style="width:100%;" [ngClass]="{'lockedSec':onlock==contents[1].SUB_SECTIONS[0].id, 'unlockedSec':onlock!=contents[1].SUB_SECTIONS[0].id}">
	<p>Complete <b>Table 1</b> for residential units <i><ins>only</ins></i>. Commercial units, both spaces that are purpose-built and dwelling units converted to commercial use will be accounted for in <b>Table 2.</b> If "Other" dwelling units have been indicated, <b>Table 3</b> will need to be completed as indicated.</p>
		<div style="width:100%; padding:0 0 0 20px; display:inline-block;">
		<p style="font-weight:bold; margin-top:4px; margin-bottom:2px; border-top:2px double black; border-bottom:1px solid black; background-color: #ccc;">Table 1 - below, indicate the unit type and occupancy at the time of the visit and the number of units inspected of each type</p>
		  <div style="width:32%; display:inline-block; border-top:1px solid black;vertical-align: top;">
			  <p style="border-top:1px solid black; border-bottom:1px solid black; text-align:center; font-weight:bold; background-color: #ccc;">Unit Type
			  </p>
			  <table style="width:100%; border-collapse: collapse;">
				  <thead>
					  <tr style="text-align: center;">
						  <th style="border:none; width:30%">BR</th>
						  <th style="border:none; width:30%">BA</th>
						 <!--<th style="border:none; width:24%">SF</th>-->
						  <th style="border:none; width:40%">Style</th>
					  </tr>
				  </thead>
				  <tbody>
					<tr *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix" >
					  <td style="border:none; border-bottom:1px solid black; height:16px; padding:0">
						  
						  <input type='number' [(ngModel)]="row.BedroomCount" style="width:90%; border:none;text-align: center;" (change)="validateInput($event, row, 'BedroomCount')"/>
					  </td>
					  <td style="border:none; border-bottom:1px solid black; height:16px; padding:0;border-left: 4px solid;">
						  <input type='number' [(ngModel)]="row.BathroomCount" style="width:90%; border:none;padding:0;text-align: center;" (change)="validateInput($event, row, 'BathroomCount', 'decimal')"/>
					  </td>
					  <!--<td style="border:none; border-bottom:1px solid black; height:16px; padding:0;border-left: 4px solid;">
						  <input type='number' [(ngModel)]="row.AvgSquareFeetNumber" style="width:90%; border:none;text-align: center;" (change)="validateInput($event)"/>
					  </td>-->
					  <td style="border-bottom:1px solid black;padding: 1px 0; display:inline;border-left: 4px solid;border-bottom:1px solid black;">
						  <select style="border:none; width:100%;" [(ngModel)]="row.StyleType">
							  <option>Flat</option>
							  <option>Townhouse</option>
							  <option>Loft</option>
							  <option>House</option>						  				
						  </select>					  
					  </td>
					</tr>
				  </tbody>
			  </table>
			  <div style="margin:4px 0; position: relative;">
			  <button class="frmBtn" style="width:30%; margin: 0 4px; float: right;" (click)="insertUnit()">Add Type</button>
			  <button class="frmBtn" style="width:30%; margin: 0 4px; float: right;" (click)="deleteUnit()">Delete</button>
			  <!--<label style="width:25%; margin: 0; font-weight:bold; float:right">Totals: </label>-->
			  </div>
		  </div>
		  <div style="width:32%; display:inline-block; border-top:1px solid black; margin-left:10px">
			  <p style="border-top:1px solid black; border-bottom:1px solid black; text-align:center; font-weight:bold; background-color: #ccc;">Number of units
			  </p>
			  <table style="width:100%; border-collapse: collapse;">
				  <thead>
					  <tr>
						  <th style="border:none; width:25%">Occupied</th>
						  <th style="border:none; width:25%">Vacant</th>
						  <th style="border:none; width:25%">Down</th>
						  <th style="border:none; width:25%">Other</th>
					  </tr>
				  </thead>
				  <tbody>
					<tr *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; let i=index; trackBy:trackByFuntion">
					  <td style="border:1px solid black; height:16px" [ngStyle]="{'background-color':row.PptyUnitTypeOccupiedUnitCount>=0?'white':'red'}">
						<input type='number' [(ngModel)]="row.PptyUnitTypeOccupiedUnitCount" style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeOccupiedUnitCount>=0?'white':'red'}" (change)="addUnit1($event, i, 'PptyUnitTypeOccupiedUnitCount')"/>
					</td>
					  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.VacantUnitCount>=0?'white':'red'}">
						<input [(ngModel)]="row.VacantUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.VacantUnitCount>=0?'white':'red'}" (change)="addUnit1($event, i, 'VacantUnitCount')"/>
					</td>
					  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeDownUnitCount>=0?'white':'red'}">
						<input [(ngModel)]="row.PptyUnitTypeDownUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeDownUnitCount>=0?'white':'red'}" (change)="addUnit1($event, i, 'PptyUnitTypeDownUnitCount')"/>
					</td>
					  <td  style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeOtherUnitCount>=0?'white':'red'}">
						<input [(ngModel)]="row.PptyUnitTypeOtherUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeOtherUnitCount>=0?'white':'red'}" (change)="addUnit1($event, i, 'PptyUnitTypeOtherUnitCount')" />
					</td>
					</tr>
				  </tbody>
			  </table>
			  <!--<div style="display: inline-block; margin:4px 0; width:100%; text-align:centre; border-top:2px solid black; border-bottom:2px solid black">
					<label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOccupiedUnitCount}}</label>
					<label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalVacantUnitCount}}</label>
					<label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.PptyTotalDownUnitCount}}</label>
					<label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount}}</label>    
			  </div>-->
		  </div>
		  <div style="width:32%; display:inline-block; border-top:1px solid black; margin-left:10px; vertical-align:top">
			  <p style="border-top:1px solid black;border-bottom:1px solid black;  text-align:center; font-weight:bold; background-color: #ccc;">Number of units inspected
			  </p>
			<table style="width:100%; border-collapse: collapse;">
				  <thead>
					  <tr>
						  <th style="border:none; width:25%">Occupied</th>
						  <th style="border:none; width:25%">Vacant</th>
						  <th style="border:none; width:25%">Down</th>
						  <th style="border:none; width:25%">Other</th>
					  </tr>
				  </thead>
				  <tbody>
					<tr *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; let i=index; trackBy:trackByFuntion">
					  <td style="border:1px solid black" [ngStyle]="{'background-color':row.PptyUnitTypeOccupiedInspectedUnitCount>=0?'white':'red'}">
						<input [(ngModel)]="row.PptyUnitTypeOccupiedInspectedUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeOccupiedInspectedUnitCount>=0?'white':'red'}"  (change)="addUnit2($event, i,'PptyUnitTypeOccupiedInspectedUnitCount')"/>
					</td>
					  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeVacantInspectedUnitCount>=0?'white':'red'}">
						<input [(ngModel)]="row.PptyUnitTypeVacantInspectedUnitCount" type='number' style="width:99%; border:none;"  [ngStyle]="{'background-color':row.PptyUnitTypeVacantInspectedUnitCount>=0?'white':'red'}" (change)="addUnit2($event, i,'PptyUnitTypeVacantInspectedUnitCount')"/>
					</td>
					  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeDownInspectedUnitCount>=0?'white':'red'}">
						<input [(ngModel)]="row.PptyUnitTypeDownInspectedUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeDownInspectedUnitCount>=0?'white':'red'}" (change)="addUnit2($event, i,'PptyUnitTypeDownInspectedUnitCount')"/>
					</td>
					  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeOtherInspectedUnitCount>=0?'white':'red'}">
						<input [(ngModel)]="row.PptyUnitTypeOtherInspectedUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeOtherInspectedUnitCount>=0?'white':'red'}" (change)="addUnit2($event, i,'PptyUnitTypeOtherInspectedUnitCount')"/>
					</td>
					</tr>
				  </tbody>
			  </table>
			  <!--<div style="display: inline-block; margin:4px 0; width:100%; text-align:centre; border-top:2px solid black; border-bottom:2px solid black">
			  <label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOccupiedInspectedUnitCount}}</label>
			  <label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlVacantInspectedUnitCount}}</label>
			  <label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlDownInspectedUnitCount}}</label>
			  <label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOtherInspectedUnitCount}}</label>
			  </div>-->
		  </div>
		</div>
		<div style="width:65%; padding:0 0 0 20px; display:inline-block;">
			<div class='row' style="padding:0 4px; height:24px; width: 100%; font-weight:bold; margin:4px 0; border-top:2px double black; border-bottom:1px solid black; background-color: #ccc;">
				<p style="width:50%; margin: 0;">Table 2</p>
				<div style="display: inline-block; width:50%; margin: 0;">
					<label style="width:25%">0</label>
					<label style="width:25%">0</label>
					<label style="width:25%">0</label>
					<label style="width:25%">0</label>    
			  </div>
			</div>	
			<p style="margin-top:0; border-top:1px solid black;border-bottom:1px solid black; text-align:center; font-weight:bold; background-color: #ccc;">Detail of Commercial Units</p>
		  <div style="width:45%; display:inline-block">
			  <p style="text-align:right; font-size:12px; margin:4px 10px; ">Number of purpose-built spaces</p>
			  <p style="text-align:right;  font-size:12px; margin:4px 10px">Number of converted residential units</p>
		  </div>
		  <div style="width:49.3%; display:inline-block; margin-left:10px">
			  <table style="width:100%; border-collapse: collapse;">
				  <thead>
					  <tr style="vertical-align: bottom;">
						  <th style="border:none; width:25%;text-align: center">Occupied</th>
						  <th style="border:none; width:25%;text-align: center">Vacant</th>
						  <th style="border:none; width:25%;text-align: center">Down</th>
						  <th style="border:none; width:25%;text-align: center">Total</th>
					  </tr>
				  </thead>
				  <tbody>
					  <tr>
						  <td style="border:1px solid black; height:16px">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].OccupiedUnitCount" type='number' style="width:99%; border:none;text-align: center" (change)="addUnit3(0, $event,'OccupiedUnitCount')"/> 
						</td>
						  <td style="border:1px solid black; height:16px">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].VacantUnitCount" type='number' style="width:99%; border:none;text-align: center" (change)="addUnit3(0, $event, 'VacantUnitCount')"/>
						</td>
						  <td style="border:1px solid black; height:16px">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].DownUnitCount" type='number' style="width:99%; border:none;text-align: center" (change)="addUnit3(0, $event, 'DownUnitCount')"/>
						</td>
						  <td style="border:1px solid black; height:16px; background-color: #ccc;">
							<label style="width:99%; border:none;text-align: center">{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].UnitCount}}</label> 
						</td>
					  <tr>
					  <tr>
						  <td style="border:1px solid black; height:16px">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].OccupiedUnitCount" type='number' style="width:99%; border:none;text-align: center;" (change)="addUnit3(1, $event,'OccupiedUnitCount')"/>
						</td>
						  <td style="border:1px solid black; height:16px">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].VacantUnitCount" type='number' style="width:99%; border:none;text-align: center;" (change)="addUnit3(1, $event,'VacantUnitCount')"/>
						</td>
						  <td style="border:1px solid black; height:16px">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].DownUnitCount" type='number' style="width:99%; border:none;text-align: center" (change)="addUnit3(1, $event, 'DownUnitCount')"/>
						</td>
						  <td style="border:1px solid black; height:16px; background-color: #ccc;">
							<label style="width:99%; border:none;text-align: center">{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].UnitCount}}</label>
						</td>
					  <tr>
				  </tbody>
			  </table>
		  </div>
		  
		  <div style="width:98%; padding:0 0 0 20px; display:inline-block;border:2px double black">
			  <div style="width:85%; display:inline-block">
				  <p style="text-align:right; font-size:12px; margin:4px 10px">Occupied units, including commercial space and other</p>
				  <p style="text-align:right; font-size:12px; margin:4px 10px">Vacant/down units, including commercial space</p>
				  <p style="text-align:right; font-size:12px; margin:4px 10px">Total number of ALL units, including commercial space</p>
			  </div>
			  <div style="width:12%; display:inline-block; margin-left:10px">
				  <p style="text-align:center; font-size:12px; border-bottom:1px solid black; margin:4px 10px">{{contents[1].SUB_SECTIONS[0].data.summary.RsdntlTotalUnitCount}}</p>
				  <p style="text-align:center; font-size:12px; border-bottom:1px solid black; margin:4px 10px">{{contents[1].SUB_SECTIONS[0].data.summary.CommercialTotalUnitCount}}</p>
				  <p style="text-align:center; font-size:12px; border-bottom:1px solid black; margin:4px 10px">{{contents[1].SUB_SECTIONS[0].data.summary.TotalUnitCount}}</p>
			  </div>
		  </div>
		  </div>
		  <div style="width:33%; padding:0 0 0 20px; display:inline-block; vertical-align:top">
		<p style="font-weight:bold; margin-top:4px; margin-bottom:4px; border-top:2px double black; border-bottom:1px solid black; background-color: #ccc;">Table 3</p>
		<p style="margin-top:0; border-top:1px solid black;border-bottom:1px solid black; text-align:center; font-weight:bold; background-color: #ccc;">*Detail of "Other" noted above</p>
			<div style="width:90%; display:inline-block; margin-left:10px">
			 <table style="width:100%; border-collapse: collapse;border:none">
				  <thead>
					  <tr>
						<th style="border:none; width:65%"></th>
						<th style="border:none; width:35%">Total units</th>
					  </tr>
				  </thead>
				  <tbody>
					  <tr>
						<td style="border:none; text-align: right;padding-right: 8px;">Management office</td>
						  <td style="border:1px solid black; padding:0;">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMgmtOfficeUnitCount" type='number' style="width:99%; border:none; text-align: center" (change)="addUnit4($event, 'PptyTotalOtherMgmtOfficeUnitCount')"/>
						</td>
					  </tr>
					  <tr>
						<td style="border:none; text-align: right;padding-right: 4px">Model</td>
						  <td style="border:1px solid black; padding:0;">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherModelUnitCount" type='number' style="width:99%; border:none; text-align: center" (change)="addUnit4($event, 'PptyTotalOtherModelUnitCount')"/>
						</td>
					  </tr>
					  <tr>
						<td style="border:none; text-align: right;padding-right: 4px;">Maintenance shop</td>                          
						<td style="border:1px solid black; padding:0;">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMaintenanceShopUnitCount" type='number' style="width:99%; border:none; text-align: center" (change)="addUnit4($event, 'PptyTotalOtherMaintenanceShopUnitCount')"/>
						</td>
					  </tr>
					  <tr>
						<td style="border:none; text-align: right;padding-right: 4px;">Storage</td>  
						<td style="border:1px solid black; padding:0;">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherStorageUnitCount" type='number' style="width:99%; border:none; text-align: center" (change)="addUnit4($event, 'PptyTotalOtherStorageUnitCount')"/>
						</td>
					  </tr>
					  <tr>
						<td style="border:none; text-align: right;padding-right: 4px;">Hospitality suite</td>
						  <td style="border:1px solid black; padding:0;">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherHospitalitySuiteUnitCount" type='number' style="width:99%; border:none; text-align: center" (change)="addUnit4($event, 'PptyTotalOtherHospitalitySuiteUnitCount')"/>
						</td>
					  </tr>
					  <tr>
						<td style="border:none; text-align: right;padding-right: 4px;">Other administrative</td>
						  <td style="border:1px solid black; padding:0;">
							<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMiscellaneousUnitCount" type='number' style="width:99%; border:none; text-align: center" (change)="addUnit4($event, 'PptyTotalOtherMiscellaneousUnitCount')"/>
						</td>
					  </tr>
				  </tbody>
			  </table>
			  <label *ngIf="contents[1].SUB_SECTIONS[0].data['unequal']" style="color: red; font-weight: bold;text-align: center;">Table 3 is incomplete.</label>
		  </div>
		  </div>
			</div>
			</div>
		</div>
		<div style="font-size:10px"><!--Unit Inspection Information-->
			<h6 [id]="contents[1].SUB_SECTIONS[1].id" [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;" (click)="frmSwitch(contents[1].SUB_SECTIONS[1].id)">{{contents[1].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
			<div (click)="frmSwitch(contents[1].SUB_SECTIONS[1].id)">
			<div style="width:100%" [ngClass]="{'lockedSec':onlock==contents[1].SUB_SECTIONS[1].id, 'unlockedSec':onlock!=contents[1].SUB_SECTIONS[1].id}">
			<div style="width:100%">
				<div class="row" style="width: 100%;margin-left: 8px;">
					<div class='klistItem' style="width:86%;">
						<p style="width:75%;">Were any uncertified or unpermitted units, and/or modifications to units identified or suspected, either via the inspection or from the building records research?</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<select style="width:100%" [(ngModel)]="contents[1].SUB_SECTIONS[1].data.Violations">
							<option value="YES" >Yes</option>
							<option value="NO" >No</option>					                  
						</select>
					</div>					
				  </div>
			</div>
			<div *ngIf="contents[1].SUB_SECTIONS[1].data.Violations=='YES'">
				  <div class="row" style="width: 60%;margin-left: 8px;">
					<div class='klistItem' style="width:86%;">
						<p style="width:75%;">Number of units certified with municipality:</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<input min="0" max="1000000000" type="number" style="width:100%" [(ngModel)]="contents[1].SUB_SECTIONS[1].data.Certified">
					</div>
					<div class='klistItem' style="width:86%;">
						<p style="width:75%;">Current number of units at the property (uncertified and certified):</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<input min="0" max="1000000000" type="number" style="width:100%" [(ngModel)]="contents[1].SUB_SECTIONS[1].data.AllUnit">
					</div>					
				  </div>
				  <ng-container *ngFor="let item of contents[1].SUB_SECTIONS[1].data.ViolationRecord;">
					<table style="border:2px solid black; width:100%; border-collapse: collapse;">
						<tbody>
							<tr>
								<td class="frm-graycell" style="width:20%">Location or Unit #</td>
								<td class="frm-normalcell" style="width:53%; border-top:double 2px black">
									<input type="text" [(ngModel)]="item.Location" style="width:100%; border:none">
								</td>
								<td class="frm-graycell" style="width:20%">Violation on record?</td>
								<td class="frm-normalcell" style="width:7%">
									<select style="width:100%" [(ngModel)]="item.OnRecords">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</td>
							</tr>
							<tr>
								<td class="frm-graycell" colspan="4">Description of violation and/or observed concerns</td>
							</tr>
							<tr>
								<td  class="frm-normalcell" colspan="4">
									<textarea [(ngModel)]="item.Description" rows="2" style="width:100%; border:none"></textarea>
								</td>
							</tr>
						</tbody>
					</table>
				  </ng-container>
				  <div style="position:relative; height:20px">
					<button class="frmBtn" style="float:right" (click)="insertVoliationRow()">Insert</button>
					<button class="frmBtn" *ngIf="contents[1].SUB_SECTIONS[1].data.ViolationRecord.length>0" style="float:right"(click)="deleteVoliationRow()">Delete</button>		  
				   </div>
			</div>
			</div>
			</div>
		</div>
			<div><!--Unit Inspection Information-->
			<h6 [id]="contents[1].SUB_SECTIONS[2].id" [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;" (click)="frmSwitch(contents[1].SUB_SECTIONS[2].id)">{{contents[1].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
			<div (click)="frmSwitch(contents[1].SUB_SECTIONS[2].id)">
			<div style="width:100%" [ngClass]="{'lockedSec':onlock==contents[1].SUB_SECTIONS[2].id, 'unlockedSec':onlock!=contents[1].SUB_SECTIONS[2].id}">
			<p>Indicate the type of unit, using the following abbreviations: 0BR, 1BR, 2BR, etc. Give the unit number and status, using the following status codes: O =
				occupied, V = vacant, D = down and R = other (maintenance shop, management office, etc.). For example, an occupied one-bedroom unit numbered 101
				should be listed as 1BR/101/O.</p>
			<div style="width:100%; display:inline; position:relative">
			<table style="width:100%; border-collapse: collapse;text-align: center; border:none">
				<tbody>
				<ng-container *ngFor="let row of unitrow|fill; let i=index; trackBy:trackByFuntion">
				<tr style="vertical-align: bottom;">
					<td class='frmCell'>{{4*i+1}}
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
						
						<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].UnitType" class="frmInput" (blur)="addinput($event, i,0, 'UnitType')"/>
						<i (click)="op1.toggle($event)"  class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
						<p-overlayPanel #op1 [appendTo]="'body'">
							<ng-template pTemplate> 
								<ng-container *ngFor="let item of bedroomList">
									<a href='javascript:void(0)' class='frmItem' (click)="addBedroomType(item, i,0, 'UnitType')">{{item}}</a><br>
								</ng-container>
							</ng-template>
						</p-overlayPanel>
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
						
						<input type='text' (blur)="addUnitId($event, i, 0, 'SlrDesignatedUnitId')" [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].SlrDesignatedUnitId" class="frmInput1 half-border-right"/>
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
						<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].OccupancyStatusType" class="frmInput" (blur)="addinput1($event, i,0, 'OccupancyStatusType')"/>
						<i  (click)="op2.toggle($event)" class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
						<p-overlayPanel #op2 [appendTo]="'body'">
							<ng-template pTemplate> 
								<ng-container *ngFor="let item of bedroomStatus">
									<a href='javascript:void(0)' class='frmItem' (click)="addStaus(item, i,0, 'OccupancyStatusType')">{{item}}</a><br>
								</ng-container>
							</ng-template>
						</p-overlayPanel>
					</td>
				
					<td class='frmCell'>{{4*i+2}}
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%" class="half-a-border-on-right">
						
						<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].UnitType" class="frmInput"  (blur)="addinput($event, i,1, 'UnitType')"/>
						<i (click)="op3.toggle($event)"  class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
						<p-overlayPanel #op3 [appendTo]="'body'">
							<ng-template pTemplate> 
								<ng-container *ngFor="let item of bedroomList">
									<a href='javascript:void(0)' class='frmItem' (click)="addBedroomType(item, i, 1, 'UnitType')">{{item}}</a><br>
								</ng-container>
							</ng-template>
						</p-overlayPanel>
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
						<input type='text' (blur)="addUnitId($event, i, 1, 'SlrDesignatedUnitId')"  [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].SlrDesignatedUnitId" class="frmInput1 half-border-right"/>
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
						<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].OccupancyStatusType" class="frmInput"  (blur)="addinput1($event, i,1, 'OccupancyStatusType')"/>
						<i  (click)="op4.toggle($event)" class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
						<p-overlayPanel #op4 [appendTo]="'body'">
							<ng-template pTemplate> 
								<ng-container *ngFor="let item of bedroomStatus">
									<a href='javascript:void(0)' class='frmItem' (click)="addStaus(item, i, 1, 'OccupancyStatusType')">{{item}}</a><br>
								</ng-container>
							</ng-template>
						</p-overlayPanel>
					</td>
				  
					<td class='frmCell'>{{4*i+3}}
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
						
						<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].UnitType" class="frmInput"  (blur)="addinput($event, i,2, 'UnitType')"/>
						<i (click)="op5.toggle($event)"  class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
						<p-overlayPanel #op5 [appendTo]="'body'">
							<ng-template pTemplate> 
								<ng-container *ngFor="let item of bedroomList">
									<a href='javascript:void(0)' class='frmItem' (click)="addBedroomType(item, i, 2,  'UnitType')">{{item}}</a><br>
								</ng-container>
							</ng-template>
						</p-overlayPanel>
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
						<input type='text' (blur)="addUnitId($event, i, 2, 'SlrDesignatedUnitId')"  [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].SlrDesignatedUnitId" class="frmInput1 half-border-right"/>
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; width:5%">
						<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].OccupancyStatusType" class="frmInput"  (blur)="addinput1($event, i,2, 'OccupancyStatusType')"/>
						<i  (click)="op6.toggle($event)" class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
						<p-overlayPanel #op6 [appendTo]="'body'">
							<ng-template pTemplate> 
								<ng-container *ngFor="let item of bedroomStatus">
									<a href='javascript:void(0)' class='frmItem' (click)="addStaus(item, i, 2, 'OccupancyStatusType')">{{item}}</a><br>
								</ng-container>
							</ng-template>
						</p-overlayPanel>
					</td>
				 
					<td class='frmCell'>{{4*i+4}}
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
						
						<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].UnitType" class="frmInput"  (blur)="addinput($event, i,3, 'UnitType')"/>
						<i (click)="op7.toggle($event)"  class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
						<p-overlayPanel #op7 [appendTo]="'body'">
							<ng-template pTemplate> 
								<ng-container *ngFor="let item of bedroomList">
									<a href='javascript:void(0)' class='frmItem' (click)="addBedroomType(item, i, 3,  'UnitType')">{{item}}</a><br>
								</ng-container>
							</ng-template>
						</p-overlayPanel>
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:12%">
						<input type='text' (blur)="addUnitId($event, i, 3, 'SlrDesignatedUnitId')"   [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].SlrDesignatedUnitId" class="frmInput1 half-border-right"/>
					</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
						<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].OccupancyStatusType" class="frmInput"  (blur)="addinput1($event, i,3, 'OccupancyStatusType')"/>
						<i  (click)="op8.toggle($event)" class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
						<p-overlayPanel #op8 [appendTo]="'body'">
							<ng-template pTemplate> 
								<ng-container *ngFor="let item of bedroomStatus">
									<a href='javascript:void(0)' class='frmItem' (click)="addStaus(item, i, 3, 'OccupancyStatusType')">{{item}}</a><br>
								</ng-container>
							</ng-template>
						</p-overlayPanel>
					</td>
				</tr>
			</ng-container>			
				</tbody>
			</table>
		  </div>
		  <div style="position:relative; height:20px">
			<button class="frmBtn" style="float:right" (click)="insertUnitRow()">Insert</button>
			<button class="frmBtn" *ngIf="unitrow>0" style="float:right"(click)="deleteUnitRow()">Delete</button>		  
		   </div>
		<div class="row" style="width: 100%;margin-left: 4px;margin-top: 10px;">
			<div class='klistItem' style="width:86%;">
				<p style="width:75%;">Were there any problems with gaining access to the required number of units?</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				<select style="width:100%" [(ngModel)]="contents[1].SUB_SECTIONS[2].data.AccessProblems.status">
					<option value="YES" >Yes</option>
					<option value="NO" >No</option>					                  
				</select>
			</div>
			<div  *ngIf="contents[1].SUB_SECTIONS[2].data.AccessProblems.status=='YES'" style="width: 100%; margin-bottom: 4px;">
				<p>Provide details:</p>
				<textarea [(ngModel)]="contents[1].SUB_SECTIONS[2].data.AccessProblems.description" style="width: 100%;"></textarea>
			</div>
		  </div>
	</div></div>
	</div>
	</div>
	<div style="margin-top: 6px;font-size: 12px;">
	<h6 [id]="contents[2].id" [ngStyle]="{'background-color':listid==contents[2].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section III: Property Condition Assessment</h6>
	<ng-container *ngFor="let sec of contents[2].SUB_SECTIONS|slice:0:-4; trackBy: trackByFuntion; let j=index">
	<div style="width:100%">
		<h6 [id]="sec.id" [ngStyle]="{'color':listid==sec.id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px" (click)="frmSwitch(sec.id)">{{sec.SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(sec.id)">		
		<p>{{sec.data.intro}}</p>
		<div *ngIf="j==0" style="width:100%; display:inline; position:relative" [ngClass]="{'lockedSec':onlock==sec.id, 'unlockedSec':onlock!=sec.id}">
			<div style="width:24.5%; display:inline-block;vertical-align: top;">
			<label style="padding:0">
				<select style="vertical-align:middle; line-height:16px" [(ngModel)]="sec.data.checkItem[0]" (click)="selectItem($event, sec.data)">
					<option value=""></option>
					<option value="X">X</option>
				</select>
				<span>Galvanized water pipe</span>
			</label><br>
			<label>
				<select style="vertical-align:middle; line-height:16px"  [(ngModel)]="sec.data.checkItem[1]" (click)="selectItem($event, sec.data)">
					<option value=""></option>
					<option value="X">X</option>
				</select>
				<span>Polybutylene water pipe</span>
			</label><br>
			</div>
			<div style="width:24.5%; display:inline-block;vertical-align: top;" >
				<label style="padding:0">
					<select  [(ngModel)]="sec.data.checkItem[2]" (click)="selectItem($event, sec.data)">
						<option value=""></option>
						<option value="X">X</option>
					</select>
					<span>Aluminum branch wiring</span>
				</label><br>
				<label>
					<select  [(ngModel)]="sec.data.checkItem[3]"  (click)="selectItem($event, sec.data)">
						<option value=""></option>
						<option value="X">X</option>
					</select>
					<span>Edison base/T-type fuses</span>
				</label><br>
				</div>
				<div style="width:24.5%; display:inline-block;vertical-align: top;">
					<label style="padding:0">
						<select  [(ngModel)]="sec.data.checkItem[4]" (click)="selectItem($event, sec.data)">
							<option value=""></option>
							<option value="X">X</option>
						</select>
						<span>Recalls</span>
					</label><br>
					<label>
						<select  [(ngModel)]="sec.data.checkItem[5]" (click)="selectItem($event, sec.data)">
							<option value=""></option>
							<option value="X">X</option>
						</select>
						<span>Stab-lok breakers</span>
					</label><br>
					</div>
					<div style="width:24.5%; display:inline-block;vertical-align: top;">
						<label style="padding:0">
							<select  [(ngModel)]="sec.data.checkItem[6]" (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>Fiberboard exterior siding</span>
						</label><br>
						<label>
							<select  [(ngModel)]="sec.data.checkItem[7]"  (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>T1-11 siding</span>
						</label><br>
						</div>
						<div style="width:73.5%; display:inline-block;vertical-align: top;">
							<label style="padding:0">
								<select  [(ngModel)]="sec.data.checkItem[8]" (click)="selectItem($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>EIFS (exterior foam insulation system)</span>
							</label><br>
						</div>
						<div style="width:24.5%; display:inline-block;vertical-align: top;">
							<label style="padding:0">
								<select  [(ngModel)]="sec.data.None" (click)="selectNone($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>None</span>
							</label><br>
						</div>
						<div style="width:99%; display:inline-block;vertical-align: top;">
							<label style="padding:0">
								<select [(ngModel)]="sec.data.checkItem[9]">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>Other</span>
								
							</label>
							<input [(ngModel)]="sec.data.other" style="width:60%; border-bottom: #000 2px solid;">
						</div>
					</div>
		
					<div *ngIf="j==1" style="width:100%; display:inline; position:relative"  [ngClass]="{'lockedSec':onlock==sec.id, 'unlockedSec':onlock!=sec.id}">
						<div style="width:33.1%; display:inline-block;vertical-align: top;">
						<label style="padding:0">
							<select style="vertical-align:middle; line-height:16px" [(ngModel)]="sec.data.checkItem[0]" (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>Smoke detectors</span>
						</label><br>
						<label>
							<select style="vertical-align:middle; line-height:16px"  [(ngModel)]="sec.data.checkItem[1]" (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>Sprinklers</span>
						</label><br>
						<label style="padding:0">
							<select  [(ngModel)]="sec.data.checkItem[2]" (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>Intercom</span>
						</label><br>
						
						</div>
						<div style="width:33.1%; display:inline-block;vertical-align: top;" >
							<label style="padding:0">
								<select  [(ngModel)]="sec.data.checkItem[3]" (click)="selectItem($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>Carbon monoxide detectors</span>
							</label><br>
							<label>
								<select  [(ngModel)]="sec.data.checkItem[4]" (click)="selectItem($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>Emergency lights & exit signs</span>
							</label><br>
							<label>
								<select  [(ngModel)]="sec.data.checkItem[5]" (click)="selectItem($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>Security cameras</span>
							</label>
							</div>
							<div style="width:33.1%; display:inline-block;vertical-align: top;">
								<label style="padding:0">
									<select  [(ngModel)]="sec.data.checkItem[6]" (click)="selectItem($event, sec.data)">
										<option value=""></option>
										<option value="X">X</option>
									</select>
									<span>Fire extinguishers</span>
								</label><br>
								<label>
									<select  [(ngModel)]="sec.data.checkItem[7]" (click)="selectItem($event, sec.data)">
										<option value=""></option>
										<option value="X">X</option>
									</select>
									<span>Fire alarms</span>
								</label><br>
								<label>
									<select  [(ngModel)]="sec.data.checkItem[8]" (click)="selectItem($event, sec.data)">
										<option value=""></option>
										<option value="X">X</option>
									</select>
									<span>Secured entrance doors</span>
								</label>
								</div>
								<div  style="width:66.2%; display:inline-block;vertical-align: top;">
									<label>
										<select  [(ngModel)]="sec.data.checkItem[9]" (click)="selectItem($event, sec.data)">
											<option value=""></option>
											<option value="X">X</option>
										</select>
										<span>Other</span>
									</label>
									<input [(ngModel)]="sec.data.other" style="width:80%; border-bottom: #000 2px solid;">
								</div>
								<div   style="width:33.1%; display:inline-block;vertical-align: top;">
									
								<label>
									<select  [(ngModel)]="sec.data.None"  (click)="selectNone($event, sec.data)">
										<option value=""></option>
										<option value="X">X</option>
									</select>
									<span>None</span>
								</label>
								</div>
								</div>
						<div *ngIf="sec3type1.indexOf(j)>-1"  [ngClass]="{'lockedSec':onlock==sec.id, 'unlockedSec':onlock!=sec.id}">
							<div  *ngIf="!sec.data.issues&&(!sec.data.checkItem||sec.data.checkItem.join('').length>0)&&(!sec.data.ifcover)" style="width: 100%; margin-bottom: 4px;">
								<p>Description:</p>
								<textarea [(ngModel)]="sec.data.otherDetail.description" style="width: 100%;"></textarea>
							</div>
						<div *ngIf="sec.data.issues"   class="row" style="width: 100%;margin-left: 4px;margin-top: 10px;">
							<ng-container *ngFor="let issue of sec.data.issues">
								<div class='klistItem' style="width:86%;">
									<p style="width:100%;">{{issue.label}}</p>
								</div>
								<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="issue.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
								<ng-container *ngIf="issue.status=='YES'">
									<p >Description:</p>
									<textarea style="width:99%; margin-bottom: 4px;" [(ngModel)]="issue.description"></textarea>
								</ng-container>
							</ng-container>
						</div>
						<div *ngIf="sec.data.ifcover"   class="row" style="width: 100%;margin-left: 4px;margin-top: 10px;">
							<div class='klistItem' style="width:86%;">
								<p style="width:100%;">{{sec.data.ifcover.label}}</p>
							</div>
							<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="sec.data.ifcover.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<ng-container *ngIf="sec.data.ifcover.status=='YES'">
								<p >Description:</p>
								<textarea style="width:99%; margin-bottom: 4px;" [(ngModel)]="sec.data.ifcover.description"></textarea>
							</ng-container>
						
					</div>	
						<div  *ngIf="((!sec.data.checkItem||sec.data.checkItem.join('').length>0)&&j!=4)||(j==4&&sec.data.ifcover.status=='YES')"  class="row" style="width: 100%;margin-left: 4px;">
							<div *ngIf="!sec.data.issues" class='klistItem' style="width:86%;">
								<p style="width:100%;">What is the general condition of this component?</p>
							</div>
							<div  *ngIf="!sec.data.issues" class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="sec.data.otherDetail.condition">
									<option value="Excellent" >Excellent</option>
									<option value="Above Average" >Above Average</option>	
									<option value="Average" >Average</option>
									<option value="Below Average" >Below Average</option>
									<option value="Inferior" >Inferior</option>				                  
								</select>
							</div>
							<div class='klistItem' style="width:86%;">
								<p style="width:75%;">Were any deficiencies identified that could be categorized as a Critical, PR-90, Priority or Operational Repair?</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="sec.data.otherDetail.hasDeficiencies">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
						</div>
						<div *ngIf="(((!sec.data.checkItem||sec.data.checkItem.join('').length>0)&&j!=4)||(j==4&&sec.data.ifcover.status=='YES'))&&sec.data.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
							<ng-container *ngFor="let item of sec.data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class='klistItem' style="width:83.45%;">
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="item.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
								<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
									<div class='klistItem' style="width:20%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem' style="width:74%;margin-left: 1%;">
										<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;" (change)="getAllDeficiencies(sec.id, sec.SECTION_TITLE)"></textarea>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem' style="width:20%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem' style="width:2%;">$</div>
										<div class='klistItem' style="width:20%;">
											<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies(sec.id, sec.SECTION_TITLE)">
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
					<div *ngIf="sec3type2.indexOf(j)>-1"  [ngClass]="{'lockedSec':onlock==sec.id, 'unlockedSec':onlock!=sec.id}">
						<ng-container *ngFor="let sec1 of sec.data.sub">
							<h6 [id]="sec1.id" style="border-bottom:2px solid black;border-left:2px solid black;width:25% ">{{sec1.subcat}}</h6>
							<p *ngIf="sec1.otherDetail.intro">{{sec1.otherDetail.intro}}</p>
							<div class="row" *ngIf="sec1.otherDetail.providers" style="width:100%; margin-left:0">
								<ng-container *ngFor="let provider of sec1.otherDetail.providers; trackBy:trackByFuntion let k=index">
									<div style="width:49.5%; display:inline-block;">
										<div style="height:4px; border:none"></div>
										<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
											<label style="margin-left:4px">{{provider.label}}</label>
											<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, provider, 2, j, k )"><i class="far fa-list-alt"></i></a>
											<div *ngIf="provider.html" [innerHTML]="provider.secHtml.changingThisBreaksApplicationSecurity|safeHtml"></div>
											<input *ngIf="!provider.html" type="text" style="border:none;width:100%"/>
										</div>
									</div>
								</ng-container>
							</div>
							<div *ngIf="sec1.otherDetail.ifConditions">
								<div class="row" style="width:100%">
									<div class='klistItem1' style="width:20%;">
										<p style="border-bottom:solid 1px black">Present/Not Present</p>
									</div>
									<div class='klistItem ml-1' style="width:79%;">
										<p style="border-bottom:solid 1px black">Risk factor</p>
									</div>
									<ng-container *ngFor="let condition of sec1.otherDetail.ifConditions; trackBy:trackByFuntion let h=index">
										<div class='klistItem1' style="width:20%;">
											<select style="width:70%" [(ngModel)]="condition.status" [ngStyle]="{'border':condition.status? '2px solid #666':'2px solid #F78181'}" >
												<option value="N" >Not Present</option>
												<option value="Y" >Present</option>
											</select>
										</div>
										<div class='klistItem ml-1' style="width:79%;">
											<p style="margin-top:0;">{{condition.condition}}</p>
											<div *ngIf="condition.status=='Y'" style="width:100%; margin-left: 0;">
												<ng-container *ngIf="condition.questions">
													<div class='klistItem' style="width:83.5%;">
														<p>{{condition.questions[0].label}}</p>
													</div>
													<div class='klistItem' style="width:14%;text-align: center;position: relative;">
														<select style="width:100%; float: right;" [(ngModel)]="condition.questions[0].status">
															<option value="YES">Yes</option>
															<option value="NO">No</option>					                  
														</select>
													</div>
													<ng-container *ngIf="condition.questions[0].status=='YES'">
														<div class='klistItem' style="width:83.5%;">
															<p>{{condition.questions[1].label}}</p>
														</div>
														<div class='klistItem' style="width:14%;margin-left: 5px;text-align: center;">
															<select style="width:100%" [(ngModel)]="condition.questions[1].status">
																<option value="YES" >Yes</option>
																<option value="NO" >No</option>					                  
															</select>
														</div>
														<div class="row"  *ngIf="condition.questions[1].moreinfo&&condition.questions[1].status=='YES'"  style="margin-left:10px; width:100%">
															<div class='klistItem' style="width:83.45%;">
																<p>{{condition.questions[1].info}}</p>
															</div>
															<div class='klistItem' style="width:15%;margin-left: 1%;text-align: center;">
																<input [(ngModel)]="condition.questions[1].value" style="width:50%"><span style="margin-left: 4px;">{{condition.questions[1].unit}}</span>
															</div>
														</div>
													</ng-container>	
												</ng-container>
														<div *ngIf="(!condition.questions||condition.questions[0].status=='NO'||condition.questions[1].status=='YES')&&condition.description" class="row" style="width: 100%;margin-left: 4px;">
															<div class='klistItem' style="width:100%;">
																<p style="width:75%;">{{condition.description.label}}</p>
																<textarea style="width:100%" [(ngModel)]="condition.description.text"></textarea>
															</div>
															<div class='klistItem' style="width:86%;">
																<p style="width:75%;">Were any deficiencies identified that could be categorized as a Critical, PR-90, Priority or Operational Repair?</p>
															</div>
															<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
																<select style="width:100%" [(ngModel)]="condition.hasDeficiencies">
																	<option value="YES" >Yes</option>
																	<option value="NO" >No</option>					                  
																</select>
															</div>
														</div>
														<div *ngIf="condition.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
															<ng-container *ngFor="let item of condition.deficiencies;let i=index; trackBy:trackByFuntion">
																<div class='klistItem' style="width:83.45%;">
																	<p>{{item.cat}}</p>
																</div>
																<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
																	<select style="width:100%" [(ngModel)]="item.status">
																		<option value="YES" >Yes</option>
																		<option value="NO" >No</option>					                  
																	</select>
																</div>
																<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
																	<div class='klistItem' style="width:20%;">
																		<p>Provide a brief description:</p>
																	</div>
																	<div class='klistItem' style="width:74%;margin-left: 1%;">
																		<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies(sec.id,sec.SECTION_TITLE+' ('+ sec1.subcat+')')"></textarea>
																	</div>
																	<ng-container *ngIf="item.type!='ors'">
																		<div class='klistItem' style="width:20%;">
																			<p>Cost to cure:</p>
																		</div>
																		<div class='klistItem' style="width:2%;">$</div>
																		<div class='klistItem' style="width:20%;">
																			<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies(sec.id, sec.SECTION_TITLE+' ('+ sec1.subcat+')')">
																		</div>
																	</ng-container>
																</div>
															</ng-container>
														</div>
														<p *ngIf="condition.intro">Please go to the <i>Problematic Materials and Conditions</i> section at the top of this page for further discussion.</p>
														
													
																						
											</div>
											
										</div>
												 
									</ng-container>
									</div>
							</div>
							<div *ngIf="sec1.otherDetail.ifPresent" class="row" style="width: 100%;margin-left: 4px;">
								<div class='klistItem' style="width:86%;">
									<p style="width:75%;">{{sec1.otherDetail.ifPresent.question}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="sec1.otherDetail.ifPresent.status">
										<option value="YES">Yes</option>
										<option value="NO">No</option>												                  
									</select>
								</div>
							</div>
							<div *ngIf="(!sec1.otherDetail.ifPresent||sec1.otherDetail.ifPresent?.status=='YES')&&(!sec1.otherDetail.providers&&(!sec1.otherDetail.ifConditions))" style="width: 100%; margin-bottom: 4px;">
								<p>Description:</p>
								<textarea [(ngModel)]="sec1.otherDetail.description" style="width: 100%;"></textarea>
							</div>
						
					<div *ngIf="(!sec1.otherDetail.ifPresent||sec1.otherDetail.ifPresent?.status=='YES')&&(!sec1.otherDetail.ifConditions)" class="row" style="width: 100%;margin-left: 4px;">
						<div class='klistItem' style="width:86%;">
							<p style="width:75%;">What is the general condition of these components?</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="sec1.otherDetail.condition">
								<option value="Excellent" >Excellent</option>
								<option value="Above Average" >Above Average</option>	
								<option value="Average" >Average</option>
								<option value="Below Average" >Below Average</option>
								<option value="Inferior" >Inferior</option>				                  
							</select>
						</div>
						<div class="row" *ngIf="sec1.otherDetail.detailQuestion" style="width: 100%;;margin-left: 0">
							<ng-container *ngFor="let detailQ of sec1.otherDetail.detailQuestion">
								<div class='klistItem' style="width:86%;">
									<p style="width:75%;">{{detailQ.question}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="detailQ.status">
										<option value="YES">Yes</option>
										<option value="NO">No</option>					                  
									</select>									
								</div>
								<div class="row" *ngIf="detailQ.status=='NO'&&detailQ.sub" style="width: 100%;;margin-left: 10px">
									<div class='klistItem' style="width:86%;">
										<p style="width:75%;">{{detailQ.sub.label}}</p>
									</div>
									<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
										<select style="width:100%;margin-right: 10px;float: right;" [(ngModel)]="detailQ.sub.status">
											<option value="YES" >Yes</option>
											<option value="NO" >No</option>					                  
										</select>										
									</div>
									<div class="row" *ngIf="detailQ.sub.status=='NO'&&detailQ.sub.sub" style="width: 100%;;margin-left: 10px">
										<div class='klistItem' style="width:86%;">
											<p style="width:75%;">{{detailQ.sub.sub.label}}</p>
										</div>
										<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
											<select style="width:100%;margin-right: 20px;float: right;" [(ngModel)]="detailQ.sub.sub.status">
												<option value="YES" >Yes</option>
												<option value="NO" >No</option>					                  
											</select>											
										</div>
										<div class="row" *ngIf="detailQ.sub.sub.status=='NO'&&detailQ.sub.sub.costs" style="width: 100%;margin-left: 10px;">
											<ng-container *ngFor="let costitem of detailQ.sub.sub.costs; let l=index">
											<div class='klistItem' style="width:84%;">
												<p style="width:75%;">{{costitem.description}}</p>
											</div>
											<label class='klistItem' style="width:2%;"*ngIf="l">$</label>
											<div class='klistItem' style="width:2%;" *ngIf="l==0"></div>
											<div class='klistItem' style="width:12%;text-align: center;">
												<input style="width:90%; float:right;margin-right: 10px;" [(ngModel)]="costitem.cost" (change)="validateInput($event, costitem, 'cost')">
											</div>
											</ng-container>
										</div>
									</div>
								</div>
								<div class="row" *ngIf="detailQ.status=='NO'&&detailQ.costs" style="width:100%; margin-left: 10px;">
									<ng-container *ngFor="let costitem of detailQ.costs; let h=index">
										<div class='klistItem' style="width:84%;">
											<p style="width:75%;">{{costitem.description}}</p>
										</div>
										<div class='klistItem' style="width:2%;" *ngIf="h==0"></div>
										<label class='klistItem' style="width:2%;" *ngIf="h>0">$</label>
										<div class='klistItem' style="width:12%;text-align: center">
											<input style="width:90%; float:right;margin-right: 10px;" [(ngModel)]="costitem.cost" (change)="validateInput($event, costitem, 'cost')">										
										</div>
									</ng-container>
								</div>
							</ng-container>
	
						</div>
						<div class='klistItem' style="width:86%;">
							<p style="width:75%;">Did management report any concerns or were any deficiencies identified?</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="sec1.otherDetail.hasDeficiencies">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
					</div>
					<div *ngIf="sec1.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
						<ng-container *ngFor="let item of sec1.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
							<div class='klistItem' style="width:83.45%;">
								<p>{{item.cat}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="item.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
								<div class='klistItem' style="width:20%;">
									<p>Provide a brief description:</p>
								</div>
								<div class='klistItem' style="width:74%;margin-left: 1%;">
									<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies(sec.id, sec.SECTION_TITLE+' ('+ sec1.subcat+')')"></textarea>
								</div>
								<ng-container *ngIf="item.type!='ors'">
									<div class='klistItem' style="width:20%;">
										<p>Cost to cure:</p>
									</div>
									<div class='klistItem' style="width:2%;">$</div>
									<div class='klistItem' style="width:20%;">
										<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies(sec.id, sec.SECTION_TITLE+' ('+ sec1.subcat+')')">
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</ng-container>
				</div>
		</div>
	</div>
	</ng-container>
	<ng-container *ngFor="let sec of contents[2].SUB_SECTIONS|slice:-4:-2; trackBy: trackByFuntion; let j=index">
		<div style="width:100%">
			<h6 [id]="sec.id" [ngStyle]="{'color':listid==sec.id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px">{{sec.SECTION_TITLE}}</h6>
			<div (click)="frmSwitch(sec.id)">
				<div [ngClass]="{'lockedSec':onlock==sec.id, 'unlockedSec':onlock!=sec.id}">
				<div *ngIf="sec.data.laws"   class="row" style="width: 100%;margin-left: 4px;">
				<div class='klistItem' style="width:86%;">
					<p style="width:100%;">{{sec.data.laws.label}}</p>
				</div>
				<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					<select style="width:100%" [(ngModel)]="sec.data.laws.status" (change)="clearOther(sec.data)">
						<option value="YES" >Yes</option>
						<option value="NO" >No</option>					                  
					</select>
				</div>			
			</div>
			<div *ngIf="sec.data.detail&&sec.data.laws.status=='YES'" class="row" style="width: 100%;margin-left: 4px;">
				<div class='klistItem' style="width:86%;">
					<p style="width:100%;">{{sec.data.detail.label}}</p>
				</div>
				<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					<select style="width:100%" [(ngModel)]="sec.data.detail.status">
						<option value="YES" >Yes</option>
						<option value="NO" >No</option>					                  
					</select>
				</div>			
			</div>
			<div *ngIf="sec.data.needRepair&&sec.data.laws.status=='NO'" class="row" style="width: 100%;margin-left: 0;display: inline-block;">
				<div class='klistItem' style="width:86.5%;">
					<p style="width:80%;">{{sec.data.needRepair.label}}</p>
				</div>
				<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					<select style="width:100%" [(ngModel)]="sec.data.needRepair.status">
						<option value="YES" >Yes</option>
						<option value="NO" >No</option>					                  
					</select>
				</div>	
					
			</div>
			<div  *ngIf="sec.data.laws.status=='NO'&&sec.data.needRepair&&sec.data.needRepair.status=='YES'"> 
				<label style="margin-left: 40px;">Provide a brief description:</label>
				<textarea [(ngModel)]="sec.data.needRepair.description" style="width:73%; float: right;margin-right: 10px;"></textarea>
			</div>
				
			<div *ngIf="((j==0&&sec.data.detail.status=='NO')||(j==1&&sec.data.detail.status=='YES'))&&sec.data.laws.status=='YES'" style="margin-left: 4px;">
				<p>Description:</p>
				<textarea style="width:99%; margin-bottom: 4px;" [(ngModel)]="sec.data.description"></textarea>
				<p *ngIf="j==0">Identify the type of repair required below to correct the deficiency:</p>
				<div class="row" style="width: 100%;margin-left: 20px;">
					<ng-container *ngFor="let item of sec.data.deficiencies;let i=index; trackBy:trackByFuntion">
						<div class='klistItem' style="width:83.45%;">
							<p>{{item.cat}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="item.status">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
						<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
							<div class='klistItem' style="width:20%;">
								<p>Provide a brief description:</p>
							</div>
							<div class='klistItem' style="width:74%;margin-left: 1%;">
								<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies(sec.id, sec.SECTION_TITLE)"></textarea>
							</div>
							<ng-container *ngIf="item.type!='ors'">
								<div class='klistItem' style="width:20%;">
									<p>Cost to cure:</p>
								</div>
								<div class='klistItem' style="width:2%;">$</div>
								<div class='klistItem' style="width:20%;">
									<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies(sec.id, sec.SECTION_TITLE)">
								</div>
							</ng-container>
						</div>					
					</ng-container>
				</div>
			</div>
				</div>	
			</div>
		</div>
	</ng-container>
	
	<div style="width:100%">
		<h6 [id]="contents[2].SUB_SECTIONS[8].id" [ngStyle]="{'color':listid==contents[2].SUB_SECTIONS[8].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px" (click)="frmSwitch(contents[2].SUB_SECTIONS[8].id)">{{contents[2].SUB_SECTIONS[8].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[2].SUB_SECTIONS[8].id)">
		<div [ngClass]="{'lockedSec':onlock==contents[2].SUB_SECTIONS[8].id, 'unlockedSec':onlock!=contents[2].SUB_SECTIONS[8].id}">
		<div class="row" style="width: 100%;margin-left: 0;">
			<div class='klistItem' style="width:86.45%;">
				<p>Total number of outstanding municipal violations as of the date of the site visit:</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				<input type="number" min="0" max="1000000" style="width: 100%;" [(ngModel)]="contents[2].SUB_SECTIONS[8].data.violationCount">
			</div>					
			
		</div>
		<p>Provide a general description of the types of violations, excluding those that are considered life/safety issues or significant deficiencies:</p>
		<textarea style="width:100%" [(ngModel)]="contents[2].SUB_SECTIONS[8].data.description"></textarea>
		<p>List the violations and costs to cure below for those findings that are considered to be life/safety issues or significant deficiencies.</p>
		<p><b>Note: costs and descriptions should not be duplicated elsewhere in this report.</b></p>
		<table>
			<thead>
				<tr>
					<th class="frm-graycell" style="width:70%">Description of violation</th>
					<th class="frm-graycell" style="width:18%">Underlying physical<br> issue resolved?</th>
					<th class="frm-graycell" style="width:12%">Cost to Cure</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let row of contents[2].SUB_SECTIONS[8].data.list">
					<tr>
						<td>
							<textarea style="width:100%" row='1' [(ngModel)]="row.description"></textarea>
						</td>
						<td>
							<select style="width:100%" [(ngModel)]="row.status">
								<option value="Yes" >Yes</option>
								<option value="No" >No</option>					                  
							</select>
						</td>
						<td>
							<input type="number" min="0" max="1000000" style="width: 100%;" [(ngModel)]="row.cost"  (change)="validateInput($event, row, 'cost')">
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
		
		<div style="margin: 10px 0;position:relative; height:20px">
			<button class="frmBtn" style="float:right" (click)="insertViolationRow(contents[2].SUB_SECTIONS[8].data)">Add</button>
			<button class="frmBtn" *ngIf="contents[2].SUB_SECTIONS[8].data.list.length>0" style="float:right"(click)="deleteViolationRow(contents[2].SUB_SECTIONS[8].data)">Delete Last Entry</button>		  
		</div>
		</div>	
		</div>	
	</div>
	<div style="width:100%">
		<h6 [id]="contents[2].SUB_SECTIONS[9].id" [ngStyle]="{'color':listid==contents[2].SUB_SECTIONS[9].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px" (click)="frmSwitch(contents[2].SUB_SECTIONS[9].id)">{{contents[2].SUB_SECTIONS[9].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[2].SUB_SECTIONS[9].id)">
		<div [ngClass]="{'lockedSec':onlock==contents[2].SUB_SECTIONS[9].id, 'unlockedSec':onlock!=contents[2].SUB_SECTIONS[9].id}">
		<p>Provide a history of repairs and capital improvements for the last 12 months along with improvements planned for the next 24 months.</p>
		<table style="width: 100%;">
			<tbody>	
				<ng-container *ngFor="let row of contents[2].SUB_SECTIONS[9].data.list">
				
					<tr>
						<td  class="frm-graycell" rowspan="2"  style="width: 19%;">Description</td>
						<td rowspan="2"  style="width: 60%;">
							<textarea style="width:100%" row='1' [(ngModel)]="row.description"></textarea>
						</td>
						<td  class="frm-graycell" colspan="2"  style="width: 6%;text-align: right">Status</td>
						<td  style="width:15%;">
							<select style="width:100%" [(ngModel)]="row.status">
								<option value="">&lt;select &gt;</option>
								<option value="In progress">In progress</option>
								<option value="Completed">Completed</option>
								<option value="Planned">Planned</option>					                  
							</select>
						</td>
					</tr>
					<tr>
						<td  class="frm-graycell" colspan="2"  style="width: 6%;text-align: right;">Cost</td>
						<td  style="width: 15%;">
							$<input type="number" min="0" max="1000000" style="width: 90%;" [(ngModel)]="row.cost"  (change)="validateInput($event, row, 'cost')">
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
		<div style="margin: 10px 0;position:relative; height:20px">
			<button class="frmBtn" style="float:right" (click)="insertViolationRow(contents[2].SUB_SECTIONS[9].data)">Add</button>
			<button class="frmBtn" *ngIf="contents[2].SUB_SECTIONS[9].data.list.length>0" style="float:right"(click)="deleteViolationRow(contents[2].SUB_SECTIONS[9].data)">Delete Last Entry</button>		  
		</div>
		</div>
		</div>	
	</div>	
	</div>
	<div style="margin-top: 6px;font-size: 12px;"><!--Section IV: Environmental Site Assessment-->
	<h6 [id]="contents[3].id" [ngStyle]="{'background-color':listid==contents[3].id?'rgb(195, 212, 47)':'white'}"  style="text-align: right; padding:4px">{{contents[3].SECTION_TITLE}}</h6>
	<div style="width:100%"><!--Environmental Summary-->
		<h6 [id]="contents[3].SUB_SECTIONS[0].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px" (click)="frmSwitch(contents[3].SUB_SECTIONS[0].id)">{{contents[3].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[3].SUB_SECTIONS[0].id)">
			<div style="width:100%; position:relative" [ngClass]="{'lockedSec':onlock==contents[3].SUB_SECTIONS[0].id, 'unlockedSec':onlock!=contents[3].SUB_SECTIONS[0].id}">
			
				<div style="width:100%;display:inline-block">
					<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[0].data.summary">
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<label style="margin-left:4px; width: 34%;" >{{item.label}}</label>
						<label style="width: 13%;"><input type="checkbox" [checked]="item.acceptable=='Y'"  (change)="summaryCheck($event, item, 'acceptable')">Acceptable</label>
						<label *ngIf="!item.requireMMP" style="width: 15%;"><input type="checkbox" [checked]="item.requireOM=='Y'" (change)="summaryCheck($event, item, 'requireOM')">O&M required</label>
						<label *ngIf="item.requireMMP" style="width: 15%;"><input type="checkbox" [checked]="item.requireMMP=='Y'"  (change)="summaryCheck($event, item, 'requireMMP')">MMP required</label>
						<label *ngIf="item.requireMMP" style="width: 23%;"></label>
						<label *ngIf="!item.requireMMP" style="width: 23%;"><input type="checkbox" [checked]="item.requireFurther=='Y'"  (change)="summaryCheck($event, item, 'requireFurther')">Further testing required</label>
						<label style="width: 14%;"><input type="checkbox" [checked]="item.notacceptable=='Y'"  (change)="summaryCheck($event, item, 'notacceptable')">Not Acceptable</label>					
					</div>
					</ng-container>
				</div>
				<div style="width:100%;display:inline-block">
					<div style="height:4px; border:none"></div>
					<div class="row" style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<div class='klistItem' style="width:87%;">
							<p>{{contents[3].SUB_SECTIONS[0].data.law.label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[0].data.law.status">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
					</div>
				</div>
				<div>
					<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[0].data.questions">
						<ng-container *ngIf="contents[3].SUB_SECTIONS[0].data.summary[item.required][item.field]=='Y'">
							<p>{{item.label}}</p>
							<textarea row="2" [(ngModel)]="item.description" style="width:100%"></textarea>
						</ng-container>
						
					</ng-container>
				</div>
				<div>
					<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[0].data.discuss">
						<ng-container *ngIf="item.field=='notacceptable'">
							<div *ngIf="contents[3].SUB_SECTIONS[0].data.summary[item.required][item.field]=='Y'||contents[3].SUB_SECTIONS[0].data.summary[item.required].acceptable=='Y'" [innerHTML]="item.label"></div>
						</ng-container>
						<ng-container *ngIf="item.field=='requireFurther'">
							<div *ngIf="contents[3].SUB_SECTIONS[0].data.summary[item.required][item.field]=='Y'" [innerHTML]="item.label"></div>
						</ng-container>
						
					</ng-container>
				</div>
			</div>
		</div>
		<h6 [id]="contents[3].SUB_SECTIONS[1].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px" (click)="frmSwitch(contents[3].SUB_SECTIONS[1].id)">{{contents[3].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[3].SUB_SECTIONS[1].id)">
		<div style="width:100%; position:relative" [ngClass]="{'lockedSec':onlock==contents[3].SUB_SECTIONS[1].id, 'unlockedSec':onlock!=contents[3].SUB_SECTIONS[1].id}">
				<div style="width:100%;display:inline-block">
					<div class="row" style="width:100%;margin-left: 0;">
						
							<div class='klistItem' style="width:87%;">
								<p>{{contents[3].SUB_SECTIONS[1].data.issues[0].label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[1].data.issues[0].status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<ng-container *ngIf="contents[3].SUB_SECTIONS[1].data.issues[0].status=='YES'">
								<div class='klistItem' style="width:87%;">
									<p>{{contents[3].SUB_SECTIONS[1].data.issues[1].label}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[1].data.issues[1].status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
								<div *ngIf="contents[3].SUB_SECTIONS[1].data.issues[1].status=='YES'" style="margin-left: 20px;width:100%">
									<p>Describe:</p>
									<textarea style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[1].data.issues[1].description"></textarea>
								</div>
						</ng-container>
					</div>
							<ng-container *ngIf="contents[3].SUB_SECTIONS[1].data.issues[0].status=='YES'&&contents[3].SUB_SECTIONS[1].data.issues[1].status=='YES'">
							<div *ngIf="contents[3].SUB_SECTIONS[1].data.other" class="row" style="width:100%;margin-left: 20px;">
								<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[1].data.other">
								<div class='klistItem' style="width:83.45%;">
									<p style="width:75%;">{{item.label}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="item.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
							</ng-container>
								</div>
							<div *ngIf="contents[3].SUB_SECTIONS[1].data.otherDetail" class="row" style="width:100%;margin-left: 20px;">
							<div class='klistItem' style="width:83.45%;">
								<p style="width:90%;">{{contents[3].SUB_SECTIONS[1].data.otherDetail.label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[1].data.otherDetail.hasDeficiencies">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							</div>
						
						<div *ngIf="contents[3].SUB_SECTIONS[1].data.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[1].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class='klistItem' style="width:83.45%;">
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="item.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
								<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
									<div class='klistItem' style="width:20%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem' style="width:74%;margin-left: 1%;">
										<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies(contents[3].SUB_SECTIONS[1].id, contents[3].SUB_SECTIONS[1].SECTION_TITLE)"></textarea>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem' style="width:20%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem' style="width:2%;">$</div>
										<div class='klistItem' style="width:20%;">
											<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies(contents[3].SUB_SECTIONS[1].id, contents[3].SUB_SECTIONS[1].SECTION_TITLE)">
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</ng-container>
					
						
					</div>
				</div>
		</div>
				<h6 [id]="contents[3].SUB_SECTIONS[2].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px" (click)="frmSwitch(contents[3].SUB_SECTIONS[2].id)">{{contents[3].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
				<div (click)="frmSwitch(contents[3].SUB_SECTIONS[2].id)">
				<div style="width:100%;display:inline-block" [ngClass]="{'lockedSec':onlock==contents[3].SUB_SECTIONS[2].id, 'unlockedSec':onlock!=contents[3].SUB_SECTIONS[2].id}">
					<ng-container *ngFor="let items of contents[3].SUB_SECTIONS[2].data">
						<div style="width:100%;display:inline-block">
					<div class="row" style="width:100%;margin-left: 0;">
						
							<div class='klistItem' style="width:87%;">
								<p>{{items.issues[0].label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="items.issues[0].status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<ng-container *ngIf="items.issues[0].status=='YES'">
								<p>{{items.issues[0].descriptionLabel}}</p>
								<table>
									<thead>
										<th class="frm-graycell" style="width:86%">Location</th>
										<th class="frm-graycell" style="width:14%">Condition</th>
										<th class="frm-graycell" style="width:14%">Potential for disturbance</th>
									</thead>
									<tbody>
										<ng-container *ngFor="let row of items.issues[0].materials">
											<tr>
												<td>
													<textarea rows="2" [(ngModel)]="row.location" style="width: 100%;"></textarea>
												</td>
												<td>
													<select  style="width: 100%;" [(ngModel)]="row.condition">
														<option>Damaged</option>
														<option>Undamaged</option>
													</select>
												</td>
												<td>
													<select  style="width: 100%;" [(ngModel)]="row.disturbance">
														<option>High</option>
														<option>Low</option>
														<option>Restricted from tenant access</option>
														<option>Only during construction activities</option>
													</select>
												</td>
											</tr>
										</ng-container>
									</tbody>
								</table>
								<div style="margin: 10px 0;position:relative; height:20px">
									<button class="frmBtn" style="float:right" (click)="insertMaterials(items.issues[0])">Add</button>
									<button *ngIf="items.issues[0].materials.length>1" class="frmBtn" style="float:right" (click)="deleteMaterials(items.issues[0])">Delete Last Entry</button>		  
								</div>									
									<div  class="row" style="width:100%;margin-left: 20px;">
									<div   class='klistItem' style="width:85%;">
										<p>{{items.issues[1].label}}</p>
									</div>
									<div   class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
										<select style="width:100%" [(ngModel)]="items.issues[1].status">
											<option value="YES" >Yes</option>
											<option value="NO" >No</option>					                  
										</select>
									</div>
								</div>
								<div  *ngIf="items.issues[1].status=='YES'" class="row" style="width:100%;margin-left: 20px;">
									<div  *ngIf="items.issues[1].moreinfo" style="width:100%; margin-left: 0">
										<p>{{items.issues[1].descriptionLabel}}</p>
										<textarea style="width:98%" [(ngModel)]="items.issues[1].description"></textarea>
									</div>
									<div  class='klistItem' style="width:85%;">
										<p>{{items.issues[2].label}}</p>									
									</div>
									<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
										<select style="width:100%" [(ngModel)]="items.issues[2].status">
											<option value="YES" >Yes</option>
											<option value="NO" >No</option>					                  
										</select>
									</div>							
									<div  *ngIf="items.issues[2].status=='YES'" style="width:100%; margin-left: 0">
										<p>{{items.issues[2].descriptionLabel}}</p>
										<textarea style="width:98%" [(ngModel)]="items.issues[2].description"></textarea>
									</div>
								</div>
								
						</ng-container>
					</div>
							<ng-container *ngIf="items.issues[0].status=='YES'">
							<div *ngIf="items.otherDetail" class="row" style="width:100%;margin-left: 20px;">
							<div class='klistItem' style="width:84.45%;">
								<p style="width:90%;">{{items.otherDetail.label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="items.otherDetail.hasDeficiencies">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							
						
						<div *ngIf="items.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
							<ng-container *ngFor="let item of items.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class='klistItem' style="width:82%;">
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="item.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
								<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
									<div class='klistItem' style="width:20%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem' style="width:73%;margin-left: 1%;">
										<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies(contents[3].SUB_SECTIONS[2].id, contents[3].SUB_SECTIONS[2].SECTION_TITLE)"></textarea>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem' style="width:20%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem' style="width:2%;">$</div>
										<div class='klistItem' style="width:20%;">
											<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies(contents[3].SUB_SECTIONS[2].id, contents[3].SUB_SECTIONS[2].SECTION_TITLE)">
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
					</ng-container>
				</div>
				</ng-container>	
					
				</div>
				</div>
				<h6 [id]="contents[3].SUB_SECTIONS[3].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[3].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px" (click)="frmSwitch(contents[3].SUB_SECTIONS[3].id)">{{contents[3].SUB_SECTIONS[3].SECTION_TITLE}}</h6>
				<div (click)="frmSwitch(contents[3].SUB_SECTIONS[3].id)">
				<div style="width:100%;display:inline-block" [ngClass]="{'lockedSec':onlock==contents[3].SUB_SECTIONS[3].id, 'unlockedSec':onlock!=contents[3].SUB_SECTIONS[3].id}">
					
					<div style="width:100%;display:inline-block">
					<div class="row" style="width:100%;margin-left: 0;">
						
							<div class='klistItem' style="width:87%;">
								<p>{{contents[3].SUB_SECTIONS[3].data.issues[0].label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[3].data.issues[0].status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
						</div>
							<ng-container *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].status=='YES'">
								<p>{{contents[3].SUB_SECTIONS[3].data.issues[0].descriptionLabel}}</p>
								<table>
									<thead>
										<th class="frm-graycell" style="width:86%">Location</th>
										<th class="frm-graycell" style="width:14%">Condition</th>
									</thead>
									<tbody>
										<ng-container *ngFor="let row of contents[3].SUB_SECTIONS[3].data.issues[0].materials">
											<tr>
												<td>
													<textarea rows="2" [(ngModel)]="row.location" style="width: 100%;"></textarea>
												</td>
												<td>
													<select  style="width: 100%;" [(ngModel)]="row.condition">
														<option>Damaged</option>
														<option>Undamaged</option>
													</select>
												</td>
											</tr>
										</ng-container>
									</tbody>
								</table>
								<div style="margin: 10px 0;position:relative; height:20px">
									<button class="frmBtn" style="float:right" (click)="insertMaterials(contents[3].SUB_SECTIONS[3].data.issues[0])">Add</button>
									<button *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].materials.length>1" class="frmBtn" style="float:right"(click)="deleteMaterials(contents[3].SUB_SECTIONS[3].data.issues[0])">Delete Last Entry</button>		  
								</div>									
							</ng-container>
					
							<ng-container *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].status=='YES'">
								<div *ngIf="contents[3].SUB_SECTIONS[3].data.otherDetail" class="row" style="width:100%;margin-left: 20px;">
								<div class='klistItem' style="width:84.45%;">
									<p style="width:90%;">{{contents[3].SUB_SECTIONS[3].data.otherDetail.label}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[3].data.otherDetail.hasDeficiencies">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
							
						
						<div *ngIf="contents[3].SUB_SECTIONS[3].data.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[3].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class='klistItem' style="width:82%;">
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="item.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
								<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
									<div class='klistItem' style="width:20%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem' style="width:73%;margin-left: 1%;">
										<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;" (change)="getAllDeficiencies(contents[3].SUB_SECTIONS[3].id, contents[3].SUB_SECTIONS[3].SECTION_TITLE)"></textarea>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem' style="width:20%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem' style="width:2%;">$</div>
										<div class='klistItem' style="width:20%;">
											<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;" (change)="getAllDeficiencies(contents[3].SUB_SECTIONS[3].id, contents[3].SUB_SECTIONS[3].SECTION_TITLE)">
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
					</ng-container>
				</div>
				
					
				</div>	
				</div>
				<h6 [id]="contents[3].SUB_SECTIONS[4].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[4].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px" (click)="frmSwitch(contents[3].SUB_SECTIONS[4].id)">{{contents[3].SUB_SECTIONS[4].SECTION_TITLE}}</h6>
				<div (click)="frmSwitch(contents[3].SUB_SECTIONS[4].id)">
				<div style="width:100%;display:inline-block" [ngClass]="{'lockedSec':onlock==contents[3].SUB_SECTIONS[4].id, 'unlockedSec':onlock!=contents[3].SUB_SECTIONS[4].id}">
					
					<div style="width:100%;display:inline-block">
					<div class="row" style="width:100%;margin-left: 0;">
						
							<div class='klistItem' style="width:87%;">
								<p>{{contents[3].SUB_SECTIONS[4].data.issues[0].label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[4].data.issues[0].status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
						</div>
							
							<ol>
								<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.issues[0].items">
									<li style="font-weight: normal;font-size: 14px;">{{item}}</li>
								</ng-container>
							</ol>
							<ng-container *ngIf="contents[3].SUB_SECTIONS[4].data.issues[0].status=='NO'">
								<p>{{contents[3].SUB_SECTIONS[4].data.issues[0].descriptionLabel}}</p>
								<textarea  rows="2" [(ngModel)]="contents[3].SUB_SECTIONS[4].data.issues[0].description" style="width: 100%;"></textarea>								
							</ng-container>
							<div *ngIf="(contents[3].SUB_SECTIONS[4].data.issues[0].status==='YES'||contents[3].SUB_SECTIONS[4].data.issues[0].status==='NO')&&contents[3].SUB_SECTIONS[4].data.other" class="row" style="width:100%;margin-left: 0;">
								<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.other">
									<div class='klistItem' style="width:87%;">
										<p style="width:75%;">{{item.label}}</p>
									</div>
									<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
										<select style="width:100%" [(ngModel)]="item.status" (change)="ifdeficiencies($event, contents[3].SUB_SECTIONS[4].data)">
											<option value="YES" >Yes</option>
											<option value="NO" >No</option>					                  
										</select>
									</div>
									<ng-container *ngIf="item.status=='YES'">
										<p>{{item.descriptionLabel}}</p>
										<textarea  rows="2" [(ngModel)]="item.description" style="width: 100%;"></textarea>								
									</ng-container>
								</ng-container>
							</div>
							<ng-container *ngIf="contents[3].SUB_SECTIONS[4].data.other[0].status=='YES'&&contents[3].SUB_SECTIONS[4].data.other[0].status=='YES'">
								<div *ngIf="contents[3].SUB_SECTIONS[4].data.otherDetail" class="row" style="width:100%;margin-left: 20px;">
								<div class='klistItem' style="width:84.25%;">
									<p style="width:90%;">{{contents[3].SUB_SECTIONS[4].data.otherDetail.label}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<!--<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[4].data.otherDetail.hasDeficiencies">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>-->
								</div>
							
						
						<div class="row" style="width: 100%;margin-left: 20px;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class='klistItem' style="width:82%;">
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="item.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
								<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
									<div class='klistItem' style="width:20%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem' style="width:73%;margin-left: 1%;">
										<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;" (change)="getAllDeficiencies(contents[3].SUB_SECTIONS[4].id, contents[3].SUB_SECTIONS[4].SECTION_TITLE)"></textarea>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem' style="width:20%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem' style="width:2%;">$</div>
										<div class='klistItem' style="width:20%;">
											<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 90%;" (change)="getAllDeficiencies(contents[3].SUB_SECTIONS[4].id, contents[3].SUB_SECTIONS[4].SECTION_TITLE)">
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
					</ng-container>
				</div>
				
					
				</div>	
				</div>	
		
	</div>
	</div>
	<div style="margin-top: 6px;font-size: 12px;"><!--Section V: List of Repairs and Capital Needs Over the Loan Term-->
	<h6 [id]="contents[4].id" [ngStyle]="{'background-color':listid==contents[4].id?'rgb(195, 212, 47)':'white'}"  style="text-align: right; padding:4px">{{contents[4].SECTION_TITLE}}</h6>
	<div style="width:100%"><!--Summary of Repairs and Violations-->
		<h6 [id]="contents[4].SUB_SECTIONS[0].id" [ngStyle]="{'color':listid==contents[4].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px" (click)="frmSwitch(contents[4].SUB_SECTIONS[0].id)">{{contents[4].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[4].SUB_SECTIONS[0].id)">
		<div [ngClass]="{'lockedSec':onlock==contents[4].SUB_SECTIONS[0].id, 'unlockedSec':onlock!=contents[4].SUB_SECTIONS[0].id}">
			<p>{{contents[4].SUB_SECTIONS[0].data.intro}}</p>
		<div style="width:100%; display:inline; position:relative" [ngClass]="{'lockedSec':onlock==contents[4].SUB_SECTIONS[0].id, 'unlockedSec':onlock!=contents[4].SUB_SECTIONS[0].id}">
			<ng-container *ngFor="let repairdata of contents[4].SUB_SECTIONS[0].data.summarylabel; let i=index; trackBy:trackByFuntion">
				<ng-container *ngIf="contents[4].SUB_SECTIONS[0].data.summarydata[repairdata.field].length>0" >
				<h6 style="border-bottom:2px solid black;border-left:2px solid black;width:30%; margin-bottom: 0; ">{{repairdata.label}}</h6>
				<table style="margin-top: 0;border: none;margin-bottom: 20px;">
					<thead>
						<ng-container *ngFor="let col of repairdata.cols; let j=index; trackBy:trackByFuntion">
							<th style="border:none" [ngStyle]="{'width':repairdata.space[j],'text-align':j==2?'center':'left'}">{{col}}</th>
						</ng-container>					
					</thead>
					<tbody>
						<ng-container *ngFor="let rowdata of contents[4].SUB_SECTIONS[0].data.summarydata[repairdata.field]; let j=index; trackBy:trackByFuntion">
							<tr>
								<ng-container *ngFor="let cell of repairdata.rows">
									<td style="border:1px black solid; border-collapse: collapse;" *ngIf="cell!='cost'">{{rowdata[cell]}}</td>
									<td style="border:1px black solid; border-collapse: collapse;" *ngIf="cell=='cost'" >{{USDollar.format(rowdata[cell])}}</td>
								</ng-container>
							</tr>						
						</ng-container>
						<ng-container *ngIf="repairdata.field!='ors';">
							<tr>
								<td colspan="2" style="text-align: right;">
									TOTAL
								</td>
								<td class="frm-graycell">
									{{USDollar.format(repairdata.total)}}
								</td>
							</tr>					
					</ng-container>
					</tbody>
				</table>
			</ng-container>
			</ng-container>
	
			
				
		</div>
		</div>	
		</div>	
	</div>
	<div style="width:100%"><!--Repair Costs-->
		<h6 [id]="contents[4].SUB_SECTIONS[1].id" [ngStyle]="{'color':listid==contents[4].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px" (click)="frmSwitch(contents[4].SUB_SECTIONS[1].id)">{{contents[4].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[4].SUB_SECTIONS[1].id)">
			<div style="width:100%; position:relative" [ngClass]="{'lockedSec':onlock==contents[4].SUB_SECTIONS[1].id, 'unlockedSec':onlock!=contents[4].SUB_SECTIONS[1].id}">			
				<div style="width:100%;display:inline-block">					
					<div class="row" style="display:inline-block;margin:0;width:100%;">
						<div class='klistItem' style="width:87%;">
							<p>{{contents[4].SUB_SECTIONS[1].data.label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="contents[4].SUB_SECTIONS[1].data.status">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
						<ng-container *ngIf="contents[4].SUB_SECTIONS[1].data.status=='YES'">
							<p>{{contents[4].SUB_SECTIONS[1].data.descriptionLabel}}</p>
							<textarea  rows="2" [(ngModel)]="contents[4].SUB_SECTIONS[1].data.description" style="width: 100%;"></textarea>								
						</ng-container>
					</div>
				</div>
			</div>	
		</div>	
	</div>
	<div style="width:100%"><!--Overall Property Condition Rating/Capital Needs Over the Loan Term-->
		<h6 [id]="contents[4].SUB_SECTIONS[2].id" [ngStyle]="{'color':listid==contents[4].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px" (click)="frmSwitch(contents[4].SUB_SECTIONS[2].id)">{{contents[4].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[4].SUB_SECTIONS[2].id)">
			<div [ngClass]="{'lockedSec':onlock==contents[4].SUB_SECTIONS[2].id, 'unlockedSec':onlock!=contents[4].SUB_SECTIONS[2].id}">
			<p>{{contents[4].SUB_SECTIONS[2].data.intro}}</p>
			<div style="width:100%; display:inline; position:relative" [ngClass]="{'lockedSec':onlock==contents[4].SUB_SECTIONS[2].id, 'unlockedSec':onlock!=contents[4].SUB_SECTIONS[2].id}">
				<div style="width:100%;display:inline-block; margin-left: 20px;">
					<div style="border-bottom: 1px solid black;margin-top: 10px;">
						<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Excellent'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Excellent')"><label class="rateItem">Excellent</label>
					</div>
					<hr class="line1">
					<p>Thee Property is new or maintained in like new condition with proactive maintenance practices, thus exhibiting no deferred maintenance or life safety/code issues.</p>
					<div>
						<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Above Average'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Above Average')"><label class="rateItem">Above Average</label>
					</div>
					<hr class="line1">
					<p>The Property is fully functional, well maintained, exhibits minimal wear and tear and no deferred maintenance or life safety/code issues. Any identified repairs are due to recent events (e.g., a wind storm or a burst pipe) or are very limited in scope (routine maintenance). Low reserves are required.</p>
					<div>
						<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Average'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Average')"><label class="rateItem">Average</label>
					</div>
					<hr class="line1">
					<p>The Property is fully functional and generally well maintained. It may exhibit customary wear and tear based on age and may have minimal deferred maintenance. Any life safety/code issues can be readily corrected as part of the operating budget and are isolated in nature. Moderate reserves are required.</p>
					<div style="margin: 0;padding:0">
						<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Below Average'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Below Average')"><label class="rateItem">Below Average</label>
					</div>
					<hr class="line1">
					<p>The Property exhibits pervasive wear and tear, some limits in functionality and deferred maintenance issues. Life safety/code issues are significant and/or numerous and involve substantial cost. High reserves are required.</p>
					<div>
						<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Inferior'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Inferior')"><label class="rateItem">Inferior</label>
					</div>
					<hr class="line1">
					<p>The Property exhibits inferior/deteriorating conditions and some limits in functionality. Deferred maintenance is pervasive and will be costly to cure. Multiple life safety/code issues are identified and involve significant cost. Extensive repairs are required.</p>
					<p style="margin-top: 30px;">{{contents[4].SUB_SECTIONS[2].data.descriptionLabel}}</p>
					<textarea  rows="2" [(ngModel)]="contents[4].SUB_SECTIONS[2].data.description" style="width: 100%;"></textarea>					
				</div>
			</div>
			</div>
		</div>		
	</div>	
	</div>
	<div style="margin-top: 6px;font-size: 12px;"><!--Section VI: Definitions-->
	<h6 [id]="contents[5].id" [ngStyle]="{'background-color':listid==contents[5].id?'rgb(195, 212, 47)':'white'}"  style="text-align: right; padding:4px">{{contents[5].SECTION_TITLE}}</h6>
	<div style="width:100%"><!--Section VI: Definitions-->
		<h6 [id]="contents[5].SUB_SECTIONS[0].id" [ngStyle]="{'color':listid==contents[5].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px" (click)="frmSwitch(contents[5].SUB_SECTIONS[0].id)">{{contents[5].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[5].SUB_SECTIONS[0].id)">
		<div style="width:100%; position:relative" [ngClass]="{'lockedSec':onlock==contents[5].SUB_SECTIONS[0].id, 'unlockedSec':onlock!=contents[5].SUB_SECTIONS[0].id}">
			<div style="border-bottom: 1px solid black;margin-top: 4px;">
				<p class="rateItem">Excellent</p>
			</div>
			<p>The component is new or maintained in like new condition with proactive maintenance practices, thus exhibiting no deferred maintenance or life safety/code issues.</p>
				<p class="rateItem">Above Average</p>
				<hr class="line1">
			<p>The component is fully functional, well maintained, exhibits minimal wear and tear and no deferred maintenance or life safety/code issues. Any identified repairs are due to recent events (e.g., a wind storm or a burst pipe) or are very limited in scope (routine maintenance). Low reserves are required.</p>	
				<p class="rateItem">Average</p>
				<hr class="line1">
			<p>The component is fully functional and generally well maintained. It may exhibit customary wear and tear based on age and may have minimal deferred maintenance. Any life/safety codes issues can be readily corrected as part of the operating budget and are isolated in nature. Moderate reserves are required.</p>	
				<p class="rateItem">Below Average</p>
				<hr class="line1">
			<p>The component exhibits pervasive wear and tear, some limits in functionality and deferred maintenance issues. Life safety/code issues are significant and/or numerous and involve substantial cost. High reserves are required.</p>	
				<p class="rateItem">Inferior</p>
				<hr class="line1">
			<p>The component exhibits inferior/deteriorating conditions and some limits in functionality. Deferred maintenance is pervasive and will be costly to cure. Multiple life safety/code issues are identified and involve significant cost. Extensive repairs are required.</p>		
		</div>	
		</div>	
	</div>
	<div style="width:100%"><!--Section VI: Definitions-->
		<h6 [id]="contents[5].SUB_SECTIONS[1].id" [ngStyle]="{'color':listid==contents[5].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px" (click)="frmSwitch(contents[5].SUB_SECTIONS[1].id)">{{contents[5].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
		<div (click)="frmSwitch(contents[5].SUB_SECTIONS[1].id)">
		<div style="width:100%; position:relative" [ngClass]="{'lockedSec':onlock==contents[5].SUB_SECTIONS[1].id, 'unlockedSec':onlock!=contents[5].SUB_SECTIONS[1].id}">
			
				<p class="rateItem">Critical Repairs</p>
				<hr class="line1">
			<p>These are repairs and replacements that significantly impact habitability, value, income or marketability and that must be corrected before Freddie Mac will proceed with the transaction.</p>
				<p class="rateItem">PR-90 Repairs</p>
				<hr class="line1">
			<p>These are corrective actions that must be completed within 90 days, and are limited to:</p>
			<ul>
				<li>Imminent life safety hazards</li>
				<li>Ongoing substantive damage to the property</li>
			
			</ul>
			
				<p class="rateItem">Priority Repairs</p>
				<hr class="line1">
			<p>These are repairs and replacements that are significant and must be addressed as soon as possible. Priority Repairs consist of:</p>
			<ul>
				<li>All non-imminent life safety hazards</li>
				<li>Violations of any federal, State or local law, ordinance or code relating to zoning, subdivision and use, building and housing accessibility (including the Americans with Disabilities and Fair Housing Acts), health matters or fire safety</li>
				<li>Material deficiencies *</li>
				<li>Significant deferred maintenance *</li>
			</ul>
			<label class="note">* Additional guidance can be found in Section 62.3(b) of the Freddie Mac Multifamily Seller/Servicer Guide</label>
			
			<p class="rateItem">Operational Repairs</p>
			<hr class="line1">
			<p>These are repairs and replacements that consist of Minor Deficiencies, Minor Deferred Maintenance and Handicap Accessibility Enhancements that are expected to be completed by the Borrower as part of a repairs and maintenance budget and that cannot be reasonably resolved by Routine Maintenance. Operational Repairs consist of:</p>
			<ul>
				<li>Minor deficiencies *</li>
				<li>Minor deferred maintenance *</li>
				<li>Handicap Accessibility Enhancements *</li>				
			</ul>
			<label class="note">* Additional guidance can be found in Section 62.3(b) of the Freddie Mac Multifamily Seller/Servicer Guide</label>
		</div>	
		</div>	
	</div>
	
	</div>	
	</ng-container>
	<ng-container *ngIf="reportInfo?.PHASE1_TYPE&&reportInfo.PHASE1_TYPE=='1103'&&contents.length>0">
		<h6 [id]='contents[0].id' [ngStyle]="{'background-color':listid==contents[0].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section I: Summary</h6>
		<div style="font-size:12px"><!--Mortgage, Consultant and Property Information-->
		<h6 [id]='contents[0].SUB_SECTIONS[0].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[0].SUB_SECTIONS[0].id)">{{contents[0].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
		<div  (click)="frmSwitch(contents[0].SUB_SECTIONS[0].id)">
			<div style="width:100%; display:inline; position:relative" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[0].id&&rptUser.length==1, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[0].id||rptUser.length>1}">
			<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label for="frmloanNo" style="margin-left:4px">Freddie Mac loan number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FrmLoanNo',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" disabled ="text" style="border:none;width:94%"/>
			  
			  </div>
			</div>
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <!--<label style="margin-left:4px">Report date</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FinalAsmntDate',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>-->
			  <label style="margin-left:4px">Report date</label><input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.FinalAsmntDate"><br>
			  <p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.FinalAsmntDate|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.FinalAsmntDate" type="text" style="border:none;width:100%" />
			</div>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			   <label style="margin-left:4px">Property name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AsReportedName',0,0)"><i class="far fa-list-alt"></i></a>
			   <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			   <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" disabled ="text" style="border:none;width:100%"/>
			  </div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Seller/Servicer name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AccountName',0,0)"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" disabled ="text" style="border:none;width:100%"/>
			  </div>
			</div>
			
			<div style="width:49.5%; display:inline-block;">
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <div style="height:4px"></div>
			  <label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			 <label  style="margin-left:4px" for="frmloanNo">Seller/Servicer number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PartyBusinessAccountId',0,0)"><i class="far fa-list-alt"></i></a>
			 <div *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			 <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
			</div>
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label for="frmloanNo"  style="margin-left:4px">Inspection date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'VisitDate',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate?.html" type="text" style="border:none;width:100%" />-->
			  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.VisitDate"><br>
			  <p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.VisitDate|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate" type="text" style="border:none;width:100%" />
			  </div>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
		   <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <div style="height:4px"></div>
			  <label style="margin-left:4px">City, State, Zip</label>
			  <div>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'CityName',0,0)"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode',0,0)"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'PostalCode',0,0)"><i class="far fa-list-alt"></i></a>
			</div>
		</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
				<div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label style="margin-left:4px">Environmental consultant (firm name)</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmName',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmName?.html" disabled ="text" style="border:none;width:100%"/>
				</div>
				  </div>
			<div style="width:49.5%; display:inline-block;">
				<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label  style="margin-left:4px" for="frmloanNo">Number of units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Units',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data.Units?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.Units?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.Units?.html" disabled ="text" style="border:none;width:100%"/> 
				</div>
				  </div>
				<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label style="margin-left:4px" for="frmloanNo">Number of residential buildings</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'ApartmentUnits',0,0)"><i class="far fa-list-alt"></i></a><br>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.html" disabled type="text" style="border:none;width:100%"/>
				  </div>
				  </div>
				</div>
				<div style="width:49.5%; display:inline-block;">
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<div style="height:4px"></div>
					  <label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmAddressLineText',0,0)"><i class="far fa-list-alt"></i></a>
					  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
					</div>
					</div>
				
			<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label style="margin-left:4px" for="frmloanNo">Number of ground floor units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'GroundUnits',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.GroundUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.GroundUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.GroundUnits?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
			  </div>
			<div style="width:49.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label style="margin-left:4px" for="frmloanNo">Date of construction</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'BuildYear',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.BuildYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.BuildYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.BuildYear?.html" disabled ="text" style="border:none;width:100%"/>
			 </div>
			  </div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px"></div>
			  <label style="margin-left:4px">City, State, Zip</label>
			  <div>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmCityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'FirmCityName',0,0)"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'FirmStateUspsCode',0,0)"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'FirmPostalCode',0,0)"><i class="far fa-list-alt"></i></a>
			</div>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;"></div>
			<div style="width:49.5%; display:inline-block;">
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <div style="height:4px"></div>
				  <label style="margin-left:4px">Telephone number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmPhoneNumber',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber?.html" disabled ="text" style="border:none;width:100%"/>
					  </div>
				</div>
			<div style="width:49.5%; display:inline-block;">
				<div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label style="margin-left:4px">On-site contact (with title)</label>
				  <!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'OnsiteName',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.OnsiteName?.html" disabled ="text" style="border:none;width:100%"/>-->
				  <div>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'OnsiteName',0,0)"><i class="far fa-list-alt"></i></a>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsiteTitle?.html" style="display: inline-table;margin-left: 10px;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteTitle?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'OnsiteTitle',0,0)"><i class="far fa-list-alt"></i></a>
				</div>
				</div>
				  </div>	
			
			<div style="width:49.5%; display:inline-block;">
				<div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label style="margin-left:4px">Name of inspector</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'InspectorName',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.InspectorName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.InspectorName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.InspectorName?.html" disabled ="text" style="border:none;width:100%"/>
				  </div>
				  </div>	
			<div style="width:49.5%; display:inline-block;">
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <div style="height:4px"></div>
			  <label style="margin-left:4px">On-site contact telephone number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'OnsitePhoneNo',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo?.html" disabled ="text" style="border:none;width:100%"/>
				  </div>
			</div>
			
			</div>
		</div>
			<h6 [id]='contents[0].SUB_SECTIONS[1].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[0].SUB_SECTIONS[1].id)">{{contents[0].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
			<div  (click)="frmSwitch(contents[0].SUB_SECTIONS[1].id)">
				<div style="width:100%;" [ngClass]="{'lockedSec':onlock==contents[0].SUB_SECTIONS[1].id, 'unlockedSec':onlock!=contents[0].SUB_SECTIONS[1].id}">
					<p>Check the applicable result for each hazard and provide costs where appropriate.</p>
					<table style="border: 1px solid black;border-left:4px solid black;text-align: center;">
						<thead>
							<th style="width:30%; text-align: left">Environmental Issue</th>
							<th style="width:10%">Acceptable</th>
							<th style="width:25%">Indicate if O&M<br>Program Required</th>
							<th style="width:10%">Mitigation<br>Cost</th>
							<th style="width:10%">Additional<br>Information<br>Required</th>
							<th colspan="2" style="width:20%">Section and<br>Page Number(s)</th>					
						</thead>
						<tbody>
							<ng-container *ngFor="let rowdata of contents[0].SUB_SECTIONS[1].data.summary">
								<tr>
									<td>{{rowdata.label}}</td>
									<td><input type="checkbox" style="text-align: center;" [checked]="rowdata.acceptable=='Y'"  (change)="summaryCheck($event, rowdata, 'acceptable')"></td>
									<td style="position: relative;"><input *ngIf="rowdata.requireOM==''||rowdata.requireOM" type="checkbox" style="text-align: center;" [checked]="rowdata.requireOM=='Y'"  (change)="summaryCheck($event, rowdata, 'requireOM')">
										<input *ngIf="rowdata.requireMMP==''||rowdata.requireMMP" type="checkbox" style="text-align: center;" [checked]="rowdata.requireMMP=='Y'"  (change)="summaryCheck($event, rowdata, 'requireMMP')">
										<ng-container *ngIf="rowdata.requireMMP==''||rowdata.requireMMP">
											<label style="position: absolute; right:20px">MMP</label>
										</ng-container></td>
									<td>$<input type="number"  min="0" max="1000000000" style="text-align: center;width:85%" [(ngModel)]="rowdata.cost" (change)="setvalue($event, rowdata)"></td>
									<td><input type="checkbox" style="text-align: center;" [checked]="rowdata.requireFurther=='Y'" (change)="summaryCheck($event, rowdata, 'requireFurther')"></td>
									<td><input type="text" size="20" style="text-align: center;width:80px"[(ngModel)]="rowdata.sectionNo" ></td>
									<td><input type="text" size="20" style="text-align: center;width:80px" [(ngModel)]="rowdata.pageNo"></td>							
								</tr>
							</ng-container>
							
							
						</tbody>
					</table>
					<div style="border-left:solid 4px black; border-bottom:1px solid black;margin-top: 20PX;">
						<label>{{contents[0].SUB_SECTIONS[1].data.law.label}}</label>
						<input class="ml-3" type="checkbox" [checked]="contents[0].SUB_SECTIONS[1].data.law.status=='Y'" (change)="lawCheck($event,contents[0].SUB_SECTIONS[1].data.law, 'Y')"><label class="ml-1">Yes</label>
						<input class="ml-3" type="checkbox" [checked]="contents[0].SUB_SECTIONS[1].data.law.status=='N'" (change)="lawCheck($event,contents[0].SUB_SECTIONS[1].data.law, 'N')"><label class="ml-1">No</label>
					</div>
				</div>
			</div>
			<h6 [id]='contents[1].id' [ngStyle]="{'background-color':listid==contents[1].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section II: Private Wells, Radon and Attachments</h6>
			<div style="font-size:12px"><!--Private Wells, Radon and Attachments-->
			<h6 style="background-color:black;padding:4px; margin-top: 20px;height: 20px;"></h6>
			<div style="width:100%; display:inline; position:relative" class="unlockedSec">
				<div style="width:49.5%; display:inline-block;">
				<div style="width:49.5%;display:inline-block">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label for="frmloanNo" style="margin-left:4px">Freddie Mac loan number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FrmLoanNo',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" disabled ="text" style="border:none;width:94%"/>
				  
				  </div>
				</div>
				<div style="width:49.5%;display:inline-block">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label style="margin-left:4px">Report date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FinalAsmntDate',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" disabled ="text" style="border:none;width:94%"/>-->
				  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.FinalAsmntDate"><br>
			  <p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.FinalAsmntDate|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" disabled ="text" style="border:none;width:94%"/>
				</div>
				</div>
				</div>
				<div style="width:49.5%; display:inline-block;">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				   <label style="margin-left:4px">Property name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AsReportedName',0,0)"><i class="far fa-list-alt"></i></a>
				   <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				   <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" disabled ="text" style="border:none;width:100%"/>
				  </div>
				</div>
				<div style="width:49.5%; display:inline-block;">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Seller/Servicer name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AccountName',0,0)"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" disabled ="text" style="border:none;width:100%"/>
				  </div>
				</div>
				
				<div style="width:49.5%; display:inline-block;">
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <div style="height:4px"></div>
				  <label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
				</div>
				</div>
				<div style="width:49.5%; display:inline-block;">
				<div style="width:49.5%;display:inline-block">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				 <label  style="margin-left:4px" for="frmloanNo">Seller/Servicer number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PartyBusinessAccountId',0,0)"><i class="far fa-list-alt"></i></a>
				 <div *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				 <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" disabled ="text" style="border:none;width:100%"/>
				</div>
				</div>
				<div style="width:49.5%;display:inline-block">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label for="frmloanNo"  style="margin-left:4px">Inspection date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'VisitDate',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate?.html" type="text" style="border:none;width:100%" />-->
				  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.VisitDate"><br>
			  <p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.VisitDate|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate" type="text" style="border:none;width:100%" />
				  </div>
				</div>
				</div>
				<div style="width:49.5%; display:inline-block;">
			   <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <div style="height:4px"></div>
				  <label style="margin-left:4px">City, State, Zip</label>
				  <div>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'CityName',0,0)"><i class="far fa-list-alt"></i></a>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode',0,0)"><i class="far fa-list-alt"></i></a>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'PostalCode',0,0)"><i class="far fa-list-alt"></i></a>
				</div>
			</div>
				</div>
			</div>
			<h6  [id]='contents[1].SUB_SECTIONS[0].id' [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[1].SUB_SECTIONS[0].id)">{{contents[1].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
			<div  (click)="frmSwitch(contents[1].SUB_SECTIONS[0].id)">
			<div style="width: 100%" [ngClass]="{'lockedSec':onlock==contents[1].SUB_SECTIONS[0].id, 'unlockedSec':onlock!=contents[1].SUB_SECTIONS[0].id}">
						<div class='klistItem' style="width:86%;">
							<p>{{contents[1].SUB_SECTIONS[0].data?.label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<label><input type="radio" name="frm1103-1-0" [checked]="contents[1].SUB_SECTIONS[0].data.status=='Yes'" (change)="contents[1].SUB_SECTIONS[0].data.status='Yes'">Yes</label>
							<label class="ml-3"><input type="radio" name="frm1103-1-0" [checked]="contents[1].SUB_SECTIONS[0].data.status=='No'" (change)="contents[1].SUB_SECTIONS[0].data.status='No'">No</label>
						</div>
						<div *ngIf="contents[1].SUB_SECTIONS[0].data.status=='Yes'" style="margin-left: 20px;">
						<div class='klistItem' style="width:82%;">
							<p>{{contents[1].SUB_SECTIONS[0].data.label2}}</p>
						</div>
						<div class='klistItem' style="width:16%;margin-left: 1%;text-align: center;">
							<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[1].SUB_SECTIONS[0].data.date">
							<input style="width: 80%;" type="text" disabled [attr.value]="contents[1].SUB_SECTIONS[0].data.date|date:'MMMM dd, yyyy'">
							
							
			  
						</div>					
						
							<p>{{contents[1].SUB_SECTIONS[0].data.label3}}</p>
							<textarea  rows="2" [(ngModel)]="contents[1].SUB_SECTIONS[0].data.info" style="width: 100%;"></textarea>								
						</div>
			</div>
			</div>
			
			<h6  [id]='contents[1].SUB_SECTIONS[1].id' [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[1].SUB_SECTIONS[1].id)">{{contents[1].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
			<div (click)="frmSwitch(contents[1].SUB_SECTIONS[1].id)">
				<div style="width: 100%" [ngClass]="{'lockedSec':onlock==contents[1].SUB_SECTIONS[1].id, 'unlockedSec':onlock!=contents[1].SUB_SECTIONS[1].id}">
				<div class='klistItem' style="width:86%;">
					<p>{{contents[1].SUB_SECTIONS[1].data?.label}}</p>
				</div>
				<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					<label><input type="radio" name="frm1103-1-1" value="Yes" [checked]="contents[1].SUB_SECTIONS[1].data.status=='Yes'" (change)="contents[1].SUB_SECTIONS[1].data.status='Yes'">Yes</label>
					<label class="ml-3"><input type="radio" name="frm1103-1-1" value="No" [checked]="contents[1].SUB_SECTIONS[1].data.status=='No'" (change)="contents[1].SUB_SECTIONS[1].data.status='No'">No</label>
				</div>
				<div *ngIf="contents[1].SUB_SECTIONS[1].data.status=='No'" style="border-left: #000 4px solid; border-bottom: #000 1px solid;">
					<label>Explain below:</label>
					<textarea  rows="2" [(ngModel)]="contents[1].SUB_SECTIONS[1].data.info" style="width: 100%;"></textarea>								
				</div>
			</div>
			</div>
			<h6  [id]='contents[1].SUB_SECTIONS[2].id' [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[1].SUB_SECTIONS[2].id)">{{contents[1].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
			<div (click)="frmSwitch(contents[1].SUB_SECTIONS[2].id)">
				<div style="width: 100%" [ngClass]="{'lockedSec':onlock==contents[1].SUB_SECTIONS[2].id, 'unlockedSec':onlock!=contents[1].SUB_SECTIONS[2].id}">
					<ng-container *ngFor="let item of contents[1].SUB_SECTIONS[2].data.Attachments; let i=index; trackBy:trackByFuntion">
					<div style="display:flex">
						<label style="display: flex;width:40%; font-weight: bold;">{{item.label}}</label>
						<ng-container *ngIf="i<6">
							<label style="display: flex;width:20%;"><input type="checkbox" [checked]="item.status=='attached'" (change)="item.status='attached'">Attached</label>
							<label style="display: flex;width:20%;" ><input type="checkbox" [checked]="item.status=='nattached'" (change)="item.status='nattached'">Not attached</label>
							<label  style="display: flex;width:20%;" *ngIf="i==1||i==2"><input type="checkbox" [checked]="item.status=='nreq'" (change)="item.status='nreq'">Not required</label>
							<label  style="display: flex;width:20%;" *ngIf="i==4||i==5"><input type="checkbox" [checked]="item.status=='navailable'" (change)="item.status='navailable'">Not available</label>
						</ng-container>
					</div>
					<div *ngIf="item.status=='nattached'||i==6" style="border-left: #000 4px solid; border-bottom: #000 1px solid;">
						<label  *ngIf="i!=6">Explain below:</label>
						<textarea  rows="2" [(ngModel)]="item.info" style="width: 100%;"></textarea>								
					</div>
				</ng-container>
				</div>
			</div>
		</div>
		<h6 [id]='contents[2].id' [ngStyle]="{'background-color':listid==contents[2].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section III: Unit Inspection and Certification</h6>
			<div style="font-size:12px"><!--Private Wells, Radon and Attachments-->
			<h6 style="background-color:black;padding:4px; margin-top: 20px;height: 20px;"></h6>
			<div style="width:100%; display:inline; position:relative" class="unlockedSec">
				<div style="width:49.5%; display:inline-block;">
				<div style="width:49.5%;display:inline-block">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label for="frmloanNo" style="margin-left:4px">Freddie Mac loan number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FrmLoanNo',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" disabled ="text" style="border:none;width:94%"/>
				  
				  </div>
				</div>
				<div style="width:49.5%;display:inline-block">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label style="margin-left:4px">Report date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FinalAsmntDate',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" disabled ="text" style="border:none;width:94%"/>-->
				  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.FinalAsmntDate"><br>
			  <p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.FinalAsmntDate|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" disabled ="text" style="border:none;width:94%"/>
				</div>
				</div>
				</div>
				<div style="width:49.5%; display:inline-block;">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				   <label style="margin-left:4px">Property name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AsReportedName',0,0)"><i class="far fa-list-alt"></i></a>
				   <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				   <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" disabled ="text" style="border:none;width:100%"/>
				  </div>
				</div>
				<div style="width:49.5%; display:inline-block;">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Seller/Servicer name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AccountName',0,0)"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" disabled ="text" style="border:none;width:100%"/>
				  </div>
				</div>
				
				<div style="width:49.5%; display:inline-block;">
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <div style="height:4px"></div>
				  <label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
				</div>
				</div>
				<div style="width:49.5%; display:inline-block;">
				<div style="width:49.5%;display:inline-block">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				 <label  style="margin-left:4px" for="frmloanNo">Seller/Servicer number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PartyBusinessAccountId',0,0)"><i class="far fa-list-alt"></i></a>
				 <div *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				 <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" disabled ="text" style="border:none;width:100%"/>
				</div>
				</div>
				<div style="width:49.5%;display:inline-block">
				  <div style="height:4px; border:none"></div>
				  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <label for="frmloanNo"  style="margin-left:4px">Inspection date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'VisitDate',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate?.html" type="text" style="border:none;width:100%" />-->
				  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.VisitDate"><br>
			  		<p style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.VisitDate|date:"MMMM dd, yyyy"}}</p>
					  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate" type="text" style="border:none;width:100%" />
				  </div>
				</div>
				</div>
				<div style="width:49.5%; display:inline-block;">
			   <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				  <div style="height:4px"></div>
				  <label style="margin-left:4px">City, State, Zip</label>
				  <div>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'CityName',0,0)"><i class="far fa-list-alt"></i></a>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode',0,0)"><i class="far fa-list-alt"></i></a>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'PostalCode',0,0)"><i class="far fa-list-alt"></i></a>
				</div>
			</div>
				</div>
			</div>
			<h6  [id]='contents[2].SUB_SECTIONS[0].id' [ngStyle]="{'color':listid==contents[2].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[2].SUB_SECTIONS[0].id)">{{contents[2].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
			<div  (click)="frmSwitch(contents[2].SUB_SECTIONS[0].id)">
				<div style="width: 100%" [ngClass]="{'lockedSec':onlock==contents[2].SUB_SECTIONS[0].id, 'unlockedSec':onlock!=contents[2].SUB_SECTIONS[0].id}">
					<table style="width:100%; border-collapse: collapse;text-align: center; border:none">
						<tbody>
						<ng-container *ngFor="let row of unitrow|fill; let i=index; trackBy:trackByFuntion">
						<tr style="vertical-align: bottom;">
							<td class='frmCell'>{{4*i+1}}</td>					
							<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:22%">
								<input type='text' (blur)="addUnitId($event, i, 0)" [(ngModel)]="contents[2].SUB_SECTIONS[0].data.units[4*i]" class="frmInput2"/>
							</td>
							<td class='frmCell'>{{4*i+2}}</td>
							<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:22%">
								<input type='text' (blur)="addUnitId($event, i, 1)" [(ngModel)]="contents[2].SUB_SECTIONS[0].data.units[4*i+1]" class="frmInput2"/>
							</td>
							<td class='frmCell'>{{4*i+3}}</td>
							<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:22%">
								<input type='text' (blur)="addUnitId($event, i, 2)" [(ngModel)]="contents[2].SUB_SECTIONS[0].data.units[4*i+2]" class="frmInput2"/>
							</td>
							<td class='frmCell'>{{4*i+4}}</td>
							<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:22%">
								<input type='text' (blur)="addUnitId($event, i, 3)" [(ngModel)]="contents[2].SUB_SECTIONS[0].data.units[4*i+3]" class="frmInput2"/>
							</td>
							
						</tr>
					</ng-container>			
						</tbody>
					</table>
					<div style="position:relative; height:20px">
						<button class="frmBtn" style="float:right" (click)="insertUnitRow()">Insert</button>
						<button class="frmBtn" *ngIf="unitrow>5" style="float:right"(click)="deleteUnitRow()">Delete</button>		  
					</div>
				</div>
			</div>
			<h6  [id]='contents[2].SUB_SECTIONS[1].id' [ngStyle]="{'color':listid==contents[2].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;" (click)="frmSwitch(contents[2].SUB_SECTIONS[1].id)">{{contents[2].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
			<div  (click)="frmSwitch(contents[2].SUB_SECTIONS[1].id)">
				<div style="width: 100%" [ngClass]="{'lockedSec':onlock==contents[2].SUB_SECTIONS[1].id, 'unlockedSec':onlock!=contents[2].SUB_SECTIONS[1].id}">
					<div style="width:100%">
						<p>On behalf of the environmental consultant, the undersigned hereby certifies that:</p>
						<ul>
							<li>The attached environmental report was prepared by the consultant in accordance with all applicable requirements in the Freddie Mac <i>Multifamily Seller/Servicer Guide</i>.</li>
							<li>The report was prepared in a manner consistent with generally accepted industry practices and standards.</li>
							<li>All information is true and correct, to the best of the undersigned's knowledge, and reflects the consultant's best professional opinion and judgment.</li>
							<li>No changes or additions have been made to the standard provisions of this form other than those expressly approved in writing by Freddie Mac.</li>
						</ul>
					</div>
					<div style="width:100%; display:inline; position:relative">
						<div style="width:49%;display:inline-block;">
							<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
								<div style="height:4px;"></div>
								<label style="margin-left:4px">Consulting firm name</label><br>
								<!--<input type="text" [(ngModel)]="contents[2].SUB_SECTIONS[1].data['firm']" (blur)="addTitle($event, 'firm')" style="border:none;width:50%"/>-->
								<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'firm', 2, 1 )"><i class="far fa-list-alt"></i></a>
								<div *ngIf="contents[2].SUB_SECTIONS[1].data?.firm?.html" [innerHTML]="contents[2].SUB_SECTIONS[1].data?.firm?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
								<input *ngIf="!contents[2].SUB_SECTIONS[1].data?.firm?.html" disabled ="text" style="border:none;width:94%"/>
							</div>
						</div><br>
						<div style="width:49%; display:inline-block;">
							<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
								<div style="height:4px;"></div>
								<label style="margin-left:4px">Signature of authorized representative</label><br>
								<ng-container *ngIf="!contents[2].SUB_SECTIONS[1].data['sign']">
									<input type="text" style="border:none;width:90%"/>
									<i class="far fa-edit fa-sm float-sm-right iconBtn m-0" (click)="getSign()"></i>
									</ng-container>
								<ng-container *ngIf="contents[2].SUB_SECTIONS[1].data['sign']">
									<img [src]="contents[2].SUB_SECTIONS[1].data['sign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
									<i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeSign()"></i>
								</ng-container>					
							</div>
						</div>
						
						<div style="width:49%; display:inline-block;;margin-left:10px">
						<div style="display:inline-block;;margin:0;width:100%;">
							<div style="height:4px; border:none; "></div>
							<label style="margin-left:4px">Date</label>
							<!--<input type="text" [(ngModel)]="contents[2].SUB_SECTIONS[1].data['date']" (change)="addTitle($event, 'date')" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>-->
							<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[2].SUB_SECTIONS[1].data['date']"><br>
							<p *ngIf="contents[2].SUB_SECTIONS[1].data['date']" style="padding-left: 10px;border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%">{{contents[2].SUB_SECTIONS[1].data['date']|date:"MMMM dd, yyyy"}}</p>
							<input *ngIf="!contents[2].SUB_SECTIONS[1].data['date']" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
						</div>
						</div>
						<div style="width:49%; display:inline-block;">
						<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
							<div style="height:4px;"></div>
							<label style="margin-left:4px">Name (typed or printed)</label><br>
							<input *ngIf="!contents[2].SUB_SECTIONS[1].data['name']" type="text" style="border:none;width:100%"/>
							<ng-container *ngIf="contents[2].SUB_SECTIONS[1].data['name']">
								<label  style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">{{contents[2].SUB_SECTIONS[1].data['name']}}</label>
								<i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeName()"></i>
							</ng-container>
							
						</div>
						</div>
						<div style="width:49%; display:inline-block;margin-left:10px">
						<div style="display:inline-block;margin:0;width:100%;">
							<div style="height:4px; border:none; "></div>
							<label style="margin-left:4px">Title</label><br>
							<input type="text" [(ngModel)]="contents[2].SUB_SECTIONS[1].data['title']" (change)="addTitle($event, 'title')" style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>

						</div>
						</div>
					</div>
				</div>
			</div>
			</div>
	</div>
	</ng-container>
</div>
	  <div style="visibility:none">
  <app-pdfdata [content]='contents' [appe]="appendices" [rptInfo]="reportInfo" [pcaInfo]="pcaOp" [front]="frontpages" [xml]="xmlContent" [xmlN]="xmlName" 
	[pdfgroup]="pdfs" [slot]="allSlots" [rdata]="r" [toPrint]="pdfType" [size]="lpagesize" (spinToggle)="pdfSpin($event)" (errorInfo)="showErrMsg($event)"></app-pdfdata>
</div>
	<!--<div #outContent id="outContent" style='display:none'>
	
		<ng-container *ngFor="let doc of contents; let i=index">
		<ng-container  *ngIf="!doc.HIDE">
		
		<div *ngIf="doc.NEW" class="page-after"></div>
			<ng-container *ngIf="!(doc.OSNAME||doc.OPNAME)"><h1 *ngIf="!doc.TOC"><span class="m-left">{{doc.SECTION_SEQUENCE}}</span>&nbsp;<label  style="margin-left:10px">{{doc.SECTION_TITLE}}</label></h1>
			<h1 *ngIf="doc.TOC" style="bookmark-level: none"><span class="m-left">{{doc.SECTION_SEQUENCE}}</span>&nbsp;<label style="margin-left:10px">{{doc.SECTION_TITLE}}</label></h1>
			</ng-container>
		<div *ngIf='(allEditor.indexOf(i.toString()+"--")>-1||(doc.text&&doc.text.length>0))&&!doc?.intro' class="p-f-left" [innerHTML]="doc.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
		</div>
		<div style="width:100%; padding:8px 16px" *ngIf="doc.TYPE=='PHOTOS'&&doc.photos&&doc.photos.length>0">
			<ng-container *ngFor="let row of toPhotoTable(doc.photos, 2)">
				<div style="display: flex; flex-flow: row wrap; justify-content: start;">
				<ng-container *ngFor="let photo of row">
					<div style="padding: 10px; flex: 0 50%;">
						<div  style="border:1px solid #CCC; padding-bottom: 10px; height:300px;">
							<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:270px;">
							<p style="text-align:center;font-size:11px;	height:30px;">{{photo.FILE_DESCRIPTION}}</p>
						</div>
					</div>
				</ng-container>
				</div>
			</ng-container>
		</div>
		<ng-container *ngFor="let doc1 of doc.SUB_SECTIONS; let j=index">
		<ng-container *ngIf="!doc1.HIDE">
			<ng-container *ngIf="(doc1.TYPE!='TABLE'&&doc1.TYPE!='COSTTABLE')||(doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.rows.length>0)||(doc1.TYPE=='COSTTABLE'&&doc1.data&&doc1.data.rows.length>1)">
			<div  [ngClass]="{'page-after legal-landscape':doc1['ZOOM']}">
				<div *ngIf="doc1.NEW" class="page-after"></div>
				<ng-container *ngIf="!(doc1.OSNAME||doc1.OTNAME||doc1.OPNAME)">
				<h2 *ngIf="!(doc1.TOC||doc.TOC)"><span class="m-left">{{doc1.SECTION_SEQUENCE}}</span>&nbsp;<label  style="margin-left:10px">{{doc1.SECTION_TITLE}}</label></h2>
				<h2 *ngIf="doc1.TOC||doc.TOC" style="bookmark-level: none"><span class="m-left">{{doc1.SECTION_SEQUENCE}}</span>&nbsp;<label  style="margin-left:10px">{{doc1.SECTION_TITLE}}</label></h2>
				</ng-container>
			<div>	
			<table *ngIf="!doc1.OTABLE&&((doc1.TYPE=='TABLE'&&doc1.data?.erisName)||doc1.TYPE=='COSTTABLE'||doc1.TYPE=='PCATABLE'||doc1.TYPE=='UNITTABLE')&&doc1.data" [ngStyle]="{'width':doc1.TYPE=='UNITTABLE'?'50%':'100%'}">
		
				<thead *ngIf="!doc1.OHEADER">
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index">
						<th *ngIf="!h.hide||h.hide=='N'||doc1['ZOOM']" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}">
							<span style="font-weight:bold"> {{h.NAME}}</span>
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data?.rows; let h=index">
					<tr *ngIf="(r.length>1&&r.hide!='Y')&&(!(doc1.TYPE=='COSTTABLE'&&h==0))&&(!doc1.filted||doc1.filted.indexOf(r[0].DATA)>-1)">
						<ng-container *ngFor="let k of r; let q=index">
							<td *ngIf="(!k.hide||k.hide=='N')||doc1['ZOOM']" [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="vertical-align:top;">
								<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span><span>{{k?.DATA}}</span><span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
							</td>
						</ng-container>
					</tr>
					<tr *ngIf="r.length==1&&doc1.data&&r.hide!='Y'">
						<td colSpan='{{doc1.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}" style="vertical-align:top;">
							<span> {{r[0]?.DATA}}</span>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
			<table *ngIf="!doc1.OTABLE&&(doc1.TYPE=='TABLE'&&!doc1.data?.erisName)" style="border: 1px solid black;  border-collapse: collapse; font-size:10px; width:100%">
					<thead *ngIf="!doc1.OHEADER">
					<tr style="background-color:#eeeeee;">
						<ng-container *ngFor="let h of doc1.data?.cols; let o=index">
							<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;">
								<span style="font-weight:bold" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc1.data?.rows; let h=index">
					
						<tr *ngIf="r.items&&r.items.length>1&&(!r.items[0].colspan)">
						    <ng-container *ngFor="let m of r.items; let q=index">
								<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign, 'background':m.bkcolor}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
									<span *ngIf="m.DATA" [innerHTML]="m.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
								</td>								
							</ng-container>
						</tr>
						<tr *ngIf="r.items?.length==1&&r.items[0].colspan">					
							<td colSpan='{{r.items[0].colspan}}' [ngStyle]="{'text-align':r.items[0].celAllign, 'background':r.items[0].bkcolor}"  style="font-weight:bold; border: 1px solid black;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							</td>
						</tr>
						
					</ng-container>
					</tbody>			
				</table>
			
			</div>
			</div>
			</ng-container>
			<div *ngIf='(allEditor.indexOf(i.toString()+"-"+j.toString()+"-")>-1&&otherTypes.indexOf(doc1.TYPE)==-1||(doc1.text&&doc1.text.length>0))&&!doc1?.intro' class="p-m-left" [innerHtml]="doc1.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
			</div>
			<div style="width:100%; padding:8px 16px" *ngIf="doc1.TYPE=='PHOTOS'&&doc1.photos&&doc1.photos.length>0">
			
			<ng-container *ngFor="let row of toPhotoTable(doc1.photos, 2)">
				<div style="display: flex; flex-flow: row wrap; justify-content: start;">
				<ng-container *ngFor="let photo of row">
					<div style="padding: 10px; flex: 0 50%;">
						<div  style="border:1px solid #CCC; padding-bottom: 10px; height:300px;">
							<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:270px;">
							<p style="text-align:center;font-size:11px;	height:30px;">{{photo.FILE_DESCRIPTION}}</p>
						</div>
					</div>
				</ng-container>
				</div>
			</ng-container>

		</div>
			<ng-container *ngFor="let doc2 of doc1.SUB_SECTIONS; let k=index">
			<ng-container *ngIf="!doc2.HIDE">
				<ng-container *ngIf="(doc2.TYPE!='TABLE'&&doc2.TYPE!='COSTTABLE')||(doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.rows.length>0)||(doc2.TYPE=='COSTTABLE'&&doc2.data&&doc2.data.rows.length>1)">
			
				<div *ngIf="doc2.NEW" class="page-before"></div>
				<ng-container *ngIf="!(doc2.OSNAME||doc2.OTNAME||doc2.OPNAME)">
				<h3 *ngIf="(doc1.TOC||doc.TOC||doc2.TOC)" style="bookmark-level: none"><span class="m-left">{{doc2.SECTION_SEQUENCE}}</span>&nbsp;<label style="margin-left:10px">{{doc2.SECTION_TITLE}}</label></h3>
				<h3 *ngIf="!(doc1.TOC||doc.TOC||doc2.TOC)"><span class="m-left">{{doc2.SECTION_SEQUENCE}}</span>&nbsp;<label style="margin-left:10px">{{doc2.SECTION_TITLE}}</label></h3>
				</ng-container>
				<div *ngIf='(allEditor.indexOf(i.toString()+"-"+j.toString()+"-"+k.toString())>-1||(doc2.text&&doc2.text.length>0))&&!doc2?.intro'  class="p-m-left" [innerHtml]="doc2.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
				</div>
				<div style="width:100%; padding:8px 16px; overflow:auto;" *ngIf="doc2.TYPE=='PHOTOS'&&doc2.photos&&doc2.photos.length>0">
					<ng-container *ngFor="let row of toPhotoTable(doc2.photos, 2)">
						<div style="display: flex; flex-flow: row wrap; justify-content: start;">
						<ng-container *ngFor="let photo of row">
							<div style="padding: 10px; flex: 0 50%;">
								<div  style="border:1px solid #CCC; padding-bottom: 10px; height:300px;">
									<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:270px;">
									<p style="text-align:center;font-size:11px;	height:30px;">{{photo.FILE_DESCRIPTION}}</p>
								</div>
							</div>
						</ng-container>
						</div>
					</ng-container>
		</div>
		<table *ngIf="!doc2.OTABLE&&((doc2.TYPE=='TABLE'&&doc2.data?.erisName)||doc2.TYPE=='COSTTABLE'||doc2.TYPE=='PCATABLE'||doc2.TYPE=='UNITTABLE')&&doc2.data" [ngStyle]="{'width':doc2.TYPE=='UNITTABLE'?'50%':'100%'}">
					<thead *ngIf="!doc2.OHEADER">
					<tr>
						<ng-container *ngFor="let h of doc2.data?.cols; let o=index">
							<th  *ngIf="!h.hide||h.hide=='N'||doc2['ZOOM']" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}">
								<span>{{h.NAME}}</span>
							</th>
						</ng-container>
					</tr>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc2.data?.rows; let h=index">
						<tr *ngIf="r.length>1&&r.hide!='Y'&&(!(doc2.TYPE=='COSTTABLE'&&h==0))&&(!doc2.filted||doc2.filted.indexOf(r[0].DATA)>-1)">
						    <ng-container *ngFor="let m of r; let q=index">
								<td *ngIf="(!m.hide||m.hide=='N')||doc2['ZOOM']" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="vertical-align:top;">
									<span *ngIf="m.sign&&m.sign==currSign">{{m.sign}}</span><span>{{m?.DATA}}</span><span *ngIf="m.sign&&m.sign!=currSign">{{m.sign}}</span>
								</td>
							
							</ng-container>
						</tr>
						<tr *ngIf="r.length==1&&doc2.data&&r.hide!='Y'">					
							<td colSpan='{{doc2.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}" style="vertical-align:top;">
								<span>{{r[0]?.DATA}}</span>
							</td>
						</tr>
					</ng-container>
					</tbody>
				</table>
				<table *ngIf="!doc2.OTABLE&&(doc2.TYPE=='TABLE'&&!doc2.data?.erisName)" style="border: 1px solid black;  border-collapse: collapse; font-size:10px; width:100%">
					<thead *ngIf="!doc2.OHEADER">
					<tr style="background-color:#eeeeee;">
						<ng-container *ngFor="let h of doc2.data?.cols; let o=index">
							<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
								<span style="font-weight:bold" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc2.data?.rows; let h=index">
					
						<tr *ngIf="r.items?.length>1&&(!r.items[0].colspan)">
						    <ng-container *ngFor="let m of r.items; let q=index">
								<td [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'background':m.bkcolor}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
									<span *ngIf="m.DATA" [innerHTML]="m.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
								</td>								
							</ng-container>
						</tr>
						<tr *ngIf="r.items?.length==1&&r.items[0].colspan">					
							<td colSpan='{{r.items[0].colspan}}' [ngStyle]="{'text-align':r.items[0].celAllign, 'background':r.items[0].bkcolor}"  style="font-weight:bold; border: 1px solid black;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							</td>
						</tr>
						
					</ng-container>
					</tbody>			
				</table>
				
</ng-container>				
			</ng-container>
			</ng-container>
		</ng-container>	
</ng-container>		
	</ng-container>
	</ng-container>
	
	</div>-->
	</div>
</div>
</div>
</div>
<div id='toolPanel' class="col-md-2 toolContainer" [style.pointer-events]="tableShow ? 'none' : 'auto'">
<!-- Nav tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#home">Tools</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu1" (click)="getHistory(0)">Saved</a>
    </li>
	<li class="nav-item">
		<a class="nav-link" data-toggle="tab" href="#menu2">Settings</a>
	</li>
  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    <div id="home" class="container tab-pane active" style="position:relative; padding:0">
	<div class="toolGroup">
	
	<div class="row mt-0 mb-0 p-0" style="width:100%">
		<!--<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="allowAdd!='Y'||(!(reportInfo?.PCA_INDICATOR=='Y'||reportInfo?.REPORT_TITLE=='Phase I'))" (click)='openRpts()'>Import Report</button>-->
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="reportInfo?.ALLOW_IMPORT_REPORT!='Y'" (click)='openRpts()'>Import Report</button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="erisShow" (click)='autoSave("manual save")'>Save Report</button>
		<i class="mt-3 fas fa-info-circle iconBtn" title="HOW TO SAVE YOUR WORK IN SCRIVA" data-target='#saveModal' data-toggle="modal"></i>
		<hr class="line1">
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="allowAdd!='Y'||((reportInfo?.PCA_INDICATOR=='frm1104'||reportInfo?.PHASE1_TYPE=='1103')&&selectedEditor!='F')" (click)='addTable()'>Add Table</button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="allowAdd!='Y'||((reportInfo?.PCA_INDICATOR=='frm1104'||reportInfo?.PHASE1_TYPE=='1103')&&selectedEditor!='F')" (click)='addPara()' >Add Text Section</button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="allowAdd!='Y'||selectedEditor=='F'||((reportInfo?.PCA_INDICATOR=='frm1104'||reportInfo?.PHASE1_TYPE=='1103')&&selectedEditor!='F')"  (click)='addPhotos()'>Add Photo Section</button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="allowAdd!='Y'||selectedEditor=='F'||((reportInfo?.PCA_INDICATOR=='frm1104'||reportInfo?.PHASE1_TYPE=='1103')&&selectedEditor!='F')"  (click)='addPdfSec()'>Add PDF Section</button>
		
		<!--<p-overlayPanel #op93 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="false">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<ng-container *ngFor="let sign of signs; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="sign['FILE_URL']=sign.SIGNATURE_URL; selectInsert(sign, '40px'); op93.hide();">
							{{sign.FULL_NAME}}
						</a>
						<br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>
		<p-overlayPanel #op94 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="false">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<ng-container *ngFor="let seal of seals; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="seal['FILE_URL']=seal.SEAL_URL; selectInsert(seal, '80px'); op94.hide();">
							{{seal.FULL_NAME}}
						</a>				
						<br>																	
					</ng-container>				
				</div>				
			</ng-template>								
		</p-overlayPanel>-->	
		<hr *ngIf="reportInfo?.PCA_INDICATOR=='Y'||reportInfo?.PCA_INDICATOR=='4099e'||reportInfo?.PCA_INDICATOR=='frm1105'" class="line1">
		<button *ngIf="reportInfo?.PCA_INDICATOR=='Y'&&reportInfo?.PCA_TABLE_STYLE&&reportInfo?.PCA_TABLE_STYLE.length>0" [disabled]="allowAdd!='Y'"  class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="selectedCell=null; addCost(reportInfo.PCA_TABLE_STYLE)">Add Cost Rec</button>
		<button *ngIf="reportInfo?.PCA_INDICATOR=='4099e'||reportInfo?.PCA_INDICATOR=='frm1105'" [disabled]="allowAdd!='Y'"  class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="selectedCell=null; addCostTable2()">Add Cost Rec</button>
		<button *ngIf="reportInfo?.OUTPUT_XML_TYPE!='NA'" class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="getFMEinput()">Fannie Mae Data Input</button>		
		<!--<button class="btn-block btn btn-black btn-small m-1 toolBtn" (click)='addSummary()'  style="width:86%">Add Project Summary</button>-->
		<hr class="line1">
		<button class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)='opPrjFile()'>Project Documents</button>
		<hr class="line1">
		<button class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="comparisonTable()">Comparison Table</button>	
	</div>
	<input #file type="file" style="display: none;"  multiple (change)="uploadImage()"  accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG'/>
	<input #file1 type="file" style="display: none;" multiple (change)="uploadFile()" accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf, .ppt,.pptx,.kml,.dwg">
	<input #file2 type="file" style="display: none;" (change)="importFile()"  accept='.txt'>
	<input #file3 type="file" style="display: none;" (change)="uploadFile1()" accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf, .ppt,.pptx,.kml,.dwg">
	<input #file4 type="file" style="display: none;" (change)="uploadPdf()" accept='.pdf,.PDF'>
	<input #file5 type="file" style="display: none;" (change)="importTable()"  accept='.xlsx,.csv'>	
	<div class="row mt-0 mb-1 p-0"  style="width:100%">
	    <hr class="line1">
		<a (click)="openMapTools()" class="btn btn-black btn-small m-1 p-1 toolBtn" style="width:86%">Open Map Tools</a>
	</div>
	<div *ngIf="reportInfo?.ALLOW_CLOSER=='Y'" class="row mt-0 mb-1 p-0"  style="width:100%">
	    <hr class="line1">
		<span class="toolbarCheckbox">
			<input type="checkbox" [checked]="reportInfo?.REQUEST_CLOSER_XML=='Y'" (change)="toggleCloser($event)">
			<!--<a class="ml-1 mb-1" [ngClass]="{'disabled':reportInfo?.REQUEST_CLOSER_XML!='Y'}" (click)="op811.toggle($event);" title="XML setting"><i class="pi pi-angle-down" style="margin: 5px;"></i></a>
			<p-overlayPanel #op811 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
				<ng-template pTemplate>
					<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
						XML
					</div>
				</ng-template>
			</p-overlayPanel>-->
		</span>
		<button  style="width:65%" [disabled]="reportInfo?.REQUEST_CLOSER_XML!='Y'" class="btn btn-black btn-small m-1 toolBtn" (click)="getCloserinput()">Closer Data Input</button>
	</div>
	<div class="row mt-0 mb-1 p-0"  style="width:100%">
	    <hr class="line1">
		<a href="javascript:void(0)" (click)="getPhotolog('app')" class="ml-3 mb-2 mt-2" style="font-size:.9em;" *ngIf="reportInfo?.PHOTOLOG_LIST?.length>0&&reportInfo?.PHOTOLOG_LIST[0]?.PHOTOLOG_URL?.length>0">Photo log</a>
		<a *ngIf="reportInfo?.PHOTOLOG_LIST?.length>0&&reportInfo?.PHOTOLOG_LIST[0]?.PHOTOLOG_URL?.length>0" class="ml-1 mt-1" target=_blank [href]="'photolog/'+reportInfo.PROJECT_ID+'/'+reportInfo.REPORT_ID"><i class="far fa-edit btn-blue" style="pointer-events:none"></i></a>
		<a (click)='getPhotolog("main")' *ngIf="reportInfo?.PHOTOLOG_LIST?.length==0||(reportInfo?.PHOTOLOG_LIST[0]?.PHOTOLOG_URL?.length==0)" class="btn btn-black btn-small m-1 p-1 toolBtn" style="width:86%">Create New Photo log</a>
    </div>
	<div class="row mt-0 mb-0 p-0" style="width:100%">
	<hr class="line1">
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" (click)='getSign("add");'>Signature </button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="(reportInfo?.PCA_INDICATOR=='frm1104'||reportInfo?.PHASE1_TYPE=='1103')&&selectedEditor!='F'" (click)='getSeal();'>Seal</button>
		<button [disabled]="noPrint" class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" (click)='preview()'>Generate PDF</button>
		<button [disabled]="noPrint" class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" (click)="preview('apponly')">Appendix Only</button>
		<button [disabled]="noPrint" class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="preview('app')">Generate PDF with Appendix</button>
		<button *ngIf="reportInfo?.OUTPUT_XML_TYPE!='NA'" [disabled]="noPrint" class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="preview('xml')">Generate PDF + Appendix + XML</button>
		<button *ngIf="reportInfo?.PCA_INDICATOR=='frm1105'" [disabled]="noPrint" class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="preview('frm')">Generate PDF + Appendix + JSON</button>
		<button *ngIf="reportInfo?.REQUEST_CLOSER_XML =='Y'" [disabled]="noPrint" class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="toPrintCloserXml()">Generate Closer XML</button>
	</div>	
	<div class="row mt-0 mb-1 p-0"  style="width:100%">
		<hr class="line1">
		<!--<label style="width:25%" class="percent" title="Click to hide incomplete sections" [ngClass]="{'active':onlyWCompete}" (click)='onlyWCompete=!onlyWCompete; onlyCost=false; onlyRCompete=false'>Writing : </label>addRepeat("slot","signature")addRepeat("slot","seal")-->
		<button class="col-md-3 btn btn-block btn-black btn-small toolBtn percent" title="Click to Show Incomplete Sections" [ngClass]="{'active':onlyWCompete}" (click)='onlyWCompete=!onlyWCompete; onlyCost=false; onlyRCompete=false'>Writing</button>
		<div style="width:50%; margin-left:10px" >
			<div class="progress" [title]="wPercentage  + '%'" style="height:6px;margin-top:8px;background-color:#999; width:80%">
				<div class="progress-bar" [ngStyle]="{'width': wPercentage+'%'}" style="background:rgb(195,212,47)">
				</div>
			</div>
		</div>	
			<span *ngIf="wPercentage>0">{{wPercentage}}%</span>
			</div>
		<div class="row mt-1 mb-1 p-0"  style="width:100%">		
		<!--<label style="width:25%" class="percent" title="Click to hide incomplete sections" [ngClass]="{'active':onlyRCompete}"  (click)='onlyRCompete=!onlyRCompete; onlyCost=false; onlyWCompete=false'>Review : </label>-->
		<button class="col-md-3 btn btn-block btn-black btn-small toolBtn percent" title="Click to Show Incomplete Review Sections" [ngClass]="{'active':onlyRCompete}"  (click)='onlyRCompete=!onlyRCompete; onlyCost=false; onlyWCompete=false'>Review</button>
		<div style="width:50%; margin-left:10px" >
			<div class="progress" [title]="rPercentage + '%'" style="height:6px;margin-top:8px;background-color:#999; width:80%">
				<div class="progress-bar" [ngStyle]="{'width': rPercentage+'%'}" style="background:rgb(195,212,47)">
				</div>
			</div>
		</div>
			<span *ngIf="rPercentage>0">{{rPercentage}}%</span>
		</div>
	<div class="row mt-0 mb-1 p-0"  style="width:100%; position: relative;">
		<hr class="line1">
		<app-reportinfo [user]="reportInfo" (info)="onInfo($event)" (getLogo)="onSavedLogo($event)">
		</app-reportinfo>
		<span #pdfspin class="fa fa-spinner fa-spin pdfstatus" style="font-size:24px;color:rgb(195,212,47); display:none"></span>
		<a *ngIf="errMsg.length>0" class="pdfstatus" [title]="errMsg"><i class="fas fa-info-circle" style="font-size:12px; margin:3px 5px 0 0; color:#F78181;"></i></a>
	</div>
	<div  style="width:100%; height:26vh; overflow:auto; margin-left:-10px; padding:0">
	<hr class="line1">
	<label *ngIf="rptUser.length==1" class="savedLabel">
		<a (click)="blockMultiUser()" style="cursor: pointer"><i title="Multi-user warnings" class="fas fa-info-circle ml-1" style="font-size:1.6em; margin:3px 5px 0 0; color:rgb(195,212,47)"></i></a>
		Active User in Current Report
	</label>
	<label *ngIf="rptUser.length>1" class="savedLabel highlight">
		<a (click)="blockMultiUser()" style="cursor: pointer"><i title="Multi-user warnings" class="fas fa-info-circle ml-1" style="font-size:1.6em; margin:3px 5px 0 0;"></i></a>
		Active Users in Current Report
	</label>
	<div *ngIf="rptUser.length>0" style="padding-top:4px; width:100%">
		<ng-container *ngFor='let user of rptUser'>							
			<!--<a href="javascript:void(0)" class="roundBtn" [title]="user.USER_FULLNAME">{{user.USER_SHORT_NAME}}</a>-->
			<div class="card" style="margin-bottom:4px; border:1px solid #C3D42F; padding:2px;font-size:1em; width:95%">
				<div [style.color]="'dedede'">
					<i class="fas fa-user-circle m-1" style="font-size:1.4em;color:rgb(195,212,47)"></i>
					<span style="font-weight:bold">{{user.USER_FULLNAME}}</span><span style="margin-left:10px">{{user.TIME_STAMP}}</span>
					<span style="margin-left:10px">{{user.SECTION_TITLE}}</span>
					<a (click)="confirmExit(user)" title="Sign out user from current report" style="cursor: pointer"><i class="fas fa-arrow-right p-2 float-md-right" style="color: #F78181"></i></a>
				</div>
			</div>
		</ng-container>
	</div>
	<label *ngIf="secUser.length>0" class="savedLabel">Active User(s) in Current Section: </label>
	<div *ngIf="secUser.length>0" style="padding:0; margin:0;width:100%">
		<ng-container *ngFor='let user of secUser'>								
			<div class="card" style="margin-bottom:4px; border:1px solid #C3D42F; padding:2px;font-size:1em; width:95%">
				<div [style.color]="'dedede'">
					<i class="fas fa-user-circle m-1" [ngStyle]="{'color':user.ALLOWED_TO_EDIT=='Y'? 'rgb(195,212,47)':'#666'}" style="font-size:1.4em;"></i>
					<span style="font-weight:bold">{{user.USER_FULLNAME}}</span><span style="margin-left:10px">{{user.TIME_STAMP}}</span>
					<p style="margin:0 0 0 24px">{{user.COMMENT_CONTENT}}</p>
				</div>
			</div>
		</ng-container>
	</div>
	</div>
	</div>
	</div>
    <div id="menu1" class="container tab-pane fade" >
		<div class='fixContent2' *ngIf="history?.length>0" style="overflow:auto">
			<strong>Edit History:</strong>
			<label class="savedLabel1 ml-2">(Total: {{historyNo}} Pages)</label><br>
			<label class="savedLabel1">Go to</label><input class="hisInput1" type='number' (change)="goHisPage($event)">
			<!--<input class="hisInput" type='text' (change)="searhHis($event)">
			<i class="fas fa-search iconBtn" (change)="searhHis($event)"></i>-->
			<br>
			<label class="savedLabel1">Page</label><span *ngIf="curHisNo>5">...</span>
			<ng-container *ngFor="let page of totalShow|fill;let i=index">
				<a [ngStyle]="{'color':curHisNo==(curHisNo-4+i)?'#C2D63F':null}" *ngIf="(curHisNo-4+i)>0&&((curHisNo-4+i)<(historyNo+1))" class="btn btn-link btn-sm p-0 mr-1" (click)="getHistory(curHisNo-4+i)">{{curHisNo-4+i}}</a>
			</ng-container>
			<span *ngIf="curHisNo<(historyNo-5)">...</span>
			<table style="width:95%; border: 1px solid black;  border-collapse: collapse;font-size:11px">
				<thead>
					<tr>
						<th style="width:50%">Section</th>					
						<th style="width:20%">User</th>							
						<th style="width:30%">Date/Time</th>					
					</tr>
				</thead>
					<tbody>
						<ng-container *ngFor="let rpt of history;">
							<tr>
								<td><a href="javascript:void(0)" (click)="getVersion(rpt.VERSION_ID)">
									<span *ngIf="rpt.SECTION_TITLE?.length>0">{{rpt.SECTION_TITLE}}</span>
									<!--<span *ngIf="!rpt.SECTION_TITLE">Auto Save</span>-->
								</a>
								</td>
								<td><span style="color:#C2D63F">{{rpt.UPDATED_BY_USER[0].USER_FIRSTNAME}}</span></td>								
								<td><span style="color:#C2D63F">{{rpt.UPDATE_TIMESTAMP}}</span></td>
																
							</tr>
						</ng-container>
					</tbody>
				</table>
				</div> 
				<div class='fixContent2' *ngIf="secHistory.length>0" style="overflow:auto">
					<strong>Section Edit History:</strong>
				<table style="width:95%; border: 1px solid black;  border-collapse: collapse;font-size:11px">
				<thead>
					<tr>
						<th style="width:50%">Section</th>					
						<th style="width:20%">User</th>							
						<th style="width:30%">Date/Time</th>					
					</tr>
				</thead>
					<tbody>
						<ng-container *ngFor="let rpt of secHistory; trackBy:trackByFuntion">
							<tr>
								<td><a href="javascript:void(0)" (click)="getSecVersion(rpt.VERSION_ID, secHistory['SECTION_ID'], rpt.UPDATED_BY_USER[0].USER_FIRSTNAME )">
									<span *ngIf="rpt.SECTION_TITLE?.length>0">{{rpt.SECTION_TITLE}}</span>
									<span *ngIf="!rpt.SECTION_TITLE">Auto Save</span>
								</a>
								</td>
								<td><span style="color:#C2D63F">{{rpt.UPDATED_BY_USER[0].USER_FIRSTNAME}}</span></td>								
								<td><span style="color:#C2D63F">{{rpt.UPDATE_TIMESTAMP}}</span></td>
													
							</tr>
						</ng-container>
					</tbody>
				</table>
				</div>
    </div>
	<div id="menu2" class="container tab-pan fade">
		<div class="row mt-0 mb-1 p-0">
		<hr class="line1">
		<label class="savedLabel col-md-4">Cover Page: </label>
		<!--<select class="savedPage col-md-6" [(ngModel)]="selectedCover.COPIED_FROM_ID" (change)='updateRpt("cover")'>
			<option></option>
			<option *ngFor="let cover of covers" [value]="cover.COVERPAGE_ID">{{cover.COVERPAGE_TITLE}}</option>
		</select>-->
		<span class="col-md-6">
		<a *ngIf="selectedCover.COPIED_FROM_ID" class="savedTitle" href="javascript:void(0)"  (click)="openCoverPage(selectedCover.COVERPAGE_ID)">{{selectedCover.COVERPAGE_TITLE}}</a>
		</span>
		<a class="ml-1 mb-1" (click)="getAllCover(); op81.toggle($event);" title="Choose Cover Page"><i class="pi pi-angle-down" style="margin: 5px;"></i></a>
		<!--<a *ngIf="selectedCover.COPIED_FROM_ID" title="Edit Cover Page" class="ml-1 mt-1" target=_blank [href]="'cover/Cover-'+selectedCover.COVERPAGE_ID"><i class="far fa-edit iconBtn" style="pointer-events:none"></i></a>-->
		<p-overlayPanel #op81 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedCover.COPIED_FROM_ID=null;selectedCover.COVERPAGE_TITLE=null; updateRpt('cover'); op81.hide();">
							None
					</a><br>
					<ng-container *ngFor="let cover of covers; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedCover.COPIED_FROM_ID=cover.COVERPAGE_ID;selectedCover.COVERPAGE_TITLE=cover.COVERPAGE_TITLE; coverImages=[];coverChange=false;coverImageIndex=-1;updateRpt('cover'); op81.hide();">
							{{cover.COVERPAGE_TITLE}}
						</a>
						<br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>
		<br>
	<label class="savedLabel col-md-4">Header: </label>
		<!--<select class="savedPage col-md-6" [(ngModel)]="selectedHeader.COPIED_FROM_ID" (change)='updateRpt("header")'>
			<option></option>
			<option *ngFor="let header of headers" [value]="header.HEADERFOOTER_ID">{{header.HF_TITLE}}</option>
		</select>
		<a *ngIf="selectedHeader.COPIED_FROM_ID" title="Edit Header" class="ml-1 mt-1" target=_blank [href]="'cover/Header-'+selectedHeader.HEADER_ID"><i class="far fa-edit iconBtn" style="pointer-events:none"></i></a>-->
		<span class="col-md-6">
		<a *ngIf="selectedHeader.COPIED_FROM_ID" class="savedTitle" href="javascript:void(0)" (click)="openHFPage(selectedHeader.HEADER_ID)">{{selectedHeader.HF_TITLE}}</a>
		</span>
		<a class="ml-1 mb-1" (click)="getAllHeader(); op82.toggle($event);" title="Choose Header"><i class="pi pi-angle-down" style="margin: 5px;"></i></a>
		<p-overlayPanel #op82 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedHeader.COPIED_FROM_ID=null;selectedHeader.HF_TITLE=null; updateRpt('header'); op82.hide();">
							None
					</a><br>
					<ng-container *ngFor="let header of headers; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedHeader.COPIED_FROM_ID=header.HEADERFOOTER_ID;selectedHeader.HF_TITLE=header.HF_TITLE; updateRpt('header'); op82.hide();">
							{{header.HF_TITLE}}
						</a>
						<br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>
	<label class="savedLabel col-md-4">Footer: </label>
		<!--<select class="savedPage col-md-6" [(ngModel)]="selectedFooter.COPIED_FROM_ID" (change)='updateRpt("footer")'>
			<option></option>
			<option *ngFor="let footer of footers" [value]="footer.HEADERFOOTER_ID">{{footer.HF_TITLE}}</option>
		</select>
		<a *ngIf="selectedFooter.COPIED_FROM_ID" title="Edit Footer" class="ml-1 mt-1" target=_blank [href]="'cover/Footer-'+selectedFooter.FOOTER_ID"><i class="far fa-edit iconBtn" style="pointer-events:none"></i></a>-->
		<span class="col-md-6">
		<a *ngIf="selectedFooter.COPIED_FROM_ID" class="savedTitle" href="javascript:void(0)" (click)="openHFPage(selectedFooter.FOOTER_ID)">{{selectedFooter.HF_TITLE}}</a>
		</span>
		<a class="ml-1 mb-1" (click)="getAllFooter(); op83.toggle($event);" title="Choose Footer"><i class="pi pi-angle-down" style="margin: 5px;"></i></a>
		<p-overlayPanel #op83 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedFooter.COPIED_FROM_ID=null;selectedFooter.HF_TITLE=null; updateRpt('footer'); op83.hide();">
							None
					</a><br>
					<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedFooter.COPIED_FROM_ID=footer.HEADERFOOTER_ID;selectedFooter.HF_TITLE=footer.HF_TITLE; updateRpt('footer'); op83.hide();">
							{{footer.HF_TITLE}}
						</a>
						<br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>
	<label class="savedLabel col-md-4">Watermark: </label>
		<!--<select class="savedPage col-md-6" [(ngModel)]="selectedWatermarker" (change)='setWatermarker("watermarker")'>
			<option value=""></option>
			<option *ngFor="let watermarker of watermarkers" [value]="watermarker.WATERMARK_ID">{{watermarker.WM_TITLE}}</option>
		</select>
		<ng-container *ngFor="let watermarker of watermarkers">
					<a href='javascript:void(0)' (click)='preview("draft", watermarker.WATERMARK_ID)'>{{watermarker.WM_TITLE}}</a><br>
		</ng-container>	-->
		<a class="savedTitle col-md-6 ">{{selectedWatermarker.WM_TITLE}}</a>
		<a class="ml-1 mb-1" (click)="getWatermarkers(); op84.toggle($event);" title="Choose Watermark"><i class="pi pi-angle-down" style="margin: 5px;"></i></a>
		<p-overlayPanel #op84 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedWatermarker.WATERMARK_ID=null;selectedWatermarker.WM_TITLE=null; setWatermarker('watermarker'); op84.hide();">
							None
					</a><br>
					<ng-container *ngFor="let watermarker of watermarkers; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedWatermarker=watermarker; setWatermarker('watermarker'); op84.hide();">
							{{watermarker.WM_TITLE}}
						</a>
						<br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>
		<label class="savedLabel col-md-6">Print Table of Content: </label>
		<select class="col-md-5" style="padding:0; font-size:11px" (change)="setToc($event)">
		<option value='Y' [selected]="reportInfo?.TOC_IND=='Y'">Yes</option>
		<option value='N' [selected]="reportInfo?.TOC_IND=='N'">No</option>
		</select>
		<label class="savedLabel col-md-4">TOC Header: </label>
		<span class="col-md-6">
		<a *ngIf="selectedTHeader.TOC_HEADER_ID" class="savedTitle" href="javascript:void(0)" (click)="openHFPage(selectedTHeader.TOC_HEADER_ID)">{{selectedTHeader.HF_TITLE}}</a>
		</span>
		<a class="ml-1 mb-1" (click)="getAllHeader(); op86.toggle($event);" title="Choose Header"><i class="pi pi-angle-down" style="margin: 5px;"></i></a>
		<p-overlayPanel #op86 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedTHeader.TOC_HEADER_ID=null;selectedTHeader.HF_TITLE=null; updateRpt('theader'); op86.hide();">
							None
					</a><br>
					<ng-container *ngFor="let header of headers; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedTHeader.TOC_HEADER_ID=header.HEADERFOOTER_ID;selectedTHeader.HF_TITLE=header.HF_TITLE; updateRpt('theader'); op86.hide();">
							{{header.HF_TITLE}}
						</a>
						<br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>
	<label class="savedLabel col-md-4">TOC Footer: </label>
		<span class="col-md-6">
		<a *ngIf="selectedTFooter.TOC_FOOTER_ID" class="savedTitle" href="javascript:void(0)" (click)="openHFPage(selectedTFooter.TOC_FOOTER_ID)">{{selectedTFooter.HF_TITLE}}</a>
		</span>
		<a class="ml-1 mb-1" (click)="getAllFooter(); op87.toggle($event);" title="Choose Footer"><i class="pi pi-angle-down" style="margin: 5px;"></i></a>
		<p-overlayPanel #op87 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedTFooter.TOC_FOOTER_ID=null;selectedTFooter.HF_TITLE=null; updateRpt('tfooter'); op87.hide();">
							None
					</a><br>
					<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedTFooter.TOC_FOOTER_ID=footer.HEADERFOOTER_ID;selectedTFooter.HF_TITLE=footer.HF_TITLE; updateRpt('tfooter'); op87.hide();">
							{{footer.HF_TITLE}}
						</a>
						<br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>
		<div *ngIf="reportInfo?.PCA_INDICATOR=='frm1105'">
		<label class="savedLabel col-md-6">Freddie Mac Footer: </label>
		<label class="col-md-4">
		<a *ngIf="selectedFrmFooter.FRM_FOOTER_ID>-1" class="savedTitle" href="javascript:void(0)" (click)="openHFPage(selectedFrmFooter.FRM_FOOTER_ID)">{{selectedFrmFooter.HF_TITLE}}</a>
		</label>
		<a class="ml-1 mb-1" (click)="getAllFooter(); op88.toggle($event);" title="Choose Footer"><i class="pi pi-angle-down" style="margin: 5px;"></i></a>
		<p-overlayPanel #op88 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
					<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedFrmFooter.FRM_FOOTER_ID=null;selectedFrmFooter.HF_TITLE=null; updateRpt('Ffooter'); op88.hide();">
							None
					</a><br>
					<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
						<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="selectedFrmFooter.FRM_FOOTER_ID=footer.HEADERFOOTER_ID;selectedFrmFooter.HF_TITLE=footer.HF_TITLE; updateRpt('Ffooter'); op88.hide();">
							{{footer.HF_TITLE}}
						</a>
						<br>
					</ng-container>
				</div>
			</ng-template>
		</p-overlayPanel>	
		</div>	
		<label class="savedLabel col-md-6">Company Profile: </label>
		<select class="savedPage col-md-5" (change)='updateRpt("Profile", $event)'>
			<option *ngFor="let profile of profiles; trackBy:trackByFuntion" [value]="profile.COMP_PROFILE_ID" [selected]="selectedProfile==profile.COMP_PROFILE_ID">{{profile.REPORT_STYLE_NAME}}</option>
		</select>
		<label class="savedLabel col-md-6">Signature Profile: </label>
		<label class="savedPage col-md-6" style="color:#C2D63F; background-color:transparent">{{reportInfo?.SIGNATURE_STYLE?.SIGNATURE_STYLE_NAME}}</label>		
		<!--<label class="savedLabel col-md-7">FME Profile: </label>
		<select class="savedPage col-md-4">
			<option >Default Profile</option>
			<option >Company Profile</option>
		</select>-->
		<div class="pl-3"><input type="checkbox" disabled [(ngModel)]="contentIndent" (change)="saveIndent()"><label class="savedLabel">Text to follow the header indent</label></div>	
		<label class="savedLabel col-md-10">PDF File Name: <a class="ml-1 mb-1" (click)="pdfedit=!pdfedit;" title="Edit PDF File Name"><i class="fas fa-edit"></i></a>
	</label>
	<span class="savedLabel col-md-12" style="color:#C2D63F" >{{pdfFname.name}}</span>	<br>
	<div class="pl-3"><input type="checkbox" [(ngModel)]="blackText" (change)="saveBlack()"><label class="savedLabel">Print PDF with Black Text Sections</label></div>
	<!--<p-overlayPanel #op85 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>-->
			<div id="pdfEditor" [ngStyle]="{'display':pdfedit?'block':'none'}" >
				<div style="padding:4px; max-height:400px; overflow:auto; width:300px" class="ckContainer">
					<app-paragraph [srcViewer]="'N'" [editorType]="'lite'" (click)="selectedEditor='P'" [addedSlot]="pdfFname['addedItem']"  class="docItem"  [content]="pdfFname['text']"  [getText]="pdfFname['reqIndex']"  (selected)="selectedRow=-1;selectedCell=null;addLib=true; selectedEditor='P'" (outText)="pdfPara($event)" (onExit)='pdfData($event);'></app-paragraph>															
				</div>
				<button type="button" class="btn btn-outline-light btn-sm m-1" (click)="savepdf(); pdfedit=false">Save</button>
			</div>
			<!--</ng-template>
		</p-overlayPanel>-->
		<br><label class="savedLabel1 col-md-12" >* Amazon will automatically convert spaces, punctuation marks including commas, or symbols (e.g., #, @, /, *, -) to an underscore (_).</label>
		</div>
		<hr class="line1">
		<!--<button *ngIf="selectedCover.COVERPAGE_ID" class="col-md-11 btn btn-black btn-small m-1 toolBtn" [disabled]="allowAdd!='Y'" (click)='editCoverSign()'>Sign the Cover Page</button>-->
		<button *ngIf="selectedCover.COVERPAGE_ID" class="col-md-11 btn btn-black btn-small m-1 toolBtn" [disabled]="allowAdd!='Y'" (click)='editCover()'>Add/Change Cover Images</button>
		<!--<button *ngIf="selectedCover.COVERPAGE_ID" class="col-md-5 btn btn-black btn-small m-1 toolBtn" [disabled]="allowAdd!='Y'" (click)='upload("FILE");fileShow=true'>Upload Image</button>-->
		<div *ngIf="coverImages?.length>0" style="max-height:36vh; width:98%; margin:4px; padding:0; border:1px solid rgb(9, 17, 33); overflow: auto;border:1px solid #666">
			<ng-container *ngFor="let image of coverImages; let i=index">
						<div style="width:200px; height:140px; margin:10px 0">
							<div style="display: flex;flex-direction: column;padding:0 ">
								<img class="bkImage" style="display:inline-block; width:200px; height:100px;" [src]="image.src" alt="Loading ... ">
								<!--<label>Change Image<app-edit-input [text]="" (edited)="changeImage(i, $event);"></app-edit-input></label>-->
								<button class="col-md-11 btn btn-black btn-small mt-1 toolBtn" (click)="openPhoto(image, i)">Add/Change Photo </button>
							</div>
						</div>
					</ng-container>					
		</div>
		<button  *ngIf="coverImages?.length>0" class="btn-block btn btn-black btn-small mt-1 toolBtn" style="margin-bottom: 50px;" (click)='updateCover()'>Save Cover Photo</button>

	</div>
	 
  </div>
	
</div>
</div>
</div>
 <app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]" (didClosed)="showLogo = null">
    <ng-container name="body">
      <app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo' (editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
    </ng-container>
  </app-panel>

</div>
<div id="libraryModal" #libraryModal class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:40%">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Library</h6><span *ngIf="libraries.length==0" class="fa fa-spinner fa-spin" style="font-size:24px;"></span>
		 	<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>        
        <!-- Modal body -->
        <div class="modal-body">				
			<div class="row p-2">
			<div style="height:400px; overflow:auto;width:55%; padding-left:10px">
			<p-table #dt3 [value]="libraries" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','LABELS']" (onFilter)="onFilter($event, dt3)">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th>
							<div style="display:inline-block; padding:0">   
								<select style="margin-bottom:2px;margin-top:4px; width:90px;min-width:50px; font-size:14px; background-color:rgb(28, 36, 51); color:#ccc" (change)="filterLibs($event)">
							<option value="">Identifier
							</option>
							<ng-container *ngFor="let label of libLabels">
							<option [value]="label.value">{{label.value}}
							</option>
							</ng-container>
							</select>
							</div>
							<input type="text" pInputText size="10" placeholder="Filter" (change)="filterLibs($event)" style="width:auto">
							<i class="pi pi-search" style="margin:4px 4px 0 0" (click)='filterLibs($event)'></i>	
							<!--<p-dropdown [options]="libLabels"  placeholder="Filter by Identifier" [style]="{'width':'40%','minWidth':'40px'}" (onChange)="dt3.filter($event.value, 'LABELS', 'contains')"  [showClear]="true"></p-dropdown>
								<i class="pi pi-search" style="margin:4px 2px 0 4px"></i>
							<input type="text" pInputText size="12" placeholder="Filter" (input)="dt3.filterGlobal($event.target.value, 'contains')" style="width:auto">-->
						</th>					
					</tr>		
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr>
						<td>
							<div class="card"  [ngClass]="{'active':curLibId.indexOf(rowData.LIBRARY_ID)>-1}" (click)="selLib(rowData)"> 						
								<div class="row"><label style="color:#C2D63F; width:80%; margin-left:16px">{{rowData.ITEM_TITLE}}</label>
									<!--<a href="javascript:void(0)" style="width:5%; float:right" title="Preview" (click)="op3.toggle($event);"><i class="pi pi-info-circle"></i></a>-->
									<a href="javascript:void(0)" style="width:5%; float:left; " title="Preview" (click)="op4.toggle($event);"><i class="pi pi-eye"></i></a>					
								</div>
								<span>{{rowData.SHORT_CONTENT}}</span>
								<!--<p-overlayPanel #op3 [appendTo]="libraryModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '800px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto"> 
											<h6>{{rowData.ITEM_TITLE}}</h6>
											<hr>
											<div>
												Instruction : {{rowData.INSTRUCTIONS}}
											</div>										
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>-->
								<p-overlayPanel #op4 [appendTo]="libraryModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '440px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F; max-height:400px; overflow:auto; font-size:.9em"> 
											<h6>{{rowData.ITEM_TITLE}}</h6>
											<ng-container *ngFor="let label of rowData.LABELS.split(';')">
												<label class="tag1">{{label}}</label>
											</ng-container>
											<div>
												<strong>Instruction :</strong><span style="color:white"> {{rowData.INSTRUCTIONS}}</span>
											</div>
											<div>
												<strong>Content :</strong><span style="color:white"> {{rowData.CONTENT}}</span>
											</div>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>	
		</div>
		<div class="d-flex flex-column justify-content-center p-2" style="width:9%">
					<button type="button" class="btn btn-outline-light btn-sm" title="Add Selected Library to Repeat Field" (click)="addSelLib()">></button>
					<div style="height:30px"></div>
					<button type="button" [disabled]="(libraries.length>10&&!filteredData)||(filteredData&&filteredData.length>10)" class="btn btn-outline-light btn-sm p-0" title="Add More than one Library to Repeat Field ( Max 10)" (click)="addAllSelLib()">>></button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm" title="Remove Selected Library from Repeat Field" (click)="rmvAddedLib()"><</button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm  p-0" title="Remove All Library from repeat Field" (click)="clearAddedLib()"><<</button>
					<div style="height:30px"></div>
					<button *ngIf="libToSlot" type="button" class="btn btn-outline-success btn-sm" title="Add Library to Repeat Field" (click)='addLibToSlot()'><i class="far fa-save"></i></button>
					<button *ngIf="!libToSlot" type="button" class="btn btn-outline-success btn-sm" title="Add Library to Page" (click)='addLibToDoc()'><i class="fas fa-plus"></i></button>
					<div style="height:30px"></div>
					<span class="fa fa-spinner fa-spin" style="font-size:36px; display:none"></span>
				
				</div>
		<div cdkDropList (cdkDropListDropped)="dropLib($event)" [cdkDropListData]="addedLib" class="rounded" style="height:400px; overflow:auto;width:35%; border:solid 1px rgb(195,212,47)">
			<ng-container *ngFor="let lib of addedLib">
				<div cdkDrag class="card row" style="width:95%; margin:2px 4px" [ngClass]="{'active':curLibId.indexOf(lib.LIBRARY_ID)>-1}" (click)="selLib(lib)"> 						
					<p>{{lib.CONTENT}}</p>
				</div>
			</ng-container>
		</div>
		</div>

	</div>
	</div>
	</div>	
</div>
<div id="tableModal" #tableModal class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered " style="min-width:40%;">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 *ngIf='curTableData?.rows.length==0' class="modal-title" style="color:rgb(195,212,47)">Create New Table</h6>
			<h6 *ngIf='curTableData?.rows.length>0' class="modal-title" style="color:rgb(195,212,47)">Table Property</h6>
				<div class="form-check-inline ml-4">
				<label class="form-check-label">
					<input type="checkbox" [checked]="isEven" (change)="isEven=!isEven" class="form-check-input" value="">Even Cell Size
				</label>
			</div>	
			<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>
        
        <!-- Modal body -->
        <div class="modal-body" style="max-height: 85vh;">
			<div class="row m-0 p-0">
			<label  class="ml-4">
			 <input type="radio" [disabled]="curTableData?.rows.length>0||curTableData?.SLOT_ID>-1"  name="tableSrc" class="m-0" [checked]="slotTableType==0||!(curTableData?.src&&curTableData?.src==0)" (change)="setTableSrc(0)"> 
				New Customized Table
			</label>
			<div *ngIf="slotTableType==0||(curTableData?.src&&curTableData?.src==0)" class="col-md-6">
					<label>Columns:</label>
					<input [disabled]='curTableData?.rows.length>0' min="0"   max="1000000000"  type="number" style="margin-left:4px; padding:2px; font-size:.8em" [(ngModel)]="colNo" min="0" max="10" (input)='setCol()'/>
					<label class="ml-2">Rows: </label>
					<input type="number" min="0"   max="1000000000" [disabled]="curTableData?.rows.length>0"  style="margin-left:4px;  padding:2px; font-size:.8em" [(ngModel)]="rowNo" min="0" max="10"/>				
					<a class="btn btn-outline-light btn-sm float-md-right" (click)="addCol()">Add Column</a>
				</div>
			</div>
			<div class="row m-0 p-0">
			<label class="radio-inline ml-4"> 
				<input type="radio" [disabled]="curTableData?.rows.length>0||selectedEditor=='F'||curTableData?.SLOT_ID>-1"  name="tableSrc" [checked]="slotTableType==1||curTableData?.erisName" (change)="setTableSrc(1)">
				ERIS Data
			</label>
			<div  *ngIf="slotTableType==1" class="col-md-7">
				<select [disabled]="curTableData?.rows.length>0||selectedEditor=='F'||curTableData?.SLOT_ID>-1" (change)="getErisTable($event)" class="col-md-11"  (click)="getTables('eris')">
				<option>Select ERIS Data</option>
				<option *ngFor="let s of erisSlots; let i=index" [value]="i" [selected]='curTableData.erisName==s.KEY'>{{s.KEY}}</option>
				</select>
				</div>
			</div>
			<div (mouseleave)='dragEnd($event)' (mouseenter)="dragStart($event)">
			<div *ngIf="curTableData?.cols.length>0||curTableData?.SLOT_ID">
			<div class="dragItem" style="width:100%;">
						<div style="flex-basis:5%;">No.</div>
						<div style="flex-basis:30%;">Name*</div>
						<!--<div style="width:80px;">Type</div>-->
						<div style="flex-basis:11%;">Column Width</div>
						<div style="flex-basis:5%;padding-left: 4px;">Unit</div>
						<!--<div style="width:80px;">Table Direction</div>-->
						<div style="flex-basis:6%;">
							<ng-container *ngIf="!curTableData.cols[0].hide&&curTableData.cols[0].text">
								Lock<i class="fas fa-info-circle ml-1" title="Lock content, backgroundfrom editing"></i>
							</ng-container>
							
						</div>
						<div style="flex-basis:9%;">
							<ng-container *ngIf="!curTableData.cols[0].hide&&curTableData.cols[0].text">
								V-Header<i class="fas fa-info-circle ml-1" title="Set Vertical Header style in PDF"></i>
							</ng-container>
							
						</div>
						<div style="flex-basis:10%;">Header Alignment</div>
						<div style="flex-basis:10%;">Cell Alignment</div>
						<div style="flex-basis:5%;"></div>
					</div>
			<div *ngIf="colNo>0" #dropList  cdkDropList [cdkDropListData]="curTableData.cols" (cdkDropListDropped)="dropCol($event)" style="max-height:50vh; overflow: auto;">
					
					<ng-container *ngFor="let item of curTableData.cols; let i=index">
						<div *ngIf="!item.hide&&(!item.text)" cdkDrag class="drag-box">
						<div style="flex-basis:5%; padding:4px">
							<span>{{i}}</span>
							</div>
						<div style="flex-basis:25%">							
							<app-editable [text]="item.NAME"  style="width:100px" (edited)="changeLabel($event, i)" [defaultText]='"Header"'></app-editable>
							</div>
							<div style="flex-basis:5%">
								<a class="btnRound1 float-right" [ngStyle]="{'color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.html)?'#c2d63e':'#999','border-color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" (click)="toDefaultEdit(item)">FO</a>
							</div>
							<div style="flex-basis:10%">
								<input [disabled]='isEven' type="number" min="0"   max="1000000000" [(ngModel)]="curTableData.cols[i].width" min="0" max="50"/>
							</div>	
							<div style="flex-basis:5%">
							<select [disabled]='isEven' [(ngModel)]="curTableData.cols[i].unit">				
								<option>%</option>
								<option>px</option>								
							</select>
							</div>	
							<div style="flex-basis:15%"></div>
							<!--<select style="width:100px" [(ngModel)]="curTableData.cols[i].dir">				
								<option>Default</option>
								<option>Vertical</option>								
							</select>-->
							<div style="flex-basis:10%">
							<select [(ngModel)]="curTableData.cols[i].colAlign">				
								<option>Left</option>
								<option>Center</option>
								<option>Right</option>								
							</select>
							</div>	
							<div style="flex-basis:10%">
							<select [(ngModel)]="curTableData.cols[i].celAllign">				
								<option>Left</option>
								<option>Center</option>
								<option>Right</option>							
							</select>
							</div>	
							<div style="flex-basis:5%">
							<a class="btn btn-small btn-link" (click)="deleteCol(i)">
								<i class="fas fa-trash"></i>
							</a>
							</div>								
						</div>
						<div *ngIf="!item.hide&&item.text" class="drag-box" style="cursor:default">
							<div style="flex-basis:5%; padding:4px">
							<span>{{i}}</span>
							</div>
							<div style="flex-basis:25%">
							<span>{{item.text}}</span>
							</div>
							<div style="flex-basis:5%">
								<a class="btnRound1 float-right" [ngStyle]="{'color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.html)?'#c2d63e':'#999','border-color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" (click)="toDefaultEdit(item)">FO</a>
								
							</div>
							<div style="flex-basis:10%">
							<input [disabled]='isEven' type="number" min="0"   max="1000000000" [(ngModel)]="curTableData.cols[i].width" min="0" max="50"/>
							</div>	
							<div style="flex-basis:5%">
							<select [disabled]='isEven' style="width:50px" [(ngModel)]="curTableData.cols[i].unit">				
								<option>%</option>
								<option>px</option>								
							</select>
							</div>
							<div style="flex-basis:6%; vertical-align: middle;padding-left: 10px;">
								<input type="checkbox" [checked]="curTableData.cols[i]['lock']" [disabled]="allowLock!='Y'" (change)="curTableData.cols[i]['lock']=!curTableData.cols[i]['lock']">
							</div>	
							<div style="flex-basis:9%; vertical-align: middle;padding-left: 10px;">
								<!--<input type="checkbox" [(ngModel)]="ifVH" (change)="secVH($event)">-->
								<input type="checkbox" [checked]="curTableData.cols[i]['VH']" (change)="curTableData.cols[i]['VH']=!curTableData.cols[i]['VH']">

							</div>
							<div style="flex-basis:10%">
							<select [(ngModel)]="curTableData.cols[i].colAlign">				
								<option>Left</option>
								<option>Center</option>
								<option>Right</option>								
							</select>
							</div>
							<div style="flex-basis:10%">
							<select [(ngModel)]="curTableData.cols[i].celAllign">				
								<option>Left</option>
								<option>Center</option>
								<option>Right</option>							
							</select>
							</div>
							<div style="flex-basis:5%">
							<a class="btn btn-small btn-link" (click)="deleteCol(i)" [ngClass]="{'disabled':curTableData.cols[i]['lock']||(curTableData['locked']&&curTableData['locked']['header'])}">
								<i class="fas fa-trash"></i>
							</a>
							</div>							
						</div>						
					</ng-container>
				</div>				
			</div>
			</div>
				<button *ngIf="curTableData?.rows.length==0" type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createTable()">Create Table</button>
				<button *ngIf="curTableData?.rows.length>0"type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createTable()">Save</button>
			
		</div>

	</div>
	</div>
	</div>
	<div id="marginModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-sm modal-dialog-centered "  style="max-width: 40%;">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Set Margin Size</h6>
		  <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
			<!--<label class="col-md-7">Margin Top</label><input  min="0"   max="1000000000" class="col-md-4" type='number' [(ngModel)]="pageMargin.top"/>px<br>
			<label class="col-md-7">Margin Bottom</label><input min="0"   max="1000000000"  class="col-md-4" type='number' [(ngModel)]="pageMargin.bottom"/>px<br>	
			<label class="col-md-7">Margin Left</label><input  min="0"   max="1000000000" class="col-md-4" type='number' [(ngModel)]="pageMargin.left"/>px<br>
			<label class="col-md-7">Margin Right</label><input  min="0"   max="1000000000" class="col-md-4" type='number' [(ngModel)]="pageMargin.right"/>px<br>		
        <button class="btn m-0 btn-op float-right" (click)="saveMargin()">Save</button>-->
		<div class="row" style="font-size: 14px; width:100%; ">
			<div class="col-md-6" style="text-align: right;">
				<label class="col-md-8">Margin Top</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="pageMargin.top"/>px<br>
				<label class="col-md-8">Margin Bottom</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="pageMargin.bottom"/>px<br>	
				<label class="col-md-8">Margin Left</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="pageMargin.left"/>px<br>
				<label class="col-md-8">Margin Right</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="pageMargin.right"/>px<br>		
				
			</div>
			<div class="col-md-6"  style="text-align: right;">
				<label class="col-md-8">TOC Margin Top</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="tocMargin.top"/>px<br>
				<label class="col-md-8">TOC Margin Bottom</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="tocMargin.bottom"/>px<br>	
				<label class="col-md-8">TOC Margin Left</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="tocMargin.left"/>px<br>
				<label class="col-md-8">TOC Margin Right</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="tocMargin.right"/>px<br>		
				<button class="btn m-0 p-2 btn-op float-right" (click)="saveMargin()">Save</button>
			</div>
		</div>
		</div>
								
	</div>
	</div>
	</div>
	<div id="costDetailModal" #costDetailModal class="modal fade" data-backdrop='false'>
		<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:50%">
			<div class="modal-content" style="background:#444; color:#ccc">
				<!-- Modal Header -->
				<div class="modal-header">
					<h6 *ngIf="!rowItem['edit']" class="modal-title">Add Cost Recommendation</h6>
					<h6 *ngIf="rowItem['edit']" class="modal-title">Edit Cost Recommendation</h6>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>        
				<!-- Modal body -->
				<div class="modal-body" style="font-size:12px;">
					<label *ngIf="reportInfo?.PCA_INDICATOR=='4099e'">Fannie Mae Category :</label><span class="costLabel3" *ngIf="reportInfo?.PCA_INDICATOR=='4099e'&&rowItem['catLabel']?.length>0"> {{rowItem['catLabel']}}</span>					

					<div class="row costRow">
						<ng-container *ngIf="reportInfo?.PCA_INDICATOR=='4099e'">
							<div *ngIf="rowItem.catIndex>-1" style="width:99%; margin-left: 10px;">
								<label class="costLabel mr-1" style="width:40%"><span style="color:red">*</span>Capital Item Category</label>
								<label class="costLabel mr-1"  style="width:40%"><span style="color:red">*</span>Capital Item</label>
								<label class="costLabel"  style="width:13%">Action Item</label>
								<select class="costInput mr-1" style="width:40%" [ngStyle]="{'border':rowItem.NTCHK||(!rowItem.NTCHK&&rowItem.selectedYear.length==0)||(!rowItem.NTCHK&&rowItem.selectedYear.length>0&&rowItem.longCat.length>0)? 'none':'2px solid #F78181'}" (change)="selFmeCost('capital', $event)" [disabled]="rowItem.NTCHK">
									<option></option>
									<option *ngFor="let item of capitalCategory[rowItem.catIndex].subCat; let i=index" [value]="i" [selected]="item.id==rowItem['longCat']">{{item.label}}</option>
								</select>
								<select class="costInput mr-1" [ngStyle]="{'width': reportInfo.PCA_INDICATOR=='4099e'? '40%':'53%', 'border':rowItem.NTCHK||(!rowItem.NTCHK&&rowItem.selectedYear.length==0)||(!rowItem.NTCHK&&rowItem.selectedYear.length>0&&rowItem.catItem>-1)? 'none':'2px solid #F78181'}" (change)="selFmeCost('capitalitem', $event)" [disabled]="rowItem.NTCHK">
									<option></option>
									<option *ngFor="let item of capitalItems[rowItem.catIndex]; let i=index" [value]="i" [selected]="i==rowItem['catItem']"  (change)="selFmeCost('catItem', $event)">{{item.FME_FIELD_NAME}}</option>
								</select>
								<select *ngIf="reportInfo?.PCA_INDICATOR=='4099e'" class="costInput" style="width:13%" [ngStyle]="{'border':rowItem['ACTION'].length>0||rowItem.NTCHK? 'none':'2px solid #F78181'}" (change)="selFmeCost('ACTION', $event)" [disabled]="rowItem.NTCHK">
									<option></option>
									<option *ngFor="let item of actionItemOps; let i=index" [value]="i" [selected]="item.name==rowItem['ACTION']">{{item.name}}</option>
								</select>
								<!--<p-multiSelect [style]="{'width':'100%', 'padding':'1px', 'font-size':'10px'}" [options]="actionItemOps" [filter]="false" [ngStyle]="{'border':curDoc.ul?.ACTION.length>0? 'none':'2px solid #F78181'}" [(ngModel)]="curDoc.ul.ACTION" optionLabel="name" (onChange)="selFmeUl(curDoc, $event, 'ACTION')"></p-multiSelect>-->
							</div>
						</ng-container>
						<div style="width:50%; margin-left:10px">
							<label class="costLabel">Cost Recommendation</label>
							<input class="costInput" style="width:85%" [(ngModel)]="rowItem.Item" type='text' [ngStyle]="{'border':rowItem.Item.length>0||passAction.indexOf(rowItem['ACTION'])>-1? 'none':'2px solid #F78181'}" (input)="customInput($event)">
							<select class="costInput" style="width:10%"(change)="selCost($event)">
								<option></option>
								<option *ngFor="let item of curCosts; let i=index" [value]="i" [selected]="curCost?.COST_LIBRARY_ID==item.COST_LIBRARY_ID">{{item.ITEM_TITLE}}</option>
							</select>
						</div>
						<div style="width:10%">
							<label class="costLabel">EUL</label>
							<input class="costInput" [(ngModel)]="rowItem.EUL" min="0"   max="1000000000" type='number' [disabled]="rowItem.NTCHK" (blur)="changeCostFactor(rowItem.EUL, 'EUL')">-
						</div>
						<div style="width:10%">
							<label class="costLabel">EFF AGE</label>
							<input class="costInput" [(ngModel)]="rowItem.EFF" min="0"   max="1000000000" type='number' [disabled]="rowItem.NTCHK" (blur)="changeCostFactor(rowItem.EFF, 'EFF')">=
						</div>
						<div style="width:10%">
							<label class="costLabel">RUL</label>
							<input class="costInput" disabled [value]="rowItem?.EUL-rowItem?.EFF" min="0"   max="1000000000" type='number' [disabled]="rowItem.NTCHK" (blur)="changeCostFactor($event)">
						</div>
						<div style="width:12%">
							<label class="costLabel">RUL Input</label>
							<input class="costInput" [(ngModel)]="rowItem.RULtext" type='text' [disabled]="rowItem.NTCHK">
						</div>
					</div>
					<div class="row costRow">
						<div style="width:20%; margin-left:10px">
							<label class="costLabel">Calculation</label>
							<input class="costInput" [(ngModel)]="rowItem.Quantity" min="0" [ngStyle]="{'border':rowItem.NTCHK||(!rowItem.NTCHK&&rowItem.Quantity>0)||passAction.indexOf(rowItem['ACTION'])>-1? 'none':'2px solid #F78181'}"  max="1000000000" type='number' (blur)="getReserve('Quantity')" [disabled]="rowItem.NTCHK"> X
							<label class="costHint"><span style="color:red">*</span>Quantity</label>
						</div>
						<div style="width:22%">
							<label *ngIf="curCost?.COST.length>10" class="costHint m-0" [title]="curCost?.COST">{{curCost?.COST.substring(0,10)}}...</label>
							<label *ngIf="!(curCost?.COST.length>10)"class="costHint m-0">{{curCost?.COST}}</label>
							<input class="costInput" [(ngModel)]="rowItem.Cost" min="0" (blur)="getReserve('Cost')" max="1000000000" type='number' [disabled]="rowItem.NTCHK"><!--[ngStyle]="{'border':rowItem.NTCHK||(!rowItem.NTCHK&&rowItem.Cost>0)? 'none':'2px solid #F78181'}" -->
							<label class="costHint"><span style="color:red">*</span>Unit Cost</label>
						</div>
						<div style="width:12%">
							<label class="costHint m-0">{{curCost?.UNIT}}</label>
							<input class="costInput" style="width:55%" [(ngModel)]="rowItem.Unit" [ngStyle]="{'border':rowItem.NTCHK||(!rowItem.NTCHK&&rowItem.Unit.length>0)||passAction.indexOf(rowItem['ACTION'])>-1? 'none':'2px solid #F78181'}" type='text' (input)="customInput($event)" [disabled]="rowItem.NTCHK">
							<select class="costInput"  style="width:20%" (change)="selUnit($event)" [disabled]="rowItem.NTCHK">
								<option></option>
								<option *ngFor="let unit of units" [value]="unit.COST_UNIT_NAME" [selected]="rowItem.Unit==unit.COST_UNIT_NAME">{{unit.COST_UNIT_NAME}}</option>
							</select>=
							<label class="costHint"><span style="color:red">*</span>Unit Type</label>
						</div>
						<div style="width:12%">
							<br>
							<input class="costInput" disabled [(ngModel)]="rowItem.Cycle" type='number'>x
							<label class="costHint">Cycle Cost</label>
						</div>
						<div style="width:11%">
							<br>
							<input class="costInput" [(ngModel)]="rowItem.Percent" min="0"   max="1000000000" type='number' (input)="getReserve()" [disabled]="rowItem.NTCHK">=
							<label class="costHint">Replace%</label>
						</div>
						<div style="width:21%">
							<br>
							<input class="costInput" type='number' min="0"   max="1000000000" disabled [(ngModel)]="rowItem.Total">
							<label class="costHint">Total</label>
						</div>
					</div>
					<div *ngIf="reportInfo?.PCA_INDICATOR=='Y'" class="row">
						<div style="width:35%; margin-left:10px;">
							<input class='ml-3' type="checkbox" [(ngModel)]="rowItem.shortCHK" [disabled]="pcaOp.term=='Exclude'" (change)="getReserve()"><label class="costLabel m-1"  style="width:80%" [ngClass]="{'disableLabel':pcaOp.term=='Exclude'}">Short Term Repair Costs</label><br>
							<input class='ml-3' type="checkbox" [(ngModel)]="rowItem.immiCHK" (change)="getReserve()"><label class="costLabel m-1" style="width:80%">Immediate Repair Costs</label>
						</div>
						<div style="width:12%">
							<input [disabled]="pcaOp.term=='Exclude'"  class="costInput" [(ngModel)]="rowItem.Short" (blur)="getReserve('Short')"  type='number' min="0" max="1000000000">
							<input class="costInput" [(ngModel)]="rowItem.Immediate" min="0"   max="1000000000" (blur)="getReserve('Immediate')"  type='number'>
						</div>
						<div style="width:25%">
							<input type="checkbox" [(ngModel)]="rowItem.allow" [checked]="rowItem.allow" ><label class="costLabel2">Allow Unallocated Costs</label><br>
							<label class="costLabel2">Unallocated Costs</label>
							<input class="costInput2" type='number' [disabled]="rowItem.NTCHK" [ngStyle]="{'color':rowItem.reserve<0?'red':'black'}" disabled [(ngModel)]="rowItem.reserve">	
							<!--<input class="costInput col-md-10" type='number'  [ngStyle]="{'color':(rowItem.data[5].data*rowItem.data[1].data*rowItem.data[3].data/100-rowItem.data[6].data-rowItem.data[7].data)<0?'red':'black'}" disabled [value]="rowItem.data[5].data*rowItem.data[1].data*rowItem.data[3].data/100-rowItem.data[6].data-rowItem.data[7].data">-->							
						</div>
					</div>
					<ng-container *ngIf="reportInfo?.PCA_INDICATOR=='4099e'">
						<div>
							<input type="checkbox" style=" margin-left: 30px;" [(ngModel)]="rowItem.allow" [checked]="rowItem.allow"><label style="width:200px;" class="costLabel2">Allow Unallocated Costs</label>
							<label class="costLabel2" style="width:120px">Unallocated Costs</label>
							<input class="costInput2" style="width:200px" type='number' [ngStyle]="{'color':rowItem.reserve<0?'red':'black'}" disabled [(ngModel)]="rowItem.reserve">	
							<!--<input class="costInput col-md-10" type='number'  [ngStyle]="{'color':(frmrowItem.data[5].data*frmrowItem.data[1].data*frmrowItem.data[3].data/100-frmrowItem.data[6].data-frmrowItem.data[7].data)<0?'red':'black'}" disabled [value]="frmrowItem.data[5].data*frmrowItem.data[1].data*frmrowItem.data[3].data/100-frmrowItem.data[6].data-frmrowItem.data[7].data">-->							
						</div>
						<div class="row">
						<div style="width:23%; text-align: right;">
							<label class="costLabel4">Life Safety:</label><input type="checkbox" [(ngModel)]="rowItem.LSCHK" [disabled]="rowItem.NTCHK" (change)="getReserve1()">
						</div>
					
						<div style="width:10%">
							<input  class="costInput3" [(ngModel)]="rowItem.LS" (blur)="getReserve1('LS')" type='number' min="0" max="1000000000" [disabled]="rowItem.NTCHK">
						</div>
						<div style="width:65%">
							<textarea class="costInput3" rows="2" placeholder="Brief Description" [ngStyle]="{'border':rowItem.LSCHK&&rowItem.LSBD.length==0?'2px solid #F78181':'none'}" [disabled]="rowItem.NTCHK" [(ngModel)]="rowItem.LSBD" type='text' ></textarea>
						</div>	
						<div style="width:23%; text-align: right;">
							<label class="costLabel4">Critical Repair:</label><input type="checkbox" [(ngModel)]="rowItem.CRCHK" [disabled]="rowItem.NTCHK" (change)="getReserve1()">
						</div>
						<div style="width:10%">
							<input  class="costInput3" [(ngModel)]="rowItem.CR" (blur)="getReserve1('CR')" type='number' min="0" max="1000000000" [disabled]="rowItem.NTCHK">
						</div>
						<div style="width:65%">
							<textarea class="costInput3" rows="2" placeholder="Brief Description" [ngStyle]="{'border':rowItem.CRCHK&&rowItem.CRBD.length==0?'2px solid #F78181':'none'}" [disabled]="rowItem.NTCHK" [(ngModel)]="rowItem.CRBD" type='text' ></textarea>
						</div>							
						<div style="width:23%; text-align: right;">
							<label class="costLabel4">Deferred Maintenance:</label><input type="checkbox" [(ngModel)]="rowItem.DMCHK" [disabled]="rowItem.NTCHK" (change)="getReserve1()">
						</div>
						<div style="width:10%">
							<input  class="costInput3" [(ngModel)]="rowItem.DM" (blur)="getReserve1('DM')" type='number' min="0" max="1000000000" [disabled]="rowItem.NTCHK">
						</div>
						<div style="width:65%">
							<textarea class="costInput3" rows="2" placeholder="Brief Description" [ngStyle]="{'border':rowItem.DMCHK&&rowItem.DMBD.length==0?'2px solid #F78181':'none'}" [disabled]="rowItem.NTCHK" [(ngModel)]="rowItem.DMBD" type='text' ></textarea>
						</div>	
						<div style="width:23%; text-align: right;">
							<label class="costLabel4">Items of Note:</label><input type="checkbox" [(ngModel)]="rowItem.NTCHK" (change)="fmeOp($event)">
						</div>
						
						<div  *ngIf="rowItem.NTCHK" style="width:75%">
							<textarea class="costInput3" rows="5" placeholder="Brief Description" [ngStyle]="{'border':rowItem.NTCHK&&rowItem.NT.length==0?'2px solid #F78181':'none'}" [(ngModel)]="rowItem.NT"></textarea>
						</div>	
					</div>	
					</ng-container>
					<!--<div *ngIf="reportInfo?.PCA_INDICATOR=='4099e'" class="row">
							<div style="width:30%; margin-left: 20px;">
								<input type="checkbox" [(ngModel)]="rowItem.LSCHK" [disabled]="rowItem.NTCHK" (change)="getReserve1()"><label class="costLabel4">Life Safety:</label><br>
								<input type="checkbox" [(ngModel)]="rowItem.CRCHK" [disabled]="rowItem.NTCHK" (change)="getReserve1()"><label class="costLabel4">Critical Repair:</label><br>
								<input type="checkbox" [(ngModel)]="rowItem.DMCHK" [disabled]="rowItem.NTCHK" (change)="getReserve1()"><label class="costLabel4">Deferred Maintenance:</label><br>
								<input type="checkbox" [(ngModel)]="rowItem.NTCHK" (change)="fmeOp($event)"><label class="costLabel4">Items of Note</label>
							</div>
							<div style="width:10%">
								<input  class="costInput" [(ngModel)]="rowItem.LS" (blur)="getReserve1('LS')" type='number' min="0" max="1000000000" [disabled]="rowItem.NTCHK">
								<input class="costInput" [(ngModel)]="rowItem.CR" min="0"   max="1000000000" (blur)="getReserve1('CR')" type='number' [disabled]="rowItem.NTCHK">
								<input class="costInput" [(ngModel)]="rowItem.DM" min="0"   max="1000000000" (blur)="getReserve1('DM')" type='number' [disabled]="rowItem.NTCHK">
							</div>
							<div style="width:30%">
								<input class="costInput" [(ngModel)]="rowItem.LSBD" type='text' [disabled]="rowItem.NTCHK" placeholder="Brief Description">
								<input class="costInput" [(ngModel)]="rowItem.CRBD" type='text' [disabled]="rowItem.NTCHK" placeholder="Brief Description">
								<input class="costInput" [(ngModel)]="rowItem.DMBD" type='text' [disabled]="rowItem.NTCHK" placeholder="Brief Description">
							</div>
						
						<div style="width:25%">
							<input type="checkbox" [(ngModel)]="rowItem.allow" [checked]="rowItem.allow" [disabled]="rowItem.NTCHK"><label class="costLabel2">Allow Unallocated Costs</label><br>
							<label class="costLabel2">Unallocated Costs</label>
							<input class="costInput2" type='number' [disabled]="rowItem.NTCHK" [ngStyle]="{'color':rowItem.reserve<0?'red':'black'}" disabled [(ngModel)]="rowItem.reserve">	
												
						</div>
						<ng-container  *ngIf="rowItem.NTCHK">
						<label class="costLabel" style="text-align: left; margin-left: 20px;">Brief Description:</label><br>
						<textarea style="width:92%; margin-left: 20px;" rows="5" [ngStyle]="{'border':rowItem.NTCHK&&rowItem.NT.length>0? 'none':'2px solid #F78181'}" [(ngModel)]="rowItem.NT"></textarea>
						</ng-container>					
					</div>-->
					<div class="row m-2" *ngIf="!rowItem.NTCHK&&reportInfo?.PCA_INDICATOR!='Y'">
						<div *ngFor="let p of rrCols; let r=index" style="width:20%">
							<div *ngFor="let h of rrRows; let o=index" style="width:100%">
								<div *ngIf="(r*rrRows.length+o)<pcaOp.reserve">
									<input type="checkbox" class="yearbox" (change)="getReserve1()" [value]="r*rrRows.length+o+1">
									<label for="yearbox{{r*rrRows.length+o+1}}" style="width:16px">{{r*rrRows.length+o+1}}</label>
									<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate[r*rrRows.length+o]<0?'red':'black'}"  [(ngModel)]="rowItem.allocate[r*rrRows.length+o]" (input)="checkTotal()" type='number'>
								</div>
							</div>
						</div>
						<!--<div style="width:20%">
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<1" value="1">1 <input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['0']<0?'red':'black'}"  [(ngModel)]="rowItem.allocate['0']" [disabled]="pcaOp.reserve<1" (input)="checkTotal()" type='number'><br>
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<2" value="2">2 <input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['1']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['1']" [disabled]="pcaOp.reserve<2" (input)="checkTotal()" type='number'><br>
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<3" value="3">3 <input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['2']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['2']" [disabled]="pcaOp.reserve<3" (input)="checkTotal()" type='number'><br>
						</div>
						<div style="width:20%">
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<4" value="4">4<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['3']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['3']" [disabled]="pcaOp.reserve<4" (input)="checkTotal()" type='number'><br>
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<5" value="5">5<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['4']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['4']" [disabled]="pcaOp.reserve<5" (input)="checkTotal()" type='number'><br>
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<6" value="6">6<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['5']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['5']" [disabled]="pcaOp.reserve<6" (input)="checkTotal()" type='number'><br>
						</div>
						<div style="width:20%">
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<7" value="7">7<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['6']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['6']" [disabled]="pcaOp.reserve<7" (input)="checkTotal()" type='number'><br>
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<8" value="8">8<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['7']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['7']" [disabled]="pcaOp.reserve<8" (input)="checkTotal()" type='number'><br>
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<9" value="9">9<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['8']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['8']" [disabled]="pcaOp.reserve<9" (input)="checkTotal()" type='number'><br>
						</div>
						<div style="width:20%">
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<10" value="10">10<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['9']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['9']" [disabled]="pcaOp.reserve<10" (input)="checkTotal()" type='number'><br>
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<11" value="11">11<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['10']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['10']" [disabled]="pcaOp.reserve<11" (input)="checkTotal()" type='number'><br>
							<input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<12" value="12">12<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['11']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['11']" [disabled]="pcaOp.reserve<12" (input)="checkTotal()" type='number'><br>
						</div>
						<div style="width:20%">
							<ng-container *ngIf="pcaOp.reserve>=13"><input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<13" value="13">13<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['12']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['12']" [disabled]="pcaOp.reserve<13" (input)="checkTotal()" type='number'><br></ng-container>
							<ng-container *ngIf="pcaOp.reserve>=14"><input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<14" value="14">14<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['13']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['13']" [disabled]="pcaOp.reserve<14" (input)="checkTotal()" type='number'><br></ng-container>
							<ng-container *ngIf="pcaOp.reserve>=15"><input type="checkbox" class="yearbox" (change)="getReserve1()" [disabled]="pcaOp.reserve<15" value="15">15<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate['14']<0?'red':'black'}" [(ngModel)]="rowItem.allocate['14']" [disabled]="pcaOp.reserve<15" (input)="checkTotal()" type='number'><br></ng-container>
						</div>-->
					</div>
					<div class="row m-2" *ngIf="reportInfo?.PCA_INDICATOR=='Y'" >
						<div *ngFor="let p of rrCols; let r=index" style="width:20%">
							<div *ngFor="let h of rrRows; let o=index" style="width:100%">
								<div *ngIf="(r*rrRows.length+o)<pcaOp.reserve">
									<input type="checkbox" class="yearbox" (change)="getReserve1()" [value]="r*rrRows.length+o+1">
									<label for="yearbox{{r*rrRows.length+o+1}}" style="width:16px">{{r*rrRows.length+o+1}}</label>
									<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':rowItem.allocate[r*rrRows.length+o]<0?'red':'black'}"  [(ngModel)]="rowItem.allocate[r*rrRows.length+o]" (input)="checkTotal()" type='number'>
								</div>
							</div>
						</div>	
					</div>
						<a href='javascript:void(0)' class="btn pcaBtn m-1" (click)="checkAllocate('Y');">Check All</a>
						<a href='javascript:void(0)' class="btn pcaBtn m-1" (click)="checkAllocate('N');">Uncheck All</a>
						
						<p style="color:rgb(195,212,47)">You may select Checkboxes to spread costs evenly. Uneven spreads will calculate to early years in the loan term. You may manually enter the cost spread.</p>	
						<span *ngIf="reserveWarn" style="color:orange">*There are unallocated cost items. Check the box 'Allow Unallocated Costs' or complete the allocation.</span>
						<span *ngIf="validateWarn" style="color:orange">*Please review the calculations before adding to the table.</span>
						<span *ngIf="validateWarn1" style="color:orange">*Not all required fields have been entered.</span>
						<br>
						<ng-container *ngIf="reportInfo?.PCA_INDICATOR!='4099e'">
							<a *ngIf="!rowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="addPcaRow();">Add Cost Item</a>
							<a *ngIf="!rowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="addPcaRow('new');">Add and Create New Cost item</a>
							<a *ngIf="rowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="editPcaRow(rowItem['editIndex']);">Save item</a>
							
						</ng-container>
						<ng-container *ngIf="reportInfo?.PCA_INDICATOR=='4099e'">
							<a *ngIf="!rowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="saveFME();">Add Cost Item</a>
							<a *ngIf="!rowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="saveFME('new');">Add and Create New Cost item</a>
							<a *ngIf="rowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="editPcaRow1(rowItem['editIndex']);">Save item</a>
						</ng-container>
					</div>
			</div>
		</div>	
	</div>
	<div id="costZoomModal" #costZoomModal class="modal fade" data-backdrop='false'>
		<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:80%">
			<div class="modal-content" style="background:#444; color:white; max-height:80vh">
				<!-- Modal Header -->
				<div class="modal-header">
					<h6 class="modal-title">Replacement Repair Cost Table</h6>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>        
				<!-- Modal body -->
				<div class="modal-body" style="font-size:12px;width:100%; overflow: auto;">
					<table *ngIf="repairData&&!repairData['TYPE']" style="width:100%; font-size:12px; font-family:Arial, sans-serif;">
						<tr>
							<ng-container *ngFor="let h of repairData.cols; let o=index">
								<th style="padding:4px">
									<span style="font-weight:bold">{{h.NAME}}</span>
								</th>
							</ng-container>
						</tr>
						<ng-container *ngFor="let r of repairData.rows; let h=index">
							<tr>
								<ng-container *ngFor="let k of r; let q=index">
									<td  style="padding:4px">
										<!--<span [ngStyle]="{'font-weight':k.bold}"><span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>{{k.DATA}}<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span></span>-->
										<span *ngIf="!k?.index" [ngStyle]="{'font-weight':k.bold}"><span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>{{k.DATA}}<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span></span>
										<a *ngIf="k?.index" href="javascript:void(0)" data-dismiss="modal" [ngStyle]="{'font-weight':k.bold}" (click)="scrollTo(k.id, k?.index)">{{k.DATA}}</a>
									</td>				
								</ng-container>
							</tr>
  
						</ng-container>
					</table>
					<table *ngIf="repairData&&repairData['TYPE']" style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid #ccc;border-collapse: collapse; color:white">
						<tr *ngIf="repairData.titlerow">
							<th [colSpan]="repairData.cols.length" [ngStyle]="{'width':repairData.titlerow[0].width+repairData.titlerow[0].unit,'text-align':repairData.titlerow[0].colAlign}" style="font-weight: bold">{{repairData.titlerow[0].NAME}}
							</th>	
						</tr>
						<tr *ngIf="repairData.header">
							<ng-container *ngFor="let h of repairData.cols; let o=index; trackBy:trackByFuntion">
								<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="font-weight: bold">{{h.NAME}}
								</th>	
							</ng-container>
						</tr>
						<ng-container *ngFor="let r of repairData?.rows; let l=index; trackBy:trackByFuntion">
							<tr>
								<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
									<td *ngIf="!k.colspan" [ngStyle]="{'text-align':repairData?.cols[q]?.celAllign, 'font-weight':k.weight, width:repairData.cols[q]?.width+repairData.cols[q]?.unit}">
										<!--<span *ngIf="k.DATA" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
										<span *ngIf="!k.DATA">{{k.data}}</span>	-->	
										<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
										<span *ngIf="!k.sign">{{k.data}}</span>			
									</td>
									<td *ngIf="k.colspan" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':repairData?.cols[q].celAllign, 'font-weight':k.weight}">{{k.data}}
									</td>			
								</ng-container>
							</tr>					
						</ng-container>  
					</table>
				</div>
			</div>
		</div>	
	</div>
	<div id="historyModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6  *ngIf="!secHistoryData"  class="modal-title">Section History Data</h6>
		  <label  *ngIf="secHistoryData" style="margin-bottom:0; font-size:1.1em; font-weight:bold; margin-right:20px">{{secHistoryData?.SECTION_SEQUENCE}}  {{secHistoryData?.SECTION_TITLE}}</label>
		  <span style="margin-left:80px;margin-right:20px; margin-bottom:0; margin-top:4px; font-size:.8em"><b>Edit by: </b> {{secHistoryData?.user}} <b> at </b> {{secHistoryData?.timestamp}}</span>
		  <button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>

        <div class="modal-body">
		<div class="example-list p-3" style="color:black; max-height:600px; overflow:auto">
			<ng-container *ngIf="secHistoryData">
				<div *ngIf="secHistoryData" [ngClass]="{'hideSec':secHistoryData.HIDE}" style="position:relative" class="ck-content" >
			<!--<h2 style="font-weight:bold; font-size:14px">{{secHistoryData.SECTION_SEQUENCE}}<label *ngIf="!((secHistoryData.TYPE=='TABLE'&&secHistoryData.OTNAME)||secHistoryData.OSNAME||(secHistoryData.TYPE=='PHOTOS'&&secHistoryData.OPNAME))" style="margin-left:20px">    {{secHistoryData.SECTION_TITLE}}</label></h2>-->
				<label style="font-weight:bold; font-size:14px">{{secHistoryData.SECTION_SEQUENCE}}
				<label *ngIf="!(secHistoryData.OSNAME||(secHistoryData.TYPE=='PHOTOS'&&secHistoryData.OPNAME))" style="margin-left:20px">   {{secHistoryData.SECTION_TITLE}}</label></label>
				<table *ngIf="(secHistoryData.TYPE=='TABLE'||secHistoryData.TYPE=='COSTTABLE'||secHistoryData.TYPE=='PCATABLE'||secHistoryData.TYPE=='UNITTABLE')&&secHistoryData.data" style="border: 1px solid black;  border-collapse: collapse;font-size:8px; font-family:Arial, sans-serif;">
				<thead>
				<tr style="background-color:#eeeeee;">
					<ng-container *ngFor="let h of secHistoryData.data?.cols; let o=index">
						<th *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;">
							<span style="font-weight:bold" [innerHtml]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							<!--<ng-template #showText>
							<span style="font-weight:bold"> {{h.NAME}}</span>
							</ng-template>-->
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of secHistoryData.data?.rows; let h=index">
					<tr *ngIf="r.items.length>0&&(!r.items[0].colspan)&&r.hide!='Y'">
						<td *ngFor="let k of r.items" [ngStyle]="{'text-align':k.colAlign, 'background':k.bkcolor?k.bkcolor:'white'}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
							<span *ngIf="k.DATA" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
						</td>
			
					</tr>
					<tr *ngIf="r.items.length==1&&secHistoryData.data&&r.hide!='Y'">
						<ng-container *ngIf="r.items[0].colspan">
							<td [attr.colspan]="r.items[0].colspan" [ngStyle]="{'text-align':r.items[0].celAllign, 'background':r.items[0].bkcolor? r.items[0].bkcolor:'white'}" style="border: 1px solid black;  border-collapse: collapse;">
								<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							</td>
						</ng-container>	
					</tr>
				</ng-container>
				</tbody>
			</table>
		
			<div *ngIf='(secHistoryData.text&&secHistoryData.text.length>0)&&!secHistoryData?.intro' style="font-family:Segoe UI, sans-serif;; font-size:12px; width:90%; padding:0; margin:0" [innerHtml]="secHistoryData.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
			</div>
			<div *ngIf='(secHistoryData.text&&secHistoryData.text.length>0)&&secHistoryData?.intro' style="font-family:Segoe UI, sans-serif;; font-size:12px; width:90%; padding:0; margin:0" [innerHtml]="secHistoryData.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
			</div>
			<div style="width:100%; padding:8px 16px" *ngIf="secHistoryData.TYPE=='PHOTOS'&&secHistoryData.photos&&secHistoryData.photos.length>0">
			<div class="row">
			<ng-container *ngFor="let photo of secHistoryData.photos; let s=index">
				<div style="padding: 10px; float: left;  width: 40%;">
					<div  style="border:1px solid #CCC;  padding-bottom: 10px;  height:300px;">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:90%">
						<p class="desc">{{photo.FILE_DESCRIPTION}}</p>
					</div>
				</div>
			</ng-container>
			</div>
		</div>
		</div>
			</ng-container>
		 </div>
			<a href='javascript:void(0)' class="btn btn-outline-light btn-sm float-md-right m-2" data-dismiss="modal">Close</a>	
			<a *ngIf="!secHistoryData?.TYPE||(secHistoryData?.TYPE=='TABLE'&&(!secHistoryData?.data?.erisName))||secHistoryData?.text?.length>=0"  href='javascript:void(0)' class="btn btn-outline-light btn-sm float-md-right m-2" (click)="restoreContent()">Restore Content</a>
			
        </div>

	</div>
	</div>
	</div>
	<div id="preModal" #preModal class="modal fade" data-backdrop='false'>
		<div class="modal-dialog modal-lg modal-dialog-centered " style="width:816px">
			<div class="modal-content">
				<!-- Modal Header -->
				<div class="modal-header">
					<h6 class="modal-title">Report Preview</h6>
					<button type="button" class="close" data-dismiss="modal" (click)="preShow=false">&times;</button>
				</div>        
				<!-- Modal body -->
				<div *ngIf='preShow' class="modal-body" style="font-size:10px;width:100%; height:88vh; overflow:auto">
					<app-preview [content]='contents' [curReport]="reportInfo" [front]="frontpages" [space1]="head1Space" [space2]="head2Space" [space2]="head2Space"></app-preview>
				</div>
			</div>
		</div>	
	</div>
	<div id="saveModal" #saveModal class="modal fade" data-backdrop='false'>
		<div class="modal-dialog modal-lg modal-dialog-centered " style="width:560px; ">
			<div class="modal-content">
				<!-- Modal Header -->
				<div class="modal-header">
					<h6 class="modal-title">HOW TO SAVE YOUR WORK IN SCRIVA</h6>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>        
				<!-- Modal body -->
				<div class="modal-body" style="width:100%; height:58vh; overflow:auto">
					<ol>
						<li class="olli">Sections - After editing language in a text section:
							<ul class="infoList">
								<li>Click out of the section to another section or any open area within your report</li>
								<li>Click the “Save” icon in green running along the right margin of your report</li>
								<li>Click the “Save Report” icon in the upper right corner in the Tools sidebar	</li>
							</ul>
						</li>
						<li class="olli">Tables	
							<ul class="infoList">
								<li>Click the “Save” button when working in a table cell</li>
								<li>Click the “Save” icon in green running along the right margin of your report</li>
								<li>Click the “Save Report” icon in the upper right corner in the Tools sidebar</li>
							</ul>
						</li>
						<li class="olli">Adding/working with “Add Photo Section”
							<ul class="infoList">
								<li>Click into another section or table (aka continue working in your report)</li>
								<li>Click the “Save” icon in green running along the right margin of your report</li>
								<li>Click the “Save Report” icon in the upper right corner in the Tools sidebar</li>
								<li>Wait at least 60 seconds for your work to automatically save</li>
							</ul>	
						</li>
						<li class="olli">Adding/working with “Add PDF Section”
							<ul class="infoList">
								<li>Click into another section or table (aka continue working in your report)</li>
								<li>Click the “Save” icon in green running along the right margin of your report</li>
								<li>Click the “Save Report” icon in the upper right corner in the Tools sidebar</li>
								<li>Wait at least 60 seconds for your work to automatically save</li>
							</ul>
						</li>
						<li class="olli">Adding/working with Signature/Seal
							<ul class="infoList">
								<li>Click into another section or table (aka continue working in your report)</li>
								<li>Click the “Save” icon in green running along the right margin of your report</li>
								<li>Click the “Save Report” icon in the upper right corner in the Tools sidebar</li>
								<li>Wait at least 60 seconds for your work to automatically save</li>
							</ul>
						</li>
						<li class="olli">Filtering ERIS table
							<ul class="infoList">
								<li>Click into another section or table (aka continue working in your report)</li>
								<li>Click the “Save” icon in green running along the right margin of your report</li>
								<li>Click the “Save Report” icon in the upper right corner in the Tools sidebar</li>
								<li>Wait at least 60 seconds for your work to automatically save</li>
							</ul>
						</li>
					</ol>
				</div>
			</div>
		</div>	
	</div>
	<div id="fmeModal" #fmeModal class="modal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

		<div class="modal-dialog modal-dialog-centered" style="max-width: 60%;height:60vh">
		  <div class="modal-content" style="background-color: #4b4b4b">
	  
			<div class="modal-header">
			  <h6 class="modal-title" style="color:#ccc">Fannie Mae Data Input</h6>
			  <label *ngIf="allowFmeInput!='Y'" style="color:#f86565; text-align:center; margin-left: 10%;">Read Only ( Other User Editing This Form )</label>
			  <button type="button" class="close" data-dismiss="modal" (click)="closeFmeInput()">&times;</button>
			</div>
	  
			<div class="modal-body">
			  <div style="width:100%;">
				<div class="container tab-pane" style="width:100%; padding:0; height:60vh; overflow:auto">
					<form [formGroup]="myForm">
						<ng-container *ngFor="let f of fmeInputQuestion">
							<table class="fmeset" style="width:100%; margin-bottom:20px; background-color: #dedede;">
							<tr>
								<th colspan="3" style="background-color: #ccc;color:#202a3c;">{{f['FME CATEGORY']}}</th>
							</tr>
							<ng-container *ngFor="let r of f.FME_QUESTIONS">
								<tr>
								<td style="width:40%">{{r.FME_FIELD_NAME}}</td>
								<td style="width:30%"  [ngStyle]="{'pointer-events': allowFmeInput!='Y'?'none':'auto', 'opacity': allowFmeInput!='Y'?0.6:1 }">
										<span *ngIf="r.FME_FIELD_TYPE=='Selection'||(targetIds.indexOf(r.FME_ID)>-1&&!r.RF_ASSIGNED.SLOT_ID)">{{r.FME_VALUE}}</span>
										<input *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)&&(!r.FME_SELECTION_CHOICES)&&targetIds.indexOf(r.FME_ID)==-1" [formControlName]="r.FME_FIELD_TAG" type='text' style="width:100%" [ngClass]="{'redBorder':myForm.controls[r.FME_FIELD_TAG].errors}" (change)="updateFmeQ(r,$event, 'text')">
										<!--<span *ngIf="r.FME_FIELD_TYPE=='Selection'">{{r.FME_VALUE}}</span>-->
										
										<div *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" [ngClass]="{'redBorder':myForm.controls[r.FME_FIELD_TAG].errors}">
											<span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1&&r.FME_VALUE" class="fmeSlotHContent">{{r.FME_VALUE}}</span>
											<span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1&&(!r.FME_VALUE)" class="fmeSlotNoContent" >{{r.RF_ASSIGNED.KEY}}</span>
										</div>
										<!--<input *ngIf="r.RF_ASSIGNED.SLOT_ID>-1&&r.FME_VALUE" [formControlName]="r.FME_FIELD_TAG"  type='text' style="width:10%" [ngClass]="{'redBorder':myForm.controls[r.FME_FIELD_TAG].errors}"  [value]="r.FME_VALUE">-->
										<select class="float-right" style="width: 18px; padding-left:14px;" *ngIf="r.FME_SELECTION_CHOICES.length>0" (change)="updateFmeQ(r,$event)" [ngClass]="{'redBorder':!r.FME_VALUE&&r.FME_FIELD_REQUIRED=='Y'}">
											<option></option>
											<option *ngFor="let j of r.FME_SELECTION_CHOICES.split(';;')" [selected]="j==r.FME_VALUE" [value]="j">{{j}}</option>
										</select>
								</td>
								<td style="width:30%">{{r.FME_HELPFUL_HINTS}}</td>
								</tr>
							</ng-container>
							</table>
						</ng-container>
					</form>
				 </div>

				<div class="col-md-12 justify-content-center text-center mt-1" [ngStyle]="{'pointer-events': allowFmeInput!='Y'?'none':'auto', 'opacity': allowFmeInput!='Y'?0.6:1 }">
					<button class="btn btn-dark btn-sm pt-2 pb-2 pl-4 pr-4 mr-3" type="button" (click)="fmeInputValidate()">Validate</button>
					<button class="btn btn-dark btn-sm pt-2 pb-2 pl-4 pr-4 mr-3" type="button" (click)="printXml()">To XML</button>
				  	<button class="btn btn-dark btn-sm pt-2 pb-2 pl-4 pr-4" type="button" data-dismiss="modal" (click)="closeFmeInput()">Save and Close</button>
				</div>
				<p *ngIf="passed=='N'" class="fmeInvalid">The value(s) entered in the red fields do not match the data validation restrictions. Please edit these fields and re-submit</p>
				<p *ngIf="passed=='Y'" class="fmeValid">Validation Successful!</p>
				
		  </div>
		
			</div>
		  </div>
		</div>
	  </div>
	  <div id="closerModal" #closerModal class="modal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false" >

		<div class="modal-dialog modal-dialog-centered" style="max-width: 60%;height:60vh">
		  <div class="modal-content" style="background-color: #4b4b4b">
	  
			<div class="modal-header">
			  <h6 class="modal-title" style="color:#ccc">Closer Data Input</h6>
			  <label *ngIf="allowCloser!='Y'" style="color:#f86565; text-align:center; margin-left: 10%;">Read Only ( Other User Editing This Form )</label>
			  <button type="button" class="close" data-dismiss="modal" (click)="closeCloser()">&times;</button>			  
			</div>
	  
			<div class="modal-body">
			  <div style="width:100%;">
				<div class="container tab-pane" style="width:100%; padding:0; height:60vh; overflow:auto">
					<form [formGroup]="closerForm">
			  <ng-container *ngFor="let f of closerInputQuestion">
				<table class="fmeset" style="width:100%; margin-bottom:20px; background-color: #dedede;">
				  <tr>
					<th colspan="3" style="background-color: #ccc;color:#202a3c;">{{f['CLOSER_CATEGORY']}}</th>
				  </tr>
				  <ng-container *ngFor="let r of f.CLOSER_QUESTIONS">
					<tr>
					  <td style="width:40%">{{r.CLOSER_FIELD_NAME}}</td>
					  <td style="width:30%; display:ralative"  [ngStyle]="{'pointer-events': allowCloser!='Y'?'none':'auto', 'opacity': allowCloser!='Y'?0.6:1 }">
							<span *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)&&(r.CLOSER_FIELD_TYPE=='Selection'||r.CLOSER_FIELD_TYPE=='Date')">{{r.CLOSER_VALUE}}</span>
							<input *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)&&(!r.CLOSER_SELECTION_CHOICES)&&r.CLOSER_FIELD_TYPE!='Date'&&r.CLOSER_FIELD_TYPE!='Formula'" [formControlName]="r.CLOSER_ID" type='text' style="width:100%" [ngClass]="{'redBorder':closerForm.controls[r.CLOSER_ID]&&closerForm.controls[r.CLOSER_ID].errors}" (change)="updateCloserQ(r,$event)">
							<input type="date" class="dateIcon" [value]="r.CLOSER_VALUE?r.CLOSER_VALUE.slice(0,10):''" [ngClass]="{'redBorder':closerForm.controls[r.CLOSER_ID]&&closerForm.controls[r.CLOSER_ID].errors}" (change)="updateCloserQ(r,$event)" *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)&&r.CLOSER_FIELD_TYPE=='Date'">
							<span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1&&(!r.CLOSER_VALUE)" class="closerSlotNoContent" >{{r.RF_ASSIGNED.KEY}}</span>
							<div *ngIf="r.RF_ASSIGNED.SLOT_ID>-1&&r.CLOSER_VALUE" [ngClass]="{'redBorder':closerForm.controls[r.CLOSER_ID]&&closerForm.controls[r.CLOSER_ID].errors}"><span class="fmeSlotHContent">{{r.CLOSER_VALUE}}</span></div>
							<div *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)&&(r.CLOSER_FIELD_TYPE=='Formula')"  [ngClass]="{'redBorder':closerForm.controls[r.CLOSER_ID]&&closerForm.controls[r.CLOSER_ID].errors}"><span>{{r.CLOSER_VALUE}}</span></div>
							<select class="float-right" style="width: 18px; padding-left:14px;" *ngIf="r.CLOSER_SELECTION_CHOICES.length>0" (change)="updateCloserQ(r,$event)" [ngClass]="{'redBorder':!r.CLOSER_VALUE&&r.CLOSER_FIELD_REQUIRED=='Y'}">
								<option></option>
								<option *ngFor="let j of r.CLOSER_SELECTION_CHOICES.split(';;')" [selected]="j==r.CLOSER_VALUE" [value]="j">{{j}}</option>
							</select>
					  </td>
					  <!--<td style="width:30%">{{r.CLOSER_HELPFUL_HINTS}}</td>-->
					</tr>
				  </ng-container>
				</table>
			  </ng-container>
			</form>
				 </div>
				<p style="color:#C2D63F; font-size:.9em">{{closerXmlName}}.xml</p>
				<div class="col-md-12 justify-content-center text-center mt-1" [ngStyle]="{'pointer-events': allowCloser!='Y'?'none':'auto', 'opacity': allowCloser!='Y'?0.6:1 }">
					<button class="btn btn-dark btn-sm pt-2 pb-2 pl-4 pr-4 mr-3" type="button" (click)="closerInputValidate()">Validate</button>
					<button class="btn btn-dark btn-sm pt-2 pb-2 pl-4 pr-4 mr-3" [disabled]="closerPassed=='N'" type="button" (click)="printCloserXml()">To XML</button>
				  	<button class="btn btn-dark btn-sm pt-2 pb-2 pl-4 pr-4" type="button" data-dismiss="modal" (click)="closeCloser()" >Save and Close</button>
				</div>
				<p *ngIf="closerPassed=='N'" class="closerInvalid">The value(s) entered in the red fields do not match the data validation restrictions. Please edit these fields and re-submit</p>
				<p *ngIf="closerPassed=='Y'" class="closerValid">Validation Successful!</p>
				
		  </div>
		
			</div>
		  </div>
		</div>
	  </div>
	  <div *ngIf="frmShow" id="task-box" class="task-box1"  style="width:710px" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
			<label>Freddie Mac Content Input</label>
			<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="frmShow=false;"></i>
			<div class="ckContainer" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:450px; overflow:auto; cursor:auto; width:100%">
				<app-paragraph [addedSlot]="curFrm.addedItem"  class="docItem"  [content]="curFrm.html"  [getText]="curFrm['reqIndex']"  (selected)="selectedRow=-1;addLib=true;selectedEditor='C' " (onExit)='toFrmData($event, curFrm)' (outText)="curFrm.text=$event" (rfSelected)="selectedRF($event)"></app-paragraph>
				<button  class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; selectedRow=-1;showSlots()">Repeat Fields</button>				
			</div>
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="curFrm={'data':'','html':'', 'secHtml':null, 'addedItem':null};frmShow=false">Save</button>
						
		</div>					
		</div>
	  <div *ngIf="pisummaryShow" class="task-box1"  style="width:510px; z-index: 2000;top:40vh;right: 25vw;" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
			<label>Project Summary Content Input</label>
			<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="pisummaryShow=false;"></i>
			<div class="ckContainer" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:450px; overflow:auto; cursor:auto; width:100%">
				<app-paragraph [addedSlot]="picurSummaryItem.addedItem" class="docItem"  [content]="picurSummaryItem.html" [getText]="picurSummaryItem['reqIndex']"  (selected)="selectedRow=-1;addLib=true;selectedEditor='C' " (onExit)='pisummaryData($event)' (outText)="pisummaryText($event)"></app-paragraph>
				<button  class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; selectedRow=-1;showSlots()">Repeat Fields</button>				
			</div>
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="curSummary=null;pisummaryShow=false">Save</button>
						
		</div>
						
		</div>
		<div *ngIf="defaultShow" class="task-box1"  style="width:610px; top:30vh;right: 30vw;position: absolute;" cdkDrag [cdkDragDisabled]="intext">
				<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
					<label>Define Field Options</label>
					<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="defaultShow=false;"></i>
					<hr class="line1">
					<label class="col-md-4 savedLabel1">Field Option</label>			
					<input type="text" class="col-md-7" placeholder="Input your Field Options here"/>
					<i class="fas fa-plus iconBtn" title="Add Item to Field Options" (click)="addFOItem($event, eriscurcol)"></i>
					<div *ngIf='eriscurcol.FO&&eriscurcol.FO.length>0' class="mt-2" style="max-height: 100px; overflow: auto;">
							<ng-container *ngFor="let label of eriscurcol.FO; let i=index; trackBy:trackByFuntion">
								<label class="col-md-9" *ngIf="label.trim().length>0">{{label}}</label>
								<i class="fas fa-times iconBtn mr-3" title='Remove Item' (click)='removeFOItem(eriscurcol, i)'></i>
								<i class="fas fa-plus iconBtn" title='Add to default value' (click)='addRepeat("FO", label)'></i><br>
							</ng-container>
					</div>
					<hr class="line1">
					<label  class="savedLabel1">Default Value:</label><i class="far fa-edit iconBtn ml-1" (click)="toDefaultEdit(eriscurcol)"></i><br>
					<div style="margin:0; color:#C2D63F;font-size:.9em"> 
						<div class="ckContainer" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:300px; max-height:400px; overflow:auto; cursor:auto; width:100%;">
							<app-paragraph [addedSlot]="eriscurcol.DefaultFO.addedItem" [editorType]="'lite'" class="docItem"  [content]="eriscurcol.DefaultFO.html" [getText]="eriscurcol.DefaultFO['reqIndex']"  (selected)="selectedRow=-1;" (onExit)='defaultData($event)' (outText)="defaultText($event)"></app-paragraph>
						</div>
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="updateErisHeader(); defaultShow=false">Save</button>
														
					</div>	
				</div>					
		</div>	
		<div *ngIf="psShow" #psmodal class="task-box4"  style="width:510px; top:30vh;right: 25vw" cdkDrag [cdkDragDisabled]="intext">
			<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
				<label>Set Project Summary Columns</label>
				<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="psShow=false;"></i>
				<div *ngIf="this.summaryType=='PHASE I'" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:550px; overflow:auto; cursor:auto; width:100%">
				<ng-container *ngFor="let item of picurSummary; let i=index">
					<ng-container *ngIf="i>0">
						<label>{{item.col}}</label><i *ngIf='item.inputType=="text"' class="far fa-edit iconBtn" (click)="toSummaryEdit(item)"></i><br>
						<!--<textarea *ngIf='item.inputType=="text"' cols=2 class='colInput col-md-12' [(ngModel)]="item.data"></textarea>-->
						<input *ngIf='item.inputType=="Checkmark"' class='colInput col-md-4'  type='text' [(ngModel)]="item.data"/>
						<a *ngIf='summaryColsType[i]=="Checkmark"' class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;" (click)="item.data='✓'">Check On</a>
						<a *ngIf='summaryColsType[i]=="Checkmark"' class="btn btn-outline-light  pb-0 pt-0 ml-2 mb-1" style="font-size:.7em;" (click)="item.data=''">Clear</a><br>
						<div *ngIf='item.inputType=="text"&&item.secHtml' style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="item.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						
											
					</ng-container>							
				</ng-container>
				<!--<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn mt-1 float-md-right" (click)="savePISummay(); psShow=false;">Add and Save Section to PS</button>
				<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn mt-1" (click)="removePISummay(); psShow=false;">Remove Section from PS</button>-->			
						
			</div>
			<div *ngIf="this.summaryType=='PCA'" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:550px; overflow:auto; cursor:auto; width:100%">
						
						
				<ng-container *ngFor="let item of pcacurSummary; let i=index">
						<label>{{item.col}}</label>
						<i *ngIf='item.inputType=="text"' class="far fa-edit iconBtn" (click)="toSummaryEdit(item)"></i><br>
						
						<ng-container *ngIf='item.inputType=="option"'>
							<select *ngIf='!item.ops' [(ngModel)]="item.cat" [ngStyle]="{'border':item.cat.length>0? 'none':'2px solid #F78181'}">
								<option *ngFor='let op of summaryCategory' [selected]="item.cat==op" [value]="op">{{op}}</option>
							</select><span *ngIf='i==0' style="color:#F78181">*</span>
							<ng-container *ngIf='item.ops'>
							<input type="text" class="col-md-6" id="actionItem" placeholder="Input your Action here"/>
							<button (click)="op333.toggle($event);" title="Select Item"><i class="fas fa-chevron-down" style="pointer-events:none; color:#C2D63F"></i></button>
							<i class="fas fa-plus iconBtn" title="Add Item to Action" (click)="addActionItem(item)"></i>
							<p-overlayPanel #op333 [appendTo]="'body'" [dismissable]="true" [style]="{'width': '240px'}">
								<ng-template pTemplate>
									<div style="margin:0; max-height:400px; padding:4px; width:220px; overflow:auto">
										<ng-container *ngFor="let label of item.ops; trackBy: trackByFuntion">
											<div class="listItem2" style="margin:0; width:180px; border:1px ridge black" >
												<a href="javascript:void(0)" style="color:rgb(195,212,47); margin:2px" (click)="addToAction(label)">{{label}}</a><br>
											</div>
										</ng-container>
									</div>																
								</ng-template>
							</p-overlayPanel>
							<div class="col-md-10">
								<ng-container *ngFor="let label of item.ACTION let i=index; trackBy:trackByFuntion">
									<label class='mr-2'*ngIf="label.trim().length>0">{{label}}<i class="fas fa-times iconBtn ml-2" (click)='removeActionItem(i)'></i></label>
								</ng-container>
							</div>
						
						</ng-container><br>
							<!--<select *ngIf='item.ops' [(ngModel)]="item.data">
								<option>Please select Action</option>
								<option *ngFor='let op of item.ops' [selected]="item.cat==op" [value]="op">{{op}}</option>
							</select><br>-->
						</ng-container>
						<ng-container *ngIf='item.inputType=="Checkmark"'>
							<input class='colInput col-md-4'  type='text' [(ngModel)]="item.data"/>
							<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;" (click)="item.data='✓'">Check On</a>
							<a class="btn btn-outline-light  pb-0 pt-0 ml-2 mb-1" style="font-size:.7em;" (click)="item.data=''">Clear</a><br>
							<!--<div *ngIf='item.inputType=="text"&&item.secHtml' style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="item.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>-->
						</ng-container>					
				</ng-container>
			</div>
			<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn mt-1 float-md-right" (click)="savePISummay();">Add and Save Section to PS</button>
			<span *ngIf="catReq" style="color:#F78181" class="float-sm-right mr-1">{{catReq}}</span>
			<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn mt-1" (click)="removePISummay(); psShow=false;">Remove Section from PS</button>			
											
			</div>
		</div>
	 
		<div id="frmCostModal" #frmCostModal class="modal fade" data-backdrop='false'>
			<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:50%">
				<div class="modal-content" style="background:#444; color:#ccc">
					<!-- Modal Header -->
					<div class="modal-header">
						<h6 *ngIf="!frmrowItem['edit']" class="modal-title">Add Cost Recommendation</h6>
						<h6 *ngIf="frmrowItem['edit']" class="modal-title">Edit Cost Recommendation</h6>
						<button type="button" class="close" data-dismiss="modal" (click)="resetFrmCostTable;opfrm.hide()">&times;</button>
					</div>        
					<!-- Modal body -->
					<div class="modal-body" style="font-size:12px;">
						<div class="costRow" style="text-align: center;">
							<label>Area of Property: </label><br>
							<select disabled class="costInput" style="width:96%; font-size: 11px;" (change)="selFrmUl(frmrowItem, $event, 'cat', 'cost')">
								<option value="-1">Please Select Freddie Mac Category</option>
								<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.tag==frmrowItem.cat">{{item.label}}</option>
							</select>
						</div>
						<div class="row costRow">
							
								<div style="width:99%; margin-left: 10px;">
									<label class="costLabel mr-2" style="width:48%">Condition</label>
									<label class="costLabel"  style="width:48%">Action</label>
									<select class="costInput mr-2" style="width:49%" (change)="selFrmCost('condition', $event)" [disabled]='filledItems.ADDED' [ngStyle]="{'border':frmrowItem.condition.length>0? 'none':'2px solid #F78181'}">
										<option></option>
										<option *ngFor="let item of conditionOps; let i=index" [value]="item" [selected]="item==frmrowItem['condition']">{{item}}</option>
									</select>
									<!--<select class="costInput" style="width:49%" (change)="selFmeCost('action', $event)">
										<option></option>
										<option *ngFor="let item of actionItemOps; let i=index" [value]="item.name" [selected]="item.name==frmrowItem['action']"  (change)="selFmeCost('action', $event)">{{item.name}}</option>
									</select>
									<p-multiSelect [style]="{'width':'49%', 'padding':'1px', 'font-size':'10px'}" [options]="actionItemOps" [filter]="false" [ngStyle]="{'border':frmrowItem.ACTION?.length>0? 'none':'2px solid #F78181'}" [(ngModel)]="frmrowItem['ACTION']" optionLabel="name" (onChange)="selFrmCost('ACTION',$event)"></p-multiSelect>
									-->
									<input [(ngModel)]="frmrowItem['actiontext']" disabled style="width:41%; padding:1px; font-size:12px">
									<a href="javascript:void(0)" class='btn btn-outline-light btn-sm pt-0 pb-0 pl-2 pr-2 mb-1' (click)="opfrm.toggle($event)"><i class="fas fa-angle-down fa-sm"></i></a>
									<p-overlayPanel #opfrm [appendTo]="frmCostModal" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="20000" [style]="{'width': '160px'}">
										<ng-template pTemplate>
											<div style="margin:0; max-height:400px; padding:4px 0; width:140px; overflow:auto">
												<ng-container *ngFor="let label of actionItemOps; let i=index trackBy: trackByFuntion">
													<div class="listItem2" style="margin:0; width:110px; border:1px ridge black" >
														<input type="checkbox" class='frmAction' (change)="addToFrmAction($event)" [checked]="frmrowItem['actions'].indexOf(label.name)>-1" [value]="i" [disabled]='filledItems[label.name]'><label style="color:rgb(195,212,47); margin:2px">{{label.name}}</label><br>
													</div>
												</ng-container>
												<a href="javascript:void(0)"  class='btn btn-list2 btn-outline-light btn-sm p-0 mr-1' (click)="checkAllFrmAction($event, true)">Check All</a>
												<a href="javascript:void(0)"  class='btn btn-list2 btn-outline-light btn-sm p-0' (click)="checkAllFrmAction($event, false)">Uncheck All</a>
											</div>																
										</ng-template>
									</p-overlayPanel>
								</div>								
							<div style="width:50%; margin-left:10px">
								<label class="costLabel">Cost Recommendation</label>
								<input class="costInput" [disabled]='frmrowItem["FRM"]||frmrowItem["edit"]' style="width:85%" [(ngModel)]="frmrowItem.Item" type='text' [ngStyle]="{'border':frmrowItem.Item.length>0? 'none':'2px solid #F78181'}" (change)="frmrowItem['Item']=frmrowItem['Item'].trim(); customInput($event)">
								<select class="costInput" [disabled]='frmrowItem["FRM"]||frmrowItem["edit"]' style="width:10%"(change)="selFrmCost('Item', $event)" (click)="getAddedItems($event)">
									<option value="-1"></option>
									<option *ngFor="let item of frmrowItem['costitems']; let i=index" [value]="i" ><span *ngIf="item.parent">{{item.parent}}--</span>{{item.key}}</option>
								</select>
								<div *ngIf="frmrowItem['other']">Other:<input type="text" [(ngModel)]="frmrowItem['otherInput']" [ngStyle]="{'border':frmrowItem.otherInput.length>0? 'none':'2px solid #F78181'}" style='width: 77%;' maxlength="100" (change)="frmrowItem['otherInput']=frmrowItem['otherInput'].trim(); getSameItem(frmrowItem)"></div>
								<div *ngIf="frmrowItem['describe']">Describe:<input type="text" [(ngModel)]="frmrowItem['describeInput']" [ngStyle]="{'border':frmrowItem.describeInput.length>0? 'none':'2px solid #F78181'}" style='width: 72%;' maxlength="100" [disabled]='filledItems.ADDED' (change)="frmrowItem['describeInput']=frmrowItem['describeInput'].trim()"></div>
							</div>
							<div style="width:10%">
								<label class="costLabel">EUL</label>
								<input class="costInput" [(ngModel)]="frmrowItem.EUL" min="0"   max="1000000000" type='number' (blur)="changeCostFactor(frmrowItem.EUL, 'EUL')" [disabled]='filledItems.ADDED'>-
							</div>
							<div style="width:10%">
								<label class="costLabel">EFF AGE</label>
								<input class="costInput" [(ngModel)]="frmrowItem.EFF" min="0"   max="1000000000" type='number' (blur)="changeCostFactor(frmrowItem.EFF, 'EFF')" [disabled]='filledItems.ADDED'>=
							</div>
							<div style="width:10%">
								<label class="costLabel">RUL</label>
								<input class="costInput" disabled [value]="frmrowItem?.EUL-frmrowItem?.EFF" min="0"   max="1000000000" type='number' (blur)="changeCostFactor($event)" [disabled]='filledItems.ADDED'>
							</div>
							<div style="width:12%">
								<label class="costLabel">RUL Input</label>
								<input class="costInput" [(ngModel)]="frmrowItem.RULtext" type='text' [disabled]='filledItems.ADDED'>
							</div>
						</div>
						<div class="row costRow">
							<div style="width:20%; margin-left:10px">
								<label class="costLabel">Calculation</label>
								<input class="costInput" [(ngModel)]="frmrowItem.Quantity" min="0"  max="1000000000" type='number' (blur)="getReserve2('Quantity')"> X
								<label class="costHint"><span style="color:red">*</span>Quantity</label>
							</div>
							<div style="width:22%">
								<label *ngIf="curCost?.COST.length>10" class="costHint m-0" [title]="curCost?.COST">{{curCost?.COST.substring(0,10)}}...</label>
								<label *ngIf="!(curCost?.COST.length>10)"class="costHint m-0">{{curCost?.COST}}</label>
								<input class="costInput" [(ngModel)]="frmrowItem.Cost" min="0" (blur)="getReserve2('Cost')" max="1000000000" type='number'><!--[ngStyle]="{'border':frmrowItem.NTCHK||(!frmrowItem.NTCHK&&frmrowItem.Cost>0)? 'none':'2px solid #F78181'}" -->
								<label class="costHint"><span style="color:red">*</span>Unit Cost</label>
							</div>
							<div style="width:12%">
								<label class="costHint m-0">{{curCost?.UNIT}}</label>
								<input class="costInput" style="width:55%" [(ngModel)]="frmrowItem.Unit"  type='text' (input)="customInput($event)">
								<select class="costInput"  style="width:20%" (change)="selUnit($event)">
									<option></option>
									<option *ngFor="let unit of units" [value]="unit.COST_UNIT_NAME" [selected]="frmrowItem.Unit==unit.COST_UNIT_NAME">{{unit.COST_UNIT_NAME}}</option>
								</select>=
								<label class="costHint"><span style="color:red">*</span>Unit Type</label>
							</div>
							<div style="width:12%">
								<br>
								<input class="costInput" disabled [(ngModel)]="frmrowItem.Cycle" type='number'>x
								<label class="costHint">Cycle Cost</label>
							</div>
							<div style="width:11%">
								<br>
								<input class="costInput" [(ngModel)]="frmrowItem.Percent" min="0"   max="1000000000" type='number' (input)="getReserve2()">
								<label class="costHint">Replace%</label>
							</div>
							<div style="width:21%">
								<br>
								<input class="costInput" type='number' min="0"   max="1000000000" disabled [(ngModel)]="frmrowItem.Total">
								<label class="costHint">Total</label>
							</div>
						</div>
						<!--<label class="costLabel" style="text-align: left; margin-left: 20px;"> Comments/Mold Observation:</label><br>
							<textarea style="width:92%; margin-left: 20px;" rows="5" [(ngModel)]="rowItem.MOComm"></textarea>-->
							<div>
								<!--<div style="display:inline-block; width: 160px; margin-left: 10px;">
									<a href='javascript:void(0)' class="btn pcaBtn m-1" (click)="calQuantity()">Calculate Quantities</a>
								</div>-->
								<input type="checkbox" style=" margin-left: 30px;" [(ngModel)]="frmrowItem.allow" [checked]="frmrowItem.allow"><label style="width:200px;" class="costLabel2">Allow Unallocated Costs</label>
								<label class="costLabel2" style="width:120px">Unallocated Costs</label>
								<input class="costInput2" style="width:100px" type='number' [ngStyle]="{'color':frmrowItem.reserve<0?'red':'black'}" disabled [(ngModel)]="frmrowItem.reserve">	
								<!--<input class="costInput col-md-10" type='number'  [ngStyle]="{'color':(frmrowItem.data[5].data*frmrowItem.data[1].data*frmrowItem.data[3].data/100-frmrowItem.data[6].data-frmrowItem.data[7].data)<0?'red':'black'}" disabled [value]="frmrowItem.data[5].data*frmrowItem.data[1].data*frmrowItem.data[3].data/100-frmrowItem.data[6].data-frmrowItem.data[7].data">-->							
							</div>
							<div class="row">
							<div style="width:10%; float:right">
								<label class="costLabel1">CR:</label><input type="checkbox" class="m-1" [(ngModel)]="frmrowItem.CRCHK" (change)="getReserve2()" [disabled]="filledItems.CR">
							</div>
							<div style="width:10%">
								<input  class="costInput3" [(ngModel)]="frmrowItem.CR" (blur)="getReserve2('CR')" type='number' min="0" max="1000000000" style="border:none" [disabled]="filledItems.CR">
								<label class="costHint">Cost</label>
							</div>
							<div style="width:10%">
								<input  class="costInput3" [(ngModel)]="frmrowItem.CRQuantity" (blur)="getReserve2('CRQuantity')" placeholder="Quantity" type='text' [ngStyle]="{'border':frmrowItem.CRQuantity!==''&&frmrowItem.CRQuantity=='NaN'?'2px solid #F78181':'none'}" [disabled]="filledItems.CR">
								<label class="costHint">Quantity</label>
							</div>
							<div style="width:68%">
								<textarea class="costInput3" rows="2" placeholder="Input your comments here"  [ngStyle]="{'border':frmrowItem.CRCHK&&frmrowItem.CRBP.length==0?'2px solid #F78181':'none'}"[(ngModel)]="frmrowItem.CRBP" type='text' [disabled]="filledItems.CR" ></textarea>
								
							</div>	
							<div style="width:10%; float:right">
								
								<label class="costLabel1">PR:</label><input type="checkbox" class="m-1" [(ngModel)]="frmrowItem.PRCHK" (change)="getReserve2()" [disabled]="filledItems.PR">
								
								
							</div>
						
							<div style="width:10%">
							
								<input class="costInput3" [(ngModel)]="frmrowItem.PR" min="0"   max="1000000000" style="border:none" (blur)="getReserve2('PR')" type='number' [disabled]="filledItems.PR"><br>
								<label class="costHint">Cost</label>
							</div>
							<div style="width:10%">
								<input  class="costInput3" [(ngModel)]="frmrowItem.PRQuantity" (blur)="getReserve2('PRQuantity')" placeholder="Quantity" type='text' [ngStyle]="{'border':frmrowItem.PRQuantity!==''&&frmrowItem.PRQuantity=='NaN'?'2px solid #F78181':'none'}" [disabled]="filledItems.PR">
								<label class="costHint">Quantity</label>
							</div>
							<div style="width:68%">
								
								<textarea class="costInput3" rows="2" placeholder="Input your comments here"  [ngStyle]="{'border':frmrowItem.PRCHK&&frmrowItem.PRBP.length==0?'2px solid #F78181':'none'}"[(ngModel)]="frmrowItem.PRBP" type='text' [disabled]="filledItems.PR"></textarea>
								
							</div>	
							<div style="width:10%; float:right">
							
								<label class="costLabel1">PR-90:</label><input type="checkbox" class="m-1" [(ngModel)]="frmrowItem.PR90CHK" (change)="getReserve2()" [disabled]="filledItems['PR-90']">
								
							</div>
						
							<div style="width:10%">
								
								<input class="costInput3" [(ngModel)]="frmrowItem.PR90" min="0"  max="1000000000" style="border:none" (blur)="getReserve2('PR90')" type='number' [disabled]="filledItems['PR-90']"><br>
								<label class="costHint">Cost</label>
							</div>
							<div style="width:10%">
								<input  class="costInput3" [(ngModel)]="frmrowItem.PR90Quantity" (blur)="getReserve2('PR90Quantity')" placeholder="Quantity" type='text' [ngStyle]="{'border':frmrowItem.PR90Quantity!==''&&frmrowItem.PR90Quantity=='NaN'?'2px solid #F78181':'none'}" [disabled]="filledItems['PR-90']">
								<label class="costHint">Quantity</label>
							</div>
							<div style="width:68%">
								
								<textarea class="costInput3" rows="2" placeholder="Input your comments here" [ngStyle]="{'border':frmrowItem.PR90CHK&&frmrowItem.PR90BP.length==0?'2px solid #F78181':'none'}" [(ngModel)]="frmrowItem.PR90BP" type='text' [disabled]="filledItems['PR-90']"></textarea>
							</div>								
							
						</div>	
							<!--<label class="costLabel" style="text-align: left; margin-left: 20px;"> Comments/Mold Observation:</label><br>
							<textarea style="width:92%; margin-left: 20px;" rows="2" [(ngModel)]="frmrowItem.MOComm"></textarea>
							<label class="costLabel" style="text-align: left; margin-left: 20px;">Critical and Priority Repairs Comments:</label><br>
							<textarea style="width:92%; margin-left: 20px;" rows="2" [(ngModel)]="frmrowItem.CPRComm"></textarea>-->						
						<div class="row mb-0 pb-0">							
							<label class="costLabel" style="width:200px; text-align: left; margin-left: 10px;">Remaining Repair Quantity (RR):</label>								
							<input  class="costInput3 ml-1" style="width:10%" [(ngModel)]="frmrowItem.RRQuantity" (blur)="getReserve2('RRQuantity')" placeholder="Quantity" type='text' [ngStyle]="{'border':frmrowItem.RRQuantity!==''&&frmrowItem.RRQuantity=='NaN'?'2px solid #F78181':'none'}" [disabled]="filledItems.RR">
						</div>
						<div class="row m-2 mt-0 pt-0">
							<div style="width:25%">
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<1||filledItems.RR" value="1">1 <input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['0']<0?'red':'black'}"  [(ngModel)]="frmrowItem.allocate['0']" [disabled]="pcaOp.reserve<1||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<2||filledItems.RR" value="2">2 <input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['1']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['1']" [disabled]="pcaOp.reserve<2||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<3||filledItems.RR" value="3">3 <input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['2']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['2']" [disabled]="pcaOp.reserve<3||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
							</div>
							<div style="width:25%">
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<4||filledItems.RR" value="4">4<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['3']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['3']" [disabled]="pcaOp.reserve<4||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<5||filledItems.RR" value="5">5<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['4']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['4']" [disabled]="pcaOp.reserve<5||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<6||filledItems.RR" value="6">6<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['5']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['5']" [disabled]="pcaOp.reserve<6||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
							</div>
							<div style="width:25%">
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<7||filledItems.RR" value="7">7<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['6']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['6']" [disabled]="pcaOp.reserve<7||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<8||filledItems.RR" value="8">8<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['7']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['7']" [disabled]="pcaOp.reserve<8||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<9||filledItems.RR" value="9">9<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['8']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['8']" [disabled]="pcaOp.reserve<9||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
							</div>
							<div style="width:25%">
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<10||filledItems.RR" value="10">10<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['9']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['9']" [disabled]="pcaOp.reserve<10||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<11||filledItems.RR" value="11">11<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['10']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['10']" [disabled]="pcaOp.reserve<11||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
								<input type="checkbox" class="yearbox1" (change)="getReserve2()" [disabled]="pcaOp.reserve<12||filledItems.RR" value="12">12<input class="costInput1" min="0"   max="1000000000" [ngStyle]="{'color':frmrowItem.allocate['11']<0?'red':'black'}" [(ngModel)]="frmrowItem.allocate['11']" [disabled]="pcaOp.reserve<12||filledItems.RR" (input)="checkFrmTotal()" type='number'><br>
							</div>
						</div>	
							<a href='javascript:void(0)' class="btn pcaBtn m-1" [ngClass]="{'disabled':filledItems.RR}" (click)="checkFrmAllocate('Y');">Check All</a>
							<a href='javascript:void(0)' class="btn pcaBtn m-1" [ngClass]="{'disabled':filledItems.RR}" (click)="checkFrmAllocate('N');">Uncheck All</a>
							
							<p style="color:rgb(195,212,47)">You may select Checkboxes to spread costs evenly. Uneven spreads will calculate to early years in the loan term. You may manually enter the cost spread.<br></p>	
							<span *ngIf="reserveWarn" style="color:orange">*There are unallocated cost items. Check the box 'Allow Unallocated Costs' or complete the allocation.<br></span>
							<span *ngIf="validateWarn" style="color:orange">*Please review the calculations before adding to the table.<br></span>
							<span *ngIf="validateWarn1" style="color:orange">*Not all required fields have been entered.<br></span>
							<span *ngIf="quantityWarn" style="color:orange">*Invalid quantity entered. The total allocated quantity exceeds the available quantity.</span>
							<br>
							<label class="costLabel" style="text-align: left; margin-left: 10px;"> Comments/Mold Observation:</label><br>
							<textarea style="width:96%; margin-left: 10px;" rows="2" placeholder="Input your comments here" [(ngModel)]="frmrowItem.MOComm"></textarea>
							<!--<label class="costLabel" style="text-align: left; margin-left: 10px;"><input type="checkbox" class="m-1" [(ngModel)]="frmrowItem.ORCHK" (change)="getReserve2()">Operational Repairs:</label><br>
							<textarea style="width:96%; margin-left: 10px;" placeholder="Input your description here" rows="2" [(ngModel)]="frmrowItem.ORBP" [ngStyle]="{'border':frmrowItem.ORCHK&&frmrowItem.ORBP.length==0?'2px solid #F78181':'none'}"></textarea>-->
							<ng-container *ngIf="reportInfo?.PCA_INDICATOR!='4099e'">
								<a *ngIf="!frmrowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" [ngClass]="{'disabled':filledItems['ALL']}" (click)="addtoFrm();opfrm.hide()">Add Cost Item</a>
								<a *ngIf="!frmrowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" [ngClass]="{'disabled':filledItems['ALL']}" (click)="addtoFrm('new');opfrm.hide()">Add and Create New Cost item</a>
								<a *ngIf="frmrowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="editFrmRow(frmrowItem['editIndex']);opfrm.hide()">Save item</a>
								
							</ng-container>
							<!--<ng-container *ngIf="reportInfo?.PCA_INDICATOR=='4099e'">
								<a *ngIf="!frmrowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="saveFME();">Add Cost Item</a>
								<a *ngIf="!frmrowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="saveFME('new');">Add and Create New Cost item</a>
								<a *ngIf="frmrowItem['edit']" href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="editPcaRow1(frmrowItem['editIndex']);">Save item</a>
							</ng-container>-->
						</div>
				</div>
			</div>	
		</div>
		<div id="frmZoomModal" #costZoomModal class="modal fade" data-backdrop='false'>
			<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:80%">
				<div class="modal-content" style="background:#444; color:white; max-height:80vh">
					<!-- Modal Header -->
					<div class="modal-header">
						<h6 class="modal-title">{{frmZoomTitle}}</h6>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>        
					<!-- Modal body -->
					<div class="modal-body" style="font-size:12px;width:100%; overflow: auto;">
						<table *ngIf="frmZoomData" style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid #ccc;border-collapse: collapse; color:white">
							<tr>
								<ng-container *ngFor="let h of frmZoomData.cols; let o=index; trackBy:trackByFuntion">
									<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="font-weight: bold">{{h.NAME}}
									</th>	
								</ng-container>
							</tr>
							<ng-container *ngFor="let r of frmZoomData?.rows; let l=index; trackBy:trackByFuntion">
								<tr>
									<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
										<td colSpan='{{k.colspan}}' [ngStyle]="{'text-align':frmZoomData.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:frmZoomData.cols[q].width+frmZoomData.cols[q].unit, 'padding-left':k.sub}">{{k.data}}
                       
										</td>				
									</ng-container>
								</tr>					
							</ng-container>  
						</table>
					</div>
				</div>
			</div>	
		</div>